//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    tokenFromBody(userLogin: UserLoginDTO): Observable<UserTokenDTO> {
        let url_ = this.baseUrl + "/TokenFromBody";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userLogin);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokenFromBody(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokenFromBody(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTokenDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTokenDTO>;
        }));
    }

    protected processTokenFromBody(response: HttpResponseBase): Observable<UserTokenDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTokenDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    token(userName: string | null | undefined, password: string | null | undefined, grant_Type: string | null | undefined, client_Id: string | null | undefined, client_Secret: string | null | undefined, refresh_Token: string | null | undefined, twoFactorAuthenticationToken: string | null | undefined): Observable<UserTokenDTO> {
        let url_ = this.baseUrl + "/Token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userName !== null && userName !== undefined)
            content_.append("UserName", userName.toString());
        if (password !== null && password !== undefined)
            content_.append("Password", password.toString());
        if (grant_Type !== null && grant_Type !== undefined)
            content_.append("Grant_Type", grant_Type.toString());
        if (client_Id !== null && client_Id !== undefined)
            content_.append("Client_Id", client_Id.toString());
        if (client_Secret !== null && client_Secret !== undefined)
            content_.append("Client_Secret", client_Secret.toString());
        if (refresh_Token !== null && refresh_Token !== undefined)
            content_.append("Refresh_Token", refresh_Token.toString());
        if (twoFactorAuthenticationToken !== null && twoFactorAuthenticationToken !== undefined)
            content_.append("TwoFactorAuthenticationToken", twoFactorAuthenticationToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTokenDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTokenDTO>;
        }));
    }

    protected processToken(response: HttpResponseBase): Observable<UserTokenDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTokenDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    tokenWithAzurePrincipal(userLogin: UserLoginAzureDTO): Observable<UserTokenDTO> {
        let url_ = this.baseUrl + "/TokenWithAzurePrincipal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userLogin);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokenWithAzurePrincipal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokenWithAzurePrincipal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTokenDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTokenDTO>;
        }));
    }

    protected processTokenWithAzurePrincipal(response: HttpResponseBase): Observable<UserTokenDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTokenDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    createClient(createClientDTO: CreateClientDTO): Observable<ClientDTO> {
        let url_ = this.baseUrl + "/api/Client/CreateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createClientDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO>;
        }));
    }

    protected processCreateClient(response: HttpResponseBase): Observable<ClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchClients(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, hasImportConfiguration: boolean | null | undefined, hasExportConfiguration: boolean | null | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfClientDTO> {
        let url_ = this.baseUrl + "/api/Client/SearchClients?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (hasImportConfiguration !== undefined && hasImportConfiguration !== null)
            url_ += "hasImportConfiguration=" + encodeURIComponent("" + hasImportConfiguration) + "&";
        if (hasExportConfiguration !== undefined && hasExportConfiguration !== null)
            url_ += "hasExportConfiguration=" + encodeURIComponent("" + hasExportConfiguration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfClientDTO>;
        }));
    }

    protected processSearchClients(response: HttpResponseBase): Observable<PagedResultDTOOfClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateClient(updateClient: UpdateClientDTO): Observable<ClientDTO> {
        let url_ = this.baseUrl + "/api/Client/UpdateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateClient);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO>;
        }));
    }

    protected processUpdateClient(response: HttpResponseBase): Observable<ClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateClient(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Client/DeactivateClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteClient(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Client/DeleteClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NavisionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getBaseUrlForFiles(fileStorageLocationType: FileStorageLocationType | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Navision/GetBaseUrlForFiles?";
        if (fileStorageLocationType === null)
            throw new globalThis.Error("The parameter 'fileStorageLocationType' cannot be null.");
        else if (fileStorageLocationType !== undefined)
            url_ += "fileStorageLocationType=" + encodeURIComponent("" + fileStorageLocationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBaseUrlForFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBaseUrlForFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBaseUrlForFiles(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompleteFileUrl(fileStorageLocationType: FileStorageLocationType | undefined, fileName: string | undefined, fileTypeIdentifier: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Navision/GetCompleteFileUrl?";
        if (fileStorageLocationType === null)
            throw new globalThis.Error("The parameter 'fileStorageLocationType' cannot be null.");
        else if (fileStorageLocationType !== undefined)
            url_ += "fileStorageLocationType=" + encodeURIComponent("" + fileStorageLocationType) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileTypeIdentifier !== undefined && fileTypeIdentifier !== null)
            url_ += "fileTypeIdentifier=" + encodeURIComponent("" + fileTypeIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompleteFileUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompleteFileUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCompleteFileUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductAssetUrl(itemNos: string[] | undefined): Observable<NavisionProductAssetUrl> {
        let url_ = this.baseUrl + "/api/Navision/GetProductAssetUrl?";
        if (itemNos === null)
            throw new globalThis.Error("The parameter 'itemNos' cannot be null.");
        else if (itemNos !== undefined)
            itemNos && itemNos.forEach(item => { url_ += "itemNos=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductAssetUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductAssetUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NavisionProductAssetUrl>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NavisionProductAssetUrl>;
        }));
    }

    protected processGetProductAssetUrl(response: HttpResponseBase): Observable<NavisionProductAssetUrl> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NavisionProductAssetUrl.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAsset(assetFileName: string | undefined): Observable<DeleteAssetResponseDTO> {
        let url_ = this.baseUrl + "/api/Navision/DeleteAsset?";
        if (assetFileName === null)
            throw new globalThis.Error("The parameter 'assetFileName' cannot be null.");
        else if (assetFileName !== undefined)
            url_ += "assetFileName=" + encodeURIComponent("" + assetFileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteAssetResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteAssetResponseDTO>;
        }));
    }

    protected processDeleteAsset(response: HttpResponseBase): Observable<DeleteAssetResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteAssetResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SalesPersonCodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    searchSalesPersonCodes(take: number | undefined, searchText: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/SalesPersonCode/SearchSalesPersonCodes?";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchText);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSalesPersonCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSalesPersonCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processSearchSalesPersonCodes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SystemInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getSystemInfo(): Observable<SystemInfoDTO> {
        let url_ = this.baseUrl + "/api/SystemInfo/GetSystemInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemInfoDTO>;
        }));
    }

    protected processGetSystemInfo(response: HttpResponseBase): Observable<SystemInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHAInfo(): Observable<HAInfoDTO> {
        let url_ = this.baseUrl + "/api/SystemInfo/GetHAInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHAInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHAInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HAInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HAInfoDTO>;
        }));
    }

    protected processGetHAInfo(response: HttpResponseBase): Observable<HAInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HAInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notifyExecutorPresent(): Observable<void> {
        let url_ = this.baseUrl + "/api/SystemInfo/NotifyExecutorPresent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyExecutorPresent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyExecutorPresent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyExecutorPresent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    info(): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/Info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processInfo(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceUserPassword(userId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/UserAccount/GetServiceUserPassword?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceUserPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceUserPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetServiceUserPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchUsers(clientId: number | null | undefined, skip: number | undefined, take: number | undefined, sortBy: string | null | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfUserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/SearchUsers?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfUserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfUserInfoDTO>;
        }));
    }

    protected processSearchUsers(response: HttpResponseBase): Observable<PagedResultDTOOfUserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfUserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setUserLanguage(language: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/SetUserLanguage?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUserLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(model: UpdateUserInfoDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateInterfaceUser(model: UpdateInterfaceUserInfoDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/UpdateInterfaceUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInterfaceUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInterfaceUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processUpdateInterfaceUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteServiceUser(userId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/DeleteServiceUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteServiceUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAssetStorageGroupMember(userId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/DeleteAssetStorageGroupMember?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssetStorageGroupMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssetStorageGroupMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAssetStorageGroupMember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addInterfaceUser(model: CreateInterfaceUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/AddInterfaceUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddInterfaceUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddInterfaceUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddInterfaceUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addAssetStorageGroupMemberUser(model: CreateUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/AddAssetStorageGroupMemberUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAssetStorageGroupMemberUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAssetStorageGroupMemberUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddAssetStorageGroupMemberUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resendUserOnboardingEmail(userId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/ResendUserOnboardingEmail?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendUserOnboardingEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendUserOnboardingEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendUserOnboardingEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAssetStorageGroupMemberUser(model: UpdateUserInfoDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/UpdateAssetStorageGroupMemberUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetStorageGroupMemberUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetStorageGroupMemberUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processUpdateAssetStorageGroupMemberUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/UserAccount/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(model: ChangePasswordDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/UserAccount/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(newPassword: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/UserAccount/ResetPassword?";
        if (newPassword === null)
            throw new globalThis.Error("The parameter 'newPassword' cannot be null.");
        else if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setPassword(model: SetPasswordDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoleMappingInfo(): Observable<RoleMappingInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/GetRoleMappingInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleMappingInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleMappingInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleMappingInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleMappingInfoDTO>;
        }));
    }

    protected processGetRoleMappingInfo(response: HttpResponseBase): Observable<RoleMappingInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleMappingInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotPassword(model: ForgotPasswordDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    request2FARegistrationCode(dto: Request2FARegistrationCodeDTO): Observable<Request2FARegistrationCodeResponseDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/Request2FARegistrationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequest2FARegistrationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequest2FARegistrationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Request2FARegistrationCodeResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Request2FARegistrationCodeResponseDTO>;
        }));
    }

    protected processRequest2FARegistrationCode(response: HttpResponseBase): Observable<Request2FARegistrationCodeResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Request2FARegistrationCodeResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verify2FARegistrationCode(dto: Verify2FARegistrationCodeDTO): Observable<Verify2FARegistrationCodeResponseDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/Verify2FARegistrationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerify2FARegistrationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerify2FARegistrationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Verify2FARegistrationCodeResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Verify2FARegistrationCodeResponseDTO>;
        }));
    }

    protected processVerify2FARegistrationCode(response: HttpResponseBase): Observable<Verify2FARegistrationCodeResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Verify2FARegistrationCodeResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reset2FARegistration(userId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/Reset2FARegistration?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReset2FARegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReset2FARegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReset2FARegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestSelfReset2FARegistration(dto: RequestSelfReset2FARegistrationDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/RequestSelfReset2FARegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestSelfReset2FARegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestSelfReset2FARegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestSelfReset2FARegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZirWebhookClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    receiveZirWebhook(webhook: ZirWebhookEventDTO): Observable<ZirWebhookResponseDTO> {
        let url_ = this.baseUrl + "/api/ZirWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webhook);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReceiveZirWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReceiveZirWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZirWebhookResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZirWebhookResponseDTO>;
        }));
    }

    protected processReceiveZirWebhook(response: HttpResponseBase): Observable<ZirWebhookResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZirWebhookResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CreditMemoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getCreditMemos(customerId: string | undefined): Observable<CreditMemoDTO[]> {
        let url_ = this.baseUrl + "/api/Webshop/GetCreditMemos?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreditMemos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreditMemos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreditMemoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreditMemoDTO[]>;
        }));
    }

    protected processGetCreditMemos(response: HttpResponseBase): Observable<CreditMemoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditMemoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopAssetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getChangedProductAssets(assetTypes: AssetType[] | null | undefined, shopIds: string[] | null | undefined, skUs: string[] | null | undefined, changedSince: DateTime | null | undefined, skip: number | undefined, take: number | undefined): Observable<WebshopProductAssetDTO[]> {
        let url_ = this.baseUrl + "/api/Webshop/GetChangedProductAssets?";
        if (assetTypes !== undefined && assetTypes !== null)
            assetTypes && assetTypes.forEach(item => { url_ += "assetTypes=" + encodeURIComponent("" + item) + "&"; });
        if (shopIds !== undefined && shopIds !== null)
            shopIds && shopIds.forEach(item => { url_ += "shopIds=" + encodeURIComponent("" + item) + "&"; });
        if (skUs !== undefined && skUs !== null)
            skUs && skUs.forEach(item => { url_ += "skUs=" + encodeURIComponent("" + item) + "&"; });
        if (changedSince !== undefined && changedSince !== null)
            url_ += "changedSince=" + encodeURIComponent(changedSince ? "" + changedSince.toString() : "") + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangedProductAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangedProductAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebshopProductAssetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebshopProductAssetDTO[]>;
        }));
    }

    protected processGetChangedProductAssets(response: HttpResponseBase): Observable<WebshopProductAssetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebshopProductAssetDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setProductAssetsStatus(dto: SetProductAssetsStatusDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/Webshop/SetProductAssetsStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProductAssetsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProductAssetsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetProductAssetsStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopAttributeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getAttributes(skip: number | undefined, take: number | undefined): Observable<GetAttributeListResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetAttributes?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttributeListResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttributeListResponseDTO>;
        }));
    }

    protected processGetAttributes(response: HttpResponseBase): Observable<GetAttributeListResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttributeListResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopBaseProductClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getProducts(languageIso: string | null | undefined, countryIso: string | null | undefined, sKUs: string[] | null | undefined, skip: number | undefined, take: number | undefined, includeAssets: boolean | undefined): Observable<GetProductListResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetProducts?";
        if (languageIso !== undefined && languageIso !== null)
            url_ += "languageIso=" + encodeURIComponent("" + languageIso) + "&";
        if (countryIso !== undefined && countryIso !== null)
            url_ += "countryIso=" + encodeURIComponent("" + countryIso) + "&";
        if (sKUs !== undefined && sKUs !== null)
            sKUs && sKUs.forEach(item => { url_ += "sKUs=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (includeAssets === null)
            throw new globalThis.Error("The parameter 'includeAssets' cannot be null.");
        else if (includeAssets !== undefined)
            url_ += "includeAssets=" + encodeURIComponent("" + includeAssets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProductListResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProductListResponseDTO>;
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<GetProductListResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductListResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductGameList(sKUs: string[] | null | undefined, skip: number | undefined, take: number | undefined): Observable<GetProductGameListResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetProductGameList?";
        if (sKUs !== undefined && sKUs !== null)
            sKUs && sKUs.forEach(item => { url_ += "sKUs=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductGameList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductGameList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProductGameListResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProductGameListResponseDTO>;
        }));
    }

    protected processGetProductGameList(response: HttpResponseBase): Observable<GetProductGameListResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductGameListResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setShopProductUrls(setShopProductUrlsDTO: SetShopProductUrlsDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/Webshop/SetShopProductUrls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setShopProductUrlsDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetShopProductUrls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetShopProductUrls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetShopProductUrls(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopBrandClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getBrands(countryIso: string | null | undefined): Observable<GetBrandsResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetBrands?";
        if (countryIso !== undefined && countryIso !== null)
            url_ += "countryIso=" + encodeURIComponent("" + countryIso) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBrandsResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBrandsResponseDTO>;
        }));
    }

    protected processGetBrands(response: HttpResponseBase): Observable<GetBrandsResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBrandsResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebShopBTOClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getBTODetails(btoReferenceNumber: string | undefined): Observable<BTODetailsDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetBTODetails?";
        if (btoReferenceNumber === null)
            throw new globalThis.Error("The parameter 'btoReferenceNumber' cannot be null.");
        else if (btoReferenceNumber !== undefined)
            url_ += "btoReferenceNumber=" + encodeURIComponent("" + btoReferenceNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBTODetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBTODetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BTODetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BTODetailsDTO>;
        }));
    }

    protected processGetBTODetails(response: HttpResponseBase): Observable<BTODetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BTODetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getCategories(countryIso: string | null | undefined): Observable<GetCategoriesResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetCategories?";
        if (countryIso !== undefined && countryIso !== null)
            url_ += "countryIso=" + encodeURIComponent("" + countryIso) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCategoriesResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCategoriesResponseDTO>;
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<GetCategoriesResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCategoriesResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopCountryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getCountryPrices(countryCode: string | undefined, shopId: string | null | undefined, skUs: string[] | null | undefined, skip: number | undefined, take: number | undefined): Observable<GetCountryProductPriceResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetCountryPrices?";
        if (countryCode === null)
            throw new globalThis.Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (shopId !== undefined && shopId !== null)
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        if (skUs !== undefined && skUs !== null)
            skUs && skUs.forEach(item => { url_ += "skUs=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCountryProductPriceResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCountryProductPriceResponseDTO>;
        }));
    }

    protected processGetCountryPrices(response: HttpResponseBase): Observable<GetCountryProductPriceResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCountryProductPriceResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountryStock(countryCode: string | undefined, shopId: string | null | undefined, skUs: string[] | null | undefined): Observable<GetCountryStockResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetCountryStock?";
        if (countryCode === null)
            throw new globalThis.Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (shopId !== undefined && shopId !== null)
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        if (skUs !== undefined && skUs !== null)
            skUs && skUs.forEach(item => { url_ += "skUs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCountryStockResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCountryStockResponseDTO>;
        }));
    }

    protected processGetCountryStock(response: HttpResponseBase): Observable<GetCountryStockResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCountryStockResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopCustomerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getCustomerInformation(contactId: number | undefined, countryCodeIso: string | null | undefined): Observable<CustomerInformationDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetCustomerInformation?";
        if (contactId === null)
            throw new globalThis.Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        if (countryCodeIso !== undefined && countryCodeIso !== null)
            url_ += "countryCodeIso=" + encodeURIComponent("" + countryCodeIso) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerInformationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerInformationDTO>;
        }));
    }

    protected processGetCustomerInformation(response: HttpResponseBase): Observable<CustomerInformationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerInformationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkCredentials(credentialsDTO: CheckCredentialsDTO): Observable<CheckCredentialsResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/CheckCredentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(credentialsDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckCredentialsResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckCredentialsResultDTO>;
        }));
    }

    protected processCheckCredentials(response: HttpResponseBase): Observable<CheckCredentialsResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckCredentialsResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    register(registrationDTO: CustomerRegistrationDTO): Observable<CustomerRegistrationResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registrationDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerRegistrationResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerRegistrationResponseDTO>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<CustomerRegistrationResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerRegistrationResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopCustomerProductPriceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getCustomerProductPrices(customerNo: string | undefined, currencyCode: string | undefined, skUs: string[] | null | undefined, skip: number | undefined, take: number | undefined): Observable<GetProductPriceResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetCustomerProductPrices?";
        if (customerNo === null)
            throw new globalThis.Error("The parameter 'customerNo' cannot be null.");
        else if (customerNo !== undefined)
            url_ += "customerNo=" + encodeURIComponent("" + customerNo) + "&";
        if (currencyCode === null)
            throw new globalThis.Error("The parameter 'currencyCode' cannot be null.");
        else if (currencyCode !== undefined)
            url_ += "currencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        if (skUs !== undefined && skUs !== null)
            skUs && skUs.forEach(item => { url_ += "skUs=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerProductPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerProductPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProductPriceResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProductPriceResponseDTO>;
        }));
    }

    protected processGetCustomerProductPrices(response: HttpResponseBase): Observable<GetProductPriceResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductPriceResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerExcludedProducts(customerNo: string | undefined, currencyCode: string | undefined): Observable<GetExcludedProductResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetCustomerExcludedProducts?";
        if (customerNo === null)
            throw new globalThis.Error("The parameter 'customerNo' cannot be null.");
        else if (customerNo !== undefined)
            url_ += "customerNo=" + encodeURIComponent("" + customerNo) + "&";
        if (currencyCode === null)
            throw new globalThis.Error("The parameter 'currencyCode' cannot be null.");
        else if (currencyCode !== undefined)
            url_ += "currencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerExcludedProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerExcludedProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExcludedProductResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExcludedProductResponseDTO>;
        }));
    }

    protected processGetCustomerExcludedProducts(response: HttpResponseBase): Observable<GetExcludedProductResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExcludedProductResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerProductPriceCsv(customerNo: string | undefined, currencyCode: string | undefined, languageCodeIso: string | undefined): Observable<CsvDataDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetCustomerProductPriceCsv?";
        if (customerNo === null)
            throw new globalThis.Error("The parameter 'customerNo' cannot be null.");
        else if (customerNo !== undefined)
            url_ += "customerNo=" + encodeURIComponent("" + customerNo) + "&";
        if (currencyCode === null)
            throw new globalThis.Error("The parameter 'currencyCode' cannot be null.");
        else if (currencyCode !== undefined)
            url_ += "currencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        if (languageCodeIso === null)
            throw new globalThis.Error("The parameter 'languageCodeIso' cannot be null.");
        else if (languageCodeIso !== undefined)
            url_ += "languageCodeIso=" + encodeURIComponent("" + languageCodeIso) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerProductPriceCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerProductPriceCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CsvDataDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CsvDataDTO>;
        }));
    }

    protected processGetCustomerProductPriceCsv(response: HttpResponseBase): Observable<CsvDataDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CsvDataDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopCustomerProductStockClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getCustomerProductStocks(customerNo: string | undefined, currencyCode: string | undefined, skUs: string[] | null | undefined, skip: number | undefined, take: number | undefined): Observable<GetCustomerProductStockResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetCustomerProductStocks?";
        if (customerNo === null)
            throw new globalThis.Error("The parameter 'customerNo' cannot be null.");
        else if (customerNo !== undefined)
            url_ += "customerNo=" + encodeURIComponent("" + customerNo) + "&";
        if (currencyCode === null)
            throw new globalThis.Error("The parameter 'currencyCode' cannot be null.");
        else if (currencyCode !== undefined)
            url_ += "currencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        if (skUs !== undefined && skUs !== null)
            skUs && skUs.forEach(item => { url_ += "skUs=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerProductStocks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerProductStocks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerProductStockResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerProductStockResponseDTO>;
        }));
    }

    protected processGetCustomerProductStocks(response: HttpResponseBase): Observable<GetCustomerProductStockResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomerProductStockResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerProductStockCsv(customerNo: string | undefined, currencyCode: string | undefined, languageCodeIso: string | undefined): Observable<CsvDataDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetCustomerProductStockCsv?";
        if (customerNo === null)
            throw new globalThis.Error("The parameter 'customerNo' cannot be null.");
        else if (customerNo !== undefined)
            url_ += "customerNo=" + encodeURIComponent("" + customerNo) + "&";
        if (currencyCode === null)
            throw new globalThis.Error("The parameter 'currencyCode' cannot be null.");
        else if (currencyCode !== undefined)
            url_ += "currencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        if (languageCodeIso === null)
            throw new globalThis.Error("The parameter 'languageCodeIso' cannot be null.");
        else if (languageCodeIso !== undefined)
            url_ += "languageCodeIso=" + encodeURIComponent("" + languageCodeIso) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerProductStockCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerProductStockCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CsvDataDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CsvDataDTO>;
        }));
    }

    protected processGetCustomerProductStockCsv(response: HttpResponseBase): Observable<CsvDataDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CsvDataDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopDocumentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getDocument(documentType: DocumentType | undefined, customerId: string | undefined, documentId: string | undefined): Observable<DocumentBase64DTO | null> {
        let url_ = this.baseUrl + "/api/Webshop/GetDocument?";
        if (documentType === null)
            throw new globalThis.Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (documentId === null)
            throw new globalThis.Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentBase64DTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentBase64DTO | null>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<DocumentBase64DTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DocumentBase64DTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopInvoiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getInvoice(customerId: string | undefined, invoiceId: string | undefined): Observable<InvoiceDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetInvoice?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDTO>;
        }));
    }

    protected processGetInvoice(response: HttpResponseBase): Observable<InvoiceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOpenInvoices(customerId: string | undefined): Observable<OpenInvoiceDTO[]> {
        let url_ = this.baseUrl + "/api/Webshop/GetOpenInvoices?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpenInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpenInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpenInvoiceDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpenInvoiceDTO[]>;
        }));
    }

    protected processGetOpenInvoices(response: HttpResponseBase): Observable<OpenInvoiceDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpenInvoiceDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebShopNavisionWindowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getNavisionSales(customerId: string | undefined, languageCodeIso: string | undefined, invoiceNoOrShipmentNoOrItemNo: string | undefined, dateFromIso: string | null | undefined): Observable<GetNavisionSalesResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetNavisionSales?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (languageCodeIso === null)
            throw new globalThis.Error("The parameter 'languageCodeIso' cannot be null.");
        else if (languageCodeIso !== undefined)
            url_ += "languageCodeIso=" + encodeURIComponent("" + languageCodeIso) + "&";
        if (invoiceNoOrShipmentNoOrItemNo === null)
            throw new globalThis.Error("The parameter 'invoiceNoOrShipmentNoOrItemNo' cannot be null.");
        else if (invoiceNoOrShipmentNoOrItemNo !== undefined)
            url_ += "invoiceNoOrShipmentNoOrItemNo=" + encodeURIComponent("" + invoiceNoOrShipmentNoOrItemNo) + "&";
        if (dateFromIso !== undefined && dateFromIso !== null)
            url_ += "dateFromIso=" + encodeURIComponent("" + dateFromIso) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNavisionSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNavisionSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNavisionSalesResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNavisionSalesResponseDTO>;
        }));
    }

    protected processGetNavisionSales(response: HttpResponseBase): Observable<GetNavisionSalesResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNavisionSalesResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNavisionBacklog(customerId: string | undefined, languageCodeIso: string | undefined, searchInput: string | undefined, dateFromIso: string | null | undefined): Observable<GetNavisionBacklogResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetNavisionBacklog?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (languageCodeIso === null)
            throw new globalThis.Error("The parameter 'languageCodeIso' cannot be null.");
        else if (languageCodeIso !== undefined)
            url_ += "languageCodeIso=" + encodeURIComponent("" + languageCodeIso) + "&";
        if (searchInput === null)
            throw new globalThis.Error("The parameter 'searchInput' cannot be null.");
        else if (searchInput !== undefined)
            url_ += "searchInput=" + encodeURIComponent("" + searchInput) + "&";
        if (dateFromIso !== undefined && dateFromIso !== null)
            url_ += "dateFromIso=" + encodeURIComponent("" + dateFromIso) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNavisionBacklog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNavisionBacklog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNavisionBacklogResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNavisionBacklogResponseDTO>;
        }));
    }

    protected processGetNavisionBacklog(response: HttpResponseBase): Observable<GetNavisionBacklogResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNavisionBacklogResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoiceBase64(customerId: string | undefined, invoiceNumber: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Webshop/GetInvoiceBase64?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (invoiceNumber === null)
            throw new globalThis.Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceBase64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetInvoiceBase64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopNewsletterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    subscribeToNewsletters(contactUniqueKey: string | null | undefined, contactId: string | null | undefined, subscriptionDetails: SubscribeToNewsLetterDTO): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webshop/SubscribeToNewsletters?";
        if (contactUniqueKey !== undefined && contactUniqueKey !== null)
            url_ += "contactUniqueKey=" + encodeURIComponent("" + contactUniqueKey) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionDetails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribeToNewsletters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribeToNewsletters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSubscribeToNewsletters(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNewsletterSubscriptions(languageCodeIso: string | undefined, contactUniqueKey: string | null | undefined, contactId: string | null | undefined): Observable<GetNewsletterSubscriptionsDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetNewsletterSubscriptions?";
        if (languageCodeIso === null)
            throw new globalThis.Error("The parameter 'languageCodeIso' cannot be null.");
        else if (languageCodeIso !== undefined)
            url_ += "languageCodeIso=" + encodeURIComponent("" + languageCodeIso) + "&";
        if (contactUniqueKey !== undefined && contactUniqueKey !== null)
            url_ += "contactUniqueKey=" + encodeURIComponent("" + contactUniqueKey) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewsletterSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsletterSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNewsletterSubscriptionsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNewsletterSubscriptionsDTO>;
        }));
    }

    protected processGetNewsletterSubscriptions(response: HttpResponseBase): Observable<GetNewsletterSubscriptionsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsletterSubscriptionsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    doubleOptInNewsletter(ipAddress: string | undefined, contactUniqueKey: string | null | undefined, contactId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webshop/DoubleOptInNewsletter?";
        if (ipAddress === null)
            throw new globalThis.Error("The parameter 'ipAddress' cannot be null.");
        else if (ipAddress !== undefined)
            url_ += "ipAddress=" + encodeURIComponent("" + ipAddress) + "&";
        if (contactUniqueKey !== undefined && contactUniqueKey !== null)
            url_ += "contactUniqueKey=" + encodeURIComponent("" + contactUniqueKey) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoubleOptInNewsletter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoubleOptInNewsletter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDoubleOptInNewsletter(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getShopOrderShippingInfo(shopOrderIds: string[] | undefined): Observable<GetShopOrderShippingInfoResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetShopOrderShippingInfo?";
        if (shopOrderIds === null)
            throw new globalThis.Error("The parameter 'shopOrderIds' cannot be null.");
        else if (shopOrderIds !== undefined)
            shopOrderIds && shopOrderIds.forEach(item => { url_ += "shopOrderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopOrderShippingInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopOrderShippingInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShopOrderShippingInfoResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShopOrderShippingInfoResultDTO>;
        }));
    }

    protected processGetShopOrderShippingInfo(response: HttpResponseBase): Observable<GetShopOrderShippingInfoResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShopOrderShippingInfoResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShopOrderInvoiceInfo(shopOrderIds: string[] | undefined): Observable<GetShopOrderInvoiceInfoResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetShopOrderInvoiceInfo?";
        if (shopOrderIds === null)
            throw new globalThis.Error("The parameter 'shopOrderIds' cannot be null.");
        else if (shopOrderIds !== undefined)
            shopOrderIds && shopOrderIds.forEach(item => { url_ += "shopOrderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopOrderInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopOrderInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShopOrderInvoiceInfoResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShopOrderInvoiceInfoResultDTO>;
        }));
    }

    protected processGetShopOrderInvoiceInfo(response: HttpResponseBase): Observable<GetShopOrderInvoiceInfoResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShopOrderInvoiceInfoResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShopOrderPaymentInfo(shopOrderIds: string[] | undefined): Observable<GetShopOrderPaymentInfoResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetShopOrderPaymentInfo?";
        if (shopOrderIds === null)
            throw new globalThis.Error("The parameter 'shopOrderIds' cannot be null.");
        else if (shopOrderIds !== undefined)
            shopOrderIds && shopOrderIds.forEach(item => { url_ += "shopOrderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopOrderPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopOrderPaymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShopOrderPaymentInfoResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShopOrderPaymentInfoResultDTO>;
        }));
    }

    protected processGetShopOrderPaymentInfo(response: HttpResponseBase): Observable<GetShopOrderPaymentInfoResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShopOrderPaymentInfoResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createShopOrder(shopOrderCreateDTO: ShopOrderCreateDTO): Observable<ShopOrderCreateResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shopOrderCreateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShopOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShopOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopOrderCreateResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopOrderCreateResultDTO>;
        }));
    }

    protected processCreateShopOrder(response: HttpResponseBase): Observable<ShopOrderCreateResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopOrderCreateResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createJouleShopOrder(jouleShopOrderCreateDTO: JouleShopOrderCreateDTO): Observable<JouleShopOrderCreateResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/CreateJouleShopOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jouleShopOrderCreateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJouleShopOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJouleShopOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JouleShopOrderCreateResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JouleShopOrderCreateResultDTO>;
        }));
    }

    protected processCreateJouleShopOrder(response: HttpResponseBase): Observable<JouleShopOrderCreateResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JouleShopOrderCreateResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShopOrderStatus(shopOrderIds: string[] | undefined): Observable<GetShopOrderStatusResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetShopOrderStatus?";
        if (shopOrderIds === null)
            throw new globalThis.Error("The parameter 'shopOrderIds' cannot be null.");
        else if (shopOrderIds !== undefined)
            shopOrderIds && shopOrderIds.forEach(item => { url_ += "shopOrderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopOrderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopOrderStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShopOrderStatusResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShopOrderStatusResultDTO>;
        }));
    }

    protected processGetShopOrderStatus(response: HttpResponseBase): Observable<GetShopOrderStatusResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShopOrderStatusResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getProfiles(skip: number | undefined, take: number | undefined): Observable<GetProfileListResponseDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetProfiles?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfileListResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfileListResponseDTO>;
        }));
    }

    protected processGetProfiles(response: HttpResponseBase): Observable<GetProfileListResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfileListResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebshopRMAClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getReasons(): Observable<RMAReasonsResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/GetReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RMAReasonsResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RMAReasonsResultDTO>;
        }));
    }

    protected processGetReasons(response: HttpResponseBase): Observable<RMAReasonsResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RMAReasonsResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchRMA(customerId: string | undefined, shipmentOrInvoiceOrSerialNo: string | undefined): Observable<RMASearchResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/SearchRMA?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (shipmentOrInvoiceOrSerialNo === null)
            throw new globalThis.Error("The parameter 'shipmentOrInvoiceOrSerialNo' cannot be null.");
        else if (shipmentOrInvoiceOrSerialNo !== undefined)
            url_ += "shipmentOrInvoiceOrSerialNo=" + encodeURIComponent("" + shipmentOrInvoiceOrSerialNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchRMA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchRMA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RMASearchResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RMASearchResultDTO>;
        }));
    }

    protected processSearchRMA(response: HttpResponseBase): Observable<RMASearchResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RMASearchResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createRMA(rmaCreateDTO: RMACreateDTO): Observable<RMACreateResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/CreateRMA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rmaCreateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRMA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRMA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RMACreateResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RMACreateResultDTO>;
        }));
    }

    protected processCreateRMA(response: HttpResponseBase): Observable<RMACreateResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RMACreateResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchRMATickets(customerId: string | undefined, languageCodeIso: string | undefined, ticketNoOrSerialNoOrSKU: string | undefined): Observable<RMAGetResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/SearchRMATickets?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (languageCodeIso === null)
            throw new globalThis.Error("The parameter 'languageCodeIso' cannot be null.");
        else if (languageCodeIso !== undefined)
            url_ += "languageCodeIso=" + encodeURIComponent("" + languageCodeIso) + "&";
        if (ticketNoOrSerialNoOrSKU === null)
            throw new globalThis.Error("The parameter 'ticketNoOrSerialNoOrSKU' cannot be null.");
        else if (ticketNoOrSerialNoOrSKU !== undefined)
            url_ += "ticketNoOrSerialNoOrSKU=" + encodeURIComponent("" + ticketNoOrSerialNoOrSKU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchRMATickets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchRMATickets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RMAGetResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RMAGetResultDTO>;
        }));
    }

    protected processSearchRMATickets(response: HttpResponseBase): Observable<RMAGetResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RMAGetResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSystemSerialNumberInformation(serialNumber: string | undefined): Observable<SystemSerialNumberInformationDTO | null> {
        let url_ = this.baseUrl + "/api/Webshop/GetSystemSerialNumberInformation?";
        if (serialNumber === null)
            throw new globalThis.Error("The parameter 'serialNumber' cannot be null.");
        else if (serialNumber !== undefined)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemSerialNumberInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemSerialNumberInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemSerialNumberInformationDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemSerialNumberInformationDTO | null>;
        }));
    }

    protected processGetSystemSerialNumberInformation(response: HttpResponseBase): Observable<SystemSerialNumberInformationDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SystemSerialNumberInformationDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createJouleRMA(rmaCreateDTO: JouleRMACreateDTO): Observable<RMACreateResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/CreateJouleRMA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rmaCreateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJouleRMA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJouleRMA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RMACreateResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RMACreateResultDTO>;
        }));
    }

    protected processCreateJouleRMA(response: HttpResponseBase): Observable<RMACreateResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RMACreateResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VendorScoreCardAdminClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getAllVendorScoreCardAdminData(): Observable<VendorScoreCardAdminDataDTO[]> {
        let url_ = this.baseUrl + "/api/VendorScoreCardAdmin/GetAllVendorScoreCardAdminData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVendorScoreCardAdminData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVendorScoreCardAdminData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorScoreCardAdminDataDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorScoreCardAdminDataDTO[]>;
        }));
    }

    protected processGetAllVendorScoreCardAdminData(response: HttpResponseBase): Observable<VendorScoreCardAdminDataDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorScoreCardAdminDataDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAllVendorScoreCardAdminData(dto: UpdateVendorScoreCardAdminDataDTO[]): Observable<VendorScoreCardAdminDataDTO[]> {
        let url_ = this.baseUrl + "/api/VendorScoreCardAdmin/UpdateAllVendorScoreCardAdminData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllVendorScoreCardAdminData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllVendorScoreCardAdminData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorScoreCardAdminDataDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorScoreCardAdminDataDTO[]>;
        }));
    }

    protected processUpdateAllVendorScoreCardAdminData(response: HttpResponseBase): Observable<VendorScoreCardAdminDataDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorScoreCardAdminDataDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VendorScoreCardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    createVendorScoreCard(dto: CreateVendorScoreCardDTO): Observable<VendorScoreCardDTO> {
        let url_ = this.baseUrl + "/api/VendorScoreCard/CreateVendorScoreCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVendorScoreCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendorScoreCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorScoreCardDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorScoreCardDTO>;
        }));
    }

    protected processCreateVendorScoreCard(response: HttpResponseBase): Observable<VendorScoreCardDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VendorScoreCardDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resendVendorScoreCardEmail(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/VendorScoreCard/ResendVendorScoreCardEmail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendVendorScoreCardEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendVendorScoreCardEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendVendorScoreCardEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllVendorScoreCardVendorDataByCardId(vendorScoreCardId: number | undefined): Observable<VendorScoreCardOverviewExtendedDTO> {
        let url_ = this.baseUrl + "/api/VendorScoreCard/GetAllVendorScoreCardVendorDataByCardId?";
        if (vendorScoreCardId === null)
            throw new globalThis.Error("The parameter 'vendorScoreCardId' cannot be null.");
        else if (vendorScoreCardId !== undefined)
            url_ += "vendorScoreCardId=" + encodeURIComponent("" + vendorScoreCardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVendorScoreCardVendorDataByCardId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVendorScoreCardVendorDataByCardId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorScoreCardOverviewExtendedDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorScoreCardOverviewExtendedDTO>;
        }));
    }

    protected processGetAllVendorScoreCardVendorDataByCardId(response: HttpResponseBase): Observable<VendorScoreCardOverviewExtendedDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VendorScoreCardOverviewExtendedDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVendorScoreCard(vendorScoreCardId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/VendorScoreCard/DeleteVendorScoreCard?";
        if (vendorScoreCardId === null)
            throw new globalThis.Error("The parameter 'vendorScoreCardId' cannot be null.");
        else if (vendorScoreCardId !== undefined)
            url_ += "vendorScoreCardId=" + encodeURIComponent("" + vendorScoreCardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVendorScoreCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVendorScoreCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteVendorScoreCard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchVendorScoreCards(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfVendorScoreCardOverviewDTO> {
        let url_ = this.baseUrl + "/api/VendorScoreCard/SearchVendorScoreCards?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchVendorScoreCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchVendorScoreCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfVendorScoreCardOverviewDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfVendorScoreCardOverviewDTO>;
        }));
    }

    protected processSearchVendorScoreCards(response: HttpResponseBase): Observable<PagedResultDTOOfVendorScoreCardOverviewDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfVendorScoreCardOverviewDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VendorScoreCardSurveyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    createVendorScoreCardSurveyData(dto: CreateVendorScoreCardSurveyDataDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/VendorScoreCardSurvey/CreateVendorScoreCardSurveyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVendorScoreCardSurveyData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendorScoreCardSurveyData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateVendorScoreCardSurveyData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVendorScoreCardByAccessToken(accessToken: string | undefined): Observable<VendorScoreCardOverviewDTO> {
        let url_ = this.baseUrl + "/api/VendorScoreCardSurvey/GetVendorScoreCardByAccessToken?";
        if (accessToken === null)
            throw new globalThis.Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorScoreCardByAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorScoreCardByAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorScoreCardOverviewDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorScoreCardOverviewDTO>;
        }));
    }

    protected processGetVendorScoreCardByAccessToken(response: HttpResponseBase): Observable<VendorScoreCardOverviewDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VendorScoreCardOverviewDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmailAccountSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getEmailAccountSettings(id: number | undefined): Observable<EmailAccountSettingsDTO> {
        let url_ = this.baseUrl + "/api/settings/EmailAccountSettings/GetEmailAccountSettings?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailAccountSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailAccountSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAccountSettingsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAccountSettingsDTO>;
        }));
    }

    protected processGetEmailAccountSettings(response: HttpResponseBase): Observable<EmailAccountSettingsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailAccountSettingsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEmailAccountSettings(dto: CreateEmailAccountSettingsDTO): Observable<EmailAccountSettingsDTO> {
        let url_ = this.baseUrl + "/api/settings/EmailAccountSettings/CreateEmailAccountSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmailAccountSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmailAccountSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAccountSettingsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAccountSettingsDTO>;
        }));
    }

    protected processCreateEmailAccountSettings(response: HttpResponseBase): Observable<EmailAccountSettingsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailAccountSettingsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEmailAccountSettings(dto: UpdateEmailAccountSettingsDTO): Observable<EmailAccountSettingsDTO> {
        let url_ = this.baseUrl + "/api/settings/EmailAccountSettings/UpdateEmailAccountSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmailAccountSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmailAccountSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAccountSettingsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAccountSettingsDTO>;
        }));
    }

    protected processUpdateEmailAccountSettings(response: HttpResponseBase): Observable<EmailAccountSettingsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailAccountSettingsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchEmailAccountSettings(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[]): Observable<PagedResultDTOOfEmailAccountSettingsDTO | null> {
        let url_ = this.baseUrl + "/api/settings/EmailAccountSettings/SearchEmailAccountSettings?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEmailAccountSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEmailAccountSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfEmailAccountSettingsDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfEmailAccountSettingsDTO | null>;
        }));
    }

    protected processSearchEmailAccountSettings(response: HttpResponseBase): Observable<PagedResultDTOOfEmailAccountSettingsDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfEmailAccountSettingsDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEmailAccountSettings(id: number | undefined): Observable<DeleteEmailAccountSettingsResultDTO> {
        let url_ = this.baseUrl + "/api/settings/EmailAccountSettings/DeleteEmailAccountSettings?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEmailAccountSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmailAccountSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteEmailAccountSettingsResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteEmailAccountSettingsResultDTO>;
        }));
    }

    protected processDeleteEmailAccountSettings(response: HttpResponseBase): Observable<DeleteEmailAccountSettingsResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteEmailAccountSettingsResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendTestEmail(toEmail: string | undefined, dto: CreateEmailAccountSettingsDTO): Observable<EmailProcessResultDTO> {
        let url_ = this.baseUrl + "/api/settings/EmailAccountSettings/SendTestEmail?";
        if (toEmail === null)
            throw new globalThis.Error("The parameter 'toEmail' cannot be null.");
        else if (toEmail !== undefined)
            url_ += "toEmail=" + encodeURIComponent("" + toEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailProcessResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailProcessResultDTO>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<EmailProcessResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailProcessResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testConnection(dto: CreateEmailAccountSettingsDTO): Observable<ProcessResultDTO> {
        let url_ = this.baseUrl + "/api/settings/EmailAccountSettings/TestConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessResultDTO>;
        }));
    }

    protected processTestConnection(response: HttpResponseBase): Observable<ProcessResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOutEmailAccounts(): Observable<EmailAccountSettingsLimitedDTO[]> {
        let url_ = this.baseUrl + "/api/settings/EmailAccountSettings/GetOutEmailAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutEmailAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutEmailAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAccountSettingsLimitedDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAccountSettingsLimitedDTO[]>;
        }));
    }

    protected processGetOutEmailAccounts(response: HttpResponseBase): Observable<EmailAccountSettingsLimitedDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailAccountSettingsLimitedDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInEmailAccounts(): Observable<EmailAccountSettingsLimitedDTO[]> {
        let url_ = this.baseUrl + "/api/settings/EmailAccountSettings/GetInEmailAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInEmailAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInEmailAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAccountSettingsLimitedDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAccountSettingsLimitedDTO[]>;
        }));
    }

    protected processGetInEmailAccounts(response: HttpResponseBase): Observable<EmailAccountSettingsLimitedDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailAccountSettingsLimitedDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParashiftDocumentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    processOutput(output: ParashiftDocumentOutputDTO): Observable<ParashiftDocumentResponseDTO> {
        let url_ = this.baseUrl + "/api/ParashiftDocument/ProcessOutput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(output);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessOutput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessOutput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParashiftDocumentResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParashiftDocumentResponseDTO>;
        }));
    }

    protected processProcessOutput(response: HttpResponseBase): Observable<ParashiftDocumentResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParashiftDocumentResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImportProcessResultClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    notifyProcessResult(dto: ImportProcessResultDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ImportProcessResult/NotifyProcessResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyProcessResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyProcessResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyProcessResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SalesOrderImportProcessResultClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    saveSalesOrderImportProcessResult(dto: SalesOrderImportNavisionProcessResultServiceMessageDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/SalesOrderImportProcessResult/SaveSalesOrderImportProcessResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSalesOrderImportProcessResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSalesOrderImportProcessResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveSalesOrderImportProcessResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AcodisWorkflowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getAcodisWorkflow(id: number | undefined): Observable<AcodisWorkflowDTO> {
        let url_ = this.baseUrl + "/api/import/AcodisWorkflow/GetAcodisWorkflow?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcodisWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcodisWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcodisWorkflowDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcodisWorkflowDTO>;
        }));
    }

    protected processGetAcodisWorkflow(response: HttpResponseBase): Observable<AcodisWorkflowDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcodisWorkflowDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllAcodisWorkflows(importType: ImportType | null | undefined): Observable<AcodisWorkflowLimitedDTO[]> {
        let url_ = this.baseUrl + "/api/import/AcodisWorkflow/GetAllAcodisWorkflows?";
        if (importType !== undefined && importType !== null)
            url_ += "importType=" + encodeURIComponent("" + importType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAcodisWorkflows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAcodisWorkflows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcodisWorkflowLimitedDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcodisWorkflowLimitedDTO[]>;
        }));
    }

    protected processGetAllAcodisWorkflows(response: HttpResponseBase): Observable<AcodisWorkflowLimitedDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AcodisWorkflowLimitedDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchAcodisWorkflows(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfAcodisWorkflowDTO> {
        let url_ = this.baseUrl + "/api/import/AcodisWorkflow/SearchAcodisWorkflows?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAcodisWorkflows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAcodisWorkflows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfAcodisWorkflowDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfAcodisWorkflowDTO>;
        }));
    }

    protected processSearchAcodisWorkflows(response: HttpResponseBase): Observable<PagedResultDTOOfAcodisWorkflowDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfAcodisWorkflowDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAcodisWorkflow(workflow: AcodisWorkflowDTO | undefined): Observable<AcodisWorkflowDTO> {
        let url_ = this.baseUrl + "/api/import/AcodisWorkflow/CreateAcodisWorkflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workflow);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAcodisWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAcodisWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcodisWorkflowDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcodisWorkflowDTO>;
        }));
    }

    protected processCreateAcodisWorkflow(response: HttpResponseBase): Observable<AcodisWorkflowDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcodisWorkflowDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAcodisWorkflow(workflow: AcodisWorkflowDTO): Observable<AcodisWorkflowDTO> {
        let url_ = this.baseUrl + "/api/import/AcodisWorkflow/UpdateAcodisWorkflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workflow);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAcodisWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAcodisWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcodisWorkflowDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcodisWorkflowDTO>;
        }));
    }

    protected processUpdateAcodisWorkflow(response: HttpResponseBase): Observable<AcodisWorkflowDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcodisWorkflowDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAcodisWorkflow(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/import/AcodisWorkflow/DeleteAcodisWorkflow?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAcodisWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAcodisWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAcodisWorkflow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAcodisWorkflowCategories(workflowId: number | undefined): Observable<AcodisCategoryDTO[]> {
        let url_ = this.baseUrl + "/api/import/AcodisWorkflow/GetAcodisWorkflowCategories?";
        if (workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcodisWorkflowCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcodisWorkflowCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcodisCategoryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcodisCategoryDTO[]>;
        }));
    }

    protected processGetAcodisWorkflowCategories(response: HttpResponseBase): Observable<AcodisCategoryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AcodisCategoryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testAcodisWorkflow(workflow: AcodisWorkflowDTO): Observable<AcodisWorkflowTestResult> {
        let url_ = this.baseUrl + "/api/import/AcodisWorkflow/TestAcodisWorkflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workflow);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestAcodisWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestAcodisWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcodisWorkflowTestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcodisWorkflowTestResult>;
        }));
    }

    protected processTestAcodisWorkflow(response: HttpResponseBase): Observable<AcodisWorkflowTestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcodisWorkflowTestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AS2MessageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    post(): Observable<void> {
        let url_ = this.baseUrl + "/api/import/AS2Message";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImportConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getImportConfiguration(id: number | undefined): Observable<ImportConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/GetImportConfiguration?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportConfigurationDTO>;
        }));
    }

    protected processGetImportConfiguration(response: HttpResponseBase): Observable<ImportConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchImportConfigurations(clientId: number | null | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfImportConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/SearchImportConfigurations?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchImportConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchImportConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfImportConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfImportConfigurationDTO>;
        }));
    }

    protected processSearchImportConfigurations(response: HttpResponseBase): Observable<PagedResultDTOOfImportConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfImportConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createImportConfiguration(dto: ImportConfigurationDTO): Observable<ImportConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/CreateImportConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateImportConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateImportConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportConfigurationDTO>;
        }));
    }

    protected processCreateImportConfiguration(response: HttpResponseBase): Observable<ImportConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateImportConfiguration(dto: ImportConfigurationDTO): Observable<ImportConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/UpdateImportConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateImportConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateImportConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportConfigurationDTO>;
        }));
    }

    protected processUpdateImportConfiguration(response: HttpResponseBase): Observable<ImportConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteImportConfiguration(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/DeleteImportConfiguration?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImportConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImportConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteImportConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createImportConfigurationTemplate(dto: ImportConfigurationDTO): Observable<ImportConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/CreateImportConfigurationTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateImportConfigurationTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateImportConfigurationTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportConfigurationDTO>;
        }));
    }

    protected processCreateImportConfigurationTemplate(response: HttpResponseBase): Observable<ImportConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateImportConfigurationTemplate(dto: ImportConfigurationDTO): Observable<ImportConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/UpdateImportConfigurationTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateImportConfigurationTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateImportConfigurationTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportConfigurationDTO>;
        }));
    }

    protected processUpdateImportConfigurationTemplate(response: HttpResponseBase): Observable<ImportConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteImportConfigurationTemplate(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/DeleteImportConfigurationTemplate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImportConfigurationTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImportConfigurationTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteImportConfigurationTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createGlobalImportConfiguration(dto: ImportConfigurationDTO): Observable<ImportConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/CreateGlobalImportConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGlobalImportConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGlobalImportConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportConfigurationDTO>;
        }));
    }

    protected processCreateGlobalImportConfiguration(response: HttpResponseBase): Observable<ImportConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateGlobalImportConfiguration(dto: ImportConfigurationDTO): Observable<ImportConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/UpdateGlobalImportConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGlobalImportConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGlobalImportConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportConfigurationDTO>;
        }));
    }

    protected processUpdateGlobalImportConfiguration(response: HttpResponseBase): Observable<ImportConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteGlobalImportConfiguration(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/DeleteGlobalImportConfiguration?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGlobalImportConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGlobalImportConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteGlobalImportConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFieldAssignmentDefinitions(importType: ImportType | undefined, accessType: ImportConfigurationClientAccessType | null | undefined): Observable<ImportFieldAssignmentDefinitionsDTO> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/GetFieldAssignmentDefinitions?";
        if (importType === null)
            throw new globalThis.Error("The parameter 'importType' cannot be null.");
        else if (importType !== undefined)
            url_ += "importType=" + encodeURIComponent("" + importType) + "&";
        if (accessType !== undefined && accessType !== null)
            url_ += "accessType=" + encodeURIComponent("" + accessType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldAssignmentDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldAssignmentDefinitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportFieldAssignmentDefinitionsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportFieldAssignmentDefinitionsDTO>;
        }));
    }

    protected processGetFieldAssignmentDefinitions(response: HttpResponseBase): Observable<ImportFieldAssignmentDefinitionsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportFieldAssignmentDefinitionsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testFtpAccess(connectionInfo: FTPClientConnectionInfoDTO): Observable<FTPConnectionResponse> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/TestFtpAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(connectionInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestFtpAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestFtpAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FTPConnectionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FTPConnectionResponse>;
        }));
    }

    protected processTestFtpAccess(response: HttpResponseBase): Observable<FTPConnectionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FTPConnectionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPossibleSourcesFromFile(sampleFile: SampleFileDTO): Observable<ImportSourceFieldDefinitionDTO[]> {
        let url_ = this.baseUrl + "/api/ImportConfiguration/GetPossibleSourcesFromFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sampleFile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleSourcesFromFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleSourcesFromFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportSourceFieldDefinitionDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportSourceFieldDefinitionDTO[]>;
        }));
    }

    protected processGetPossibleSourcesFromFile(response: HttpResponseBase): Observable<ImportSourceFieldDefinitionDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportSourceFieldDefinitionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImportInterfaceMagentoSalesOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    createShopOrder(shopOrderCreateDTO: ShopOrderCreateDTO): Observable<ShopOrderCreateResultDTO> {
        let url_ = this.baseUrl + "/api/Webshop/CreateShopOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shopOrderCreateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShopOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShopOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopOrderCreateResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopOrderCreateResultDTO>;
        }));
    }

    protected processCreateShopOrder(response: HttpResponseBase): Observable<ShopOrderCreateResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopOrderCreateResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImportInterfaceRESTSalesOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    deliver(dto: ImportDataSalesOrderDTO): Observable<void> {
        let url_ = this.baseUrl + "/Deliver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeliver(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImportProtocolClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getProtocol(id: number | undefined, iteration: number | null | undefined): Observable<ImportProtocolDTO> {
        let url_ = this.baseUrl + "/api/import/ImportProtocol/GetProtocol?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (iteration !== undefined && iteration !== null)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProtocol(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProtocol(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportProtocolDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportProtocolDTO>;
        }));
    }

    protected processGetProtocol(response: HttpResponseBase): Observable<ImportProtocolDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportProtocolDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchProtocols(clientId: number | null | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfImportProtocolDTO> {
        let url_ = this.baseUrl + "/api/import/ImportProtocol/SearchProtocols?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProtocols(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProtocols(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfImportProtocolDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfImportProtocolDTO>;
        }));
    }

    protected processSearchProtocols(response: HttpResponseBase): Observable<PagedResultDTOOfImportProtocolDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfImportProtocolDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(importFixData: ImportFixDTO): Observable<ImportProtocolDTO> {
        let url_ = this.baseUrl + "/api/import/ImportProtocol/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importFixData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportProtocolDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportProtocolDTO>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<ImportProtocolDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportProtocolDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAsFixed(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/import/ImportProtocol/SetAsFixed?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAsFixed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAsFixed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAsFixed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImportFile(protocolId: number | undefined, fileId: string | undefined): Observable<ImportFileDTO> {
        let url_ = this.baseUrl + "/api/import/ImportProtocol/GetImportFile?";
        if (protocolId === null)
            throw new globalThis.Error("The parameter 'protocolId' cannot be null.");
        else if (protocolId !== undefined)
            url_ += "protocolId=" + encodeURIComponent("" + protocolId) + "&";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportFileDTO>;
        }));
    }

    protected processGetImportFile(response: HttpResponseBase): Observable<ImportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ManualImportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    uploadManualImportSalesOrder(files: FileParameter[] | null | undefined): Observable<ImportProtocolLogEntryDTO[]> {
        let url_ = this.baseUrl + "/api/import/ManualImport/UploadManualImportSalesOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadManualImportSalesOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadManualImportSalesOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportProtocolLogEntryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportProtocolLogEntryDTO[]>;
        }));
    }

    protected processUploadManualImportSalesOrder(response: HttpResponseBase): Observable<ImportProtocolLogEntryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportProtocolLogEntryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadManualImport(importType: ImportType | undefined, files: FileParameter[] | null | undefined): Observable<ImportProtocolLogEntryDTO[]> {
        let url_ = this.baseUrl + "/api/import/ManualImport/UploadManualImport?";
        if (importType === null)
            throw new globalThis.Error("The parameter 'importType' cannot be null.");
        else if (importType !== undefined)
            url_ += "importType=" + encodeURIComponent("" + importType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadManualImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadManualImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportProtocolLogEntryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportProtocolLogEntryDTO[]>;
        }));
    }

    protected processUploadManualImport(response: HttpResponseBase): Observable<ImportProtocolLogEntryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportProtocolLogEntryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadTemplate(type: ImportType | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/import/ManualImport/DownloadTemplate?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportInterfaceActivationEmailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    generateActivationEmails(activationEmailsDTO: GenerateActivationEmailsDTO): Observable<ExportInterfaceActivationEmailDTO[]> {
        let url_ = this.baseUrl + "/api/ExportInterfaceActivationEmail/GenerateActivationEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activationEmailsDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateActivationEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateActivationEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceActivationEmailDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceActivationEmailDTO[]>;
        }));
    }

    protected processGenerateActivationEmails(response: HttpResponseBase): Observable<ExportInterfaceActivationEmailDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportInterfaceActivationEmailDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendActivationEmail(activationEmailDTO: ExportInterfaceActivationEmailDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportInterfaceActivationEmail/SendActivationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activationEmailDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendActivationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendActivationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendActivationEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendActivationEmails(activationEmailsDTO: ExportInterfaceActivationEmailDTO[]): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportInterfaceActivationEmail/SendActivationEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activationEmailsDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendActivationEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendActivationEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendActivationEmails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportInterfaceActivationEmailTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    createExportInterfaceActivationEmailTemplate(createExportInterfaceActivationEmailTemplateDTO: CreateExportInterfaceActivationEmailTemplateDTO): Observable<ExportInterfaceActivationEmailTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceActivationEmailTemplate/CreateExportInterfaceActivationEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createExportInterfaceActivationEmailTemplateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExportInterfaceActivationEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExportInterfaceActivationEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceActivationEmailTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceActivationEmailTemplateDTO>;
        }));
    }

    protected processCreateExportInterfaceActivationEmailTemplate(response: HttpResponseBase): Observable<ExportInterfaceActivationEmailTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceActivationEmailTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchExportInterfaceActivationEmailTemplates(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfExportInterfaceActivationEmailTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceActivationEmailTemplate/SearchExportInterfaceActivationEmailTemplates?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchExportInterfaceActivationEmailTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExportInterfaceActivationEmailTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfExportInterfaceActivationEmailTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfExportInterfaceActivationEmailTemplateDTO>;
        }));
    }

    protected processSearchExportInterfaceActivationEmailTemplates(response: HttpResponseBase): Observable<PagedResultDTOOfExportInterfaceActivationEmailTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfExportInterfaceActivationEmailTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateExportInterfaceActivationEmailTemplate(updateExportInterfaceActivationEmailTemplate: UpdateExportInterfaceActivationEmailTemplateDTO): Observable<ExportInterfaceActivationEmailTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceActivationEmailTemplate/UpdateExportInterfaceActivationEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateExportInterfaceActivationEmailTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExportInterfaceActivationEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExportInterfaceActivationEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceActivationEmailTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceActivationEmailTemplateDTO>;
        }));
    }

    protected processUpdateExportInterfaceActivationEmailTemplate(response: HttpResponseBase): Observable<ExportInterfaceActivationEmailTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceActivationEmailTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteExportInterfaceActivationEmailTemplate(templateId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportInterfaceActivationEmailTemplate/DeleteExportInterfaceActivationEmailTemplate?";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExportInterfaceActivationEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExportInterfaceActivationEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExportInterfaceActivationEmailTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportInterfaceConfigTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    createExportInterfaceConfigTemplate(createExportInterfaceConfigTemplateDTO: CreateExportInterfaceConfigTemplateDTO): Observable<ExportInterfaceConfigTemplateDetailsDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfigTemplate/CreateExportInterfaceConfigTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createExportInterfaceConfigTemplateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExportInterfaceConfigTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExportInterfaceConfigTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceConfigTemplateDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceConfigTemplateDetailsDTO>;
        }));
    }

    protected processCreateExportInterfaceConfigTemplate(response: HttpResponseBase): Observable<ExportInterfaceConfigTemplateDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceConfigTemplateDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchExportInterfaceConfigTemplates(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfExportInterfaceConfigTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfigTemplate/SearchExportInterfaceConfigTemplates?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchExportInterfaceConfigTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExportInterfaceConfigTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfExportInterfaceConfigTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfExportInterfaceConfigTemplateDTO>;
        }));
    }

    protected processSearchExportInterfaceConfigTemplates(response: HttpResponseBase): Observable<PagedResultDTOOfExportInterfaceConfigTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfExportInterfaceConfigTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExportInterfaceConfigTemplateDetails(templateId: number | undefined): Observable<ExportInterfaceConfigTemplateDetailsDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfigTemplate/GetExportInterfaceConfigTemplateDetails?";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportInterfaceConfigTemplateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportInterfaceConfigTemplateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceConfigTemplateDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceConfigTemplateDetailsDTO>;
        }));
    }

    protected processGetExportInterfaceConfigTemplateDetails(response: HttpResponseBase): Observable<ExportInterfaceConfigTemplateDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceConfigTemplateDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateExportInterfaceConfigTemplate(updateExportInterfaceConfigTemplate: UpdateExportInterfaceConfigTemplateDTO): Observable<ExportInterfaceConfigTemplateDetailsDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfigTemplate/UpdateExportInterfaceConfigTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateExportInterfaceConfigTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExportInterfaceConfigTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExportInterfaceConfigTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceConfigTemplateDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceConfigTemplateDetailsDTO>;
        }));
    }

    protected processUpdateExportInterfaceConfigTemplate(response: HttpResponseBase): Observable<ExportInterfaceConfigTemplateDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceConfigTemplateDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteExportInterfaceConfigTemplate(configTemplateId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfigTemplate/DeleteExportInterfaceConfigTemplate?";
        if (configTemplateId === null)
            throw new globalThis.Error("The parameter 'configTemplateId' cannot be null.");
        else if (configTemplateId !== undefined)
            url_ += "configTemplateId=" + encodeURIComponent("" + configTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExportInterfaceConfigTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExportInterfaceConfigTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExportInterfaceConfigTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFilenameExampleFromConfig(configDto: ExportInterfaceConfigTemplateDetailsDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfigTemplate/GetFilenameExampleFromConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilenameExampleFromConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilenameExampleFromConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFilenameExampleFromConfig(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportInterfaceConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    createExportInterfaceConfiguration(createExportInterfaceConfigurationDTO: CreateExportInterfaceConfigurationDTO): Observable<ExportInterfaceConfigurationDetailsDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/CreateExportInterfaceConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createExportInterfaceConfigurationDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExportInterfaceConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExportInterfaceConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceConfigurationDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceConfigurationDetailsDTO>;
        }));
    }

    protected processCreateExportInterfaceConfiguration(response: HttpResponseBase): Observable<ExportInterfaceConfigurationDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceConfigurationDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateExportInterfaceConfigurationFromTemplate(updateConfigurationFromTemplateDTO: UpdateConfigurationFromTemplateDTO): Observable<ExportInterfaceConfigurationDetailsDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/UpdateExportInterfaceConfigurationFromTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateConfigurationFromTemplateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExportInterfaceConfigurationFromTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExportInterfaceConfigurationFromTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceConfigurationDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceConfigurationDetailsDTO>;
        }));
    }

    protected processUpdateExportInterfaceConfigurationFromTemplate(response: HttpResponseBase): Observable<ExportInterfaceConfigurationDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceConfigurationDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchExportInterfaceConfigurations(clientId: number | null | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfExportInterfaceConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/SearchExportInterfaceConfigurations?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchExportInterfaceConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExportInterfaceConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfExportInterfaceConfigurationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfExportInterfaceConfigurationDTO>;
        }));
    }

    protected processSearchExportInterfaceConfigurations(response: HttpResponseBase): Observable<PagedResultDTOOfExportInterfaceConfigurationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfExportInterfaceConfigurationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateExportInterfaceConfiguration(updateExportInterfaceConfiguration: UpdateExportInterfaceConfigurationDTO): Observable<ExportInterfaceConfigurationDetailsDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/UpdateExportInterfaceConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateExportInterfaceConfiguration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExportInterfaceConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExportInterfaceConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceConfigurationDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceConfigurationDetailsDTO>;
        }));
    }

    protected processUpdateExportInterfaceConfiguration(response: HttpResponseBase): Observable<ExportInterfaceConfigurationDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceConfigurationDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExportInterfaceConfigurationDetails(configurationId: number | undefined): Observable<ExportInterfaceConfigurationDetailsDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/GetExportInterfaceConfigurationDetails?";
        if (configurationId === null)
            throw new globalThis.Error("The parameter 'configurationId' cannot be null.");
        else if (configurationId !== undefined)
            url_ += "configurationId=" + encodeURIComponent("" + configurationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportInterfaceConfigurationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportInterfaceConfigurationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceConfigurationDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceConfigurationDetailsDTO>;
        }));
    }

    protected processGetExportInterfaceConfigurationDetails(response: HttpResponseBase): Observable<ExportInterfaceConfigurationDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceConfigurationDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteExportInterfaceConfiguration(configurationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/DeleteExportInterfaceConfiguration?";
        if (configurationId === null)
            throw new globalThis.Error("The parameter 'configurationId' cannot be null.");
        else if (configurationId !== undefined)
            url_ += "configurationId=" + encodeURIComponent("" + configurationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExportInterfaceConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExportInterfaceConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExportInterfaceConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testFTPAccess(configurationId: number | undefined, ftpDTO: ExportInterfaceConfigurationDetailsFTPClientDTO): Observable<ExportInterfaceConfigurationFTPTestResultDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/TestFTPAccess?";
        if (configurationId === null)
            throw new globalThis.Error("The parameter 'configurationId' cannot be null.");
        else if (configurationId !== undefined)
            url_ += "configurationId=" + encodeURIComponent("" + configurationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ftpDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestFTPAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestFTPAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceConfigurationFTPTestResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceConfigurationFTPTestResultDTO>;
        }));
    }

    protected processTestFTPAccess(response: HttpResponseBase): Observable<ExportInterfaceConfigurationFTPTestResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceConfigurationFTPTestResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFilenameExampleFromConfig(configDto: ExportInterfaceConfigurationDetailsDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/GetFilenameExampleFromConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilenameExampleFromConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilenameExampleFromConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFilenameExampleFromConfig(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMasterData(): Observable<ExportInterfaceMasterDataDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/GetMasterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceMasterDataDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceMasterDataDTO>;
        }));
    }

    protected processGetMasterData(response: HttpResponseBase): Observable<ExportInterfaceMasterDataDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceMasterDataDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSourceFields(): Observable<ExportInterfaceAllSourceFieldsDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/GetAllSourceFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourceFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourceFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceAllSourceFieldsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceAllSourceFieldsDTO>;
        }));
    }

    protected processGetAllSourceFields(response: HttpResponseBase): Observable<ExportInterfaceAllSourceFieldsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceAllSourceFieldsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    executeExportInterfaceConfiguration(configurationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/ExecuteExportInterfaceConfiguration?";
        if (configurationId === null)
            throw new globalThis.Error("The parameter 'configurationId' cannot be null.");
        else if (configurationId !== undefined)
            url_ += "configurationId=" + encodeURIComponent("" + configurationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteExportInterfaceConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteExportInterfaceConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteExportInterfaceConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateExportInterfaceConfigurationListAsCsv(filterDTO: ExportInterfaceConfigurationFilterDTO): Observable<CsvDataDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceConfiguration/GenerateExportInterfaceConfigurationListAsCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateExportInterfaceConfigurationListAsCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateExportInterfaceConfigurationListAsCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CsvDataDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CsvDataDTO>;
        }));
    }

    protected processGenerateExportInterfaceConfigurationListAsCsv(response: HttpResponseBase): Observable<CsvDataDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CsvDataDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportInterfaceEmailTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    createExportInterfaceEmailTemplate(createExportInterfaceEmailTemplateDTO: CreateExportInterfaceEmailTemplateDTO): Observable<ExportInterfaceEmailTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceEmailTemplate/CreateExportInterfaceEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createExportInterfaceEmailTemplateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExportInterfaceEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExportInterfaceEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceEmailTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceEmailTemplateDTO>;
        }));
    }

    protected processCreateExportInterfaceEmailTemplate(response: HttpResponseBase): Observable<ExportInterfaceEmailTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceEmailTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchExportInterfaceEmailTemplates(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfExportInterfaceEmailTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceEmailTemplate/SearchExportInterfaceEmailTemplates?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchExportInterfaceEmailTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExportInterfaceEmailTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfExportInterfaceEmailTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfExportInterfaceEmailTemplateDTO>;
        }));
    }

    protected processSearchExportInterfaceEmailTemplates(response: HttpResponseBase): Observable<PagedResultDTOOfExportInterfaceEmailTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfExportInterfaceEmailTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateExportInterfaceEmailTemplate(updateExportInterfaceEmailTemplate: UpdateExportInterfaceEmailTemplateDTO): Observable<ExportInterfaceEmailTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceEmailTemplate/UpdateExportInterfaceEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateExportInterfaceEmailTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExportInterfaceEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExportInterfaceEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceEmailTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceEmailTemplateDTO>;
        }));
    }

    protected processUpdateExportInterfaceEmailTemplate(response: HttpResponseBase): Observable<ExportInterfaceEmailTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceEmailTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteExportInterfaceEmailTemplate(templateId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportInterfaceEmailTemplate/DeleteExportInterfaceEmailTemplate?";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExportInterfaceEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExportInterfaceEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExportInterfaceEmailTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportInterfaceExecutionLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    searchExportInterfaceExecutionLogs(clientId: number | null | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfExportInterfaceExecutionLogDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceExecutionLog/SearchExportInterfaceExecutionLogs?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchExportInterfaceExecutionLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExportInterfaceExecutionLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfExportInterfaceExecutionLogDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfExportInterfaceExecutionLogDTO>;
        }));
    }

    protected processSearchExportInterfaceExecutionLogs(response: HttpResponseBase): Observable<PagedResultDTOOfExportInterfaceExecutionLogDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfExportInterfaceExecutionLogDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportInterfaceFieldAssignmentTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    createExportInterfaceFieldAssignmentTemplate(createExportInterfaceFieldAssignmentTemplateDTO: CreateExportInterfaceFieldAssignmentTemplateDTO): Observable<ExportInterfaceFieldAssignmentTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceFieldAssignmentTemplate/CreateExportInterfaceFieldAssignmentTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createExportInterfaceFieldAssignmentTemplateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExportInterfaceFieldAssignmentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExportInterfaceFieldAssignmentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceFieldAssignmentTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceFieldAssignmentTemplateDTO>;
        }));
    }

    protected processCreateExportInterfaceFieldAssignmentTemplate(response: HttpResponseBase): Observable<ExportInterfaceFieldAssignmentTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceFieldAssignmentTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDefaultExportInterfaceFieldAssignmentTemplate(): Observable<ExportInterfaceFieldAssignmentTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceFieldAssignmentTemplate/CreateDefaultExportInterfaceFieldAssignmentTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDefaultExportInterfaceFieldAssignmentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDefaultExportInterfaceFieldAssignmentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceFieldAssignmentTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceFieldAssignmentTemplateDTO>;
        }));
    }

    protected processCreateDefaultExportInterfaceFieldAssignmentTemplate(response: HttpResponseBase): Observable<ExportInterfaceFieldAssignmentTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceFieldAssignmentTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchExportInterfaceFieldAssignmentTemplates(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceFieldAssignmentTemplate/SearchExportInterfaceFieldAssignmentTemplates?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchExportInterfaceFieldAssignmentTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExportInterfaceFieldAssignmentTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO>;
        }));
    }

    protected processSearchExportInterfaceFieldAssignmentTemplates(response: HttpResponseBase): Observable<PagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateExportInterfaceFieldAssignmentTemplate(updateExportInterfaceFieldAssignmentTemplate: UpdateExportInterfaceFieldAssignmentTemplateDTO): Observable<ExportInterfaceFieldAssignmentTemplateDTO> {
        let url_ = this.baseUrl + "/api/ExportInterfaceFieldAssignmentTemplate/UpdateExportInterfaceFieldAssignmentTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateExportInterfaceFieldAssignmentTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExportInterfaceFieldAssignmentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExportInterfaceFieldAssignmentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceFieldAssignmentTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceFieldAssignmentTemplateDTO>;
        }));
    }

    protected processUpdateExportInterfaceFieldAssignmentTemplate(response: HttpResponseBase): Observable<ExportInterfaceFieldAssignmentTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportInterfaceFieldAssignmentTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteExportInterfaceFieldAssignmentTemplate(templateId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportInterfaceFieldAssignmentTemplate/DeleteExportInterfaceFieldAssignmentTemplate?";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExportInterfaceFieldAssignmentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExportInterfaceFieldAssignmentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExportInterfaceFieldAssignmentTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportInterfaceFieldValueReplacementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getClientsWithFieldValueReplacements(): Observable<ClientDTO[]> {
        let url_ = this.baseUrl + "/api/ExportInterfaceFieldValueReplacement/GetClientsWithFieldValueReplacements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsWithFieldValueReplacements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsWithFieldValueReplacements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO[]>;
        }));
    }

    protected processGetClientsWithFieldValueReplacements(response: HttpResponseBase): Observable<ClientDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSourceFieldsWithFieldValueReplacements(clientId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/ExportInterfaceFieldValueReplacement/GetSourceFieldsWithFieldValueReplacements?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourceFieldsWithFieldValueReplacements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourceFieldsWithFieldValueReplacements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetSourceFieldsWithFieldValueReplacements(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFieldValueReplacementEntriesForSourceField(clientId: number | undefined, sourceField: string | undefined): Observable<ExportInterfaceFieldValueReplacementEntryDTO[]> {
        let url_ = this.baseUrl + "/api/ExportInterfaceFieldValueReplacement/GetFieldValueReplacementEntriesForSourceField?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (sourceField === null)
            throw new globalThis.Error("The parameter 'sourceField' cannot be null.");
        else if (sourceField !== undefined)
            url_ += "sourceField=" + encodeURIComponent("" + sourceField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldValueReplacementEntriesForSourceField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldValueReplacementEntriesForSourceField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceFieldValueReplacementEntryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceFieldValueReplacementEntryDTO[]>;
        }));
    }

    protected processGetFieldValueReplacementEntriesForSourceField(response: HttpResponseBase): Observable<ExportInterfaceFieldValueReplacementEntryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportInterfaceFieldValueReplacementEntryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveFieldValueReplacements(data: ExportInterfaceSaveFieldValueReplacementsDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportInterfaceFieldValueReplacement/SaveFieldValueReplacements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFieldValueReplacements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFieldValueReplacements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveFieldValueReplacements(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAllFieldValueReplacementsForClient(clientId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportInterfaceFieldValueReplacement/DeleteAllFieldValueReplacementsForClient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllFieldValueReplacementsForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllFieldValueReplacementsForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllFieldValueReplacementsForClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportInterfaceRESTItemPriceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    get(itemIds: string | undefined): Observable<ExportInterfaceRESTItemPriceDTO[] | null> {
        let url_ = this.baseUrl + "/api/ExportInterfaceRESTItemPrice?";
        if (itemIds === null)
            throw new globalThis.Error("The parameter 'itemIds' cannot be null.");
        else if (itemIds !== undefined)
            url_ += "itemIds=" + encodeURIComponent("" + itemIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceRESTItemPriceDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceRESTItemPriceDTO[] | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ExportInterfaceRESTItemPriceDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportInterfaceRESTItemPriceDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportInterfaceRESTPriceListClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    get(): Observable<ExportInterfaceRESTItemPriceDTO[] | null> {
        let url_ = this.baseUrl + "/api/ExportInterfaceRESTPriceList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportInterfaceRESTItemPriceDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportInterfaceRESTItemPriceDTO[] | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ExportInterfaceRESTItemPriceDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportInterfaceRESTItemPriceDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EconworkClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getItems(): Observable<BitrixItemDTO[]> {
        let url_ = this.baseUrl + "/api/Econwork/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BitrixItemDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BitrixItemDTO[]>;
        }));
    }

    protected processGetItems(response: HttpResponseBase): Observable<BitrixItemDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BitrixItemDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerPriceGroups(): Observable<BitrixCustomerPriceGroupDTO[]> {
        let url_ = this.baseUrl + "/api/Econwork/GetCustomerPriceGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerPriceGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerPriceGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BitrixCustomerPriceGroupDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BitrixCustomerPriceGroupDTO[]>;
        }));
    }

    protected processGetCustomerPriceGroups(response: HttpResponseBase): Observable<BitrixCustomerPriceGroupDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BitrixCustomerPriceGroupDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomers(): Observable<BitrixCustomerDTO[]> {
        let url_ = this.baseUrl + "/api/Econwork/GetCustomers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BitrixCustomerDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BitrixCustomerDTO[]>;
        }));
    }

    protected processGetCustomers(response: HttpResponseBase): Observable<BitrixCustomerDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BitrixCustomerDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMarginCorrections(): Observable<MarginCorrectionDTO[]> {
        let url_ = this.baseUrl + "/api/Econwork/GetMarginCorrections";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMarginCorrections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarginCorrections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarginCorrectionDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarginCorrectionDTO[]>;
        }));
    }

    protected processGetMarginCorrections(response: HttpResponseBase): Observable<MarginCorrectionDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarginCorrectionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPricelistSalesHistory(skip: number | undefined, take: number | undefined): Observable<PriceListSalesHistoryDTO[]> {
        let url_ = this.baseUrl + "/api/Econwork/GetPricelistSalesHistory?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPricelistSalesHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPricelistSalesHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListSalesHistoryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListSalesHistoryDTO[]>;
        }));
    }

    protected processGetPricelistSalesHistory(response: HttpResponseBase): Observable<PriceListSalesHistoryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriceListSalesHistoryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendPriceAutomationProposals(dto: SendPriceAutomationProposalsDTO): Observable<SendPriceAutomationProposalsResponseDTO> {
        let url_ = this.baseUrl + "/api/Econwork/SendPriceAutomationProposals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPriceAutomationProposals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPriceAutomationProposals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendPriceAutomationProposalsResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendPriceAutomationProposalsResponseDTO>;
        }));
    }

    protected processSendPriceAutomationProposals(response: HttpResponseBase): Observable<SendPriceAutomationProposalsResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendPriceAutomationProposalsResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EncowayBtoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getCountryPrices(countryCode: string | undefined, shopId: string | null | undefined, sKUs: string[] | null | undefined): Observable<GetEncowayCountryProductPriceResponseDTO> {
        let url_ = this.baseUrl + "/api/EncowayBto/GetCountryPrices?";
        if (countryCode === null)
            throw new globalThis.Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (shopId !== undefined && shopId !== null)
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        if (sKUs !== undefined && sKUs !== null)
            sKUs && sKUs.forEach(item => { url_ += "SKUs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEncowayCountryProductPriceResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEncowayCountryProductPriceResponseDTO>;
        }));
    }

    protected processGetCountryPrices(response: HttpResponseBase): Observable<GetEncowayCountryProductPriceResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEncowayCountryProductPriceResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountryStock(countryCode: string | undefined, shopId: string | null | undefined, sKUs: string[] | null | undefined): Observable<EncowayGetCountryStockResponseDTO> {
        let url_ = this.baseUrl + "/api/EncowayBto/GetCountryStock?";
        if (countryCode === null)
            throw new globalThis.Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (shopId !== undefined && shopId !== null)
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        if (sKUs !== undefined && sKUs !== null)
            sKUs && sKUs.forEach(item => { url_ += "SKUs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EncowayGetCountryStockResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EncowayGetCountryStockResponseDTO>;
        }));
    }

    protected processGetCountryStock(response: HttpResponseBase): Observable<EncowayGetCountryStockResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EncowayGetCountryStockResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerBtoConfiguration(configuration: EncowayRegisterBtoConfigurationDTO): Observable<EncowayRegisterBtoConfigurationResponseDTO> {
        let url_ = this.baseUrl + "/api/EncowayBto/RegisterBtoConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configuration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterBtoConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterBtoConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EncowayRegisterBtoConfigurationResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EncowayRegisterBtoConfigurationResponseDTO>;
        }));
    }

    protected processRegisterBtoConfiguration(response: HttpResponseBase): Observable<EncowayRegisterBtoConfigurationResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EncowayRegisterBtoConfigurationResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BitrixClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getChangedPriceAutomationProposals(take: number | undefined): Observable<PriceAutomationProposalDTO[]> {
        let url_ = this.baseUrl + "/api/Bitrix/GetChangedPriceAutomationProposals?";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangedPriceAutomationProposals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangedPriceAutomationProposals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceAutomationProposalDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceAutomationProposalDTO[]>;
        }));
    }

    protected processGetChangedPriceAutomationProposals(response: HttpResponseBase): Observable<PriceAutomationProposalDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriceAutomationProposalDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChangedPriceAutomationProposalsPaged(skip: number | undefined, take: number | undefined): Observable<PriceAutomationProposalDTO[]> {
        let url_ = this.baseUrl + "/api/Bitrix/GetChangedPriceAutomationProposalsPaged?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangedPriceAutomationProposalsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangedPriceAutomationProposalsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceAutomationProposalDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceAutomationProposalDTO[]>;
        }));
    }

    protected processGetChangedPriceAutomationProposalsPaged(response: HttpResponseBase): Observable<PriceAutomationProposalDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriceAutomationProposalDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setPriceAutomationProposalsAsTransferred(proposalsSyncStatusDTO: SetPriceAutomationProposalsSyncStatusDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/Bitrix/SetPriceAutomationProposalsAsTransferred";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(proposalsSyncStatusDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPriceAutomationProposalsAsTransferred(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPriceAutomationProposalsAsTransferred(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetPriceAutomationProposalsAsTransferred(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ItemCockpitClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    updateItems(updateDTO: ItemCockpitUpdateItemsDTO): Observable<ItemCockpitUpdateItemsResultDTO> {
        let url_ = this.baseUrl + "/api/ItemCockpit/UpdateItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemCockpitUpdateItemsResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemCockpitUpdateItemsResultDTO>;
        }));
    }

    protected processUpdateItems(response: HttpResponseBase): Observable<ItemCockpitUpdateItemsResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemCockpitUpdateItemsResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ItemUomClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    updateItems(updateDTO: ItemUomUpdateItemsDTO): Observable<ItemUomUpdateItemsResultDTO> {
        let url_ = this.baseUrl + "/api/ItemUom/UpdateItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemUomUpdateItemsResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemUomUpdateItemsResultDTO>;
        }));
    }

    protected processUpdateItems(response: HttpResponseBase): Observable<ItemUomUpdateItemsResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemUomUpdateItemsResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ItemWarrantyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    updateItems(updateDTO: ItemWarrantyUpdateItemsDTO): Observable<ItemWarrantyUpdateItemsResultDTO> {
        let url_ = this.baseUrl + "/api/ItemWarranty/UpdateItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemWarrantyUpdateItemsResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemWarrantyUpdateItemsResultDTO>;
        }));
    }

    protected processUpdateItems(response: HttpResponseBase): Observable<ItemWarrantyUpdateItemsResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemWarrantyUpdateItemsResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssetCollectionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    searchAssetCollections(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfAssetCollectionDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetCollection/SearchAssetCollections/SearchAssetCollections?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAssetCollections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAssetCollections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfAssetCollectionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfAssetCollectionDTO>;
        }));
    }

    protected processSearchAssetCollections(response: HttpResponseBase): Observable<PagedResultDTOOfAssetCollectionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfAssetCollectionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssetCollection(assetCollectionId: number | undefined): Observable<AssetCollectionDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetCollection/GetAssetCollection?";
        if (assetCollectionId === null)
            throw new globalThis.Error("The parameter 'assetCollectionId' cannot be null.");
        else if (assetCollectionId !== undefined)
            url_ += "assetCollectionId=" + encodeURIComponent("" + assetCollectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetCollection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetCollection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetCollectionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetCollectionDTO>;
        }));
    }

    protected processGetAssetCollection(response: HttpResponseBase): Observable<AssetCollectionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetCollectionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAssetCollection(dto: AssetCollectionDTO): Observable<AssetCollectionDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetCollection/CreateAssetCollection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAssetCollection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssetCollection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetCollectionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetCollectionDTO>;
        }));
    }

    protected processCreateAssetCollection(response: HttpResponseBase): Observable<AssetCollectionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetCollectionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAssetCollection(dto: AssetCollectionDTO): Observable<AssetCollectionDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetCollection/UpdateAssetCollection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetCollection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetCollection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetCollectionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetCollectionDTO>;
        }));
    }

    protected processUpdateAssetCollection(response: HttpResponseBase): Observable<AssetCollectionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetCollectionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAssetCollection(assetCollectionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/AssetCollection/DeleteAssetCollection?";
        if (assetCollectionId === null)
            throw new globalThis.Error("The parameter 'assetCollectionId' cannot be null.");
        else if (assetCollectionId !== undefined)
            url_ += "assetCollectionId=" + encodeURIComponent("" + assetCollectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssetCollection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssetCollection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAssetCollection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchAssetStorageEntriesForAssetCollection(assetStorageEntryCollectionId: number | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfAssetStorageEntryLimitedDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetCollection/SearchAssetStorageEntriesForAssetCollection/SearchAssetStorageEntriesForAssetCollection?";
        if (assetStorageEntryCollectionId === null)
            throw new globalThis.Error("The parameter 'assetStorageEntryCollectionId' cannot be null.");
        else if (assetStorageEntryCollectionId !== undefined)
            url_ += "assetStorageEntryCollectionId=" + encodeURIComponent("" + assetStorageEntryCollectionId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAssetStorageEntriesForAssetCollection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAssetStorageEntriesForAssetCollection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfAssetStorageEntryLimitedDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfAssetStorageEntryLimitedDTO>;
        }));
    }

    protected processSearchAssetStorageEntriesForAssetCollection(response: HttpResponseBase): Observable<PagedResultDTOOfAssetStorageEntryLimitedDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfAssetStorageEntryLimitedDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssetCollectionPublicViewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    getAssetCollectionByToken(token: string | undefined): Observable<AssetCollectionPublicViewDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetCollectionPublicView/GetAssetCollectionByToken?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetCollectionByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetCollectionByToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetCollectionPublicViewDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetCollectionPublicViewDTO>;
        }));
    }

    protected processGetAssetCollectionByToken(response: HttpResponseBase): Observable<AssetCollectionPublicViewDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetCollectionPublicViewDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fileOperations(collectionId: number | undefined, args: FileManagerDirectoryContentDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/Asset/AssetCollectionPublicView/FileOperations?";
        if (collectionId === null)
            throw new globalThis.Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileOperations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileOperations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFileOperations(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    download(collectionId: number | undefined, assetIds: number[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Asset/AssetCollectionPublicView/Download?";
        if (collectionId === null)
            throw new globalThis.Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assetIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssetStorageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    fileOperations(args: FileManagerDirectoryContentDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorage/FileOperations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileOperations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileOperations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFileOperations(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upload(path: string | null | undefined, languageCodeIso3: string | null | undefined, license: string | null | undefined, source: string | null | undefined, imageQuality: string | null | undefined, assignedAssetKeyWords: string | null | undefined, totalSize: string | null | undefined, chunkIndex: string | null | undefined, totalChunk: string | null | undefined, assetStorageEntryId: string | null | undefined, isStaticFileName: string | null | undefined, changedStaticFileName: string | null | undefined): Observable<AssetStorageUploadResultDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorage/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (path !== null && path !== undefined)
            content_.append("path", path.toString());
        if (languageCodeIso3 !== null && languageCodeIso3 !== undefined)
            content_.append("languageCodeIso3", languageCodeIso3.toString());
        if (license !== null && license !== undefined)
            content_.append("license", license.toString());
        if (source !== null && source !== undefined)
            content_.append("source", source.toString());
        if (imageQuality !== null && imageQuality !== undefined)
            content_.append("imageQuality", imageQuality.toString());
        if (assignedAssetKeyWords !== null && assignedAssetKeyWords !== undefined)
            content_.append("assignedAssetKeyWords", assignedAssetKeyWords.toString());
        if (totalSize !== null && totalSize !== undefined)
            content_.append("totalSize", totalSize.toString());
        if (chunkIndex !== null && chunkIndex !== undefined)
            content_.append("chunkIndex", chunkIndex.toString());
        if (totalChunk !== null && totalChunk !== undefined)
            content_.append("totalChunk", totalChunk.toString());
        if (assetStorageEntryId !== null && assetStorageEntryId !== undefined)
            content_.append("assetStorageEntryId", assetStorageEntryId.toString());
        if (isStaticFileName !== null && isStaticFileName !== undefined)
            content_.append("isStaticFileName", isStaticFileName.toString());
        if (changedStaticFileName !== null && changedStaticFileName !== undefined)
            content_.append("changedStaticFileName", changedStaticFileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetStorageUploadResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetStorageUploadResultDTO>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<AssetStorageUploadResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetStorageUploadResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeUpload(entryId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorage/RemoveUpload?";
        if (entryId === null)
            throw new globalThis.Error("The parameter 'entryId' cannot be null.");
        else if (entryId !== undefined)
            url_ += "entryId=" + encodeURIComponent("" + entryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAssetStorageEntry(dto: UpdateAssetStorageEntryDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorage/UpdateAssetStorageEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetStorageEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetStorageEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAssetStorageEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAssetStorageDirectoryPermissions(dto: UpdateAssetStorageDirectoryPermissionsDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorage/UpdateAssetStorageDirectoryPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetStorageDirectoryPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetStorageDirectoryPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAssetStorageDirectoryPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAssetStorageKeyWord(dto: AssetStorageKeyWordDTO): Observable<AssetStorageKeyWordDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorage/CreateAssetStorageKeyWord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAssetStorageKeyWord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssetStorageKeyWord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetStorageKeyWordDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetStorageKeyWordDTO>;
        }));
    }

    protected processCreateAssetStorageKeyWord(response: HttpResponseBase): Observable<AssetStorageKeyWordDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetStorageKeyWordDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchAssetStorageKeyWords(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfAssetStorageKeyWordDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorage/SearchAssetStorageKeyWords?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAssetStorageKeyWords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAssetStorageKeyWords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfAssetStorageKeyWordDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfAssetStorageKeyWordDTO>;
        }));
    }

    protected processSearchAssetStorageKeyWords(response: HttpResponseBase): Observable<PagedResultDTOOfAssetStorageKeyWordDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfAssetStorageKeyWordDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAssignedCollectionsForAssets(assetIds: number[] | undefined, assetCollectionIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorage/SetAssignedCollectionsForAssets?";
        if (assetIds === null)
            throw new globalThis.Error("The parameter 'assetIds' cannot be null.");
        else if (assetIds !== undefined)
            assetIds && assetIds.forEach(item => { url_ += "assetIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assetCollectionIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignedCollectionsForAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignedCollectionsForAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignedCollectionsForAssets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssetStorageSettingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    searchAssetStoragePermissionGroups(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfAssetStoragePermissionGroupDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorageSetting/SearchAssetStoragePermissionGroups?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAssetStoragePermissionGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAssetStoragePermissionGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfAssetStoragePermissionGroupDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfAssetStoragePermissionGroupDTO>;
        }));
    }

    protected processSearchAssetStoragePermissionGroups(response: HttpResponseBase): Observable<PagedResultDTOOfAssetStoragePermissionGroupDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfAssetStoragePermissionGroupDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAssetStoragePermissionGroup(dto: CreateAssetStoragePermissionGroupDTO): Observable<AssetStoragePermissionGroupDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorageSetting/CreateAssetStoragePermissionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAssetStoragePermissionGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssetStoragePermissionGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetStoragePermissionGroupDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetStoragePermissionGroupDTO>;
        }));
    }

    protected processCreateAssetStoragePermissionGroup(response: HttpResponseBase): Observable<AssetStoragePermissionGroupDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetStoragePermissionGroupDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAssetStoragePermissionGroup(dto: UpdateAssetStoragePermissionGroupDTO): Observable<AssetStoragePermissionGroupDTO> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorageSetting/UpdateAssetStoragePermissionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetStoragePermissionGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetStoragePermissionGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetStoragePermissionGroupDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetStoragePermissionGroupDTO>;
        }));
    }

    protected processUpdateAssetStoragePermissionGroup(response: HttpResponseBase): Observable<AssetStoragePermissionGroupDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetStoragePermissionGroupDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAssetStoragePermissionGroup(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/AssetStorageSetting/DeleteAssetStoragePermissionGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssetStoragePermissionGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssetStoragePermissionGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAssetStoragePermissionGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BrandLogoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    searchBrandLogos(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfBrandLogoDTO> {
        let url_ = this.baseUrl + "/api/Asset/BrandLogo/SearchBrandLogos?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBrandLogos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBrandLogos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfBrandLogoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfBrandLogoDTO>;
        }));
    }

    protected processSearchBrandLogos(response: HttpResponseBase): Observable<PagedResultDTOOfBrandLogoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfBrandLogoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createBrandLogo(dto: CreateBrandLogoDTO): Observable<BrandLogoDTO[]> {
        let url_ = this.baseUrl + "/api/Asset/BrandLogo/CreateBrandLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBrandLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBrandLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BrandLogoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BrandLogoDTO[]>;
        }));
    }

    protected processCreateBrandLogo(response: HttpResponseBase): Observable<BrandLogoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrandLogoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBrandLogo(deleteBrandLogoDTO: DeleteBrandLogoDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/BrandLogo/DeleteBrandLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteBrandLogoDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBrandLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBrandLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBrandLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductAssetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:8222";
    }

    searchProductAssets(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfProductAssetDTOStargate> {
        let url_ = this.baseUrl + "/api/Asset/ProductAsset/SearchProductAssets?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProductAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProductAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfProductAssetDTOStargate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfProductAssetDTOStargate>;
        }));
    }

    protected processSearchProductAssets(response: HttpResponseBase): Observable<PagedResultDTOOfProductAssetDTOStargate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfProductAssetDTOStargate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upload(productNumbers: string | null | undefined, publicName: string | null | undefined, originalFileName: string | null | undefined, fileExtension: string | null | undefined, languageCodeIso3: string | null | undefined, assetType: AssetType | null | undefined, isKey: boolean | null | undefined, shopIds: string | null | undefined, altText: string | null | undefined, totalSize: number | null | undefined, chunkIndex: number | null | undefined, totalChunk: number | undefined, assetIds: string | null | undefined): Observable<AssetDTOStargate[]> {
        let url_ = this.baseUrl + "/api/Asset/ProductAsset/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (productNumbers !== null && productNumbers !== undefined)
            content_.append("productNumbers", productNumbers.toString());
        if (publicName !== null && publicName !== undefined)
            content_.append("publicName", publicName.toString());
        if (originalFileName !== null && originalFileName !== undefined)
            content_.append("originalFileName", originalFileName.toString());
        if (fileExtension !== null && fileExtension !== undefined)
            content_.append("fileExtension", fileExtension.toString());
        if (languageCodeIso3 !== null && languageCodeIso3 !== undefined)
            content_.append("languageCodeIso3", languageCodeIso3.toString());
        if (assetType !== null && assetType !== undefined)
            content_.append("assetType", assetType.toString());
        if (isKey !== null && isKey !== undefined)
            content_.append("isKey", isKey.toString());
        if (shopIds !== null && shopIds !== undefined)
            content_.append("shopIds", shopIds.toString());
        if (altText !== null && altText !== undefined)
            content_.append("altText", altText.toString());
        if (totalSize !== null && totalSize !== undefined)
            content_.append("totalSize", totalSize.toString());
        if (chunkIndex !== null && chunkIndex !== undefined)
            content_.append("chunkIndex", chunkIndex.toString());
        if (totalChunk === null || totalChunk === undefined)
            throw new globalThis.Error("The parameter 'totalChunk' cannot be null.");
        else
            content_.append("totalChunk", totalChunk.toString());
        if (assetIds !== null && assetIds !== undefined)
            content_.append("assetIds", assetIds.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDTOStargate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDTOStargate[]>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<AssetDTOStargate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetDTOStargate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeUpload(assetId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/ProductAsset/RemoveUpload?";
        if (assetId === null)
            throw new globalThis.Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAssetAsKey(id: number | undefined): Observable<ProductAssetDTOStargate> {
        let url_ = this.baseUrl + "/api/Asset/ProductAsset/SetAssetAsKey?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssetAsKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssetAsKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductAssetDTOStargate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductAssetDTOStargate>;
        }));
    }

    protected processSetAssetAsKey(response: HttpResponseBase): Observable<ProductAssetDTOStargate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductAssetDTOStargate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAssetShopAsKey(assetId: number | undefined, shopId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/ProductAsset/SetAssetShopAsKey?";
        if (assetId === null)
            throw new globalThis.Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (shopId === null)
            throw new globalThis.Error("The parameter 'shopId' cannot be null.");
        else if (shopId !== undefined)
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssetShopAsKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssetShopAsKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssetShopAsKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setNewOrderIndex(assetId: number | undefined, orderIndex: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/ProductAsset/SetNewOrderIndex?";
        if (assetId === null)
            throw new globalThis.Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (orderIndex === null)
            throw new globalThis.Error("The parameter 'orderIndex' cannot be null.");
        else if (orderIndex !== undefined)
            url_ += "orderIndex=" + encodeURIComponent("" + orderIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNewOrderIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNewOrderIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNewOrderIndex(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyAsset(assetId: number | undefined, targetItemNo: string | undefined, orderIndex: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/ProductAsset/CopyAsset?";
        if (assetId === null)
            throw new globalThis.Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (targetItemNo === null)
            throw new globalThis.Error("The parameter 'targetItemNo' cannot be null.");
        else if (targetItemNo !== undefined)
            url_ += "targetItemNo=" + encodeURIComponent("" + targetItemNo) + "&";
        if (orderIndex === null)
            throw new globalThis.Error("The parameter 'orderIndex' cannot be null.");
        else if (orderIndex !== undefined)
            url_ += "orderIndex=" + encodeURIComponent("" + orderIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCopyAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAsset(dto: UpdateAssetDTO): Observable<AssetDTOStargate> {
        let url_ = this.baseUrl + "/api/Asset/ProductAsset/UpdateAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDTOStargate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDTOStargate>;
        }));
    }

    protected processUpdateAsset(response: HttpResponseBase): Observable<AssetDTOStargate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDTOStargate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAsset(assetId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Asset/ProductAsset/DeleteAsset?";
        if (assetId === null)
            throw new globalThis.Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssetConfigurations(): Observable<AssetConfigurationsDTO> {
        let url_ = this.baseUrl + "/api/Asset/ProductAsset/GetAssetConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetConfigurationsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetConfigurationsDTO>;
        }));
    }

    protected processGetAssetConfigurations(response: HttpResponseBase): Observable<AssetConfigurationsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetConfigurationsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserTokenDTO implements IUserTokenDTO {
    access_token?: string | undefined;
    token_type?: string | undefined;
    username?: string | undefined;
    clientId?: string | undefined;
    refresh_token?: string | undefined;
    refreshTokenExpiresIn?: number;
    expires_in?: number;
    expires?: string | undefined;

    constructor(data?: IUserTokenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.token_type = _data["token_type"];
            this.username = _data["username"];
            this.clientId = _data["clientId"];
            this.refresh_token = _data["refresh_token"];
            this.refreshTokenExpiresIn = _data["refreshTokenExpiresIn"];
            this.expires_in = _data["expires_in"];
            this.expires = _data["expires"];
        }
    }

    static fromJS(data: any): UserTokenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserTokenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["token_type"] = this.token_type;
        data["username"] = this.username;
        data["clientId"] = this.clientId;
        data["refresh_token"] = this.refresh_token;
        data["refreshTokenExpiresIn"] = this.refreshTokenExpiresIn;
        data["expires_in"] = this.expires_in;
        data["expires"] = this.expires;
        return data;
    }
}

export interface IUserTokenDTO {
    access_token?: string | undefined;
    token_type?: string | undefined;
    username?: string | undefined;
    clientId?: string | undefined;
    refresh_token?: string | undefined;
    refreshTokenExpiresIn?: number;
    expires_in?: number;
    expires?: string | undefined;
}

export class UserLoginDTO implements IUserLoginDTO {
    userName?: string | undefined;
    password?: string | undefined;
    grant_Type?: string | undefined;
    client_Id?: string | undefined;
    client_Secret?: string | undefined;
    refresh_Token?: string | undefined;
    twoFactorAuthenticationToken?: string | undefined;

    constructor(data?: IUserLoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.grant_Type = _data["Grant_Type"];
            this.client_Id = _data["Client_Id"];
            this.client_Secret = _data["Client_Secret"];
            this.refresh_Token = _data["Refresh_Token"];
            this.twoFactorAuthenticationToken = _data["TwoFactorAuthenticationToken"];
        }
    }

    static fromJS(data: any): UserLoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["Grant_Type"] = this.grant_Type;
        data["Client_Id"] = this.client_Id;
        data["Client_Secret"] = this.client_Secret;
        data["Refresh_Token"] = this.refresh_Token;
        data["TwoFactorAuthenticationToken"] = this.twoFactorAuthenticationToken;
        return data;
    }
}

export interface IUserLoginDTO {
    userName?: string | undefined;
    password?: string | undefined;
    grant_Type?: string | undefined;
    client_Id?: string | undefined;
    client_Secret?: string | undefined;
    refresh_Token?: string | undefined;
    twoFactorAuthenticationToken?: string | undefined;
}

export class UserLoginAzureDTO implements IUserLoginAzureDTO {
    clientId?: string;
    clientSecret?: string | undefined;

    constructor(data?: IUserLoginAzureDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["ClientId"];
            this.clientSecret = _data["ClientSecret"];
        }
    }

    static fromJS(data: any): UserLoginAzureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAzureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientId"] = this.clientId;
        data["ClientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IUserLoginAzureDTO {
    clientId?: string;
    clientSecret?: string | undefined;
}

export class ClientDTO implements IClientDTO {
    id?: number;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    active?: boolean;
    customerNumber?: string | undefined;
    vendorNumber?: string | undefined;
    salesPersonCode?: string | undefined;
    isLocal?: boolean;

    constructor(data?: IClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.zip = _data["Zip"];
            this.countryCode = _data["CountryCode"];
            this.email = _data["Email"];
            this.name = _data["Name"];
            this.phoneNumber = _data["PhoneNumber"];
            this.active = _data["Active"];
            this.customerNumber = _data["CustomerNumber"];
            this.vendorNumber = _data["VendorNumber"];
            this.salesPersonCode = _data["SalesPersonCode"];
            this.isLocal = _data["IsLocal"];
        }
    }

    static fromJS(data: any): ClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["Zip"] = this.zip;
        data["CountryCode"] = this.countryCode;
        data["Email"] = this.email;
        data["Name"] = this.name;
        data["PhoneNumber"] = this.phoneNumber;
        data["Active"] = this.active;
        data["CustomerNumber"] = this.customerNumber;
        data["VendorNumber"] = this.vendorNumber;
        data["SalesPersonCode"] = this.salesPersonCode;
        data["IsLocal"] = this.isLocal;
        return data;
    }
}

export interface IClientDTO {
    id?: number;
    address?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    active?: boolean;
    customerNumber?: string | undefined;
    vendorNumber?: string | undefined;
    salesPersonCode?: string | undefined;
    isLocal?: boolean;
}

export class CreateClientDTO implements ICreateClientDTO {
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name!: string;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    customerNumber!: string;

    constructor(data?: ICreateClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["Address"];
            this.city = _data["City"];
            this.email = _data["Email"];
            this.name = _data["Name"];
            this.phoneNumber = _data["PhoneNumber"];
            this.zip = _data["Zip"];
            this.countryCode = _data["CountryCode"];
            this.customerNumber = _data["CustomerNumber"];
        }
    }

    static fromJS(data: any): CreateClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Address"] = this.address;
        data["City"] = this.city;
        data["Email"] = this.email;
        data["Name"] = this.name;
        data["PhoneNumber"] = this.phoneNumber;
        data["Zip"] = this.zip;
        data["CountryCode"] = this.countryCode;
        data["CustomerNumber"] = this.customerNumber;
        return data;
    }
}

export interface ICreateClientDTO {
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name: string;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    customerNumber: string;
}

export class PagedResultDTOOfClientDTO implements IPagedResultDTOOfClientDTO {
    items?: ClientDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ClientDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfClientDTO {
    items?: ClientDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class FilterDTO implements IFilterDTO {
    isComplex?: boolean;
    condition?: FilterCondition | undefined;
    field?: string | undefined;
    operator?: FilterOperator | undefined;
    value?: string | undefined;
    predicates?: FilterDTO[] | undefined;

    constructor(data?: IFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplex = _data["IsComplex"];
            this.condition = _data["Condition"];
            this.field = _data["Field"];
            this.operator = _data["Operator"];
            this.value = _data["Value"];
            if (Array.isArray(_data["Predicates"])) {
                this.predicates = [] as any;
                for (let item of _data["Predicates"])
                    this.predicates!.push(FilterDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsComplex"] = this.isComplex;
        data["Condition"] = this.condition;
        data["Field"] = this.field;
        data["Operator"] = this.operator;
        data["Value"] = this.value;
        if (Array.isArray(this.predicates)) {
            data["Predicates"] = [];
            for (let item of this.predicates)
                data["Predicates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterDTO {
    isComplex?: boolean;
    condition?: FilterCondition | undefined;
    field?: string | undefined;
    operator?: FilterOperator | undefined;
    value?: string | undefined;
    predicates?: FilterDTO[] | undefined;
}

export enum FilterCondition {
    And = 0,
    Or = 1,
}

export enum FilterOperator {
    StartsWith = 0,
    EndsWith = 1,
    Contains = 2,
    Equal = 3,
    NotEqual = 4,
    GreaterThan = 5,
    GreaterThanOrEqual = 6,
    LessThan = 7,
    LessThanOrEqual = 8,
    IsNull = 9,
    IsNotNull = 10,
    Any = 11,
    None = 12,
    Empty = 13,
    NotEmpty = 14,
    DoesNotStartWith = 15,
    DoesNotEndWith = 16,
    DoesNotContain = 17,
}

export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export class UpdateClientDTO implements IUpdateClientDTO {
    id?: number;
    active?: boolean | undefined;
    name!: string;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    customerNumber!: string;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUpdateClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.name = _data["Name"];
            this.phoneNumber = _data["PhoneNumber"];
            this.zip = _data["Zip"];
            this.countryCode = _data["CountryCode"];
            this.customerNumber = _data["CustomerNumber"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): UpdateClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Name"] = this.name;
        data["PhoneNumber"] = this.phoneNumber;
        data["Zip"] = this.zip;
        data["CountryCode"] = this.countryCode;
        data["CustomerNumber"] = this.customerNumber;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["Email"] = this.email;
        return data;
    }
}

export interface IUpdateClientDTO {
    id?: number;
    active?: boolean | undefined;
    name: string;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    customerNumber: string;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
}

export enum FileStorageLocationType {
    Assets = 0,
    CustomerRegistration = 1,
}

export class NavisionProductAssetUrl implements INavisionProductAssetUrl {
    products?: AssetUrlProduct[];

    constructor(data?: INavisionProductAssetUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(AssetUrlProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NavisionProductAssetUrl {
        data = typeof data === 'object' ? data : {};
        let result = new NavisionProductAssetUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INavisionProductAssetUrl {
    products?: AssetUrlProduct[];
}

export class AssetUrlProduct implements IAssetUrlProduct {
    sKU?: string | undefined;
    assets?: AssetUrl[];

    constructor(data?: IAssetUrlProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            if (Array.isArray(_data["Assets"])) {
                this.assets = [] as any;
                for (let item of _data["Assets"])
                    this.assets!.push(AssetUrl.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetUrlProduct {
        data = typeof data === 'object' ? data : {};
        let result = new AssetUrlProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        if (Array.isArray(this.assets)) {
            data["Assets"] = [];
            for (let item of this.assets)
                data["Assets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetUrlProduct {
    sKU?: string | undefined;
    assets?: AssetUrl[];
}

export class AssetUrl implements IAssetUrl {
    assetCategoryCode?: string | undefined;
    assetGroupCode?: string | undefined;
    fileName?: string | undefined;
    url?: string | undefined;
    languageIso?: string | undefined;
    specialUsageType?: AssetUsageType;
    fileSizeKb?: number;
    fileExtension?: string | undefined;
    fileVersion?: string | undefined;
    fileResolution?: string | undefined;
    imageType?: string | undefined;

    constructor(data?: IAssetUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetCategoryCode = _data["AssetCategoryCode"];
            this.assetGroupCode = _data["AssetGroupCode"];
            this.fileName = _data["FileName"];
            this.url = _data["Url"];
            this.languageIso = _data["LanguageIso"];
            this.specialUsageType = _data["SpecialUsageType"];
            this.fileSizeKb = _data["FileSizeKb"];
            this.fileExtension = _data["FileExtension"];
            this.fileVersion = _data["FileVersion"];
            this.fileResolution = _data["FileResolution"];
            this.imageType = _data["ImageType"];
        }
    }

    static fromJS(data: any): AssetUrl {
        data = typeof data === 'object' ? data : {};
        let result = new AssetUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssetCategoryCode"] = this.assetCategoryCode;
        data["AssetGroupCode"] = this.assetGroupCode;
        data["FileName"] = this.fileName;
        data["Url"] = this.url;
        data["LanguageIso"] = this.languageIso;
        data["SpecialUsageType"] = this.specialUsageType;
        data["FileSizeKb"] = this.fileSizeKb;
        data["FileExtension"] = this.fileExtension;
        data["FileVersion"] = this.fileVersion;
        data["FileResolution"] = this.fileResolution;
        data["ImageType"] = this.imageType;
        return data;
    }
}

export interface IAssetUrl {
    assetCategoryCode?: string | undefined;
    assetGroupCode?: string | undefined;
    fileName?: string | undefined;
    url?: string | undefined;
    languageIso?: string | undefined;
    specialUsageType?: AssetUsageType;
    fileSizeKb?: number;
    fileExtension?: string | undefined;
    fileVersion?: string | undefined;
    fileResolution?: string | undefined;
    imageType?: string | undefined;
}

export enum AssetUsageType {
    None = 0,
    KeyDataImage = 1,
    KeyDataVideo = 2,
    KeyDataLogo = 3,
}

export class DeleteAssetResponseDTO implements IDeleteAssetResponseDTO {
    affectedProducts?: string[];
    deletedFromFileSystem?: boolean;

    constructor(data?: IDeleteAssetResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["AffectedProducts"])) {
                this.affectedProducts = [] as any;
                for (let item of _data["AffectedProducts"])
                    this.affectedProducts!.push(item);
            }
            this.deletedFromFileSystem = _data["DeletedFromFileSystem"];
        }
    }

    static fromJS(data: any): DeleteAssetResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAssetResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.affectedProducts)) {
            data["AffectedProducts"] = [];
            for (let item of this.affectedProducts)
                data["AffectedProducts"].push(item);
        }
        data["DeletedFromFileSystem"] = this.deletedFromFileSystem;
        return data;
    }
}

export interface IDeleteAssetResponseDTO {
    affectedProducts?: string[];
    deletedFromFileSystem?: boolean;
}

export class SystemInfoDTO implements ISystemInfoDTO {
    version?: string | undefined;
    isWebProvider?: boolean;
    isExecutor?: boolean;
    isHealthy?: boolean;
    serviceInfos?: ServiceInfoDTO[];

    constructor(data?: ISystemInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["Version"];
            this.isWebProvider = _data["IsWebProvider"];
            this.isExecutor = _data["IsExecutor"];
            this.isHealthy = _data["IsHealthy"];
            if (Array.isArray(_data["ServiceInfos"])) {
                this.serviceInfos = [] as any;
                for (let item of _data["ServiceInfos"])
                    this.serviceInfos!.push(ServiceInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Version"] = this.version;
        data["IsWebProvider"] = this.isWebProvider;
        data["IsExecutor"] = this.isExecutor;
        data["IsHealthy"] = this.isHealthy;
        if (Array.isArray(this.serviceInfos)) {
            data["ServiceInfos"] = [];
            for (let item of this.serviceInfos)
                data["ServiceInfos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISystemInfoDTO {
    version?: string | undefined;
    isWebProvider?: boolean;
    isExecutor?: boolean;
    isHealthy?: boolean;
    serviceInfos?: ServiceInfoDTO[];
}

export class ServiceInfoDTO implements IServiceInfoDTO {
    name?: string | undefined;
    isHealthy?: boolean;
    message?: string | undefined;

    constructor(data?: IServiceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.isHealthy = _data["IsHealthy"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ServiceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["IsHealthy"] = this.isHealthy;
        data["Message"] = this.message;
        return data;
    }
}

export interface IServiceInfoDTO {
    name?: string | undefined;
    isHealthy?: boolean;
    message?: string | undefined;
}

export class HAInfoDTO implements IHAInfoDTO {
    isWebProvider?: boolean;
    isExecutor?: boolean;
    webProviderIPAddress?: string | undefined;

    constructor(data?: IHAInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isWebProvider = _data["IsWebProvider"];
            this.isExecutor = _data["IsExecutor"];
            this.webProviderIPAddress = _data["WebProviderIPAddress"];
        }
    }

    static fromJS(data: any): HAInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HAInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsWebProvider"] = this.isWebProvider;
        data["IsExecutor"] = this.isExecutor;
        data["WebProviderIPAddress"] = this.webProviderIPAddress;
        return data;
    }
}

export interface IHAInfoDTO {
    isWebProvider?: boolean;
    isExecutor?: boolean;
    webProviderIPAddress?: string | undefined;
}

export class UserInfoDTO implements IUserInfoDTO {
    userId?: string | undefined;
    clientId?: number | undefined;
    client?: ClientDTO | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: Role[] | undefined;
    enabled?: boolean;
    twoFactorEnabled?: boolean;
    applicationType?: ApplicationType;

    constructor(data?: IUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.clientId = _data["ClientId"];
            this.client = _data["Client"] ? ClientDTO.fromJS(_data["Client"]) : undefined as any;
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.firstname = _data["Firstname"];
            this.lastname = _data["Lastname"];
            this.language = _data["Language"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
            this.enabled = _data["Enabled"];
            this.twoFactorEnabled = _data["TwoFactorEnabled"];
            this.applicationType = _data["ApplicationType"];
        }
    }

    static fromJS(data: any): UserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["ClientId"] = this.clientId;
        data["Client"] = this.client ? this.client.toJSON() : undefined as any;
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["Firstname"] = this.firstname;
        data["Lastname"] = this.lastname;
        data["Language"] = this.language;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["Enabled"] = this.enabled;
        data["TwoFactorEnabled"] = this.twoFactorEnabled;
        data["ApplicationType"] = this.applicationType;
        return data;
    }
}

export interface IUserInfoDTO {
    userId?: string | undefined;
    clientId?: number | undefined;
    client?: ClientDTO | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: Role[] | undefined;
    enabled?: boolean;
    twoFactorEnabled?: boolean;
    applicationType?: ApplicationType;
}

export enum Role {
    None = 0,
    Admin = 1,
    Bitrix = 2,
    Magento = 3,
    Navision = 4,
    BtoEncoway = 5,
    Econwork = 6,
    ConfigurationInterfaceAdmin = 7,
    ConfigurationInterfaceUser = 8,
    InterfaceServiceAccess = 9,
    ManualImportSalesOrderUser = 10,
    ProductAssetManagement = 11,
    BrandLogoManagement = 12,
    AssetStorageAdmin = 13,
    AssetStorageLimitedAdmin = 14,
    AssetStorageDownload = 15,
    AssetStorageUpload = 16,
    AssetStorageGroupMember = 17,
    VendorScoreCardFull = 18,
    Parashift = 19,
    ZirWebhook = 20,
}

export enum ApplicationType {
    Mobile = 0,
    Web = 1,
}

export class PagedResultDTOOfUserInfoDTO implements IPagedResultDTOOfUserInfoDTO {
    items?: UserInfoDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(UserInfoDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfUserInfoDTO {
    items?: UserInfoDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class UpdateUserInfoDTO implements IUpdateUserInfoDTO {
    userId!: string;
    clientId?: number | undefined;
    email?: string | undefined;
    enabled?: boolean | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    roles?: Role[] | undefined;

    constructor(data?: IUpdateUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.clientId = _data["ClientId"];
            this.email = _data["Email"];
            this.enabled = _data["Enabled"];
            this.firstname = _data["Firstname"];
            this.lastname = _data["Lastname"];
            this.language = _data["Language"];
            this.phoneNumber = _data["PhoneNumber"];
            this.password = _data["Password"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["ClientId"] = this.clientId;
        data["Email"] = this.email;
        data["Enabled"] = this.enabled;
        data["Firstname"] = this.firstname;
        data["Lastname"] = this.lastname;
        data["Language"] = this.language;
        data["PhoneNumber"] = this.phoneNumber;
        data["Password"] = this.password;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserInfoDTO {
    userId: string;
    clientId?: number | undefined;
    email?: string | undefined;
    enabled?: boolean | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    roles?: Role[] | undefined;
}

export class UpdateInterfaceUserInfoDTO implements IUpdateInterfaceUserInfoDTO {
    userId!: string;
    clientId?: number | undefined;
    enabled?: boolean;
    firstname?: string | undefined;
    lastname?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    roles?: Role[] | undefined;

    constructor(data?: IUpdateInterfaceUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.clientId = _data["ClientId"];
            this.enabled = _data["Enabled"];
            this.firstname = _data["Firstname"];
            this.lastname = _data["Lastname"];
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.email = _data["Email"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateInterfaceUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInterfaceUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["ClientId"] = this.clientId;
        data["Enabled"] = this.enabled;
        data["Firstname"] = this.firstname;
        data["Lastname"] = this.lastname;
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["Email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        return data;
    }
}

export interface IUpdateInterfaceUserInfoDTO {
    userId: string;
    clientId?: number | undefined;
    enabled?: boolean;
    firstname?: string | undefined;
    lastname?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    roles?: Role[] | undefined;
}

export class CreateInterfaceUserDTO implements ICreateInterfaceUserDTO {
    clientId?: number;
    userName!: string;
    password!: string;
    email?: string | undefined;
    roles?: Role[] | undefined;

    constructor(data?: ICreateInterfaceUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["ClientId"];
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.email = _data["Email"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateInterfaceUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInterfaceUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientId"] = this.clientId;
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["Email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        return data;
    }
}

export interface ICreateInterfaceUserDTO {
    clientId?: number;
    userName: string;
    password: string;
    email?: string | undefined;
    roles?: Role[] | undefined;
}

export class CreateUserDTO implements ICreateUserDTO {
    clientId?: number | undefined;
    email!: string;
    firstname!: string;
    lastname!: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    roles?: Role[] | undefined;

    constructor(data?: ICreateUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["ClientId"];
            this.email = _data["Email"];
            this.firstname = _data["Firstname"];
            this.lastname = _data["Lastname"];
            this.language = _data["Language"];
            this.phoneNumber = _data["PhoneNumber"];
            this.userName = _data["UserName"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientId"] = this.clientId;
        data["Email"] = this.email;
        data["Firstname"] = this.firstname;
        data["Lastname"] = this.lastname;
        data["Language"] = this.language;
        data["PhoneNumber"] = this.phoneNumber;
        data["UserName"] = this.userName;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        return data;
    }
}

export interface ICreateUserDTO {
    clientId?: number | undefined;
    email: string;
    firstname: string;
    lastname: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    roles?: Role[] | undefined;
}

export class ChangePasswordDTO implements IChangePasswordDTO {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["OldPassword"];
            this.newPassword = _data["NewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OldPassword"] = this.oldPassword;
        data["NewPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDTO {
    oldPassword: string;
    newPassword: string;
}

export class SetPasswordDTO implements ISetPasswordDTO {
    newPassword!: string;
    verificationToken!: string;
    userId!: string;
    forgotPasswordProcess?: boolean | undefined;

    constructor(data?: ISetPasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["NewPassword"];
            this.verificationToken = _data["VerificationToken"];
            this.userId = _data["UserId"];
            this.forgotPasswordProcess = _data["ForgotPasswordProcess"];
        }
    }

    static fromJS(data: any): SetPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NewPassword"] = this.newPassword;
        data["VerificationToken"] = this.verificationToken;
        data["UserId"] = this.userId;
        data["ForgotPasswordProcess"] = this.forgotPasswordProcess;
        return data;
    }
}

export interface ISetPasswordDTO {
    newPassword: string;
    verificationToken: string;
    userId: string;
    forgotPasswordProcess?: boolean | undefined;
}

export class RoleMappingInfoDTO implements IRoleMappingInfoDTO {
    fixedUserRoles?: Role[];
    viewRoles?: Role[];
    editRoles?: Role[];

    constructor(data?: IRoleMappingInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["FixedUserRoles"])) {
                this.fixedUserRoles = [] as any;
                for (let item of _data["FixedUserRoles"])
                    this.fixedUserRoles!.push(item);
            }
            if (Array.isArray(_data["ViewRoles"])) {
                this.viewRoles = [] as any;
                for (let item of _data["ViewRoles"])
                    this.viewRoles!.push(item);
            }
            if (Array.isArray(_data["EditRoles"])) {
                this.editRoles = [] as any;
                for (let item of _data["EditRoles"])
                    this.editRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleMappingInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleMappingInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fixedUserRoles)) {
            data["FixedUserRoles"] = [];
            for (let item of this.fixedUserRoles)
                data["FixedUserRoles"].push(item);
        }
        if (Array.isArray(this.viewRoles)) {
            data["ViewRoles"] = [];
            for (let item of this.viewRoles)
                data["ViewRoles"].push(item);
        }
        if (Array.isArray(this.editRoles)) {
            data["EditRoles"] = [];
            for (let item of this.editRoles)
                data["EditRoles"].push(item);
        }
        return data;
    }
}

export interface IRoleMappingInfoDTO {
    fixedUserRoles?: Role[];
    viewRoles?: Role[];
    editRoles?: Role[];
}

export class ForgotPasswordDTO implements IForgotPasswordDTO {
    username!: string;

    constructor(data?: IForgotPasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["Username"];
        }
    }

    static fromJS(data: any): ForgotPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Username"] = this.username;
        return data;
    }
}

export interface IForgotPasswordDTO {
    username: string;
}

export class Request2FARegistrationCodeResponseDTO implements IRequest2FARegistrationCodeResponseDTO {
    code?: string;
    qRCode?: string;

    constructor(data?: IRequest2FARegistrationCodeResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.qRCode = _data["QRCode"];
        }
    }

    static fromJS(data: any): Request2FARegistrationCodeResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Request2FARegistrationCodeResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["QRCode"] = this.qRCode;
        return data;
    }
}

export interface IRequest2FARegistrationCodeResponseDTO {
    code?: string;
    qRCode?: string;
}

export class Request2FARegistrationCodeDTO implements IRequest2FARegistrationCodeDTO {
    userName?: string | undefined;
    userId?: string | undefined;
    password!: string;
    recoveryCode?: string | undefined;

    constructor(data?: IRequest2FARegistrationCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.userId = _data["UserId"];
            this.password = _data["Password"];
            this.recoveryCode = _data["RecoveryCode"];
        }
    }

    static fromJS(data: any): Request2FARegistrationCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Request2FARegistrationCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["UserId"] = this.userId;
        data["Password"] = this.password;
        data["RecoveryCode"] = this.recoveryCode;
        return data;
    }
}

export interface IRequest2FARegistrationCodeDTO {
    userName?: string | undefined;
    userId?: string | undefined;
    password: string;
    recoveryCode?: string | undefined;
}

export class Verify2FARegistrationCodeResponseDTO implements IVerify2FARegistrationCodeResponseDTO {
    success?: boolean;

    constructor(data?: IVerify2FARegistrationCodeResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
        }
    }

    static fromJS(data: any): Verify2FARegistrationCodeResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Verify2FARegistrationCodeResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        return data;
    }
}

export interface IVerify2FARegistrationCodeResponseDTO {
    success?: boolean;
}

export class Verify2FARegistrationCodeDTO implements IVerify2FARegistrationCodeDTO {
    userName?: string | undefined;
    userId?: string | undefined;
    password!: string;
    code!: string;

    constructor(data?: IVerify2FARegistrationCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.userId = _data["UserId"];
            this.password = _data["Password"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): Verify2FARegistrationCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Verify2FARegistrationCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["UserId"] = this.userId;
        data["Password"] = this.password;
        data["Code"] = this.code;
        return data;
    }
}

export interface IVerify2FARegistrationCodeDTO {
    userName?: string | undefined;
    userId?: string | undefined;
    password: string;
    code: string;
}

export class RequestSelfReset2FARegistrationDTO implements IRequestSelfReset2FARegistrationDTO {
    userName!: string;
    password!: string;

    constructor(data?: IRequestSelfReset2FARegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): RequestSelfReset2FARegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestSelfReset2FARegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        return data;
    }
}

export interface IRequestSelfReset2FARegistrationDTO {
    userName: string;
    password: string;
}

export class ZirWebhookResponseDTO implements IZirWebhookResponseDTO {
    status?: string | undefined;
    message?: string | undefined;

    constructor(data?: IZirWebhookResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ZirWebhookResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZirWebhookResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["Message"] = this.message;
        return data;
    }
}

export interface IZirWebhookResponseDTO {
    status?: string | undefined;
    message?: string | undefined;
}

export class ZirWebhookEventDTO implements IZirWebhookEventDTO {
    id?: string;
    type?: string;
    payload?: any | undefined;

    constructor(data?: IZirWebhookEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.type = _data["Type"];
            this.payload = _data["Payload"];
        }
    }

    static fromJS(data: any): ZirWebhookEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZirWebhookEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Type"] = this.type;
        data["Payload"] = this.payload;
        return data;
    }
}

export interface IZirWebhookEventDTO {
    id?: string;
    type?: string;
    payload?: any | undefined;
}

export class CreditMemoDTO implements ICreditMemoDTO {
    creditMemoNo?: string | undefined;
    amount?: number;
    currencyCodeIso?: string | undefined;
    customerReference?: string | undefined;
    postingDateIso?: string | undefined;

    constructor(data?: ICreditMemoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creditMemoNo = _data["CreditMemoNo"];
            this.amount = _data["Amount"];
            this.currencyCodeIso = _data["CurrencyCodeIso"];
            this.customerReference = _data["CustomerReference"];
            this.postingDateIso = _data["PostingDateIso"];
        }
    }

    static fromJS(data: any): CreditMemoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreditMemoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CreditMemoNo"] = this.creditMemoNo;
        data["Amount"] = this.amount;
        data["CurrencyCodeIso"] = this.currencyCodeIso;
        data["CustomerReference"] = this.customerReference;
        data["PostingDateIso"] = this.postingDateIso;
        return data;
    }
}

export interface ICreditMemoDTO {
    creditMemoNo?: string | undefined;
    amount?: number;
    currencyCodeIso?: string | undefined;
    customerReference?: string | undefined;
    postingDateIso?: string | undefined;
}

export class WebshopProductAssetDTO implements IWebshopProductAssetDTO {
    sKU?: string | undefined;
    assetsRootUrl?: string | undefined;
    assets?: WebshopAssetDTO[] | undefined;

    constructor(data?: IWebshopProductAssetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.assetsRootUrl = _data["AssetsRootUrl"];
            if (Array.isArray(_data["Assets"])) {
                this.assets = [] as any;
                for (let item of _data["Assets"])
                    this.assets!.push(WebshopAssetDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebshopProductAssetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebshopProductAssetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["AssetsRootUrl"] = this.assetsRootUrl;
        if (Array.isArray(this.assets)) {
            data["Assets"] = [];
            for (let item of this.assets)
                data["Assets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWebshopProductAssetDTO {
    sKU?: string | undefined;
    assetsRootUrl?: string | undefined;
    assets?: WebshopAssetDTO[] | undefined;
}

export class WebshopAssetDTO implements IWebshopAssetDTO {
    id?: number;
    displayName?: string | undefined;
    altText?: string | undefined;
    fileExtension?: string | undefined;
    fileSizeKb?: number;
    fileRelativeUrl?: string | undefined;
    languageCodeIso?: string | undefined;
    type?: AssetType;
    shops?: WebshopAssetShopDTO[] | undefined;

    constructor(data?: IWebshopAssetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.displayName = _data["DisplayName"];
            this.altText = _data["AltText"];
            this.fileExtension = _data["FileExtension"];
            this.fileSizeKb = _data["FileSizeKb"];
            this.fileRelativeUrl = _data["FileRelativeUrl"];
            this.languageCodeIso = _data["LanguageCodeIso"];
            this.type = _data["Type"];
            if (Array.isArray(_data["Shops"])) {
                this.shops = [] as any;
                for (let item of _data["Shops"])
                    this.shops!.push(WebshopAssetShopDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebshopAssetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebshopAssetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DisplayName"] = this.displayName;
        data["AltText"] = this.altText;
        data["FileExtension"] = this.fileExtension;
        data["FileSizeKb"] = this.fileSizeKb;
        data["FileRelativeUrl"] = this.fileRelativeUrl;
        data["LanguageCodeIso"] = this.languageCodeIso;
        data["Type"] = this.type;
        if (Array.isArray(this.shops)) {
            data["Shops"] = [];
            for (let item of this.shops)
                data["Shops"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWebshopAssetDTO {
    id?: number;
    displayName?: string | undefined;
    altText?: string | undefined;
    fileExtension?: string | undefined;
    fileSizeKb?: number;
    fileRelativeUrl?: string | undefined;
    languageCodeIso?: string | undefined;
    type?: AssetType;
    shops?: WebshopAssetShopDTO[] | undefined;
}

export enum AssetType {
    Unknown = 0,
    Image = 1,
    Logo = 2,
    LandingPage = 3,
    DataSheet = 4,
    UserManual = 5,
    PressReview = 6,
    QuickStartGuide = 7,
    SalesDocument = 8,
    TestReport = 9,
    UseCase = 10,
    TechnicalDrawing = 11,
    Certificate = 12,
}

export class WebshopAssetShopDTO implements IWebshopAssetShopDTO {
    shopId?: string | undefined;
    isKey?: boolean;

    constructor(data?: IWebshopAssetShopDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopId = _data["ShopId"];
            this.isKey = _data["IsKey"];
        }
    }

    static fromJS(data: any): WebshopAssetShopDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebshopAssetShopDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShopId"] = this.shopId;
        data["IsKey"] = this.isKey;
        return data;
    }
}

export interface IWebshopAssetShopDTO {
    shopId?: string | undefined;
    isKey?: boolean;
}

export class SetProductAssetsStatusDTO implements ISetProductAssetsStatusDTO {
    assets?: ProductAssetStatusDTO[] | undefined;

    constructor(data?: ISetProductAssetsStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Assets"])) {
                this.assets = [] as any;
                for (let item of _data["Assets"])
                    this.assets!.push(ProductAssetStatusDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetProductAssetsStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetProductAssetsStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assets)) {
            data["Assets"] = [];
            for (let item of this.assets)
                data["Assets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetProductAssetsStatusDTO {
    assets?: ProductAssetStatusDTO[] | undefined;
}

export class ProductAssetStatusDTO implements IProductAssetStatusDTO {
    id!: number;
    status!: AssetSyncStatus;
    message?: string | undefined;

    constructor(data?: IProductAssetStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.status = _data["Status"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ProductAssetStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAssetStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Status"] = this.status;
        data["Message"] = this.message;
        return data;
    }
}

export interface IProductAssetStatusDTO {
    id: number;
    status: AssetSyncStatus;
    message?: string | undefined;
}

export enum AssetSyncStatus {
    Pending = 0,
    Synced = 1,
    Error = 2,
}

export class GetAttributeListResponseDTO implements IGetAttributeListResponseDTO {
    attributeList?: AttributeDTO[] | undefined;

    constructor(data?: IGetAttributeListResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["AttributeList"])) {
                this.attributeList = [] as any;
                for (let item of _data["AttributeList"])
                    this.attributeList!.push(AttributeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAttributeListResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttributeListResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attributeList)) {
            data["AttributeList"] = [];
            for (let item of this.attributeList)
                data["AttributeList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAttributeListResponseDTO {
    attributeList?: AttributeDTO[] | undefined;
}

export class AttributeDTO implements IAttributeDTO {
    attributeCode?: string | undefined;
    description?: string | undefined;
    baseUnitOfMeasureText?: string | undefined;
    translations?: TranslationDTO[] | undefined;
    values?: AttributeValueDTO[] | undefined;

    constructor(data?: IAttributeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeCode = _data["AttributeCode"];
            this.description = _data["Description"];
            this.baseUnitOfMeasureText = _data["BaseUnitOfMeasureText"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(TranslationDTO.fromJS(item));
            }
            if (Array.isArray(_data["Values"])) {
                this.values = [] as any;
                for (let item of _data["Values"])
                    this.values!.push(AttributeValueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttributeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AttributeCode"] = this.attributeCode;
        data["Description"] = this.description;
        data["BaseUnitOfMeasureText"] = this.baseUnitOfMeasureText;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.values)) {
            data["Values"] = [];
            for (let item of this.values)
                data["Values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAttributeDTO {
    attributeCode?: string | undefined;
    description?: string | undefined;
    baseUnitOfMeasureText?: string | undefined;
    translations?: TranslationDTO[] | undefined;
    values?: AttributeValueDTO[] | undefined;
}

export class TranslationDTO implements ITranslationDTO {
    languageCode?: string | undefined;
    translation?: string | undefined;

    constructor(data?: ITranslationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["LanguageCode"];
            this.translation = _data["Translation"];
        }
    }

    static fromJS(data: any): TranslationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageCode"] = this.languageCode;
        data["Translation"] = this.translation;
        return data;
    }
}

export interface ITranslationDTO {
    languageCode?: string | undefined;
    translation?: string | undefined;
}

export class AttributeValueDTO implements IAttributeValueDTO {
    attributeValue?: string | undefined;
    attributeValueID?: number;
    translations?: TranslationDTO[] | undefined;

    constructor(data?: IAttributeValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeValue = _data["AttributeValue"];
            this.attributeValueID = _data["AttributeValueID"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(TranslationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttributeValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AttributeValue"] = this.attributeValue;
        data["AttributeValueID"] = this.attributeValueID;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAttributeValueDTO {
    attributeValue?: string | undefined;
    attributeValueID?: number;
    translations?: TranslationDTO[] | undefined;
}

export class GetProductListResponseDTO implements IGetProductListResponseDTO {
    productList?: BaseProductDTO[] | undefined;
    totalProducts?: number;

    constructor(data?: IGetProductListResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ProductList"])) {
                this.productList = [] as any;
                for (let item of _data["ProductList"])
                    this.productList!.push(BaseProductDTO.fromJS(item));
            }
            this.totalProducts = _data["TotalProducts"];
        }
    }

    static fromJS(data: any): GetProductListResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductListResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productList)) {
            data["ProductList"] = [];
            for (let item of this.productList)
                data["ProductList"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalProducts"] = this.totalProducts;
        return data;
    }
}

export interface IGetProductListResponseDTO {
    productList?: BaseProductDTO[] | undefined;
    totalProducts?: number;
}

export class BaseProductDTO implements IBaseProductDTO {
    sKU?: string | undefined;
    vendorItemSKU?: string | undefined;
    belongingCategoryIds?: string[];
    brandCode?: string | undefined;
    family?: string | undefined;
    status?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    profileCode?: string | undefined;
    barCode?: string | undefined;
    shopIds?: string[];
    assets?: AssetDTO[];
    attributes?: ProductAttributeDTO[];
    attributeDescriptions?: ProductDescriptionDTO[];
    packageContents?: ProductPackageContentDTO[] | undefined;
    technicalInfos?: ProductTechnicalInfoDTO[];
    keywords?: KeywordsDTO[];
    warranties?: ProductWarrantyDTO[];

    constructor(data?: IBaseProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.vendorItemSKU = _data["VendorItemSKU"];
            if (Array.isArray(_data["BelongingCategoryIds"])) {
                this.belongingCategoryIds = [] as any;
                for (let item of _data["BelongingCategoryIds"])
                    this.belongingCategoryIds!.push(item);
            }
            this.brandCode = _data["BrandCode"];
            this.family = _data["Family"];
            this.status = _data["Status"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.profileCode = _data["ProfileCode"];
            this.barCode = _data["BarCode"];
            if (Array.isArray(_data["ShopIds"])) {
                this.shopIds = [] as any;
                for (let item of _data["ShopIds"])
                    this.shopIds!.push(item);
            }
            if (Array.isArray(_data["Assets"])) {
                this.assets = [] as any;
                for (let item of _data["Assets"])
                    this.assets!.push(AssetDTO.fromJS(item));
            }
            if (Array.isArray(_data["Attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["Attributes"])
                    this.attributes!.push(ProductAttributeDTO.fromJS(item));
            }
            if (Array.isArray(_data["AttributeDescriptions"])) {
                this.attributeDescriptions = [] as any;
                for (let item of _data["AttributeDescriptions"])
                    this.attributeDescriptions!.push(ProductDescriptionDTO.fromJS(item));
            }
            if (Array.isArray(_data["PackageContents"])) {
                this.packageContents = [] as any;
                for (let item of _data["PackageContents"])
                    this.packageContents!.push(ProductPackageContentDTO.fromJS(item));
            }
            if (Array.isArray(_data["TechnicalInfos"])) {
                this.technicalInfos = [] as any;
                for (let item of _data["TechnicalInfos"])
                    this.technicalInfos!.push(ProductTechnicalInfoDTO.fromJS(item));
            }
            if (Array.isArray(_data["Keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["Keywords"])
                    this.keywords!.push(KeywordsDTO.fromJS(item));
            }
            if (Array.isArray(_data["Warranties"])) {
                this.warranties = [] as any;
                for (let item of _data["Warranties"])
                    this.warranties!.push(ProductWarrantyDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["VendorItemSKU"] = this.vendorItemSKU;
        if (Array.isArray(this.belongingCategoryIds)) {
            data["BelongingCategoryIds"] = [];
            for (let item of this.belongingCategoryIds)
                data["BelongingCategoryIds"].push(item);
        }
        data["BrandCode"] = this.brandCode;
        data["Family"] = this.family;
        data["Status"] = this.status;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["ProfileCode"] = this.profileCode;
        data["BarCode"] = this.barCode;
        if (Array.isArray(this.shopIds)) {
            data["ShopIds"] = [];
            for (let item of this.shopIds)
                data["ShopIds"].push(item);
        }
        if (Array.isArray(this.assets)) {
            data["Assets"] = [];
            for (let item of this.assets)
                data["Assets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attributes)) {
            data["Attributes"] = [];
            for (let item of this.attributes)
                data["Attributes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attributeDescriptions)) {
            data["AttributeDescriptions"] = [];
            for (let item of this.attributeDescriptions)
                data["AttributeDescriptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.packageContents)) {
            data["PackageContents"] = [];
            for (let item of this.packageContents)
                data["PackageContents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.technicalInfos)) {
            data["TechnicalInfos"] = [];
            for (let item of this.technicalInfos)
                data["TechnicalInfos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.keywords)) {
            data["Keywords"] = [];
            for (let item of this.keywords)
                data["Keywords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warranties)) {
            data["Warranties"] = [];
            for (let item of this.warranties)
                data["Warranties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBaseProductDTO {
    sKU?: string | undefined;
    vendorItemSKU?: string | undefined;
    belongingCategoryIds?: string[];
    brandCode?: string | undefined;
    family?: string | undefined;
    status?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    profileCode?: string | undefined;
    barCode?: string | undefined;
    shopIds?: string[];
    assets?: AssetDTO[];
    attributes?: ProductAttributeDTO[];
    attributeDescriptions?: ProductDescriptionDTO[];
    packageContents?: ProductPackageContentDTO[] | undefined;
    technicalInfos?: ProductTechnicalInfoDTO[];
    keywords?: KeywordsDTO[];
    warranties?: ProductWarrantyDTO[];
}

export class AssetDTO implements IAssetDTO {
    assetCategoryCode?: string | undefined;
    assetGroupCode?: string | undefined;
    fileName?: string | undefined;
    languageIso?: string | undefined;
    specialUsageType?: AssetUsageType;
    fileBase64?: string | undefined;

    constructor(data?: IAssetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetCategoryCode = _data["AssetCategoryCode"];
            this.assetGroupCode = _data["AssetGroupCode"];
            this.fileName = _data["FileName"];
            this.languageIso = _data["LanguageIso"];
            this.specialUsageType = _data["SpecialUsageType"];
            this.fileBase64 = _data["FileBase64"];
        }
    }

    static fromJS(data: any): AssetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssetCategoryCode"] = this.assetCategoryCode;
        data["AssetGroupCode"] = this.assetGroupCode;
        data["FileName"] = this.fileName;
        data["LanguageIso"] = this.languageIso;
        data["SpecialUsageType"] = this.specialUsageType;
        data["FileBase64"] = this.fileBase64;
        return data;
    }
}

export interface IAssetDTO {
    assetCategoryCode?: string | undefined;
    assetGroupCode?: string | undefined;
    fileName?: string | undefined;
    languageIso?: string | undefined;
    specialUsageType?: AssetUsageType;
    fileBase64?: string | undefined;
}

export class ProductAttributeDTO implements IProductAttributeDTO {
    attributeCode?: string | undefined;
    attributeValueID?: number | undefined;
    attributeValue?: any | undefined;
    sortIndex?: number;

    constructor(data?: IProductAttributeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeCode = _data["AttributeCode"];
            this.attributeValueID = _data["AttributeValueID"];
            this.attributeValue = _data["AttributeValue"];
            this.sortIndex = _data["SortIndex"];
        }
    }

    static fromJS(data: any): ProductAttributeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AttributeCode"] = this.attributeCode;
        data["AttributeValueID"] = this.attributeValueID;
        data["AttributeValue"] = this.attributeValue;
        data["SortIndex"] = this.sortIndex;
        return data;
    }
}

export interface IProductAttributeDTO {
    attributeCode?: string | undefined;
    attributeValueID?: number | undefined;
    attributeValue?: any | undefined;
    sortIndex?: number;
}

export class ProductDescriptionDTO implements IProductDescriptionDTO {
    languageIso?: string | undefined;
    descriptionHTMLBase64?: string | undefined;

    constructor(data?: IProductDescriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageIso = _data["LanguageIso"];
            this.descriptionHTMLBase64 = _data["DescriptionHTMLBase64"];
        }
    }

    static fromJS(data: any): ProductDescriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDescriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageIso"] = this.languageIso;
        data["DescriptionHTMLBase64"] = this.descriptionHTMLBase64;
        return data;
    }
}

export interface IProductDescriptionDTO {
    languageIso?: string | undefined;
    descriptionHTMLBase64?: string | undefined;
}

export class ProductPackageContentDTO implements IProductPackageContentDTO {
    content?: string | undefined;
    quantity?: number;

    constructor(data?: IProductPackageContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["Content"];
            this.quantity = _data["Quantity"];
        }
    }

    static fromJS(data: any): ProductPackageContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPackageContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Content"] = this.content;
        data["Quantity"] = this.quantity;
        return data;
    }
}

export interface IProductPackageContentDTO {
    content?: string | undefined;
    quantity?: number;
}

export class ProductTechnicalInfoDTO implements IProductTechnicalInfoDTO {
    languageIso?: string | undefined;
    infoHTMLBase64?: string | undefined;

    constructor(data?: IProductTechnicalInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageIso = _data["LanguageIso"];
            this.infoHTMLBase64 = _data["InfoHTMLBase64"];
        }
    }

    static fromJS(data: any): ProductTechnicalInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTechnicalInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageIso"] = this.languageIso;
        data["InfoHTMLBase64"] = this.infoHTMLBase64;
        return data;
    }
}

export interface IProductTechnicalInfoDTO {
    languageIso?: string | undefined;
    infoHTMLBase64?: string | undefined;
}

export class KeywordsDTO implements IKeywordsDTO {
    languageIso?: string | undefined;
    keywords?: string[] | undefined;

    constructor(data?: IKeywordsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageIso = _data["LanguageIso"];
            if (Array.isArray(_data["Keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["Keywords"])
                    this.keywords!.push(item);
            }
        }
    }

    static fromJS(data: any): KeywordsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KeywordsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageIso"] = this.languageIso;
        if (Array.isArray(this.keywords)) {
            data["Keywords"] = [];
            for (let item of this.keywords)
                data["Keywords"].push(item);
        }
        return data;
    }
}

export interface IKeywordsDTO {
    languageIso?: string | undefined;
    keywords?: string[] | undefined;
}

export class ProductWarrantyDTO implements IProductWarrantyDTO {
    termsCode?: string | undefined;
    duration?: number;
    durationUnit?: string | undefined;

    constructor(data?: IProductWarrantyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termsCode = _data["TermsCode"];
            this.duration = _data["Duration"];
            this.durationUnit = _data["DurationUnit"];
        }
    }

    static fromJS(data: any): ProductWarrantyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductWarrantyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TermsCode"] = this.termsCode;
        data["Duration"] = this.duration;
        data["DurationUnit"] = this.durationUnit;
        return data;
    }
}

export interface IProductWarrantyDTO {
    termsCode?: string | undefined;
    duration?: number;
    durationUnit?: string | undefined;
}

export class GetProductGameListResponseDTO implements IGetProductGameListResponseDTO {
    productGameList?: ProductGamesDTO[] | undefined;
    totalNumberOfProducts?: number;

    constructor(data?: IGetProductGameListResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ProductGameList"])) {
                this.productGameList = [] as any;
                for (let item of _data["ProductGameList"])
                    this.productGameList!.push(ProductGamesDTO.fromJS(item));
            }
            this.totalNumberOfProducts = _data["TotalNumberOfProducts"];
        }
    }

    static fromJS(data: any): GetProductGameListResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductGameListResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productGameList)) {
            data["ProductGameList"] = [];
            for (let item of this.productGameList)
                data["ProductGameList"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfProducts"] = this.totalNumberOfProducts;
        return data;
    }
}

export interface IGetProductGameListResponseDTO {
    productGameList?: ProductGamesDTO[] | undefined;
    totalNumberOfProducts?: number;
}

export class ProductGamesDTO implements IProductGamesDTO {
    sKU?: string | undefined;
    games?: GameDTO[] | undefined;

    constructor(data?: IProductGamesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            if (Array.isArray(_data["Games"])) {
                this.games = [] as any;
                for (let item of _data["Games"])
                    this.games!.push(GameDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductGamesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGamesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        if (Array.isArray(this.games)) {
            data["Games"] = [];
            for (let item of this.games)
                data["Games"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductGamesDTO {
    sKU?: string | undefined;
    games?: GameDTO[] | undefined;
}

export class GameDTO implements IGameDTO {
    name?: string | undefined;
    performances?: GamePerformanceDTO[] | undefined;

    constructor(data?: IGameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["Performances"])) {
                this.performances = [] as any;
                for (let item of _data["Performances"])
                    this.performances!.push(GamePerformanceDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.performances)) {
            data["Performances"] = [];
            for (let item of this.performances)
                data["Performances"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGameDTO {
    name?: string | undefined;
    performances?: GamePerformanceDTO[] | undefined;
}

export class GamePerformanceDTO implements IGamePerformanceDTO {
    resolution?: number;
    fPS?: number;

    constructor(data?: IGamePerformanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resolution = _data["Resolution"];
            this.fPS = _data["FPS"];
        }
    }

    static fromJS(data: any): GamePerformanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GamePerformanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Resolution"] = this.resolution;
        data["FPS"] = this.fPS;
        return data;
    }
}

export interface IGamePerformanceDTO {
    resolution?: number;
    fPS?: number;
}

export class SetShopProductUrlsDTO implements ISetShopProductUrlsDTO {
    productUrls?: ProductUrlDTO[] | undefined;

    constructor(data?: ISetShopProductUrlsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ProductUrls"])) {
                this.productUrls = [] as any;
                for (let item of _data["ProductUrls"])
                    this.productUrls!.push(ProductUrlDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetShopProductUrlsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetShopProductUrlsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productUrls)) {
            data["ProductUrls"] = [];
            for (let item of this.productUrls)
                data["ProductUrls"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetShopProductUrlsDTO {
    productUrls?: ProductUrlDTO[] | undefined;
}

export class ProductUrlDTO implements IProductUrlDTO {
    shopId!: string;
    countryCodeIso!: string;
    sKU!: string;
    url!: string;
    deliveryTime?: string | undefined;

    constructor(data?: IProductUrlDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopId = _data["ShopId"];
            this.countryCodeIso = _data["CountryCodeIso"];
            this.sKU = _data["SKU"];
            this.url = _data["Url"];
            this.deliveryTime = _data["DeliveryTime"];
        }
    }

    static fromJS(data: any): ProductUrlDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductUrlDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShopId"] = this.shopId;
        data["CountryCodeIso"] = this.countryCodeIso;
        data["SKU"] = this.sKU;
        data["Url"] = this.url;
        data["DeliveryTime"] = this.deliveryTime;
        return data;
    }
}

export interface IProductUrlDTO {
    shopId: string;
    countryCodeIso: string;
    sKU: string;
    url: string;
    deliveryTime?: string | undefined;
}

export class GetBrandsResponseDTO implements IGetBrandsResponseDTO {
    brands?: BrandDTO[] | undefined;

    constructor(data?: IGetBrandsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Brands"])) {
                this.brands = [] as any;
                for (let item of _data["Brands"])
                    this.brands!.push(BrandDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBrandsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.brands)) {
            data["Brands"] = [];
            for (let item of this.brands)
                data["Brands"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetBrandsResponseDTO {
    brands?: BrandDTO[] | undefined;
}

export class BrandDTO implements IBrandDTO {
    code?: string | undefined;
    name?: string | undefined;
    vendorName?: string | undefined;
    homePage?: string | undefined;

    constructor(data?: IBrandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.name = _data["Name"];
            this.vendorName = _data["VendorName"];
            this.homePage = _data["HomePage"];
        }
    }

    static fromJS(data: any): BrandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BrandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Name"] = this.name;
        data["VendorName"] = this.vendorName;
        data["HomePage"] = this.homePage;
        return data;
    }
}

export interface IBrandDTO {
    code?: string | undefined;
    name?: string | undefined;
    vendorName?: string | undefined;
    homePage?: string | undefined;
}

export class BTODetailsDTO implements IBTODetailsDTO {
    sKU?: string | undefined;
    productName?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    currencyCodeIso?: string | undefined;
    components?: BTOComponentDTO[] | undefined;

    constructor(data?: IBTODetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.productName = _data["ProductName"];
            this.quantity = _data["Quantity"];
            this.unitPrice = _data["UnitPrice"];
            this.currencyCodeIso = _data["CurrencyCodeIso"];
            if (Array.isArray(_data["Components"])) {
                this.components = [] as any;
                for (let item of _data["Components"])
                    this.components!.push(BTOComponentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BTODetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BTODetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["ProductName"] = this.productName;
        data["Quantity"] = this.quantity;
        data["UnitPrice"] = this.unitPrice;
        data["CurrencyCodeIso"] = this.currencyCodeIso;
        if (Array.isArray(this.components)) {
            data["Components"] = [];
            for (let item of this.components)
                data["Components"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBTODetailsDTO {
    sKU?: string | undefined;
    productName?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    currencyCodeIso?: string | undefined;
    components?: BTOComponentDTO[] | undefined;
}

export class BTOComponentDTO implements IBTOComponentDTO {
    group?: string | undefined;
    brand?: string | undefined;
    description?: string | undefined;
    quantity?: number;

    constructor(data?: IBTOComponentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["Group"];
            this.brand = _data["Brand"];
            this.description = _data["Description"];
            this.quantity = _data["Quantity"];
        }
    }

    static fromJS(data: any): BTOComponentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BTOComponentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Group"] = this.group;
        data["Brand"] = this.brand;
        data["Description"] = this.description;
        data["Quantity"] = this.quantity;
        return data;
    }
}

export interface IBTOComponentDTO {
    group?: string | undefined;
    brand?: string | undefined;
    description?: string | undefined;
    quantity?: number;
}

export class GetCategoriesResponseDTO implements IGetCategoriesResponseDTO {
    rootCategories?: CategoryDTO[] | undefined;

    constructor(data?: IGetCategoriesResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["RootCategories"])) {
                this.rootCategories = [] as any;
                for (let item of _data["RootCategories"])
                    this.rootCategories!.push(CategoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCategoriesResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoriesResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rootCategories)) {
            data["RootCategories"] = [];
            for (let item of this.rootCategories)
                data["RootCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCategoriesResponseDTO {
    rootCategories?: CategoryDTO[] | undefined;
}

export class CategoryDTO implements ICategoryDTO {
    categoryId?: string | undefined;
    translations?: TranslationDTO[] | undefined;
    subCategories?: CategoryDTO[] | undefined;

    constructor(data?: ICategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["CategoryId"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(TranslationDTO.fromJS(item));
            }
            if (Array.isArray(_data["SubCategories"])) {
                this.subCategories = [] as any;
                for (let item of _data["SubCategories"])
                    this.subCategories!.push(CategoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryId"] = this.categoryId;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subCategories)) {
            data["SubCategories"] = [];
            for (let item of this.subCategories)
                data["SubCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICategoryDTO {
    categoryId?: string | undefined;
    translations?: TranslationDTO[] | undefined;
    subCategories?: CategoryDTO[] | undefined;
}

export class GetCountryProductPriceResponseDTO implements IGetCountryProductPriceResponseDTO {
    products?: CountryProductPriceDTO[] | undefined;
    totalProducts?: number;

    constructor(data?: IGetCountryProductPriceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(CountryProductPriceDTO.fromJS(item));
            }
            this.totalProducts = _data["TotalProducts"];
        }
    }

    static fromJS(data: any): GetCountryProductPriceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountryProductPriceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalProducts"] = this.totalProducts;
        return data;
    }
}

export interface IGetCountryProductPriceResponseDTO {
    products?: CountryProductPriceDTO[] | undefined;
    totalProducts?: number;
}

export class CountryProductPriceDTO implements ICountryProductPriceDTO {
    sKU?: string | undefined;
    b2BPricewithVAT?: number;
    b2BPricewithoutVAT?: number;
    b2BPromowithVAT?: number;
    b2BPromowithoutVAT?: number;
    b2BCurrencyCode?: string | undefined;
    b2CPricewithVAT?: number;
    b2CPricewithoutVAT?: number;
    b2CPromowithVAT?: number;
    b2CPromowithoutVAT?: number;
    b2CCurrencyCode?: string | undefined;

    constructor(data?: ICountryProductPriceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.b2BPricewithVAT = _data["B2BPricewithVAT"];
            this.b2BPricewithoutVAT = _data["B2BPricewithoutVAT"];
            this.b2BPromowithVAT = _data["B2BPromowithVAT"];
            this.b2BPromowithoutVAT = _data["B2BPromowithoutVAT"];
            this.b2BCurrencyCode = _data["B2BCurrencyCode"];
            this.b2CPricewithVAT = _data["B2CPricewithVAT"];
            this.b2CPricewithoutVAT = _data["B2CPricewithoutVAT"];
            this.b2CPromowithVAT = _data["B2CPromowithVAT"];
            this.b2CPromowithoutVAT = _data["B2CPromowithoutVAT"];
            this.b2CCurrencyCode = _data["B2CCurrencyCode"];
        }
    }

    static fromJS(data: any): CountryProductPriceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryProductPriceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["B2BPricewithVAT"] = this.b2BPricewithVAT;
        data["B2BPricewithoutVAT"] = this.b2BPricewithoutVAT;
        data["B2BPromowithVAT"] = this.b2BPromowithVAT;
        data["B2BPromowithoutVAT"] = this.b2BPromowithoutVAT;
        data["B2BCurrencyCode"] = this.b2BCurrencyCode;
        data["B2CPricewithVAT"] = this.b2CPricewithVAT;
        data["B2CPricewithoutVAT"] = this.b2CPricewithoutVAT;
        data["B2CPromowithVAT"] = this.b2CPromowithVAT;
        data["B2CPromowithoutVAT"] = this.b2CPromowithoutVAT;
        data["B2CCurrencyCode"] = this.b2CCurrencyCode;
        return data;
    }
}

export interface ICountryProductPriceDTO {
    sKU?: string | undefined;
    b2BPricewithVAT?: number;
    b2BPricewithoutVAT?: number;
    b2BPromowithVAT?: number;
    b2BPromowithoutVAT?: number;
    b2BCurrencyCode?: string | undefined;
    b2CPricewithVAT?: number;
    b2CPricewithoutVAT?: number;
    b2CPromowithVAT?: number;
    b2CPromowithoutVAT?: number;
    b2CCurrencyCode?: string | undefined;
}

export class GetCountryStockResponseDTO implements IGetCountryStockResponseDTO {
    products?: CountryStockProductDTO[] | undefined;

    constructor(data?: IGetCountryStockResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(CountryStockProductDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCountryStockResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountryStockResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCountryStockResponseDTO {
    products?: CountryStockProductDTO[] | undefined;
}

export class CountryStockProductDTO implements ICountryStockProductDTO {
    sKU?: string | undefined;
    sKU2?: string | undefined;
    ruleCode?: string | undefined;
    stock?: number;
    quantityOnTheWay?: number;

    constructor(data?: ICountryStockProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.sKU2 = _data["SKU2"];
            this.ruleCode = _data["RuleCode"];
            this.stock = _data["Stock"];
            this.quantityOnTheWay = _data["QuantityOnTheWay"];
        }
    }

    static fromJS(data: any): CountryStockProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryStockProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["SKU2"] = this.sKU2;
        data["RuleCode"] = this.ruleCode;
        data["Stock"] = this.stock;
        data["QuantityOnTheWay"] = this.quantityOnTheWay;
        return data;
    }
}

export interface ICountryStockProductDTO {
    sKU?: string | undefined;
    sKU2?: string | undefined;
    ruleCode?: string | undefined;
    stock?: number;
    quantityOnTheWay?: number;
}

export class CustomerInformationDTO implements ICustomerInformationDTO {
    contact?: CustomerContactDTO | undefined;
    customerId?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    eMail?: string | undefined;
    groupCode?: string | undefined;
    adminContactId?: number;
    hasShipmentCost?: boolean;
    partnershipCode?: string | undefined;
    shippingAddresses?: CustomerAddressDTO[] | undefined;
    billingAddress?: CustomerAddressDTO | undefined;

    constructor(data?: ICustomerInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["Contact"] ? CustomerContactDTO.fromJS(_data["Contact"]) : undefined as any;
            this.customerId = _data["CustomerId"];
            this.name = _data["Name"];
            this.address1 = _data["Address1"];
            this.address2 = _data["Address2"];
            this.zIP = _data["ZIP"];
            this.city = _data["City"];
            this.countryIso = _data["CountryIso"];
            this.eMail = _data["EMail"];
            this.groupCode = _data["GroupCode"];
            this.adminContactId = _data["AdminContactId"];
            this.hasShipmentCost = _data["HasShipmentCost"];
            this.partnershipCode = _data["PartnershipCode"];
            if (Array.isArray(_data["ShippingAddresses"])) {
                this.shippingAddresses = [] as any;
                for (let item of _data["ShippingAddresses"])
                    this.shippingAddresses!.push(CustomerAddressDTO.fromJS(item));
            }
            this.billingAddress = _data["BillingAddress"] ? CustomerAddressDTO.fromJS(_data["BillingAddress"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        data["CustomerId"] = this.customerId;
        data["Name"] = this.name;
        data["Address1"] = this.address1;
        data["Address2"] = this.address2;
        data["ZIP"] = this.zIP;
        data["City"] = this.city;
        data["CountryIso"] = this.countryIso;
        data["EMail"] = this.eMail;
        data["GroupCode"] = this.groupCode;
        data["AdminContactId"] = this.adminContactId;
        data["HasShipmentCost"] = this.hasShipmentCost;
        data["PartnershipCode"] = this.partnershipCode;
        if (Array.isArray(this.shippingAddresses)) {
            data["ShippingAddresses"] = [];
            for (let item of this.shippingAddresses)
                data["ShippingAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        data["BillingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustomerInformationDTO {
    contact?: CustomerContactDTO | undefined;
    customerId?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    eMail?: string | undefined;
    groupCode?: string | undefined;
    adminContactId?: number;
    hasShipmentCost?: boolean;
    partnershipCode?: string | undefined;
    shippingAddresses?: CustomerAddressDTO[] | undefined;
    billingAddress?: CustomerAddressDTO | undefined;
}

export class CustomerContactDTO implements ICustomerContactDTO {
    contactId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    languageIso?: string | undefined;
    isCompanyAdmin?: boolean;
    eMail?: string | undefined;
    allowDownloadAsCsv?: boolean;
    allowShippingAddress?: boolean;

    constructor(data?: ICustomerContactDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["ContactId"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.address1 = _data["Address1"];
            this.address2 = _data["Address2"];
            this.zIP = _data["ZIP"];
            this.city = _data["City"];
            this.countryIso = _data["CountryIso"];
            this.languageIso = _data["LanguageIso"];
            this.isCompanyAdmin = _data["IsCompanyAdmin"];
            this.eMail = _data["EMail"];
            this.allowDownloadAsCsv = _data["AllowDownloadAsCsv"];
            this.allowShippingAddress = _data["AllowShippingAddress"];
        }
    }

    static fromJS(data: any): CustomerContactDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContactDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContactId"] = this.contactId;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Address1"] = this.address1;
        data["Address2"] = this.address2;
        data["ZIP"] = this.zIP;
        data["City"] = this.city;
        data["CountryIso"] = this.countryIso;
        data["LanguageIso"] = this.languageIso;
        data["IsCompanyAdmin"] = this.isCompanyAdmin;
        data["EMail"] = this.eMail;
        data["AllowDownloadAsCsv"] = this.allowDownloadAsCsv;
        data["AllowShippingAddress"] = this.allowShippingAddress;
        return data;
    }
}

export interface ICustomerContactDTO {
    contactId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    languageIso?: string | undefined;
    isCompanyAdmin?: boolean;
    eMail?: string | undefined;
    allowDownloadAsCsv?: boolean;
    allowShippingAddress?: boolean;
}

export class CustomerAddressDTO implements ICustomerAddressDTO {
    addressId?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDefaultAddress?: boolean;

    constructor(data?: ICustomerAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressId = _data["AddressId"];
            this.name = _data["Name"];
            this.address1 = _data["Address1"];
            this.address2 = _data["Address2"];
            this.zIP = _data["ZIP"];
            this.city = _data["City"];
            this.countryIso = _data["CountryIso"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.isDefaultAddress = _data["IsDefaultAddress"];
        }
    }

    static fromJS(data: any): CustomerAddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AddressId"] = this.addressId;
        data["Name"] = this.name;
        data["Address1"] = this.address1;
        data["Address2"] = this.address2;
        data["ZIP"] = this.zIP;
        data["City"] = this.city;
        data["CountryIso"] = this.countryIso;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["IsDefaultAddress"] = this.isDefaultAddress;
        return data;
    }
}

export interface ICustomerAddressDTO {
    addressId?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDefaultAddress?: boolean;
}

export class CheckCredentialsResultDTO implements ICheckCredentialsResultDTO {
    customerInformation?: CustomerInformationDTO | undefined;

    constructor(data?: ICheckCredentialsResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerInformation = _data["CustomerInformation"] ? CustomerInformationDTO.fromJS(_data["CustomerInformation"]) : undefined as any;
        }
    }

    static fromJS(data: any): CheckCredentialsResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCredentialsResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerInformation"] = this.customerInformation ? this.customerInformation.toJSON() : undefined as any;
        return data;
    }
}

export interface ICheckCredentialsResultDTO {
    customerInformation?: CustomerInformationDTO | undefined;
}

export class CheckCredentialsDTO implements ICheckCredentialsDTO {
    loginId!: string;
    password!: string;
    countryCodeIso?: string | undefined;

    constructor(data?: ICheckCredentialsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginId = _data["LoginId"];
            this.password = _data["Password"];
            this.countryCodeIso = _data["CountryCodeIso"];
        }
    }

    static fromJS(data: any): CheckCredentialsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCredentialsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LoginId"] = this.loginId;
        data["Password"] = this.password;
        data["CountryCodeIso"] = this.countryCodeIso;
        return data;
    }
}

export interface ICheckCredentialsDTO {
    loginId: string;
    password: string;
    countryCodeIso?: string | undefined;
}

export class CustomerRegistrationResponseDTO implements ICustomerRegistrationResponseDTO {
    success?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ICustomerRegistrationResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.errorMessage = _data["ErrorMessage"];
        }
    }

    static fromJS(data: any): CustomerRegistrationResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRegistrationResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        data["ErrorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICustomerRegistrationResponseDTO {
    success?: boolean;
    errorMessage?: string | undefined;
}

export class CustomerRegistrationDTO implements ICustomerRegistrationDTO {
    companyDetails?: CustomerRegistrationCompanyDTO | undefined;
    deliveryAddress?: CustomerRegistrationDeliveryAddressDTO | undefined;
    contacts?: CustomerRegistrationContactDTO[] | undefined;

    [key: string]: any;

    constructor(data?: ICustomerRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.companyDetails = _data["CompanyDetails"] ? CustomerRegistrationCompanyDTO.fromJS(_data["CompanyDetails"]) : undefined as any;
            this.deliveryAddress = _data["DeliveryAddress"] ? CustomerRegistrationDeliveryAddressDTO.fromJS(_data["DeliveryAddress"]) : undefined as any;
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(CustomerRegistrationContactDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["CompanyDetails"] = this.companyDetails ? this.companyDetails.toJSON() : undefined as any;
        data["DeliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : undefined as any;
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerRegistrationDTO {
    companyDetails?: CustomerRegistrationCompanyDTO | undefined;
    deliveryAddress?: CustomerRegistrationDeliveryAddressDTO | undefined;
    contacts?: CustomerRegistrationContactDTO[] | undefined;

    [key: string]: any;
}

export class CustomerRegistrationCompanyDTO implements ICustomerRegistrationCompanyDTO {
    name?: string | undefined;
    name2?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    homepage?: string | undefined;
    languageIso?: string | undefined;
    vATNo?: string | undefined;
    file1Base64?: FileBase64DTO | undefined;
    file2Base64?: FileBase64DTO | undefined;
    file3Base64?: FileBase64DTO | undefined;
    file4Base64?: FileBase64DTO | undefined;
    industryGroup?: CustomerRegistrationIndustryGroup | undefined;
    requiredCreditLimit?: string | undefined;
    bankDetails?: string | undefined;
    noOfEmployees?: string | undefined;
    salesCurrentYear?: string | undefined;
    salesPreviousYear?: string | undefined;
    businessFocus?: CustomerRegistrationBusinessFocusDTO | undefined;
    comment?: string | undefined;

    [key: string]: any;

    constructor(data?: ICustomerRegistrationCompanyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["Name"];
            this.name2 = _data["Name2"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.zIP = _data["ZIP"];
            this.city = _data["City"];
            this.countryIso = _data["CountryIso"];
            this.telephone = _data["Telephone"];
            this.email = _data["Email"];
            this.homepage = _data["Homepage"];
            this.languageIso = _data["LanguageIso"];
            this.vATNo = _data["VATNo"];
            this.file1Base64 = _data["File1Base64"] ? FileBase64DTO.fromJS(_data["File1Base64"]) : undefined as any;
            this.file2Base64 = _data["File2Base64"] ? FileBase64DTO.fromJS(_data["File2Base64"]) : undefined as any;
            this.file3Base64 = _data["File3Base64"] ? FileBase64DTO.fromJS(_data["File3Base64"]) : undefined as any;
            this.file4Base64 = _data["File4Base64"] ? FileBase64DTO.fromJS(_data["File4Base64"]) : undefined as any;
            this.industryGroup = _data["IndustryGroup"];
            this.requiredCreditLimit = _data["RequiredCreditLimit"];
            this.bankDetails = _data["BankDetails"];
            this.noOfEmployees = _data["NoOfEmployees"];
            this.salesCurrentYear = _data["SalesCurrentYear"];
            this.salesPreviousYear = _data["SalesPreviousYear"];
            this.businessFocus = _data["BusinessFocus"] ? CustomerRegistrationBusinessFocusDTO.fromJS(_data["BusinessFocus"]) : undefined as any;
            this.comment = _data["Comment"];
        }
    }

    static fromJS(data: any): CustomerRegistrationCompanyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRegistrationCompanyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Name"] = this.name;
        data["Name2"] = this.name2;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["ZIP"] = this.zIP;
        data["City"] = this.city;
        data["CountryIso"] = this.countryIso;
        data["Telephone"] = this.telephone;
        data["Email"] = this.email;
        data["Homepage"] = this.homepage;
        data["LanguageIso"] = this.languageIso;
        data["VATNo"] = this.vATNo;
        data["File1Base64"] = this.file1Base64 ? this.file1Base64.toJSON() : undefined as any;
        data["File2Base64"] = this.file2Base64 ? this.file2Base64.toJSON() : undefined as any;
        data["File3Base64"] = this.file3Base64 ? this.file3Base64.toJSON() : undefined as any;
        data["File4Base64"] = this.file4Base64 ? this.file4Base64.toJSON() : undefined as any;
        data["IndustryGroup"] = this.industryGroup;
        data["RequiredCreditLimit"] = this.requiredCreditLimit;
        data["BankDetails"] = this.bankDetails;
        data["NoOfEmployees"] = this.noOfEmployees;
        data["SalesCurrentYear"] = this.salesCurrentYear;
        data["SalesPreviousYear"] = this.salesPreviousYear;
        data["BusinessFocus"] = this.businessFocus ? this.businessFocus.toJSON() : undefined as any;
        data["Comment"] = this.comment;
        return data;
    }
}

export interface ICustomerRegistrationCompanyDTO {
    name?: string | undefined;
    name2?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    homepage?: string | undefined;
    languageIso?: string | undefined;
    vATNo?: string | undefined;
    file1Base64?: FileBase64DTO | undefined;
    file2Base64?: FileBase64DTO | undefined;
    file3Base64?: FileBase64DTO | undefined;
    file4Base64?: FileBase64DTO | undefined;
    industryGroup?: CustomerRegistrationIndustryGroup | undefined;
    requiredCreditLimit?: string | undefined;
    bankDetails?: string | undefined;
    noOfEmployees?: string | undefined;
    salesCurrentYear?: string | undefined;
    salesPreviousYear?: string | undefined;
    businessFocus?: CustomerRegistrationBusinessFocusDTO | undefined;
    comment?: string | undefined;

    [key: string]: any;
}

export class FileBase64DTO implements IFileBase64DTO {
    name?: string | undefined;
    contentBase64?: string | undefined;
    fileType?: string | undefined;

    constructor(data?: IFileBase64DTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.contentBase64 = _data["ContentBase64"];
            this.fileType = _data["FileType"];
        }
    }

    static fromJS(data: any): FileBase64DTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileBase64DTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["ContentBase64"] = this.contentBase64;
        data["FileType"] = this.fileType;
        return data;
    }
}

export interface IFileBase64DTO {
    name?: string | undefined;
    contentBase64?: string | undefined;
    fileType?: string | undefined;
}

export enum CustomerRegistrationIndustryGroup {
    B2B = 0,
    B2C = 1,
    SubDistributor = 2,
}

export class CustomerRegistrationBusinessFocusDTO implements ICustomerRegistrationBusinessFocusDTO {
    components?: boolean;
    externalMemory?: boolean;
    systemsSoftware?: boolean;
    peripheralsNetwork?: boolean;
    consumerElectronics?: boolean;
    videoConference?: boolean;
    displayDevices?: boolean;
    systemMgtServices?: boolean;
    gaming?: boolean;

    constructor(data?: ICustomerRegistrationBusinessFocusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.components = _data["Components"];
            this.externalMemory = _data["ExternalMemory"];
            this.systemsSoftware = _data["SystemsSoftware"];
            this.peripheralsNetwork = _data["PeripheralsNetwork"];
            this.consumerElectronics = _data["ConsumerElectronics"];
            this.videoConference = _data["VideoConference"];
            this.displayDevices = _data["DisplayDevices"];
            this.systemMgtServices = _data["SystemMgtServices"];
            this.gaming = _data["Gaming"];
        }
    }

    static fromJS(data: any): CustomerRegistrationBusinessFocusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRegistrationBusinessFocusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Components"] = this.components;
        data["ExternalMemory"] = this.externalMemory;
        data["SystemsSoftware"] = this.systemsSoftware;
        data["PeripheralsNetwork"] = this.peripheralsNetwork;
        data["ConsumerElectronics"] = this.consumerElectronics;
        data["VideoConference"] = this.videoConference;
        data["DisplayDevices"] = this.displayDevices;
        data["SystemMgtServices"] = this.systemMgtServices;
        data["Gaming"] = this.gaming;
        return data;
    }
}

export interface ICustomerRegistrationBusinessFocusDTO {
    components?: boolean;
    externalMemory?: boolean;
    systemsSoftware?: boolean;
    peripheralsNetwork?: boolean;
    consumerElectronics?: boolean;
    videoConference?: boolean;
    displayDevices?: boolean;
    systemMgtServices?: boolean;
    gaming?: boolean;
}

export class CustomerRegistrationDeliveryAddressDTO implements ICustomerRegistrationDeliveryAddressDTO {
    reason?: string | undefined;
    name?: string | undefined;
    name2?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    telephone?: string | undefined;

    [key: string]: any;

    constructor(data?: ICustomerRegistrationDeliveryAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reason = _data["Reason"];
            this.name = _data["Name"];
            this.name2 = _data["Name2"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.zIP = _data["ZIP"];
            this.city = _data["City"];
            this.countryIso = _data["CountryIso"];
            this.telephone = _data["Telephone"];
        }
    }

    static fromJS(data: any): CustomerRegistrationDeliveryAddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRegistrationDeliveryAddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Reason"] = this.reason;
        data["Name"] = this.name;
        data["Name2"] = this.name2;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["ZIP"] = this.zIP;
        data["City"] = this.city;
        data["CountryIso"] = this.countryIso;
        data["Telephone"] = this.telephone;
        return data;
    }
}

export interface ICustomerRegistrationDeliveryAddressDTO {
    reason?: string | undefined;
    name?: string | undefined;
    name2?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    telephone?: string | undefined;

    [key: string]: any;
}

export class CustomerRegistrationContactDTO implements ICustomerRegistrationContactDTO {
    salutation?: string | undefined;
    language?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    function?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    isShopLoginRequired?: boolean;
    messagesSubscription?: CustomerRegistrationMessagesSubscriptionDTO | undefined;

    [key: string]: any;

    constructor(data?: ICustomerRegistrationContactDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.salutation = _data["Salutation"];
            this.language = _data["Language"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.function = _data["Function"];
            this.telephone = _data["Telephone"];
            this.email = _data["Email"];
            this.isShopLoginRequired = _data["IsShopLoginRequired"];
            this.messagesSubscription = _data["MessagesSubscription"] ? CustomerRegistrationMessagesSubscriptionDTO.fromJS(_data["MessagesSubscription"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerRegistrationContactDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRegistrationContactDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Salutation"] = this.salutation;
        data["Language"] = this.language;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Function"] = this.function;
        data["Telephone"] = this.telephone;
        data["Email"] = this.email;
        data["IsShopLoginRequired"] = this.isShopLoginRequired;
        data["MessagesSubscription"] = this.messagesSubscription ? this.messagesSubscription.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustomerRegistrationContactDTO {
    salutation?: string | undefined;
    language?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    function?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    isShopLoginRequired?: boolean;
    messagesSubscription?: CustomerRegistrationMessagesSubscriptionDTO | undefined;

    [key: string]: any;
}

export class CustomerRegistrationMessagesSubscriptionDTO implements ICustomerRegistrationMessagesSubscriptionDTO {
    orderConfirmation?: boolean;
    deliveryConfirmation?: boolean;
    serviceTicketConfirmation?: boolean;
    dailyServiceTickets?: boolean;
    paymentConfirmation?: boolean;
    eInvoice?: boolean;
    eCreditMemo?: boolean;
    eReminder?: boolean;

    constructor(data?: ICustomerRegistrationMessagesSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderConfirmation = _data["OrderConfirmation"];
            this.deliveryConfirmation = _data["DeliveryConfirmation"];
            this.serviceTicketConfirmation = _data["ServiceTicketConfirmation"];
            this.dailyServiceTickets = _data["DailyServiceTickets"];
            this.paymentConfirmation = _data["PaymentConfirmation"];
            this.eInvoice = _data["EInvoice"];
            this.eCreditMemo = _data["ECreditMemo"];
            this.eReminder = _data["EReminder"];
        }
    }

    static fromJS(data: any): CustomerRegistrationMessagesSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRegistrationMessagesSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderConfirmation"] = this.orderConfirmation;
        data["DeliveryConfirmation"] = this.deliveryConfirmation;
        data["ServiceTicketConfirmation"] = this.serviceTicketConfirmation;
        data["DailyServiceTickets"] = this.dailyServiceTickets;
        data["PaymentConfirmation"] = this.paymentConfirmation;
        data["EInvoice"] = this.eInvoice;
        data["ECreditMemo"] = this.eCreditMemo;
        data["EReminder"] = this.eReminder;
        return data;
    }
}

export interface ICustomerRegistrationMessagesSubscriptionDTO {
    orderConfirmation?: boolean;
    deliveryConfirmation?: boolean;
    serviceTicketConfirmation?: boolean;
    dailyServiceTickets?: boolean;
    paymentConfirmation?: boolean;
    eInvoice?: boolean;
    eCreditMemo?: boolean;
    eReminder?: boolean;
}

export class GetProductPriceResponseDTO implements IGetProductPriceResponseDTO {
    products?: ProductPriceDTO[] | undefined;
    totalProducts?: number;

    constructor(data?: IGetProductPriceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(ProductPriceDTO.fromJS(item));
            }
            this.totalProducts = _data["TotalProducts"];
        }
    }

    static fromJS(data: any): GetProductPriceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductPriceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalProducts"] = this.totalProducts;
        return data;
    }
}

export interface IGetProductPriceResponseDTO {
    products?: ProductPriceDTO[] | undefined;
    totalProducts?: number;
}

export class ProductPriceDTO implements IProductPriceDTO {
    sKU?: string | undefined;
    price?: number;

    constructor(data?: IProductPriceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.price = _data["Price"];
        }
    }

    static fromJS(data: any): ProductPriceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["Price"] = this.price;
        return data;
    }
}

export interface IProductPriceDTO {
    sKU?: string | undefined;
    price?: number;
}

export class GetExcludedProductResponseDTO implements IGetExcludedProductResponseDTO {
    sKUs?: string[] | undefined;
    totalProducts?: number;

    constructor(data?: IGetExcludedProductResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SKUs"])) {
                this.sKUs = [] as any;
                for (let item of _data["SKUs"])
                    this.sKUs!.push(item);
            }
            this.totalProducts = _data["TotalProducts"];
        }
    }

    static fromJS(data: any): GetExcludedProductResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetExcludedProductResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sKUs)) {
            data["SKUs"] = [];
            for (let item of this.sKUs)
                data["SKUs"].push(item);
        }
        data["TotalProducts"] = this.totalProducts;
        return data;
    }
}

export interface IGetExcludedProductResponseDTO {
    sKUs?: string[] | undefined;
    totalProducts?: number;
}

export class CsvDataDTO implements ICsvDataDTO {
    separator?: string | undefined;
    totalRecords?: number;
    csvData?: string | undefined;

    constructor(data?: ICsvDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.separator = _data["Separator"];
            this.totalRecords = _data["TotalRecords"];
            this.csvData = _data["CsvData"];
        }
    }

    static fromJS(data: any): CsvDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CsvDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Separator"] = this.separator;
        data["TotalRecords"] = this.totalRecords;
        data["CsvData"] = this.csvData;
        return data;
    }
}

export interface ICsvDataDTO {
    separator?: string | undefined;
    totalRecords?: number;
    csvData?: string | undefined;
}

export class GetCustomerProductStockResponseDTO implements IGetCustomerProductStockResponseDTO {
    products?: CustomerProductStockDTO[] | undefined;
    totalProducts?: number;

    constructor(data?: IGetCustomerProductStockResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(CustomerProductStockDTO.fromJS(item));
            }
            this.totalProducts = _data["TotalProducts"];
        }
    }

    static fromJS(data: any): GetCustomerProductStockResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerProductStockResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalProducts"] = this.totalProducts;
        return data;
    }
}

export interface IGetCustomerProductStockResponseDTO {
    products?: CustomerProductStockDTO[] | undefined;
    totalProducts?: number;
}

export class CustomerProductStockDTO implements ICustomerProductStockDTO {
    sKU?: string | undefined;
    stock?: number;
    nextConfirmedQuantity?: number;
    nextConfirmedDateIso?: string | undefined;

    constructor(data?: ICustomerProductStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.stock = _data["Stock"];
            this.nextConfirmedQuantity = _data["NextConfirmedQuantity"];
            this.nextConfirmedDateIso = _data["NextConfirmedDateIso"];
        }
    }

    static fromJS(data: any): CustomerProductStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerProductStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["Stock"] = this.stock;
        data["NextConfirmedQuantity"] = this.nextConfirmedQuantity;
        data["NextConfirmedDateIso"] = this.nextConfirmedDateIso;
        return data;
    }
}

export interface ICustomerProductStockDTO {
    sKU?: string | undefined;
    stock?: number;
    nextConfirmedQuantity?: number;
    nextConfirmedDateIso?: string | undefined;
}

export class DocumentBase64DTO implements IDocumentBase64DTO {
    documentNumber?: string | undefined;
    type?: DocumentType;
    contentBase64?: string | undefined;

    constructor(data?: IDocumentBase64DTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["DocumentNumber"];
            this.type = _data["Type"];
            this.contentBase64 = _data["ContentBase64"];
        }
    }

    static fromJS(data: any): DocumentBase64DTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentBase64DTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DocumentNumber"] = this.documentNumber;
        data["Type"] = this.type;
        data["ContentBase64"] = this.contentBase64;
        return data;
    }
}

export interface IDocumentBase64DTO {
    documentNumber?: string | undefined;
    type?: DocumentType;
    contentBase64?: string | undefined;
}

export enum DocumentType {
    Invoice = 0,
    CreditMemo = 1,
}

export class InvoiceDTO implements IInvoiceDTO {
    invoiceId?: string | undefined;
    pDFBase64?: string | undefined;

    constructor(data?: IInvoiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["InvoiceId"];
            this.pDFBase64 = _data["PDFBase64"];
        }
    }

    static fromJS(data: any): InvoiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceId"] = this.invoiceId;
        data["PDFBase64"] = this.pDFBase64;
        return data;
    }
}

export interface IInvoiceDTO {
    invoiceId?: string | undefined;
    pDFBase64?: string | undefined;
}

export class OpenInvoiceDTO implements IOpenInvoiceDTO {
    invoiceNo?: string | undefined;
    orderNo?: string | undefined;
    amount?: number;
    currencyCodeIso?: string | undefined;
    customerReference?: string | undefined;
    postingDateIso?: string | undefined;
    dueDateIso?: string | undefined;

    constructor(data?: IOpenInvoiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNo = _data["InvoiceNo"];
            this.orderNo = _data["OrderNo"];
            this.amount = _data["Amount"];
            this.currencyCodeIso = _data["CurrencyCodeIso"];
            this.customerReference = _data["CustomerReference"];
            this.postingDateIso = _data["PostingDateIso"];
            this.dueDateIso = _data["DueDateIso"];
        }
    }

    static fromJS(data: any): OpenInvoiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OpenInvoiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceNo"] = this.invoiceNo;
        data["OrderNo"] = this.orderNo;
        data["Amount"] = this.amount;
        data["CurrencyCodeIso"] = this.currencyCodeIso;
        data["CustomerReference"] = this.customerReference;
        data["PostingDateIso"] = this.postingDateIso;
        data["DueDateIso"] = this.dueDateIso;
        return data;
    }
}

export interface IOpenInvoiceDTO {
    invoiceNo?: string | undefined;
    orderNo?: string | undefined;
    amount?: number;
    currencyCodeIso?: string | undefined;
    customerReference?: string | undefined;
    postingDateIso?: string | undefined;
    dueDateIso?: string | undefined;
}

export class GetNavisionSalesResponseDTO implements IGetNavisionSalesResponseDTO {
    items?: NavisionSalesItemDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IGetNavisionSalesResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(NavisionSalesItemDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): GetNavisionSalesResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetNavisionSalesResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IGetNavisionSalesResponseDTO {
    items?: NavisionSalesItemDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class NavisionSalesItemDTO implements INavisionSalesItemDTO {
    invoiceNumber?: string | undefined;
    orderNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    sKU?: string | undefined;
    description?: string | undefined;
    quantity?: number;
    amount?: number;
    postingDate?: DateTime;

    constructor(data?: INavisionSalesItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["InvoiceNumber"];
            this.orderNumber = _data["OrderNumber"];
            this.shipmentNumber = _data["ShipmentNumber"];
            this.sKU = _data["SKU"];
            this.description = _data["Description"];
            this.quantity = _data["Quantity"];
            this.amount = _data["Amount"];
            this.postingDate = _data["PostingDate"] ? DateTime.fromISO(_data["PostingDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NavisionSalesItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NavisionSalesItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceNumber"] = this.invoiceNumber;
        data["OrderNumber"] = this.orderNumber;
        data["ShipmentNumber"] = this.shipmentNumber;
        data["SKU"] = this.sKU;
        data["Description"] = this.description;
        data["Quantity"] = this.quantity;
        data["Amount"] = this.amount;
        data["PostingDate"] = this.postingDate ? this.postingDate.toString() : undefined as any;
        return data;
    }
}

export interface INavisionSalesItemDTO {
    invoiceNumber?: string | undefined;
    orderNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    sKU?: string | undefined;
    description?: string | undefined;
    quantity?: number;
    amount?: number;
    postingDate?: DateTime;
}

export class GetNavisionBacklogResponseDTO implements IGetNavisionBacklogResponseDTO {
    items?: NavisionBacklogItemDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IGetNavisionBacklogResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(NavisionBacklogItemDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): GetNavisionBacklogResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetNavisionBacklogResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IGetNavisionBacklogResponseDTO {
    items?: NavisionBacklogItemDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class NavisionBacklogItemDTO implements INavisionBacklogItemDTO {
    orderNumber?: string | undefined;
    orderLineNumber?: number;
    sKU?: string | undefined;
    description?: string | undefined;
    quantity?: number;
    outstandingQuantity?: number;
    amount?: number;
    customerReference?: string | undefined;
    orderDate?: DateTime | undefined;
    shipmentDate?: DateTime | undefined;

    constructor(data?: INavisionBacklogItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["OrderNumber"];
            this.orderLineNumber = _data["OrderLineNumber"];
            this.sKU = _data["SKU"];
            this.description = _data["Description"];
            this.quantity = _data["Quantity"];
            this.outstandingQuantity = _data["OutstandingQuantity"];
            this.amount = _data["Amount"];
            this.customerReference = _data["CustomerReference"];
            this.orderDate = _data["OrderDate"] ? DateTime.fromISO(_data["OrderDate"].toString()) : undefined as any;
            this.shipmentDate = _data["ShipmentDate"] ? DateTime.fromISO(_data["ShipmentDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NavisionBacklogItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NavisionBacklogItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderNumber"] = this.orderNumber;
        data["OrderLineNumber"] = this.orderLineNumber;
        data["SKU"] = this.sKU;
        data["Description"] = this.description;
        data["Quantity"] = this.quantity;
        data["OutstandingQuantity"] = this.outstandingQuantity;
        data["Amount"] = this.amount;
        data["CustomerReference"] = this.customerReference;
        data["OrderDate"] = this.orderDate ? this.orderDate.toString() : undefined as any;
        data["ShipmentDate"] = this.shipmentDate ? this.shipmentDate.toString() : undefined as any;
        return data;
    }
}

export interface INavisionBacklogItemDTO {
    orderNumber?: string | undefined;
    orderLineNumber?: number;
    sKU?: string | undefined;
    description?: string | undefined;
    quantity?: number;
    outstandingQuantity?: number;
    amount?: number;
    customerReference?: string | undefined;
    orderDate?: DateTime | undefined;
    shipmentDate?: DateTime | undefined;
}

export class SubscribeToNewsLetterDTO implements ISubscribeToNewsLetterDTO {
    subscribedNewsletterIds?: number[];
    iPAddress?: string | undefined;

    constructor(data?: ISubscribeToNewsLetterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SubscribedNewsletterIds"])) {
                this.subscribedNewsletterIds = [] as any;
                for (let item of _data["SubscribedNewsletterIds"])
                    this.subscribedNewsletterIds!.push(item);
            }
            this.iPAddress = _data["IPAddress"];
        }
    }

    static fromJS(data: any): SubscribeToNewsLetterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribeToNewsLetterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscribedNewsletterIds)) {
            data["SubscribedNewsletterIds"] = [];
            for (let item of this.subscribedNewsletterIds)
                data["SubscribedNewsletterIds"].push(item);
        }
        data["IPAddress"] = this.iPAddress;
        return data;
    }
}

export interface ISubscribeToNewsLetterDTO {
    subscribedNewsletterIds?: number[];
    iPAddress?: string | undefined;
}

export class GetNewsletterSubscriptionsDTO implements IGetNewsletterSubscriptionsDTO {
    email?: string | undefined;
    subscriptions?: NewsletterSubscriptionDTO[] | undefined;

    constructor(data?: IGetNewsletterSubscriptionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            if (Array.isArray(_data["Subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["Subscriptions"])
                    this.subscriptions!.push(NewsletterSubscriptionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNewsletterSubscriptionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsletterSubscriptionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        if (Array.isArray(this.subscriptions)) {
            data["Subscriptions"] = [];
            for (let item of this.subscriptions)
                data["Subscriptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetNewsletterSubscriptionsDTO {
    email?: string | undefined;
    subscriptions?: NewsletterSubscriptionDTO[] | undefined;
}

export class NewsletterSubscriptionDTO implements INewsletterSubscriptionDTO {
    id?: number;
    sortIndex?: number;
    name?: string | undefined;
    subscribed?: boolean;

    constructor(data?: INewsletterSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.sortIndex = _data["SortIndex"];
            this.name = _data["Name"];
            this.subscribed = _data["Subscribed"];
        }
    }

    static fromJS(data: any): NewsletterSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SortIndex"] = this.sortIndex;
        data["Name"] = this.name;
        data["Subscribed"] = this.subscribed;
        return data;
    }
}

export interface INewsletterSubscriptionDTO {
    id?: number;
    sortIndex?: number;
    name?: string | undefined;
    subscribed?: boolean;
}

export class GetShopOrderShippingInfoResultDTO implements IGetShopOrderShippingInfoResultDTO {
    shippingInfos?: ShopOrderShippingInfoDTO[];

    constructor(data?: IGetShopOrderShippingInfoResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ShippingInfos"])) {
                this.shippingInfos = [] as any;
                for (let item of _data["ShippingInfos"])
                    this.shippingInfos!.push(ShopOrderShippingInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetShopOrderShippingInfoResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetShopOrderShippingInfoResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shippingInfos)) {
            data["ShippingInfos"] = [];
            for (let item of this.shippingInfos)
                data["ShippingInfos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetShopOrderShippingInfoResultDTO {
    shippingInfos?: ShopOrderShippingInfoDTO[];
}

export class ShopOrderShippingInfoDTO implements IShopOrderShippingInfoDTO {
    systemOrderId?: string | undefined;
    shopOrderId?: string | undefined;
    fullyShipped?: boolean;
    shipments?: ShopOrderShipmentDTO[];

    constructor(data?: IShopOrderShippingInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemOrderId = _data["SystemOrderId"];
            this.shopOrderId = _data["ShopOrderId"];
            this.fullyShipped = _data["FullyShipped"];
            if (Array.isArray(_data["Shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["Shipments"])
                    this.shipments!.push(ShopOrderShipmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShopOrderShippingInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderShippingInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SystemOrderId"] = this.systemOrderId;
        data["ShopOrderId"] = this.shopOrderId;
        data["FullyShipped"] = this.fullyShipped;
        if (Array.isArray(this.shipments)) {
            data["Shipments"] = [];
            for (let item of this.shipments)
                data["Shipments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShopOrderShippingInfoDTO {
    systemOrderId?: string | undefined;
    shopOrderId?: string | undefined;
    fullyShipped?: boolean;
    shipments?: ShopOrderShipmentDTO[];
}

export class ShopOrderShipmentDTO implements IShopOrderShipmentDTO {
    shipmentNumber?: string | undefined;
    shippingProvider?: string | undefined;
    totalShippedQuantity?: number;
    trackings?: ShopOrderTrackingDTO[];
    products?: ShopOrderProductShipmentDTO[];

    constructor(data?: IShopOrderShipmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentNumber = _data["ShipmentNumber"];
            this.shippingProvider = _data["ShippingProvider"];
            this.totalShippedQuantity = _data["TotalShippedQuantity"];
            if (Array.isArray(_data["Trackings"])) {
                this.trackings = [] as any;
                for (let item of _data["Trackings"])
                    this.trackings!.push(ShopOrderTrackingDTO.fromJS(item));
            }
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(ShopOrderProductShipmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShopOrderShipmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderShipmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShipmentNumber"] = this.shipmentNumber;
        data["ShippingProvider"] = this.shippingProvider;
        data["TotalShippedQuantity"] = this.totalShippedQuantity;
        if (Array.isArray(this.trackings)) {
            data["Trackings"] = [];
            for (let item of this.trackings)
                data["Trackings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShopOrderShipmentDTO {
    shipmentNumber?: string | undefined;
    shippingProvider?: string | undefined;
    totalShippedQuantity?: number;
    trackings?: ShopOrderTrackingDTO[];
    products?: ShopOrderProductShipmentDTO[];
}

export class ShopOrderTrackingDTO implements IShopOrderTrackingDTO {
    trackingNumber?: string | undefined;
    trackingUrl?: string | undefined;

    constructor(data?: IShopOrderTrackingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackingNumber = _data["TrackingNumber"];
            this.trackingUrl = _data["TrackingUrl"];
        }
    }

    static fromJS(data: any): ShopOrderTrackingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderTrackingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TrackingNumber"] = this.trackingNumber;
        data["TrackingUrl"] = this.trackingUrl;
        return data;
    }
}

export interface IShopOrderTrackingDTO {
    trackingNumber?: string | undefined;
    trackingUrl?: string | undefined;
}

export class ShopOrderProductShipmentDTO implements IShopOrderProductShipmentDTO {
    sKU?: string | undefined;
    shippedQuantity?: number;
    lineNo?: number;

    constructor(data?: IShopOrderProductShipmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.shippedQuantity = _data["ShippedQuantity"];
            this.lineNo = _data["LineNo"];
        }
    }

    static fromJS(data: any): ShopOrderProductShipmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderProductShipmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["ShippedQuantity"] = this.shippedQuantity;
        data["LineNo"] = this.lineNo;
        return data;
    }
}

export interface IShopOrderProductShipmentDTO {
    sKU?: string | undefined;
    shippedQuantity?: number;
    lineNo?: number;
}

export class GetShopOrderInvoiceInfoResultDTO implements IGetShopOrderInvoiceInfoResultDTO {
    invoiceInfos?: ShopOrderInvoiceInfoDTO[];

    constructor(data?: IGetShopOrderInvoiceInfoResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["InvoiceInfos"])) {
                this.invoiceInfos = [] as any;
                for (let item of _data["InvoiceInfos"])
                    this.invoiceInfos!.push(ShopOrderInvoiceInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetShopOrderInvoiceInfoResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetShopOrderInvoiceInfoResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceInfos)) {
            data["InvoiceInfos"] = [];
            for (let item of this.invoiceInfos)
                data["InvoiceInfos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetShopOrderInvoiceInfoResultDTO {
    invoiceInfos?: ShopOrderInvoiceInfoDTO[];
}

export class ShopOrderInvoiceInfoDTO implements IShopOrderInvoiceInfoDTO {
    systemOrderId?: string | undefined;
    shopOrderId?: string | undefined;
    fullyInvoiced?: boolean;
    invoices?: ShopOrderInvoiceDTO[];

    constructor(data?: IShopOrderInvoiceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemOrderId = _data["SystemOrderId"];
            this.shopOrderId = _data["ShopOrderId"];
            this.fullyInvoiced = _data["FullyInvoiced"];
            if (Array.isArray(_data["Invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["Invoices"])
                    this.invoices!.push(ShopOrderInvoiceDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShopOrderInvoiceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderInvoiceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SystemOrderId"] = this.systemOrderId;
        data["ShopOrderId"] = this.shopOrderId;
        data["FullyInvoiced"] = this.fullyInvoiced;
        if (Array.isArray(this.invoices)) {
            data["Invoices"] = [];
            for (let item of this.invoices)
                data["Invoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShopOrderInvoiceInfoDTO {
    systemOrderId?: string | undefined;
    shopOrderId?: string | undefined;
    fullyInvoiced?: boolean;
    invoices?: ShopOrderInvoiceDTO[];
}

export class ShopOrderInvoiceDTO implements IShopOrderInvoiceDTO {
    invoiceNumber?: string | undefined;
    fileBase64?: string | undefined;
    products?: ShopOrderInvoiceProductDTO[];

    constructor(data?: IShopOrderInvoiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["InvoiceNumber"];
            this.fileBase64 = _data["FileBase64"];
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(ShopOrderInvoiceProductDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShopOrderInvoiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderInvoiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceNumber"] = this.invoiceNumber;
        data["FileBase64"] = this.fileBase64;
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShopOrderInvoiceDTO {
    invoiceNumber?: string | undefined;
    fileBase64?: string | undefined;
    products?: ShopOrderInvoiceProductDTO[];
}

export class ShopOrderInvoiceProductDTO implements IShopOrderInvoiceProductDTO {
    sKU?: string | undefined;
    invoicedQuantity?: number;
    lineNo?: number;

    constructor(data?: IShopOrderInvoiceProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.invoicedQuantity = _data["InvoicedQuantity"];
            this.lineNo = _data["LineNo"];
        }
    }

    static fromJS(data: any): ShopOrderInvoiceProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderInvoiceProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["InvoicedQuantity"] = this.invoicedQuantity;
        data["LineNo"] = this.lineNo;
        return data;
    }
}

export interface IShopOrderInvoiceProductDTO {
    sKU?: string | undefined;
    invoicedQuantity?: number;
    lineNo?: number;
}

export class GetShopOrderPaymentInfoResultDTO implements IGetShopOrderPaymentInfoResultDTO {
    paymentInfos?: ShopOrderPaymentInfoDTO[];

    constructor(data?: IGetShopOrderPaymentInfoResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["PaymentInfos"])) {
                this.paymentInfos = [] as any;
                for (let item of _data["PaymentInfos"])
                    this.paymentInfos!.push(ShopOrderPaymentInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetShopOrderPaymentInfoResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetShopOrderPaymentInfoResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentInfos)) {
            data["PaymentInfos"] = [];
            for (let item of this.paymentInfos)
                data["PaymentInfos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetShopOrderPaymentInfoResultDTO {
    paymentInfos?: ShopOrderPaymentInfoDTO[];
}

export class ShopOrderPaymentInfoDTO implements IShopOrderPaymentInfoDTO {
    systemOrderId?: string | undefined;
    shopOrderId?: string | undefined;
    fullyPaid?: boolean;

    constructor(data?: IShopOrderPaymentInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemOrderId = _data["SystemOrderId"];
            this.shopOrderId = _data["ShopOrderId"];
            this.fullyPaid = _data["FullyPaid"];
        }
    }

    static fromJS(data: any): ShopOrderPaymentInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderPaymentInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SystemOrderId"] = this.systemOrderId;
        data["ShopOrderId"] = this.shopOrderId;
        data["FullyPaid"] = this.fullyPaid;
        return data;
    }
}

export interface IShopOrderPaymentInfoDTO {
    systemOrderId?: string | undefined;
    shopOrderId?: string | undefined;
    fullyPaid?: boolean;
}

export class ShopOrderCreateResultDTO implements IShopOrderCreateResultDTO {
    trackingId?: string | undefined;
    success?: boolean;
    errorText?: string | undefined;

    constructor(data?: IShopOrderCreateResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackingId = _data["TrackingId"];
            this.success = _data["Success"];
            this.errorText = _data["ErrorText"];
        }
    }

    static fromJS(data: any): ShopOrderCreateResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderCreateResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TrackingId"] = this.trackingId;
        data["Success"] = this.success;
        data["ErrorText"] = this.errorText;
        return data;
    }
}

export interface IShopOrderCreateResultDTO {
    trackingId?: string | undefined;
    success?: boolean;
    errorText?: string | undefined;
}

export class ShopOrderCreateDTO implements IShopOrderCreateDTO {
    shopOrderId!: string;
    customerId!: string;
    currenyCodeIso!: string;
    headerReference?: string | undefined;
    requiredDeliveryDateIso?: string | undefined;
    paymentId?: string | undefined;
    shippingAddress?: CustomerAddressDTO | undefined;
    shipToContact?: string | undefined;
    isCompleteShipping?: boolean;
    isPickupOrder?: boolean;
    products?: ShopOrderCreateOrderProductDTO[] | undefined;
    dataIdent?: string;

    constructor(data?: IShopOrderCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopOrderId = _data["ShopOrderId"];
            this.customerId = _data["CustomerId"];
            this.currenyCodeIso = _data["CurrenyCodeIso"];
            this.headerReference = _data["HeaderReference"];
            this.requiredDeliveryDateIso = _data["RequiredDeliveryDateIso"];
            this.paymentId = _data["PaymentId"];
            this.shippingAddress = _data["ShippingAddress"] ? CustomerAddressDTO.fromJS(_data["ShippingAddress"]) : undefined as any;
            this.shipToContact = _data["ShipToContact"];
            this.isCompleteShipping = _data["IsCompleteShipping"];
            this.isPickupOrder = _data["IsPickupOrder"];
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(ShopOrderCreateOrderProductDTO.fromJS(item));
            }
            this.dataIdent = _data["DataIdent"];
        }
    }

    static fromJS(data: any): ShopOrderCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShopOrderId"] = this.shopOrderId;
        data["CustomerId"] = this.customerId;
        data["CurrenyCodeIso"] = this.currenyCodeIso;
        data["HeaderReference"] = this.headerReference;
        data["RequiredDeliveryDateIso"] = this.requiredDeliveryDateIso;
        data["PaymentId"] = this.paymentId;
        data["ShippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : undefined as any;
        data["ShipToContact"] = this.shipToContact;
        data["IsCompleteShipping"] = this.isCompleteShipping;
        data["IsPickupOrder"] = this.isPickupOrder;
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        data["DataIdent"] = this.dataIdent;
        return data;
    }
}

export interface IShopOrderCreateDTO {
    shopOrderId: string;
    customerId: string;
    currenyCodeIso: string;
    headerReference?: string | undefined;
    requiredDeliveryDateIso?: string | undefined;
    paymentId?: string | undefined;
    shippingAddress?: CustomerAddressDTO | undefined;
    shipToContact?: string | undefined;
    isCompleteShipping?: boolean;
    isPickupOrder?: boolean;
    products?: ShopOrderCreateOrderProductDTO[] | undefined;
    dataIdent?: string;
}

export class ShopOrderCreateOrderProductDTO implements IShopOrderCreateOrderProductDTO {
    sKU!: string;
    quantity!: number;
    unitPrice!: number;
    lineReference?: string | undefined;
    totalLineRebate?: number;

    constructor(data?: IShopOrderCreateOrderProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.quantity = _data["Quantity"];
            this.unitPrice = _data["UnitPrice"];
            this.lineReference = _data["LineReference"];
            this.totalLineRebate = _data["TotalLineRebate"];
        }
    }

    static fromJS(data: any): ShopOrderCreateOrderProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderCreateOrderProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["Quantity"] = this.quantity;
        data["UnitPrice"] = this.unitPrice;
        data["LineReference"] = this.lineReference;
        data["TotalLineRebate"] = this.totalLineRebate;
        return data;
    }
}

export interface IShopOrderCreateOrderProductDTO {
    sKU: string;
    quantity: number;
    unitPrice: number;
    lineReference?: string | undefined;
    totalLineRebate?: number;
}

export class JouleShopOrderCreateResultDTO implements IJouleShopOrderCreateResultDTO {
    success?: boolean;

    constructor(data?: IJouleShopOrderCreateResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
        }
    }

    static fromJS(data: any): JouleShopOrderCreateResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new JouleShopOrderCreateResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        return data;
    }
}

export interface IJouleShopOrderCreateResultDTO {
    success?: boolean;
}

export class JouleShopOrderCreateDTO implements IJouleShopOrderCreateDTO {
    countryShopId!: string;
    shopOrderId!: string;
    customerId?: string | undefined;
    navCustomerId?: string | undefined;
    orderDateTimeIsoUtc?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    countryCodeIso!: string;
    paymentMethod?: string | undefined;
    paymentId?: string | undefined;
    paid?: boolean;
    currenyCodeIso!: string;
    shippingAddress?: CustomerAddressDTO | undefined;
    billingAddress?: CustomerAddressDTO | undefined;
    shippingAgentCostIncludingVAT?: number;
    orderComment?: string | undefined;
    products?: ShopOrderCreateOrderProductDTO[] | undefined;

    constructor(data?: IJouleShopOrderCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryShopId = _data["CountryShopId"];
            this.shopOrderId = _data["ShopOrderId"];
            this.customerId = _data["CustomerId"];
            this.navCustomerId = _data["NavCustomerId"];
            this.orderDateTimeIsoUtc = _data["OrderDateTimeIsoUtc"];
            this.telephone = _data["Telephone"];
            this.email = _data["Email"];
            this.countryCodeIso = _data["CountryCodeIso"];
            this.paymentMethod = _data["PaymentMethod"];
            this.paymentId = _data["PaymentId"];
            this.paid = _data["Paid"];
            this.currenyCodeIso = _data["CurrenyCodeIso"];
            this.shippingAddress = _data["ShippingAddress"] ? CustomerAddressDTO.fromJS(_data["ShippingAddress"]) : undefined as any;
            this.billingAddress = _data["BillingAddress"] ? CustomerAddressDTO.fromJS(_data["BillingAddress"]) : undefined as any;
            this.shippingAgentCostIncludingVAT = _data["ShippingAgentCostIncludingVAT"];
            this.orderComment = _data["OrderComment"];
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(ShopOrderCreateOrderProductDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JouleShopOrderCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new JouleShopOrderCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CountryShopId"] = this.countryShopId;
        data["ShopOrderId"] = this.shopOrderId;
        data["CustomerId"] = this.customerId;
        data["NavCustomerId"] = this.navCustomerId;
        data["OrderDateTimeIsoUtc"] = this.orderDateTimeIsoUtc;
        data["Telephone"] = this.telephone;
        data["Email"] = this.email;
        data["CountryCodeIso"] = this.countryCodeIso;
        data["PaymentMethod"] = this.paymentMethod;
        data["PaymentId"] = this.paymentId;
        data["Paid"] = this.paid;
        data["CurrenyCodeIso"] = this.currenyCodeIso;
        data["ShippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : undefined as any;
        data["BillingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : undefined as any;
        data["ShippingAgentCostIncludingVAT"] = this.shippingAgentCostIncludingVAT;
        data["OrderComment"] = this.orderComment;
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IJouleShopOrderCreateDTO {
    countryShopId: string;
    shopOrderId: string;
    customerId?: string | undefined;
    navCustomerId?: string | undefined;
    orderDateTimeIsoUtc?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    countryCodeIso: string;
    paymentMethod?: string | undefined;
    paymentId?: string | undefined;
    paid?: boolean;
    currenyCodeIso: string;
    shippingAddress?: CustomerAddressDTO | undefined;
    billingAddress?: CustomerAddressDTO | undefined;
    shippingAgentCostIncludingVAT?: number;
    orderComment?: string | undefined;
    products?: ShopOrderCreateOrderProductDTO[] | undefined;
}

export class GetShopOrderStatusResultDTO implements IGetShopOrderStatusResultDTO {
    statusList?: ShopOrderStatusDTO[];

    constructor(data?: IGetShopOrderStatusResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["StatusList"])) {
                this.statusList = [] as any;
                for (let item of _data["StatusList"])
                    this.statusList!.push(ShopOrderStatusDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetShopOrderStatusResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetShopOrderStatusResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statusList)) {
            data["StatusList"] = [];
            for (let item of this.statusList)
                data["StatusList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetShopOrderStatusResultDTO {
    statusList?: ShopOrderStatusDTO[];
}

export class ShopOrderStatusDTO implements IShopOrderStatusDTO {
    shopOrderId?: string | undefined;
    status?: number;

    constructor(data?: IShopOrderStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopOrderId = _data["ShopOrderId"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): ShopOrderStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShopOrderStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShopOrderId"] = this.shopOrderId;
        data["Status"] = this.status;
        return data;
    }
}

export interface IShopOrderStatusDTO {
    shopOrderId?: string | undefined;
    status?: number;
}

export class GetProfileListResponseDTO implements IGetProfileListResponseDTO {
    profileList?: ProfileDTO[] | undefined;

    constructor(data?: IGetProfileListResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ProfileList"])) {
                this.profileList = [] as any;
                for (let item of _data["ProfileList"])
                    this.profileList!.push(ProfileDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProfileListResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfileListResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profileList)) {
            data["ProfileList"] = [];
            for (let item of this.profileList)
                data["ProfileList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProfileListResponseDTO {
    profileList?: ProfileDTO[] | undefined;
}

export class ProfileDTO implements IProfileDTO {
    profileCode?: string | undefined;
    description?: string | undefined;
    titles?: ProfileTitleDTO[];

    constructor(data?: IProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileCode = _data["ProfileCode"];
            this.description = _data["Description"];
            if (Array.isArray(_data["Titles"])) {
                this.titles = [] as any;
                for (let item of _data["Titles"])
                    this.titles!.push(ProfileTitleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProfileCode"] = this.profileCode;
        data["Description"] = this.description;
        if (Array.isArray(this.titles)) {
            data["Titles"] = [];
            for (let item of this.titles)
                data["Titles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProfileDTO {
    profileCode?: string | undefined;
    description?: string | undefined;
    titles?: ProfileTitleDTO[];
}

export class ProfileTitleDTO implements IProfileTitleDTO {
    description?: string | undefined;
    sortIndex?: number;
    attributeCodes?: ProfileTitleAttributeDTO[];
    translations?: TranslationDTO[] | undefined;

    constructor(data?: IProfileTitleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.sortIndex = _data["SortIndex"];
            if (Array.isArray(_data["AttributeCodes"])) {
                this.attributeCodes = [] as any;
                for (let item of _data["AttributeCodes"])
                    this.attributeCodes!.push(ProfileTitleAttributeDTO.fromJS(item));
            }
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(TranslationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileTitleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileTitleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["SortIndex"] = this.sortIndex;
        if (Array.isArray(this.attributeCodes)) {
            data["AttributeCodes"] = [];
            for (let item of this.attributeCodes)
                data["AttributeCodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProfileTitleDTO {
    description?: string | undefined;
    sortIndex?: number;
    attributeCodes?: ProfileTitleAttributeDTO[];
    translations?: TranslationDTO[] | undefined;
}

export class ProfileTitleAttributeDTO implements IProfileTitleAttributeDTO {
    attributeCode?: string | undefined;
    sortIndex?: number;
    quickFilter?: boolean;
    expertFilter?: boolean;
    comparisonFilter?: boolean;

    constructor(data?: IProfileTitleAttributeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeCode = _data["AttributeCode"];
            this.sortIndex = _data["SortIndex"];
            this.quickFilter = _data["QuickFilter"];
            this.expertFilter = _data["ExpertFilter"];
            this.comparisonFilter = _data["ComparisonFilter"];
        }
    }

    static fromJS(data: any): ProfileTitleAttributeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileTitleAttributeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AttributeCode"] = this.attributeCode;
        data["SortIndex"] = this.sortIndex;
        data["QuickFilter"] = this.quickFilter;
        data["ExpertFilter"] = this.expertFilter;
        data["ComparisonFilter"] = this.comparisonFilter;
        return data;
    }
}

export interface IProfileTitleAttributeDTO {
    attributeCode?: string | undefined;
    sortIndex?: number;
    quickFilter?: boolean;
    expertFilter?: boolean;
    comparisonFilter?: boolean;
}

export class RMAReasonsResultDTO implements IRMAReasonsResultDTO {
    reasons?: RMAReasonDTO[] | undefined;

    constructor(data?: IRMAReasonsResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["Reasons"])
                    this.reasons!.push(RMAReasonDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RMAReasonsResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMAReasonsResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reasons)) {
            data["Reasons"] = [];
            for (let item of this.reasons)
                data["Reasons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRMAReasonsResultDTO {
    reasons?: RMAReasonDTO[] | undefined;
}

export class RMAReasonDTO implements IRMAReasonDTO {
    code?: string | undefined;
    translations?: TranslationDTO[] | undefined;
    details?: RMAReasonDetailDTO[] | undefined;

    constructor(data?: IRMAReasonDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(TranslationDTO.fromJS(item));
            }
            if (Array.isArray(_data["Details"])) {
                this.details = [] as any;
                for (let item of _data["Details"])
                    this.details!.push(RMAReasonDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RMAReasonDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMAReasonDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.details)) {
            data["Details"] = [];
            for (let item of this.details)
                data["Details"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRMAReasonDTO {
    code?: string | undefined;
    translations?: TranslationDTO[] | undefined;
    details?: RMAReasonDetailDTO[] | undefined;
}

export class RMAReasonDetailDTO implements IRMAReasonDetailDTO {
    code?: string | undefined;
    translations?: TranslationDTO[] | undefined;

    constructor(data?: IRMAReasonDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(TranslationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RMAReasonDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMAReasonDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRMAReasonDetailDTO {
    code?: string | undefined;
    translations?: TranslationDTO[] | undefined;
}

export class RMASearchResultDTO implements IRMASearchResultDTO {
    products?: RMAProductDTO[] | undefined;

    constructor(data?: IRMASearchResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(RMAProductDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RMASearchResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMASearchResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRMASearchResultDTO {
    products?: RMAProductDTO[] | undefined;
}

export class RMAProductDTO implements IRMAProductDTO {
    sKU?: string | undefined;
    vendorSKU?: string | undefined;
    lineNo?: number;
    quantity?: number;
    name?: string | undefined;
    description?: string | undefined;
    dateOfPurchaseIso?: string | undefined;
    systemOrderId?: string | undefined;
    shipmentNumber?: string | undefined;
    invoiceNumber?: string | undefined;
    customerReferenceNumber?: string | undefined;
    serialNumbers?: RMALineItemSerialNumberDTO[] | undefined;
    contents?: RMAProductPackageContentDTO[] | undefined;

    constructor(data?: IRMAProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.vendorSKU = _data["VendorSKU"];
            this.lineNo = _data["LineNo"];
            this.quantity = _data["Quantity"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.dateOfPurchaseIso = _data["DateOfPurchaseIso"];
            this.systemOrderId = _data["SystemOrderId"];
            this.shipmentNumber = _data["ShipmentNumber"];
            this.invoiceNumber = _data["InvoiceNumber"];
            this.customerReferenceNumber = _data["CustomerReferenceNumber"];
            if (Array.isArray(_data["SerialNumbers"])) {
                this.serialNumbers = [] as any;
                for (let item of _data["SerialNumbers"])
                    this.serialNumbers!.push(RMALineItemSerialNumberDTO.fromJS(item));
            }
            if (Array.isArray(_data["Contents"])) {
                this.contents = [] as any;
                for (let item of _data["Contents"])
                    this.contents!.push(RMAProductPackageContentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RMAProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMAProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["VendorSKU"] = this.vendorSKU;
        data["LineNo"] = this.lineNo;
        data["Quantity"] = this.quantity;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["DateOfPurchaseIso"] = this.dateOfPurchaseIso;
        data["SystemOrderId"] = this.systemOrderId;
        data["ShipmentNumber"] = this.shipmentNumber;
        data["InvoiceNumber"] = this.invoiceNumber;
        data["CustomerReferenceNumber"] = this.customerReferenceNumber;
        if (Array.isArray(this.serialNumbers)) {
            data["SerialNumbers"] = [];
            for (let item of this.serialNumbers)
                data["SerialNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contents)) {
            data["Contents"] = [];
            for (let item of this.contents)
                data["Contents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRMAProductDTO {
    sKU?: string | undefined;
    vendorSKU?: string | undefined;
    lineNo?: number;
    quantity?: number;
    name?: string | undefined;
    description?: string | undefined;
    dateOfPurchaseIso?: string | undefined;
    systemOrderId?: string | undefined;
    shipmentNumber?: string | undefined;
    invoiceNumber?: string | undefined;
    customerReferenceNumber?: string | undefined;
    serialNumbers?: RMALineItemSerialNumberDTO[] | undefined;
    contents?: RMAProductPackageContentDTO[] | undefined;
}

export class RMALineItemSerialNumberDTO implements IRMALineItemSerialNumberDTO {
    serialNumber?: string | undefined;
    isRMAPossible?: boolean;

    constructor(data?: IRMALineItemSerialNumberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["SerialNumber"];
            this.isRMAPossible = _data["IsRMAPossible"];
        }
    }

    static fromJS(data: any): RMALineItemSerialNumberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMALineItemSerialNumberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SerialNumber"] = this.serialNumber;
        data["IsRMAPossible"] = this.isRMAPossible;
        return data;
    }
}

export interface IRMALineItemSerialNumberDTO {
    serialNumber?: string | undefined;
    isRMAPossible?: boolean;
}

export class RMAProductPackageContentDTO implements IRMAProductPackageContentDTO {
    content?: string | undefined;
    quantity?: number;
    requiredToSend?: boolean;
    doNotSend?: boolean;

    constructor(data?: IRMAProductPackageContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["Content"];
            this.quantity = _data["Quantity"];
            this.requiredToSend = _data["RequiredToSend"];
            this.doNotSend = _data["DoNotSend"];
        }
    }

    static fromJS(data: any): RMAProductPackageContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMAProductPackageContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Content"] = this.content;
        data["Quantity"] = this.quantity;
        data["RequiredToSend"] = this.requiredToSend;
        data["DoNotSend"] = this.doNotSend;
        return data;
    }
}

export interface IRMAProductPackageContentDTO {
    content?: string | undefined;
    quantity?: number;
    requiredToSend?: boolean;
    doNotSend?: boolean;
}

export class RMACreateResultDTO implements IRMACreateResultDTO {
    success?: boolean;
    trackingId?: string | undefined;
    errorText?: string | undefined;

    constructor(data?: IRMACreateResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.trackingId = _data["TrackingId"];
            this.errorText = _data["ErrorText"];
        }
    }

    static fromJS(data: any): RMACreateResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMACreateResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        data["TrackingId"] = this.trackingId;
        data["ErrorText"] = this.errorText;
        return data;
    }
}

export interface IRMACreateResultDTO {
    success?: boolean;
    trackingId?: string | undefined;
    errorText?: string | undefined;
}

export class RMACreateDTO implements IRMACreateDTO {
    customerId!: string;
    sKU!: string;
    quantity!: number;
    serialNumber?: string | undefined;
    problemDescription?: string | undefined;
    customerReference?: string | undefined;
    resellerReference?: string | undefined;
    shipmentNumber?: string | undefined;
    invoiceNumber!: string;
    reasonCode!: string;
    reasonDetailCode!: string;

    constructor(data?: IRMACreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["CustomerId"];
            this.sKU = _data["SKU"];
            this.quantity = _data["Quantity"];
            this.serialNumber = _data["SerialNumber"];
            this.problemDescription = _data["ProblemDescription"];
            this.customerReference = _data["CustomerReference"];
            this.resellerReference = _data["ResellerReference"];
            this.shipmentNumber = _data["ShipmentNumber"];
            this.invoiceNumber = _data["InvoiceNumber"];
            this.reasonCode = _data["ReasonCode"];
            this.reasonDetailCode = _data["ReasonDetailCode"];
        }
    }

    static fromJS(data: any): RMACreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMACreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerId"] = this.customerId;
        data["SKU"] = this.sKU;
        data["Quantity"] = this.quantity;
        data["SerialNumber"] = this.serialNumber;
        data["ProblemDescription"] = this.problemDescription;
        data["CustomerReference"] = this.customerReference;
        data["ResellerReference"] = this.resellerReference;
        data["ShipmentNumber"] = this.shipmentNumber;
        data["InvoiceNumber"] = this.invoiceNumber;
        data["ReasonCode"] = this.reasonCode;
        data["ReasonDetailCode"] = this.reasonDetailCode;
        return data;
    }
}

export interface IRMACreateDTO {
    customerId: string;
    sKU: string;
    quantity: number;
    serialNumber?: string | undefined;
    problemDescription?: string | undefined;
    customerReference?: string | undefined;
    resellerReference?: string | undefined;
    shipmentNumber?: string | undefined;
    invoiceNumber: string;
    reasonCode: string;
    reasonDetailCode: string;
}

export class RMAGetResultDTO implements IRMAGetResultDTO {
    rMATickets?: RMATicketDTO[] | undefined;

    constructor(data?: IRMAGetResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["RMATickets"])) {
                this.rMATickets = [] as any;
                for (let item of _data["RMATickets"])
                    this.rMATickets!.push(RMATicketDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RMAGetResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMAGetResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rMATickets)) {
            data["RMATickets"] = [];
            for (let item of this.rMATickets)
                data["RMATickets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRMAGetResultDTO {
    rMATickets?: RMATicketDTO[] | undefined;
}

export class RMATicketDTO implements IRMATicketDTO {
    sKU?: string | undefined;
    vendorSKU?: string | undefined;
    ticketNumber?: string | undefined;
    name?: string | undefined;
    quantity?: number;
    customerReference?: string | undefined;
    customerStatus?: string | undefined;
    reasonCode?: string | undefined;
    reasonDetailCode?: string | undefined;
    solutionCode?: string | undefined;
    serialNumber?: string | undefined;
    dateRegistrationIsoUtc?: string | undefined;
    dateClosedIsoUtc?: string | undefined;
    trackingUrl?: string | undefined;

    constructor(data?: IRMATicketDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.vendorSKU = _data["VendorSKU"];
            this.ticketNumber = _data["TicketNumber"];
            this.name = _data["Name"];
            this.quantity = _data["Quantity"];
            this.customerReference = _data["CustomerReference"];
            this.customerStatus = _data["CustomerStatus"];
            this.reasonCode = _data["ReasonCode"];
            this.reasonDetailCode = _data["ReasonDetailCode"];
            this.solutionCode = _data["SolutionCode"];
            this.serialNumber = _data["SerialNumber"];
            this.dateRegistrationIsoUtc = _data["DateRegistrationIsoUtc"];
            this.dateClosedIsoUtc = _data["DateClosedIsoUtc"];
            this.trackingUrl = _data["TrackingUrl"];
        }
    }

    static fromJS(data: any): RMATicketDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RMATicketDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["VendorSKU"] = this.vendorSKU;
        data["TicketNumber"] = this.ticketNumber;
        data["Name"] = this.name;
        data["Quantity"] = this.quantity;
        data["CustomerReference"] = this.customerReference;
        data["CustomerStatus"] = this.customerStatus;
        data["ReasonCode"] = this.reasonCode;
        data["ReasonDetailCode"] = this.reasonDetailCode;
        data["SolutionCode"] = this.solutionCode;
        data["SerialNumber"] = this.serialNumber;
        data["DateRegistrationIsoUtc"] = this.dateRegistrationIsoUtc;
        data["DateClosedIsoUtc"] = this.dateClosedIsoUtc;
        data["TrackingUrl"] = this.trackingUrl;
        return data;
    }
}

export interface IRMATicketDTO {
    sKU?: string | undefined;
    vendorSKU?: string | undefined;
    ticketNumber?: string | undefined;
    name?: string | undefined;
    quantity?: number;
    customerReference?: string | undefined;
    customerStatus?: string | undefined;
    reasonCode?: string | undefined;
    reasonDetailCode?: string | undefined;
    solutionCode?: string | undefined;
    serialNumber?: string | undefined;
    dateRegistrationIsoUtc?: string | undefined;
    dateClosedIsoUtc?: string | undefined;
    trackingUrl?: string | undefined;
}

export class SystemSerialNumberInformationDTO implements ISystemSerialNumberInformationDTO {
    sKU?: string | undefined;
    dateSold?: DateTime;
    status?: string | undefined;

    constructor(data?: ISystemSerialNumberInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.dateSold = _data["DateSold"] ? DateTime.fromISO(_data["DateSold"].toString()) : undefined as any;
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): SystemSerialNumberInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSerialNumberInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["DateSold"] = this.dateSold ? this.dateSold.toString() : undefined as any;
        data["Status"] = this.status;
        return data;
    }
}

export interface ISystemSerialNumberInformationDTO {
    sKU?: string | undefined;
    dateSold?: DateTime;
    status?: string | undefined;
}

export class JouleRMACreateDTO implements IJouleRMACreateDTO {
    customerId?: string | undefined;
    sKU!: string;
    quantity!: number;
    serialNumber?: string | undefined;
    problemDescription?: string | undefined;
    customerReference?: string | undefined;
    reasonCode!: string;
    reasonDetailCode!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IJouleRMACreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["CustomerId"];
            this.sKU = _data["SKU"];
            this.quantity = _data["Quantity"];
            this.serialNumber = _data["SerialNumber"];
            this.problemDescription = _data["ProblemDescription"];
            this.customerReference = _data["CustomerReference"];
            this.reasonCode = _data["ReasonCode"];
            this.reasonDetailCode = _data["ReasonDetailCode"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.name = _data["Name"];
            this.address1 = _data["Address1"];
            this.address2 = _data["Address2"];
            this.zIP = _data["ZIP"];
            this.city = _data["City"];
            this.countryIso = _data["CountryIso"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
        }
    }

    static fromJS(data: any): JouleRMACreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new JouleRMACreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerId"] = this.customerId;
        data["SKU"] = this.sKU;
        data["Quantity"] = this.quantity;
        data["SerialNumber"] = this.serialNumber;
        data["ProblemDescription"] = this.problemDescription;
        data["CustomerReference"] = this.customerReference;
        data["ReasonCode"] = this.reasonCode;
        data["ReasonDetailCode"] = this.reasonDetailCode;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Name"] = this.name;
        data["Address1"] = this.address1;
        data["Address2"] = this.address2;
        data["ZIP"] = this.zIP;
        data["City"] = this.city;
        data["CountryIso"] = this.countryIso;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IJouleRMACreateDTO {
    customerId?: string | undefined;
    sKU: string;
    quantity: number;
    serialNumber?: string | undefined;
    problemDescription?: string | undefined;
    customerReference?: string | undefined;
    reasonCode: string;
    reasonDetailCode: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zIP?: string | undefined;
    city?: string | undefined;
    countryIso?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class VendorScoreCardAdminDataDTO implements IVendorScoreCardAdminDataDTO {
    id?: number;
    rowType?: VendorScoreCardRowType;
    orderPosition?: number;
    weightedCat?: number | undefined;
    weightedSub?: number | undefined;
    tenPointsReference?: number | undefined;
    onePointReference?: number | undefined;
    pointsType?: VendorScoreCardDataType | undefined;

    constructor(data?: IVendorScoreCardAdminDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.rowType = _data["RowType"];
            this.orderPosition = _data["OrderPosition"];
            this.weightedCat = _data["WeightedCat"];
            this.weightedSub = _data["WeightedSub"];
            this.tenPointsReference = _data["TenPointsReference"];
            this.onePointReference = _data["OnePointReference"];
            this.pointsType = _data["PointsType"];
        }
    }

    static fromJS(data: any): VendorScoreCardAdminDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VendorScoreCardAdminDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RowType"] = this.rowType;
        data["OrderPosition"] = this.orderPosition;
        data["WeightedCat"] = this.weightedCat;
        data["WeightedSub"] = this.weightedSub;
        data["TenPointsReference"] = this.tenPointsReference;
        data["OnePointReference"] = this.onePointReference;
        data["PointsType"] = this.pointsType;
        return data;
    }
}

export interface IVendorScoreCardAdminDataDTO {
    id?: number;
    rowType?: VendorScoreCardRowType;
    orderPosition?: number;
    weightedCat?: number | undefined;
    weightedSub?: number | undefined;
    tenPointsReference?: number | undefined;
    onePointReference?: number | undefined;
    pointsType?: VendorScoreCardDataType | undefined;
}

export enum VendorScoreCardRowType {
    MarketSize = 0,
    EndCustomerSales = 1,
    CurrentMarketShares = 2,
    MarketShareDevelopmentOverLastThreeYears = 3,
    GlobalMarketShare = 4,
    NumberOfCompetingProductsOrBrands = 5,
    HeelSize = 6,
    SalesStructure = 7,
    NumberOfResellersOfficial = 8,
    NumberOfOverlappingResellers = 9,
    NumberOfDistributors = 10,
    SharesOfTheRespectiveDistributors = 11,
    NumberOfResellersUnofficial = 12,
    SharesOfTheRespectiveResellers = 13,
    NumberOfSubDistributors = 14,
    DirectSalesFromTheVendor = 15,
    ProductPortfolio = 16,
    NumberOfProductCategories = 17,
    AssessmentOfTheLengthOfProductLifeCycles = 18,
    PriceVolatility = 19,
    ProductReviewsPositivOrNegative = 20,
    AverageProductSizeOfTheRespectiveCategories = 21,
    AverageProductWeightOfTheRespectiveCategories = 22,
    AverageSellingPriceOfTheRespectiveCategories = 23,
    SpecialFeaturesSuchAsCustomsFreightStorage = 24,
    MarketingAppearance = 25,
    BuildingYourOwnWebsiteRatedFromOneToTen = 26,
    SocialMediaPresence = 27,
    CurrentSponsorPartners = 28,
    ExistingInfluencerPartnerships = 29,
    MarketingPresenceForResellers = 30,
    PresenceInBlogsPressReviewersAndOtherAffiliateMarketing = 31,
    Potential = 32,
    AssessmentOfShortTermBusinessPotentialSales = 33,
    AssessmentOfShortTermBusinessPotentialDB = 34,
    AssessmentOfTheGPIIMargin = 35,
    AssessmentOfMediumTermBusinessPotentialSales = 36,
    AverageSellingPrice = 37,
    AssessmentOfMediumTermBusinessPotentialDB = 38,
}

export enum VendorScoreCardDataType {
    Integer = 0,
    Float = 1,
}

export class UpdateVendorScoreCardAdminDataDTO implements IUpdateVendorScoreCardAdminDataDTO {
    id?: number;
    weightedCat?: number | undefined;
    weightedSub?: number | undefined;
    tenPointsReference?: number | undefined;
    onePointReference?: number | undefined;
    vendorScoreCardPointsType?: VendorScoreCardDataType;
    modifiedOn?: DateTime;
    modifiedBy?: string | undefined;

    constructor(data?: IUpdateVendorScoreCardAdminDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.weightedCat = _data["WeightedCat"];
            this.weightedSub = _data["WeightedSub"];
            this.tenPointsReference = _data["TenPointsReference"];
            this.onePointReference = _data["OnePointReference"];
            this.vendorScoreCardPointsType = _data["VendorScoreCardPointsType"];
            this.modifiedOn = _data["ModifiedOn"] ? DateTime.fromISO(_data["ModifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["ModifiedBy"];
        }
    }

    static fromJS(data: any): UpdateVendorScoreCardAdminDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVendorScoreCardAdminDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WeightedCat"] = this.weightedCat;
        data["WeightedSub"] = this.weightedSub;
        data["TenPointsReference"] = this.tenPointsReference;
        data["OnePointReference"] = this.onePointReference;
        data["VendorScoreCardPointsType"] = this.vendorScoreCardPointsType;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        data["ModifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IUpdateVendorScoreCardAdminDataDTO {
    id?: number;
    weightedCat?: number | undefined;
    weightedSub?: number | undefined;
    tenPointsReference?: number | undefined;
    onePointReference?: number | undefined;
    vendorScoreCardPointsType?: VendorScoreCardDataType;
    modifiedOn?: DateTime;
    modifiedBy?: string | undefined;
}

export class VendorScoreCardDTO implements IVendorScoreCardDTO {
    vendorName?: string;
    email?: string | undefined;
    language?: string | undefined;
    state?: VendorScoreCardState;

    constructor(data?: IVendorScoreCardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorName = _data["VendorName"];
            this.email = _data["Email"];
            this.language = _data["Language"];
            this.state = _data["State"];
        }
    }

    static fromJS(data: any): VendorScoreCardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VendorScoreCardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VendorName"] = this.vendorName;
        data["Email"] = this.email;
        data["Language"] = this.language;
        data["State"] = this.state;
        return data;
    }
}

export interface IVendorScoreCardDTO {
    vendorName?: string;
    email?: string | undefined;
    language?: string | undefined;
    state?: VendorScoreCardState;
}

export enum VendorScoreCardState {
    Pending = 0,
    Complete = 1,
}

export class CreateVendorScoreCardDTO implements ICreateVendorScoreCardDTO {
    vendorName!: string;
    email?: string;
    language?: string | undefined;

    constructor(data?: ICreateVendorScoreCardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorName = _data["VendorName"];
            this.email = _data["Email"];
            this.language = _data["Language"];
        }
    }

    static fromJS(data: any): CreateVendorScoreCardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVendorScoreCardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VendorName"] = this.vendorName;
        data["Email"] = this.email;
        data["Language"] = this.language;
        return data;
    }
}

export interface ICreateVendorScoreCardDTO {
    vendorName: string;
    email?: string;
    language?: string | undefined;
}

export class VendorScoreCardOverviewDTO implements IVendorScoreCardOverviewDTO {
    id?: number;
    vendorName?: string;
    email?: string;
    language?: string;
    state?: VendorScoreCardState;
    totalPoints?: number | undefined;
    modifiedOn?: DateTime;
    modifiedBy?: string;

    constructor(data?: IVendorScoreCardOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.vendorName = _data["VendorName"];
            this.email = _data["Email"];
            this.language = _data["Language"];
            this.state = _data["State"];
            this.totalPoints = _data["TotalPoints"];
            this.modifiedOn = _data["ModifiedOn"] ? DateTime.fromISO(_data["ModifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["ModifiedBy"];
        }
    }

    static fromJS(data: any): VendorScoreCardOverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VendorScoreCardOverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["VendorName"] = this.vendorName;
        data["Email"] = this.email;
        data["Language"] = this.language;
        data["State"] = this.state;
        data["TotalPoints"] = this.totalPoints;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        data["ModifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IVendorScoreCardOverviewDTO {
    id?: number;
    vendorName?: string;
    email?: string;
    language?: string;
    state?: VendorScoreCardState;
    totalPoints?: number | undefined;
    modifiedOn?: DateTime;
    modifiedBy?: string;
}

export class VendorScoreCardOverviewExtendedDTO extends VendorScoreCardOverviewDTO implements IVendorScoreCardOverviewExtendedDTO {
    vendorDataRows?: VendorScoreCardVendorDataDTO[] | undefined;

    constructor(data?: IVendorScoreCardOverviewExtendedDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["VendorDataRows"])) {
                this.vendorDataRows = [] as any;
                for (let item of _data["VendorDataRows"])
                    this.vendorDataRows!.push(VendorScoreCardVendorDataDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VendorScoreCardOverviewExtendedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VendorScoreCardOverviewExtendedDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vendorDataRows)) {
            data["VendorDataRows"] = [];
            for (let item of this.vendorDataRows)
                data["VendorDataRows"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IVendorScoreCardOverviewExtendedDTO extends IVendorScoreCardOverviewDTO {
    vendorDataRows?: VendorScoreCardVendorDataDTO[] | undefined;
}

export class VendorScoreCardVendorDataDTO implements IVendorScoreCardVendorDataDTO {
    vendorScoreCardId?: number;
    rowType?: VendorScoreCardRowTypeV20 | undefined;
    facts?: number | undefined;
    factsType?: VendorScoreCardDataType | undefined;
    orderPosition?: number;
    points?: number | undefined;
    weightedPoints?: number | undefined;
    totalPointsCategory?: number | undefined;

    constructor(data?: IVendorScoreCardVendorDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorScoreCardId = _data["VendorScoreCardId"];
            this.rowType = _data["RowType"];
            this.facts = _data["Facts"];
            this.factsType = _data["FactsType"];
            this.orderPosition = _data["OrderPosition"];
            this.points = _data["Points"];
            this.weightedPoints = _data["WeightedPoints"];
            this.totalPointsCategory = _data["TotalPointsCategory"];
        }
    }

    static fromJS(data: any): VendorScoreCardVendorDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VendorScoreCardVendorDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VendorScoreCardId"] = this.vendorScoreCardId;
        data["RowType"] = this.rowType;
        data["Facts"] = this.facts;
        data["FactsType"] = this.factsType;
        data["OrderPosition"] = this.orderPosition;
        data["Points"] = this.points;
        data["WeightedPoints"] = this.weightedPoints;
        data["TotalPointsCategory"] = this.totalPointsCategory;
        return data;
    }
}

export interface IVendorScoreCardVendorDataDTO {
    vendorScoreCardId?: number;
    rowType?: VendorScoreCardRowTypeV20 | undefined;
    facts?: number | undefined;
    factsType?: VendorScoreCardDataType | undefined;
    orderPosition?: number;
    points?: number | undefined;
    weightedPoints?: number | undefined;
    totalPointsCategory?: number | undefined;
}

export enum VendorScoreCardRowTypeV20 {
    MarketSize = 0,
    TAM = 1,
    CurrentMarketShares = 2,
    SalesStructure = 3,
    NumberOfActiveResellers = 4,
    NumberOfDistributors = 5,
    ShareOfRevenue = 6,
    ProductPortfolio = 7,
    NumberOfProductCategories = 8,
    NumberOfProducts = 9,
    MarketingPresence = 10,
    TotalFollowerCount = 11,
    PercentageRevenueAllocatedForChannelActivities = 12,
    PotentialAndTnC = 13,
    ProjectedNetRevenue = 14,
    ExpectedGrossProfitMargin = 15,
    RevenueGoal = 16,
    PaymentTerms = 17,
}

export class PagedResultDTOOfVendorScoreCardOverviewDTO implements IPagedResultDTOOfVendorScoreCardOverviewDTO {
    items?: VendorScoreCardOverviewDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfVendorScoreCardOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(VendorScoreCardOverviewDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfVendorScoreCardOverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfVendorScoreCardOverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfVendorScoreCardOverviewDTO {
    items?: VendorScoreCardOverviewDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class CreateVendorScoreCardSurveyDataDTO implements ICreateVendorScoreCardSurveyDataDTO {
    accessToken?: string;
    rows?: VendorScoreCardSurveyDataRowDTO[];

    constructor(data?: ICreateVendorScoreCardSurveyDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["AccessToken"];
            if (Array.isArray(_data["Rows"])) {
                this.rows = [] as any;
                for (let item of _data["Rows"])
                    this.rows!.push(VendorScoreCardSurveyDataRowDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateVendorScoreCardSurveyDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVendorScoreCardSurveyDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccessToken"] = this.accessToken;
        if (Array.isArray(this.rows)) {
            data["Rows"] = [];
            for (let item of this.rows)
                data["Rows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateVendorScoreCardSurveyDataDTO {
    accessToken?: string;
    rows?: VendorScoreCardSurveyDataRowDTO[];
}

export class VendorScoreCardSurveyDataRowDTO implements IVendorScoreCardSurveyDataRowDTO {
    facts?: number | undefined;
    vendorScoreCardRowType?: VendorScoreCardRowTypeV20;

    constructor(data?: IVendorScoreCardSurveyDataRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facts = _data["Facts"];
            this.vendorScoreCardRowType = _data["VendorScoreCardRowType"];
        }
    }

    static fromJS(data: any): VendorScoreCardSurveyDataRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VendorScoreCardSurveyDataRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Facts"] = this.facts;
        data["VendorScoreCardRowType"] = this.vendorScoreCardRowType;
        return data;
    }
}

export interface IVendorScoreCardSurveyDataRowDTO {
    facts?: number | undefined;
    vendorScoreCardRowType?: VendorScoreCardRowTypeV20;
}

export class EmailAccountSettingsDTO implements IEmailAccountSettingsDTO {
    id?: number;
    accountName?: string;
    accountType?: EmailAccountType;
    direction?: EmailAccountDirection;
    receiveOnlyMailsWithAttachments?: boolean;
    emailAddress?: string;
    password?: string;
    archiveFolderName?: string | undefined;
    azureClientId?: string | undefined;
    azureClientSecret?: string | undefined;
    azureTenantId?: string | undefined;
    serverUrl?: string | undefined;
    userName?: string | undefined;
    useSSL?: boolean | undefined;
    port?: number | undefined;
    importConfigurationInfos?: NameAndIdDTO[];
    exportInterfaceConfigurationInfos?: NameAndIdDTO[];
    exportInterfaceConfigurationTemplateInfos?: NameAndIdDTO[];
    exportInterfaceActivationEmailTemplateInfos?: NameAndIdDTO[];

    constructor(data?: IEmailAccountSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.accountName = _data["AccountName"];
            this.accountType = _data["AccountType"];
            this.direction = _data["Direction"];
            this.receiveOnlyMailsWithAttachments = _data["ReceiveOnlyMailsWithAttachments"];
            this.emailAddress = _data["EmailAddress"];
            this.password = _data["Password"];
            this.archiveFolderName = _data["ArchiveFolderName"];
            this.azureClientId = _data["AzureClientId"];
            this.azureClientSecret = _data["AzureClientSecret"];
            this.azureTenantId = _data["AzureTenantId"];
            this.serverUrl = _data["ServerUrl"];
            this.userName = _data["UserName"];
            this.useSSL = _data["UseSSL"];
            this.port = _data["Port"];
            if (Array.isArray(_data["ImportConfigurationInfos"])) {
                this.importConfigurationInfos = [] as any;
                for (let item of _data["ImportConfigurationInfos"])
                    this.importConfigurationInfos!.push(NameAndIdDTO.fromJS(item));
            }
            if (Array.isArray(_data["ExportInterfaceConfigurationInfos"])) {
                this.exportInterfaceConfigurationInfos = [] as any;
                for (let item of _data["ExportInterfaceConfigurationInfos"])
                    this.exportInterfaceConfigurationInfos!.push(NameAndIdDTO.fromJS(item));
            }
            if (Array.isArray(_data["ExportInterfaceConfigurationTemplateInfos"])) {
                this.exportInterfaceConfigurationTemplateInfos = [] as any;
                for (let item of _data["ExportInterfaceConfigurationTemplateInfos"])
                    this.exportInterfaceConfigurationTemplateInfos!.push(NameAndIdDTO.fromJS(item));
            }
            if (Array.isArray(_data["ExportInterfaceActivationEmailTemplateInfos"])) {
                this.exportInterfaceActivationEmailTemplateInfos = [] as any;
                for (let item of _data["ExportInterfaceActivationEmailTemplateInfos"])
                    this.exportInterfaceActivationEmailTemplateInfos!.push(NameAndIdDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailAccountSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAccountSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AccountName"] = this.accountName;
        data["AccountType"] = this.accountType;
        data["Direction"] = this.direction;
        data["ReceiveOnlyMailsWithAttachments"] = this.receiveOnlyMailsWithAttachments;
        data["EmailAddress"] = this.emailAddress;
        data["Password"] = this.password;
        data["ArchiveFolderName"] = this.archiveFolderName;
        data["AzureClientId"] = this.azureClientId;
        data["AzureClientSecret"] = this.azureClientSecret;
        data["AzureTenantId"] = this.azureTenantId;
        data["ServerUrl"] = this.serverUrl;
        data["UserName"] = this.userName;
        data["UseSSL"] = this.useSSL;
        data["Port"] = this.port;
        if (Array.isArray(this.importConfigurationInfos)) {
            data["ImportConfigurationInfos"] = [];
            for (let item of this.importConfigurationInfos)
                data["ImportConfigurationInfos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exportInterfaceConfigurationInfos)) {
            data["ExportInterfaceConfigurationInfos"] = [];
            for (let item of this.exportInterfaceConfigurationInfos)
                data["ExportInterfaceConfigurationInfos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exportInterfaceConfigurationTemplateInfos)) {
            data["ExportInterfaceConfigurationTemplateInfos"] = [];
            for (let item of this.exportInterfaceConfigurationTemplateInfos)
                data["ExportInterfaceConfigurationTemplateInfos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exportInterfaceActivationEmailTemplateInfos)) {
            data["ExportInterfaceActivationEmailTemplateInfos"] = [];
            for (let item of this.exportInterfaceActivationEmailTemplateInfos)
                data["ExportInterfaceActivationEmailTemplateInfos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEmailAccountSettingsDTO {
    id?: number;
    accountName?: string;
    accountType?: EmailAccountType;
    direction?: EmailAccountDirection;
    receiveOnlyMailsWithAttachments?: boolean;
    emailAddress?: string;
    password?: string;
    archiveFolderName?: string | undefined;
    azureClientId?: string | undefined;
    azureClientSecret?: string | undefined;
    azureTenantId?: string | undefined;
    serverUrl?: string | undefined;
    userName?: string | undefined;
    useSSL?: boolean | undefined;
    port?: number | undefined;
    importConfigurationInfos?: NameAndIdDTO[];
    exportInterfaceConfigurationInfos?: NameAndIdDTO[];
    exportInterfaceConfigurationTemplateInfos?: NameAndIdDTO[];
    exportInterfaceActivationEmailTemplateInfos?: NameAndIdDTO[];
}

export enum EmailAccountType {
    Office365 = 0,
    IMAP = 1,
    SMTP = 2,
}

export enum EmailAccountDirection {
    In = 0,
    Out = 1,
}

export class NameAndIdDTO implements INameAndIdDTO {
    name?: string;
    id?: number;

    constructor(data?: INameAndIdDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): NameAndIdDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NameAndIdDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Id"] = this.id;
        return data;
    }
}

export interface INameAndIdDTO {
    name?: string;
    id?: number;
}

export class CreateEmailAccountSettingsDTO implements ICreateEmailAccountSettingsDTO {
    accountName!: string;
    accountType!: EmailAccountType;
    direction!: EmailAccountDirection;
    receiveOnlyMailsWithAttachments!: boolean;
    emailAddress!: string;
    password?: string | undefined;
    archiveFolderName?: string | undefined;
    azureClientId?: string | undefined;
    azureClientSecret?: string | undefined;
    azureTenantId?: string | undefined;
    serverUrl?: string | undefined;
    userName?: string | undefined;
    useSSL?: boolean | undefined;
    port?: number | undefined;

    constructor(data?: ICreateEmailAccountSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["AccountName"];
            this.accountType = _data["AccountType"];
            this.direction = _data["Direction"];
            this.receiveOnlyMailsWithAttachments = _data["ReceiveOnlyMailsWithAttachments"];
            this.emailAddress = _data["EmailAddress"];
            this.password = _data["Password"];
            this.archiveFolderName = _data["ArchiveFolderName"];
            this.azureClientId = _data["AzureClientId"];
            this.azureClientSecret = _data["AzureClientSecret"];
            this.azureTenantId = _data["AzureTenantId"];
            this.serverUrl = _data["ServerUrl"];
            this.userName = _data["UserName"];
            this.useSSL = _data["UseSSL"];
            this.port = _data["Port"];
        }
    }

    static fromJS(data: any): CreateEmailAccountSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailAccountSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountName"] = this.accountName;
        data["AccountType"] = this.accountType;
        data["Direction"] = this.direction;
        data["ReceiveOnlyMailsWithAttachments"] = this.receiveOnlyMailsWithAttachments;
        data["EmailAddress"] = this.emailAddress;
        data["Password"] = this.password;
        data["ArchiveFolderName"] = this.archiveFolderName;
        data["AzureClientId"] = this.azureClientId;
        data["AzureClientSecret"] = this.azureClientSecret;
        data["AzureTenantId"] = this.azureTenantId;
        data["ServerUrl"] = this.serverUrl;
        data["UserName"] = this.userName;
        data["UseSSL"] = this.useSSL;
        data["Port"] = this.port;
        return data;
    }
}

export interface ICreateEmailAccountSettingsDTO {
    accountName: string;
    accountType: EmailAccountType;
    direction: EmailAccountDirection;
    receiveOnlyMailsWithAttachments: boolean;
    emailAddress: string;
    password?: string | undefined;
    archiveFolderName?: string | undefined;
    azureClientId?: string | undefined;
    azureClientSecret?: string | undefined;
    azureTenantId?: string | undefined;
    serverUrl?: string | undefined;
    userName?: string | undefined;
    useSSL?: boolean | undefined;
    port?: number | undefined;
}

export class UpdateEmailAccountSettingsDTO implements IUpdateEmailAccountSettingsDTO {
    id!: number;
    accountName?: string | undefined;
    accountType?: EmailAccountType | undefined;
    direction?: EmailAccountDirection | undefined;
    receiveOnlyMailsWithAttachments?: boolean;
    emailAddress?: string | undefined;
    password?: string | undefined;
    archiveFolderName?: string | undefined;
    azureClientId?: string | undefined;
    azureClientSecret?: string | undefined;
    azureTenantId?: string | undefined;
    serverUrl?: string | undefined;
    userName?: string | undefined;
    useSSL?: boolean | undefined;
    port?: number | undefined;

    constructor(data?: IUpdateEmailAccountSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.accountName = _data["AccountName"];
            this.accountType = _data["AccountType"];
            this.direction = _data["Direction"];
            this.receiveOnlyMailsWithAttachments = _data["ReceiveOnlyMailsWithAttachments"];
            this.emailAddress = _data["EmailAddress"];
            this.password = _data["Password"];
            this.archiveFolderName = _data["ArchiveFolderName"];
            this.azureClientId = _data["AzureClientId"];
            this.azureClientSecret = _data["AzureClientSecret"];
            this.azureTenantId = _data["AzureTenantId"];
            this.serverUrl = _data["ServerUrl"];
            this.userName = _data["UserName"];
            this.useSSL = _data["UseSSL"];
            this.port = _data["Port"];
        }
    }

    static fromJS(data: any): UpdateEmailAccountSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailAccountSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AccountName"] = this.accountName;
        data["AccountType"] = this.accountType;
        data["Direction"] = this.direction;
        data["ReceiveOnlyMailsWithAttachments"] = this.receiveOnlyMailsWithAttachments;
        data["EmailAddress"] = this.emailAddress;
        data["Password"] = this.password;
        data["ArchiveFolderName"] = this.archiveFolderName;
        data["AzureClientId"] = this.azureClientId;
        data["AzureClientSecret"] = this.azureClientSecret;
        data["AzureTenantId"] = this.azureTenantId;
        data["ServerUrl"] = this.serverUrl;
        data["UserName"] = this.userName;
        data["UseSSL"] = this.useSSL;
        data["Port"] = this.port;
        return data;
    }
}

export interface IUpdateEmailAccountSettingsDTO {
    id: number;
    accountName?: string | undefined;
    accountType?: EmailAccountType | undefined;
    direction?: EmailAccountDirection | undefined;
    receiveOnlyMailsWithAttachments?: boolean;
    emailAddress?: string | undefined;
    password?: string | undefined;
    archiveFolderName?: string | undefined;
    azureClientId?: string | undefined;
    azureClientSecret?: string | undefined;
    azureTenantId?: string | undefined;
    serverUrl?: string | undefined;
    userName?: string | undefined;
    useSSL?: boolean | undefined;
    port?: number | undefined;
}

export class PagedResultDTOOfEmailAccountSettingsDTO implements IPagedResultDTOOfEmailAccountSettingsDTO {
    items?: EmailAccountSettingsDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfEmailAccountSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(EmailAccountSettingsDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfEmailAccountSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfEmailAccountSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfEmailAccountSettingsDTO {
    items?: EmailAccountSettingsDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class DeleteEmailAccountSettingsResultDTO implements IDeleteEmailAccountSettingsResultDTO {
    success?: boolean;
    stillUsedInImportConfigurations?: number[] | undefined;
    stillUsedInExportConfigurations?: number[] | undefined;
    stillUsedInExportConfigurationTemplates?: number[] | undefined;
    stillUsedInActivationEmailTemplates?: number[] | undefined;

    constructor(data?: IDeleteEmailAccountSettingsResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            if (Array.isArray(_data["StillUsedInImportConfigurations"])) {
                this.stillUsedInImportConfigurations = [] as any;
                for (let item of _data["StillUsedInImportConfigurations"])
                    this.stillUsedInImportConfigurations!.push(item);
            }
            if (Array.isArray(_data["StillUsedInExportConfigurations"])) {
                this.stillUsedInExportConfigurations = [] as any;
                for (let item of _data["StillUsedInExportConfigurations"])
                    this.stillUsedInExportConfigurations!.push(item);
            }
            if (Array.isArray(_data["StillUsedInExportConfigurationTemplates"])) {
                this.stillUsedInExportConfigurationTemplates = [] as any;
                for (let item of _data["StillUsedInExportConfigurationTemplates"])
                    this.stillUsedInExportConfigurationTemplates!.push(item);
            }
            if (Array.isArray(_data["StillUsedInActivationEmailTemplates"])) {
                this.stillUsedInActivationEmailTemplates = [] as any;
                for (let item of _data["StillUsedInActivationEmailTemplates"])
                    this.stillUsedInActivationEmailTemplates!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteEmailAccountSettingsResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmailAccountSettingsResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        if (Array.isArray(this.stillUsedInImportConfigurations)) {
            data["StillUsedInImportConfigurations"] = [];
            for (let item of this.stillUsedInImportConfigurations)
                data["StillUsedInImportConfigurations"].push(item);
        }
        if (Array.isArray(this.stillUsedInExportConfigurations)) {
            data["StillUsedInExportConfigurations"] = [];
            for (let item of this.stillUsedInExportConfigurations)
                data["StillUsedInExportConfigurations"].push(item);
        }
        if (Array.isArray(this.stillUsedInExportConfigurationTemplates)) {
            data["StillUsedInExportConfigurationTemplates"] = [];
            for (let item of this.stillUsedInExportConfigurationTemplates)
                data["StillUsedInExportConfigurationTemplates"].push(item);
        }
        if (Array.isArray(this.stillUsedInActivationEmailTemplates)) {
            data["StillUsedInActivationEmailTemplates"] = [];
            for (let item of this.stillUsedInActivationEmailTemplates)
                data["StillUsedInActivationEmailTemplates"].push(item);
        }
        return data;
    }
}

export interface IDeleteEmailAccountSettingsResultDTO {
    success?: boolean;
    stillUsedInImportConfigurations?: number[] | undefined;
    stillUsedInExportConfigurations?: number[] | undefined;
    stillUsedInExportConfigurationTemplates?: number[] | undefined;
    stillUsedInActivationEmailTemplates?: number[] | undefined;
}

export class EmailProcessResultDTO implements IEmailProcessResultDTO {
    success?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IEmailProcessResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.errorMessage = _data["ErrorMessage"];
        }
    }

    static fromJS(data: any): EmailProcessResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailProcessResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        data["ErrorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IEmailProcessResultDTO {
    success?: boolean;
    errorMessage?: string | undefined;
}

export class ProcessResultDTO implements IProcessResultDTO {
    success?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IProcessResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.errorMessage = _data["ErrorMessage"];
        }
    }

    static fromJS(data: any): ProcessResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        data["ErrorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IProcessResultDTO {
    success?: boolean;
    errorMessage?: string | undefined;
}

export class EmailAccountSettingsLimitedDTO implements IEmailAccountSettingsLimitedDTO {
    id?: number;
    accountName?: string;
    accountType?: EmailAccountType;
    direction?: EmailAccountDirection;

    constructor(data?: IEmailAccountSettingsLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.accountName = _data["AccountName"];
            this.accountType = _data["AccountType"];
            this.direction = _data["Direction"];
        }
    }

    static fromJS(data: any): EmailAccountSettingsLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAccountSettingsLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AccountName"] = this.accountName;
        data["AccountType"] = this.accountType;
        data["Direction"] = this.direction;
        return data;
    }
}

export interface IEmailAccountSettingsLimitedDTO {
    id?: number;
    accountName?: string;
    accountType?: EmailAccountType;
    direction?: EmailAccountDirection;
}

export class ParashiftDocumentResponseDTO implements IParashiftDocumentResponseDTO {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IParashiftDocumentResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ParashiftDocumentResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParashiftDocumentResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IParashiftDocumentResponseDTO {
    success?: boolean;
    message?: string | undefined;
}

export class ParashiftDocumentOutputDTO implements IParashiftDocumentOutputDTO {
    parashiftId!: string;
    outputDataBase64?: string | undefined;

    constructor(data?: IParashiftDocumentOutputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parashiftId = _data["ParashiftId"];
            this.outputDataBase64 = _data["OutputDataBase64"];
        }
    }

    static fromJS(data: any): ParashiftDocumentOutputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParashiftDocumentOutputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ParashiftId"] = this.parashiftId;
        data["OutputDataBase64"] = this.outputDataBase64;
        return data;
    }
}

export interface IParashiftDocumentOutputDTO {
    parashiftId: string;
    outputDataBase64?: string | undefined;
}

export class ImportProcessResultDTO implements IImportProcessResultDTO {
    processingInstruction?: ImportProcessResultProcessingInstructionDTO | undefined;
    messageBody?: ImportProcessResultMessageBodyDTO | undefined;
    success?: boolean;

    constructor(data?: IImportProcessResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingInstruction = _data["ProcessingInstruction"] ? ImportProcessResultProcessingInstructionDTO.fromJS(_data["ProcessingInstruction"]) : undefined as any;
            this.messageBody = _data["MessageBody"] ? ImportProcessResultMessageBodyDTO.fromJS(_data["MessageBody"]) : undefined as any;
            this.success = _data["Success"];
        }
    }

    static fromJS(data: any): ImportProcessResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProcessResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProcessingInstruction"] = this.processingInstruction ? this.processingInstruction.toJSON() : undefined as any;
        data["MessageBody"] = this.messageBody ? this.messageBody.toJSON() : undefined as any;
        data["Success"] = this.success;
        return data;
    }
}

export interface IImportProcessResultDTO {
    processingInstruction?: ImportProcessResultProcessingInstructionDTO | undefined;
    messageBody?: ImportProcessResultMessageBodyDTO | undefined;
    success?: boolean;
}

export class ImportProcessResultProcessingInstructionDTO implements IImportProcessResultProcessingInstructionDTO {
    companyName?: string | undefined;
    partner?: string | undefined;
    correlationId?: string | undefined;
    documentType?: string | undefined;

    constructor(data?: IImportProcessResultProcessingInstructionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["CompanyName"];
            this.partner = _data["Partner"];
            this.correlationId = _data["CorrelationId"];
            this.documentType = _data["DocumentType"];
        }
    }

    static fromJS(data: any): ImportProcessResultProcessingInstructionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProcessResultProcessingInstructionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyName"] = this.companyName;
        data["Partner"] = this.partner;
        data["CorrelationId"] = this.correlationId;
        data["DocumentType"] = this.documentType;
        return data;
    }
}

export interface IImportProcessResultProcessingInstructionDTO {
    companyName?: string | undefined;
    partner?: string | undefined;
    correlationId?: string | undefined;
    documentType?: string | undefined;
}

export class ImportProcessResultMessageBodyDTO implements IImportProcessResultMessageBodyDTO {
    notification?: ImportProcessResultNotificationDTO | undefined;

    constructor(data?: IImportProcessResultMessageBodyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notification = _data["Notification"] ? ImportProcessResultNotificationDTO.fromJS(_data["Notification"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImportProcessResultMessageBodyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProcessResultMessageBodyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Notification"] = this.notification ? this.notification.toJSON() : undefined as any;
        return data;
    }
}

export interface IImportProcessResultMessageBodyDTO {
    notification?: ImportProcessResultNotificationDTO | undefined;
}

export class ImportProcessResultNotificationDTO implements IImportProcessResultNotificationDTO {
    overallStatus?: string | undefined;
    messages?: ImportProcessResultMessageDTO[];

    constructor(data?: IImportProcessResultNotificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overallStatus = _data["OverallStatus"];
            if (Array.isArray(_data["Messages"])) {
                this.messages = [] as any;
                for (let item of _data["Messages"])
                    this.messages!.push(ImportProcessResultMessageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportProcessResultNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProcessResultNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OverallStatus"] = this.overallStatus;
        if (Array.isArray(this.messages)) {
            data["Messages"] = [];
            for (let item of this.messages)
                data["Messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportProcessResultNotificationDTO {
    overallStatus?: string | undefined;
    messages?: ImportProcessResultMessageDTO[];
}

export class ImportProcessResultMessageDTO implements IImportProcessResultMessageDTO {
    type?: string | undefined;
    message?: string | undefined;

    constructor(data?: IImportProcessResultMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ImportProcessResultMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProcessResultMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["Message"] = this.message;
        return data;
    }
}

export interface IImportProcessResultMessageDTO {
    type?: string | undefined;
    message?: string | undefined;
}

export class SalesOrderImportNavisionProcessResultServiceMessageDTO implements ISalesOrderImportNavisionProcessResultServiceMessageDTO {
    processingInstruction?: SalesOrderImportNavisionProcessResultProcessingInstructionDTO;
    messageBody?: SalesOrderImportNavisionProcessResultMessageBodyDTO;

    constructor(data?: ISalesOrderImportNavisionProcessResultServiceMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingInstruction = _data["ProcessingInstruction"] ? SalesOrderImportNavisionProcessResultProcessingInstructionDTO.fromJS(_data["ProcessingInstruction"]) : undefined as any;
            this.messageBody = _data["MessageBody"] ? SalesOrderImportNavisionProcessResultMessageBodyDTO.fromJS(_data["MessageBody"]) : undefined as any;
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultServiceMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultServiceMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProcessingInstruction"] = this.processingInstruction ? this.processingInstruction.toJSON() : undefined as any;
        data["MessageBody"] = this.messageBody ? this.messageBody.toJSON() : undefined as any;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultServiceMessageDTO {
    processingInstruction?: SalesOrderImportNavisionProcessResultProcessingInstructionDTO;
    messageBody?: SalesOrderImportNavisionProcessResultMessageBodyDTO;
}

export class SalesOrderImportNavisionProcessResultProcessingInstructionDTO implements ISalesOrderImportNavisionProcessResultProcessingInstructionDTO {
    correlationId?: string | undefined;
    partner?: string | undefined;
    documentType?: string | undefined;
    companyName?: string | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultProcessingInstructionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.partner = _data["Partner"];
            this.documentType = _data["DocumentType"];
            this.companyName = _data["CompanyName"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultProcessingInstructionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultProcessingInstructionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["Partner"] = this.partner;
        data["DocumentType"] = this.documentType;
        data["CompanyName"] = this.companyName;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultProcessingInstructionDTO {
    correlationId?: string | undefined;
    partner?: string | undefined;
    documentType?: string | undefined;
    companyName?: string | undefined;
}

export class SalesOrderImportNavisionProcessResultMessageBodyDTO implements ISalesOrderImportNavisionProcessResultMessageBodyDTO {
    data?: SalesOrderImportNavisionProcessResultDTO;

    constructor(data?: ISalesOrderImportNavisionProcessResultMessageBodyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["Data"] ? SalesOrderImportNavisionProcessResultDTO.fromJS(_data["Data"]) : undefined as any;
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultMessageBodyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultMessageBodyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultMessageBodyDTO {
    data?: SalesOrderImportNavisionProcessResultDTO;
}

export class SalesOrderImportNavisionProcessResultDTO implements ISalesOrderImportNavisionProcessResultDTO {
    messageHeader?: SalesOrderImportNavisionProcessResulMessageHeaderDTO | undefined;
    header?: SalesOrderImportNavisionProcessResultHeaderDTO | undefined;
    body?: SalesOrderImportNavisionProcessResultBodyDTO | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageHeader = _data["MessageHeader"] ? SalesOrderImportNavisionProcessResulMessageHeaderDTO.fromJS(_data["MessageHeader"]) : undefined as any;
            this.header = _data["Header"] ? SalesOrderImportNavisionProcessResultHeaderDTO.fromJS(_data["Header"]) : undefined as any;
            this.body = _data["Body"] ? SalesOrderImportNavisionProcessResultBodyDTO.fromJS(_data["Body"]) : undefined as any;
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MessageHeader"] = this.messageHeader ? this.messageHeader.toJSON() : undefined as any;
        data["Header"] = this.header ? this.header.toJSON() : undefined as any;
        data["Body"] = this.body ? this.body.toJSON() : undefined as any;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultDTO {
    messageHeader?: SalesOrderImportNavisionProcessResulMessageHeaderDTO | undefined;
    header?: SalesOrderImportNavisionProcessResultHeaderDTO | undefined;
    body?: SalesOrderImportNavisionProcessResultBodyDTO | undefined;
}

export class SalesOrderImportNavisionProcessResulMessageHeaderDTO implements ISalesOrderImportNavisionProcessResulMessageHeaderDTO {
    message_type?: string | undefined;
    customerId?: string | undefined;
    messageDateString?: string | undefined;
    messageTimeString?: string | undefined;
    messageTest?: string | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResulMessageHeaderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message_type = _data["message_type"];
            this.customerId = _data["CustomerId"];
            this.messageDateString = _data["MessageDateString"];
            this.messageTimeString = _data["MessageTimeString"];
            this.messageTest = _data["MessageTest"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResulMessageHeaderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResulMessageHeaderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message_type"] = this.message_type;
        data["CustomerId"] = this.customerId;
        data["MessageDateString"] = this.messageDateString;
        data["MessageTimeString"] = this.messageTimeString;
        data["MessageTest"] = this.messageTest;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResulMessageHeaderDTO {
    message_type?: string | undefined;
    customerId?: string | undefined;
    messageDateString?: string | undefined;
    messageTimeString?: string | undefined;
    messageTest?: string | undefined;
}

export class SalesOrderImportNavisionProcessResultHeaderDTO implements ISalesOrderImportNavisionProcessResultHeaderDTO {
    order_status?: SalesOrderImportNavisionProcessResultOrderStatusDTO | undefined;
    order_info?: SalesOrderImportNavisionProcessResultOrderInfoDTO | undefined;
    order_sellto?: SalesOrderImportNavisionProcessResultSellToDTO | undefined;
    order_billto?: SalesOrderImportNavisionProcessResultBillToDTO | undefined;
    order_shipto?: SalesOrderImportNavisionProcessResultShipToDTO | undefined;
    order_ship_additional?: SalesOrderImportNavisionProcessResultShipAdditionalInfoDTO | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultHeaderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order_status = _data["order_status"] ? SalesOrderImportNavisionProcessResultOrderStatusDTO.fromJS(_data["order_status"]) : undefined as any;
            this.order_info = _data["order_info"] ? SalesOrderImportNavisionProcessResultOrderInfoDTO.fromJS(_data["order_info"]) : undefined as any;
            this.order_sellto = _data["order_sellto"] ? SalesOrderImportNavisionProcessResultSellToDTO.fromJS(_data["order_sellto"]) : undefined as any;
            this.order_billto = _data["order_billto"] ? SalesOrderImportNavisionProcessResultBillToDTO.fromJS(_data["order_billto"]) : undefined as any;
            this.order_shipto = _data["order_shipto"] ? SalesOrderImportNavisionProcessResultShipToDTO.fromJS(_data["order_shipto"]) : undefined as any;
            this.order_ship_additional = _data["order_ship_additional"] ? SalesOrderImportNavisionProcessResultShipAdditionalInfoDTO.fromJS(_data["order_ship_additional"]) : undefined as any;
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultHeaderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultHeaderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order_status"] = this.order_status ? this.order_status.toJSON() : undefined as any;
        data["order_info"] = this.order_info ? this.order_info.toJSON() : undefined as any;
        data["order_sellto"] = this.order_sellto ? this.order_sellto.toJSON() : undefined as any;
        data["order_billto"] = this.order_billto ? this.order_billto.toJSON() : undefined as any;
        data["order_shipto"] = this.order_shipto ? this.order_shipto.toJSON() : undefined as any;
        data["order_ship_additional"] = this.order_ship_additional ? this.order_ship_additional.toJSON() : undefined as any;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultHeaderDTO {
    order_status?: SalesOrderImportNavisionProcessResultOrderStatusDTO | undefined;
    order_info?: SalesOrderImportNavisionProcessResultOrderInfoDTO | undefined;
    order_sellto?: SalesOrderImportNavisionProcessResultSellToDTO | undefined;
    order_billto?: SalesOrderImportNavisionProcessResultBillToDTO | undefined;
    order_shipto?: SalesOrderImportNavisionProcessResultShipToDTO | undefined;
    order_ship_additional?: SalesOrderImportNavisionProcessResultShipAdditionalInfoDTO | undefined;
}

export class SalesOrderImportNavisionProcessResultOrderStatusDTO implements ISalesOrderImportNavisionProcessResultOrderStatusDTO {
    status?: string | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultOrderStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultOrderStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultOrderStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultOrderStatusDTO {
    status?: string | undefined;
}

export class SalesOrderImportNavisionProcessResultOrderInfoDTO implements ISalesOrderImportNavisionProcessResultOrderInfoDTO {
    cus_orderno?: string | undefined;
    orderdate?: string | undefined;
    orderno?: string | undefined;
    orderref?: string | undefined;
    orderlang?: string | undefined;
    curcode?: string | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultOrderInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cus_orderno = _data["cus_orderno"];
            this.orderdate = _data["orderdate"];
            this.orderno = _data["orderno"];
            this.orderref = _data["orderref"];
            this.orderlang = _data["orderlang"];
            this.curcode = _data["curcode"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultOrderInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultOrderInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cus_orderno"] = this.cus_orderno;
        data["orderdate"] = this.orderdate;
        data["orderno"] = this.orderno;
        data["orderref"] = this.orderref;
        data["orderlang"] = this.orderlang;
        data["curcode"] = this.curcode;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultOrderInfoDTO {
    cus_orderno?: string | undefined;
    orderdate?: string | undefined;
    orderno?: string | undefined;
    orderref?: string | undefined;
    orderlang?: string | undefined;
    curcode?: string | undefined;
}

export class SalesOrderImportNavisionProcessResultSellToDTO implements ISalesOrderImportNavisionProcessResultSellToDTO {
    st_name?: string | undefined;
    st_name2?: string | undefined;
    st_address?: string | undefined;
    st_address2?: string | undefined;
    st_postcode?: string | undefined;
    st_city?: string | undefined;
    st_country?: string | undefined;
    st_contact?: string | undefined;
    st_email?: string | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultSellToDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.st_name = _data["st_name"];
            this.st_name2 = _data["st_name2"];
            this.st_address = _data["st_address"];
            this.st_address2 = _data["st_address2"];
            this.st_postcode = _data["st_postcode"];
            this.st_city = _data["st_city"];
            this.st_country = _data["st_country"];
            this.st_contact = _data["st_contact"];
            this.st_email = _data["st_email"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultSellToDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultSellToDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["st_name"] = this.st_name;
        data["st_name2"] = this.st_name2;
        data["st_address"] = this.st_address;
        data["st_address2"] = this.st_address2;
        data["st_postcode"] = this.st_postcode;
        data["st_city"] = this.st_city;
        data["st_country"] = this.st_country;
        data["st_contact"] = this.st_contact;
        data["st_email"] = this.st_email;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultSellToDTO {
    st_name?: string | undefined;
    st_name2?: string | undefined;
    st_address?: string | undefined;
    st_address2?: string | undefined;
    st_postcode?: string | undefined;
    st_city?: string | undefined;
    st_country?: string | undefined;
    st_contact?: string | undefined;
    st_email?: string | undefined;
}

export class SalesOrderImportNavisionProcessResultBillToDTO implements ISalesOrderImportNavisionProcessResultBillToDTO {
    bt_name?: string | undefined;
    bt_name2?: string | undefined;
    bt_address?: string | undefined;
    bt_address2?: string | undefined;
    bt_postcode?: string | undefined;
    bt_city?: string | undefined;
    bt_country?: string | undefined;
    bt_contact?: string | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultBillToDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bt_name = _data["bt_name"];
            this.bt_name2 = _data["bt_name2"];
            this.bt_address = _data["bt_address"];
            this.bt_address2 = _data["bt_address2"];
            this.bt_postcode = _data["bt_postcode"];
            this.bt_city = _data["bt_city"];
            this.bt_country = _data["bt_country"];
            this.bt_contact = _data["bt_contact"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultBillToDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultBillToDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bt_name"] = this.bt_name;
        data["bt_name2"] = this.bt_name2;
        data["bt_address"] = this.bt_address;
        data["bt_address2"] = this.bt_address2;
        data["bt_postcode"] = this.bt_postcode;
        data["bt_city"] = this.bt_city;
        data["bt_country"] = this.bt_country;
        data["bt_contact"] = this.bt_contact;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultBillToDTO {
    bt_name?: string | undefined;
    bt_name2?: string | undefined;
    bt_address?: string | undefined;
    bt_address2?: string | undefined;
    bt_postcode?: string | undefined;
    bt_city?: string | undefined;
    bt_country?: string | undefined;
    bt_contact?: string | undefined;
}

export class SalesOrderImportNavisionProcessResultShipToDTO implements ISalesOrderImportNavisionProcessResultShipToDTO {
    sht_name?: string | undefined;
    sht_name2?: string | undefined;
    sht_address?: string | undefined;
    sht_address2?: string | undefined;
    sht_postcode?: string | undefined;
    sht_city?: string | undefined;
    sht_country?: string | undefined;
    sht_contact?: string | undefined;
    sht_email?: string | undefined;
    sht_phone?: string | undefined;
    sht_ref?: string | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultShipToDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sht_name = _data["sht_name"];
            this.sht_name2 = _data["sht_name2"];
            this.sht_address = _data["sht_address"];
            this.sht_address2 = _data["sht_address2"];
            this.sht_postcode = _data["sht_postcode"];
            this.sht_city = _data["sht_city"];
            this.sht_country = _data["sht_country"];
            this.sht_contact = _data["sht_contact"];
            this.sht_email = _data["sht_email"];
            this.sht_phone = _data["sht_phone"];
            this.sht_ref = _data["sht_ref"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultShipToDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultShipToDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sht_name"] = this.sht_name;
        data["sht_name2"] = this.sht_name2;
        data["sht_address"] = this.sht_address;
        data["sht_address2"] = this.sht_address2;
        data["sht_postcode"] = this.sht_postcode;
        data["sht_city"] = this.sht_city;
        data["sht_country"] = this.sht_country;
        data["sht_contact"] = this.sht_contact;
        data["sht_email"] = this.sht_email;
        data["sht_phone"] = this.sht_phone;
        data["sht_ref"] = this.sht_ref;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultShipToDTO {
    sht_name?: string | undefined;
    sht_name2?: string | undefined;
    sht_address?: string | undefined;
    sht_address2?: string | undefined;
    sht_postcode?: string | undefined;
    sht_city?: string | undefined;
    sht_country?: string | undefined;
    sht_contact?: string | undefined;
    sht_email?: string | undefined;
    sht_phone?: string | undefined;
    sht_ref?: string | undefined;
}

export class SalesOrderImportNavisionProcessResultShipAdditionalInfoDTO implements ISalesOrderImportNavisionProcessResultShipAdditionalInfoDTO {
    ship_agent?: string | undefined;
    ship_service?: string | undefined;
    ship_cost?: number;

    constructor(data?: ISalesOrderImportNavisionProcessResultShipAdditionalInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ship_agent = _data["ship_agent"];
            this.ship_service = _data["ship_service"];
            this.ship_cost = _data["ship_cost"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultShipAdditionalInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultShipAdditionalInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ship_agent"] = this.ship_agent;
        data["ship_service"] = this.ship_service;
        data["ship_cost"] = this.ship_cost;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultShipAdditionalInfoDTO {
    ship_agent?: string | undefined;
    ship_service?: string | undefined;
    ship_cost?: number;
}

export class SalesOrderImportNavisionProcessResultBodyDTO implements ISalesOrderImportNavisionProcessResultBodyDTO {
    ordresp_line?: SalesOrderImportNavisionProcessResultLineItemDTO[] | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultBodyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ordresp_line"])) {
                this.ordresp_line = [] as any;
                for (let item of _data["ordresp_line"])
                    this.ordresp_line!.push(SalesOrderImportNavisionProcessResultLineItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultBodyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultBodyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ordresp_line)) {
            data["ordresp_line"] = [];
            for (let item of this.ordresp_line)
                data["ordresp_line"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultBodyDTO {
    ordresp_line?: SalesOrderImportNavisionProcessResultLineItemDTO[] | undefined;
}

export class SalesOrderImportNavisionProcessResultLineItemDTO implements ISalesOrderImportNavisionProcessResultLineItemDTO {
    line_info?: SalesOrderImportNavisionProcessResultLineInfoDTO | undefined;
    line_status?: SalesOrderImportNavisionProcessResultLineStatusDTO | undefined;
    item_info?: SalesOrderImportNavisionProcessResultLineItemInfoDTO | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultLineItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line_info = _data["line_info"] ? SalesOrderImportNavisionProcessResultLineInfoDTO.fromJS(_data["line_info"]) : undefined as any;
            this.line_status = _data["line_status"] ? SalesOrderImportNavisionProcessResultLineStatusDTO.fromJS(_data["line_status"]) : undefined as any;
            this.item_info = _data["item_info"] ? SalesOrderImportNavisionProcessResultLineItemInfoDTO.fromJS(_data["item_info"]) : undefined as any;
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultLineItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultLineItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line_info"] = this.line_info ? this.line_info.toJSON() : undefined as any;
        data["line_status"] = this.line_status ? this.line_status.toJSON() : undefined as any;
        data["item_info"] = this.item_info ? this.item_info.toJSON() : undefined as any;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultLineItemDTO {
    line_info?: SalesOrderImportNavisionProcessResultLineInfoDTO | undefined;
    line_status?: SalesOrderImportNavisionProcessResultLineStatusDTO | undefined;
    item_info?: SalesOrderImportNavisionProcessResultLineItemInfoDTO | undefined;
}

export class SalesOrderImportNavisionProcessResultLineInfoDTO implements ISalesOrderImportNavisionProcessResultLineInfoDTO {
    line_no?: string | undefined;
    line_ref?: string | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultLineInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line_no = _data["line_no"];
            this.line_ref = _data["line_ref"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultLineInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultLineInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line_no"] = this.line_no;
        data["line_ref"] = this.line_ref;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultLineInfoDTO {
    line_no?: string | undefined;
    line_ref?: string | undefined;
}

export class SalesOrderImportNavisionProcessResultLineStatusDTO implements ISalesOrderImportNavisionProcessResultLineStatusDTO {
    line_status_info?: string | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultLineStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line_status_info = _data["line_status_info"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultLineStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultLineStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line_status_info"] = this.line_status_info;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultLineStatusDTO {
    line_status_info?: string | undefined;
}

export class SalesOrderImportNavisionProcessResultLineItemInfoDTO implements ISalesOrderImportNavisionProcessResultLineItemInfoDTO {
    item_no?: string | undefined;
    cus_item_no?: string | undefined;
    man_item_no?: string | undefined;
    item_ean?: string | undefined;
    item_desc?: string | undefined;
    item_class?: string | undefined;
    item_coo?: string | undefined;

    constructor(data?: ISalesOrderImportNavisionProcessResultLineItemInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item_no = _data["item_no"];
            this.cus_item_no = _data["cus_item_no"];
            this.man_item_no = _data["man_item_no"];
            this.item_ean = _data["item_ean"];
            this.item_desc = _data["item_desc"];
            this.item_class = _data["item_class"];
            this.item_coo = _data["item_coo"];
        }
    }

    static fromJS(data: any): SalesOrderImportNavisionProcessResultLineItemInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderImportNavisionProcessResultLineItemInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item_no"] = this.item_no;
        data["cus_item_no"] = this.cus_item_no;
        data["man_item_no"] = this.man_item_no;
        data["item_ean"] = this.item_ean;
        data["item_desc"] = this.item_desc;
        data["item_class"] = this.item_class;
        data["item_coo"] = this.item_coo;
        return data;
    }
}

export interface ISalesOrderImportNavisionProcessResultLineItemInfoDTO {
    item_no?: string | undefined;
    cus_item_no?: string | undefined;
    man_item_no?: string | undefined;
    item_ean?: string | undefined;
    item_desc?: string | undefined;
    item_class?: string | undefined;
    item_coo?: string | undefined;
}

export class AcodisWorkflowDTO implements IAcodisWorkflowDTO {
    id?: number;
    name?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    importType?: ImportType;
    isInUse?: boolean;

    constructor(data?: IAcodisWorkflowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.importType = _data["ImportType"];
            this.isInUse = _data["IsInUse"];
        }
    }

    static fromJS(data: any): AcodisWorkflowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AcodisWorkflowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["ImportType"] = this.importType;
        data["IsInUse"] = this.isInUse;
        return data;
    }
}

export interface IAcodisWorkflowDTO {
    id?: number;
    name?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    importType?: ImportType;
    isInUse?: boolean;
}

export enum ImportType {
    SalesOrder = 0,
    VendorDeliveryDate = 1,
    Parashift = 2,
    RMA = 3,
}

export class AcodisWorkflowLimitedDTO implements IAcodisWorkflowLimitedDTO {
    id?: number;
    name?: string | undefined;
    importType?: ImportType;

    constructor(data?: IAcodisWorkflowLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.importType = _data["ImportType"];
        }
    }

    static fromJS(data: any): AcodisWorkflowLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AcodisWorkflowLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["ImportType"] = this.importType;
        return data;
    }
}

export interface IAcodisWorkflowLimitedDTO {
    id?: number;
    name?: string | undefined;
    importType?: ImportType;
}

export class PagedResultDTOOfAcodisWorkflowDTO implements IPagedResultDTOOfAcodisWorkflowDTO {
    items?: AcodisWorkflowDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfAcodisWorkflowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(AcodisWorkflowDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfAcodisWorkflowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfAcodisWorkflowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfAcodisWorkflowDTO {
    items?: AcodisWorkflowDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class AcodisCategoryDTO implements IAcodisCategoryDTO {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAcodisCategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): AcodisCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AcodisCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IAcodisCategoryDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export class AcodisWorkflowTestResult implements IAcodisWorkflowTestResult {
    succeeded?: boolean;
    logEntries?: string[] | undefined;

    constructor(data?: IAcodisWorkflowTestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["Succeeded"];
            if (Array.isArray(_data["LogEntries"])) {
                this.logEntries = [] as any;
                for (let item of _data["LogEntries"])
                    this.logEntries!.push(item);
            }
        }
    }

    static fromJS(data: any): AcodisWorkflowTestResult {
        data = typeof data === 'object' ? data : {};
        let result = new AcodisWorkflowTestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Succeeded"] = this.succeeded;
        if (Array.isArray(this.logEntries)) {
            data["LogEntries"] = [];
            for (let item of this.logEntries)
                data["LogEntries"].push(item);
        }
        return data;
    }
}

export interface IAcodisWorkflowTestResult {
    succeeded?: boolean;
    logEntries?: string[] | undefined;
}

export class ImportConfigurationDTO implements IImportConfigurationDTO {
    id?: number;
    client?: ClientDTO | undefined;
    configurationName!: string;
    transferType?: ImportConfigurationTransferType;
    importType?: ImportType;
    isActive?: boolean;
    type?: ImportConfigurationType;
    clientAccessType?: ImportConfigurationClientAccessType | undefined;
    copiedFromId?: number | undefined;
    userAssignments?: ImportConfigurationUserAssignmentDTO[] | undefined;
    timeScheduleConfig?: ImportConfigurationTimeScheduleDTO | undefined;
    emailConfig?: ImportConfigurationEmailDTO | undefined;
    sFTPConfig?: ImportConfigurationSFTPDTO | undefined;
    fTPClientConfig?: ImportConfigurationFTPClientDTO | undefined;
    rESTConfig?: ImportConfigurationRESTDTO | undefined;
    as2Config?: ImportConfigurationAS2DTO | undefined;
    fileConfig?: ImportConfigurationFileDTO | undefined;
    acodisConfig?: ImportConfigurationAcodisDTO | undefined;
    manualImportConfig?: ImportConfigurationManualImportDTO | undefined;
    parashiftConfig?: ImportConfigurationParashiftDTO | undefined;

    constructor(data?: IImportConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.client = _data["Client"] ? ClientDTO.fromJS(_data["Client"]) : undefined as any;
            this.configurationName = _data["ConfigurationName"];
            this.transferType = _data["TransferType"];
            this.importType = _data["ImportType"];
            this.isActive = _data["IsActive"];
            this.type = _data["Type"];
            this.clientAccessType = _data["ClientAccessType"];
            this.copiedFromId = _data["CopiedFromId"];
            if (Array.isArray(_data["UserAssignments"])) {
                this.userAssignments = [] as any;
                for (let item of _data["UserAssignments"])
                    this.userAssignments!.push(ImportConfigurationUserAssignmentDTO.fromJS(item));
            }
            this.timeScheduleConfig = _data["TimeScheduleConfig"] ? ImportConfigurationTimeScheduleDTO.fromJS(_data["TimeScheduleConfig"]) : undefined as any;
            this.emailConfig = _data["EmailConfig"] ? ImportConfigurationEmailDTO.fromJS(_data["EmailConfig"]) : undefined as any;
            this.sFTPConfig = _data["SFTPConfig"] ? ImportConfigurationSFTPDTO.fromJS(_data["SFTPConfig"]) : undefined as any;
            this.fTPClientConfig = _data["FTPClientConfig"] ? ImportConfigurationFTPClientDTO.fromJS(_data["FTPClientConfig"]) : undefined as any;
            this.rESTConfig = _data["RESTConfig"] ? ImportConfigurationRESTDTO.fromJS(_data["RESTConfig"]) : undefined as any;
            this.as2Config = _data["As2Config"] ? ImportConfigurationAS2DTO.fromJS(_data["As2Config"]) : undefined as any;
            this.fileConfig = _data["FileConfig"] ? ImportConfigurationFileDTO.fromJS(_data["FileConfig"]) : undefined as any;
            this.acodisConfig = _data["AcodisConfig"] ? ImportConfigurationAcodisDTO.fromJS(_data["AcodisConfig"]) : undefined as any;
            this.manualImportConfig = _data["ManualImportConfig"] ? ImportConfigurationManualImportDTO.fromJS(_data["ManualImportConfig"]) : undefined as any;
            this.parashiftConfig = _data["ParashiftConfig"] ? ImportConfigurationParashiftDTO.fromJS(_data["ParashiftConfig"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImportConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Client"] = this.client ? this.client.toJSON() : undefined as any;
        data["ConfigurationName"] = this.configurationName;
        data["TransferType"] = this.transferType;
        data["ImportType"] = this.importType;
        data["IsActive"] = this.isActive;
        data["Type"] = this.type;
        data["ClientAccessType"] = this.clientAccessType;
        data["CopiedFromId"] = this.copiedFromId;
        if (Array.isArray(this.userAssignments)) {
            data["UserAssignments"] = [];
            for (let item of this.userAssignments)
                data["UserAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        data["TimeScheduleConfig"] = this.timeScheduleConfig ? this.timeScheduleConfig.toJSON() : undefined as any;
        data["EmailConfig"] = this.emailConfig ? this.emailConfig.toJSON() : undefined as any;
        data["SFTPConfig"] = this.sFTPConfig ? this.sFTPConfig.toJSON() : undefined as any;
        data["FTPClientConfig"] = this.fTPClientConfig ? this.fTPClientConfig.toJSON() : undefined as any;
        data["RESTConfig"] = this.rESTConfig ? this.rESTConfig.toJSON() : undefined as any;
        data["As2Config"] = this.as2Config ? this.as2Config.toJSON() : undefined as any;
        data["FileConfig"] = this.fileConfig ? this.fileConfig.toJSON() : undefined as any;
        data["AcodisConfig"] = this.acodisConfig ? this.acodisConfig.toJSON() : undefined as any;
        data["ManualImportConfig"] = this.manualImportConfig ? this.manualImportConfig.toJSON() : undefined as any;
        data["ParashiftConfig"] = this.parashiftConfig ? this.parashiftConfig.toJSON() : undefined as any;
        return data;
    }
}

export interface IImportConfigurationDTO {
    id?: number;
    client?: ClientDTO | undefined;
    configurationName: string;
    transferType?: ImportConfigurationTransferType;
    importType?: ImportType;
    isActive?: boolean;
    type?: ImportConfigurationType;
    clientAccessType?: ImportConfigurationClientAccessType | undefined;
    copiedFromId?: number | undefined;
    userAssignments?: ImportConfigurationUserAssignmentDTO[] | undefined;
    timeScheduleConfig?: ImportConfigurationTimeScheduleDTO | undefined;
    emailConfig?: ImportConfigurationEmailDTO | undefined;
    sFTPConfig?: ImportConfigurationSFTPDTO | undefined;
    fTPClientConfig?: ImportConfigurationFTPClientDTO | undefined;
    rESTConfig?: ImportConfigurationRESTDTO | undefined;
    as2Config?: ImportConfigurationAS2DTO | undefined;
    fileConfig?: ImportConfigurationFileDTO | undefined;
    acodisConfig?: ImportConfigurationAcodisDTO | undefined;
    manualImportConfig?: ImportConfigurationManualImportDTO | undefined;
    parashiftConfig?: ImportConfigurationParashiftDTO | undefined;
}

export enum ImportConfigurationTransferType {
    Email = 0,
    SFTPServer = 1,
    FTPClient = 2,
    REST = 3,
    AS2 = 4,
    Acodis = 5,
    ManualImport = 6,
    Magento = 7,
    Zir = 8,
}

export enum ImportConfigurationType {
    Configuration = 0,
    Template = 1,
}

export enum ImportConfigurationClientAccessType {
    Client = 0,
    Global = 1,
}

export class ImportConfigurationUserAssignmentDTO implements IImportConfigurationUserAssignmentDTO {
    userId!: string;
    user?: UserInfoDTO | undefined;

    constructor(data?: IImportConfigurationUserAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.user = _data["User"] ? UserInfoDTO.fromJS(_data["User"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImportConfigurationUserAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationUserAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IImportConfigurationUserAssignmentDTO {
    userId: string;
    user?: UserInfoDTO | undefined;
}

export class ImportConfigurationTimeScheduleDTO implements IImportConfigurationTimeScheduleDTO {
    startDate?: DateTime;
    hasEndDate?: boolean;
    endDate?: DateTime | undefined;
    startTime?: Duration;
    endTime?: Duration;
    repetitionIntervalInMinutes?: number;
    onWeekDays?: WeekdayFlag;

    constructor(data?: IImportConfigurationTimeScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? DateTime.fromISO(_data["StartDate"].toString()) : undefined as any;
            this.hasEndDate = _data["HasEndDate"];
            this.endDate = _data["EndDate"] ? DateTime.fromISO(_data["EndDate"].toString()) : undefined as any;
            this.startTime = _data["StartTime"] ? Duration.fromISO(_data["StartTime"].toString()) : undefined as any;
            this.endTime = _data["EndTime"] ? Duration.fromISO(_data["EndTime"].toString()) : undefined as any;
            this.repetitionIntervalInMinutes = _data["RepetitionIntervalInMinutes"];
            this.onWeekDays = _data["OnWeekDays"];
        }
    }

    static fromJS(data: any): ImportConfigurationTimeScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationTimeScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["HasEndDate"] = this.hasEndDate;
        data["EndDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["StartTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["EndTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["RepetitionIntervalInMinutes"] = this.repetitionIntervalInMinutes;
        data["OnWeekDays"] = this.onWeekDays;
        return data;
    }
}

export interface IImportConfigurationTimeScheduleDTO {
    startDate?: DateTime;
    hasEndDate?: boolean;
    endDate?: DateTime | undefined;
    startTime?: Duration;
    endTime?: Duration;
    repetitionIntervalInMinutes?: number;
    onWeekDays?: WeekdayFlag;
}

export enum WeekdayFlag {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 4,
    Thursday = 8,
    Friday = 16,
    Saturday = 32,
    Sunday = 64,
}

export class ImportConfigurationEmailDTO implements IImportConfigurationEmailDTO {
    emailAccountId?: number | undefined;
    mandatorySubjectContent?: string | undefined;
    mandatoryBodyContent?: string | undefined;
    senderEmailAddress?: string | undefined;

    constructor(data?: IImportConfigurationEmailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAccountId = _data["EmailAccountId"];
            this.mandatorySubjectContent = _data["MandatorySubjectContent"];
            this.mandatoryBodyContent = _data["MandatoryBodyContent"];
            this.senderEmailAddress = _data["SenderEmailAddress"];
        }
    }

    static fromJS(data: any): ImportConfigurationEmailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationEmailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailAccountId"] = this.emailAccountId;
        data["MandatorySubjectContent"] = this.mandatorySubjectContent;
        data["MandatoryBodyContent"] = this.mandatoryBodyContent;
        data["SenderEmailAddress"] = this.senderEmailAddress;
        return data;
    }
}

export interface IImportConfigurationEmailDTO {
    emailAccountId?: number | undefined;
    mandatorySubjectContent?: string | undefined;
    mandatoryBodyContent?: string | undefined;
    senderEmailAddress?: string | undefined;
}

export class ImportConfigurationSFTPDTO implements IImportConfigurationSFTPDTO {

    constructor(data?: IImportConfigurationSFTPDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ImportConfigurationSFTPDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationSFTPDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IImportConfigurationSFTPDTO {
}

export class ImportConfigurationFTPClientDTO implements IImportConfigurationFTPClientDTO {
    url!: string;
    port?: number | undefined;
    fTPClientType!: FTPClientType;
    userName!: string;
    password!: string;
    relativePath?: string | undefined;
    deleteFilesAfterTransmission?: boolean;
    useCertificate?: boolean;
    certificateMediaId?: string | undefined;
    certificateMediaName?: string | undefined;
    certificatePassword?: string | undefined;
    certificateMediaType?: MediaStorageType | undefined;
    certificateContentBase64?: string | undefined;

    constructor(data?: IImportConfigurationFTPClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["Url"];
            this.port = _data["Port"];
            this.fTPClientType = _data["FTPClientType"];
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.relativePath = _data["RelativePath"];
            this.deleteFilesAfterTransmission = _data["DeleteFilesAfterTransmission"];
            this.useCertificate = _data["UseCertificate"];
            this.certificateMediaId = _data["CertificateMediaId"];
            this.certificateMediaName = _data["CertificateMediaName"];
            this.certificatePassword = _data["CertificatePassword"];
            this.certificateMediaType = _data["CertificateMediaType"];
            this.certificateContentBase64 = _data["CertificateContentBase64"];
        }
    }

    static fromJS(data: any): ImportConfigurationFTPClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationFTPClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Url"] = this.url;
        data["Port"] = this.port;
        data["FTPClientType"] = this.fTPClientType;
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["RelativePath"] = this.relativePath;
        data["DeleteFilesAfterTransmission"] = this.deleteFilesAfterTransmission;
        data["UseCertificate"] = this.useCertificate;
        data["CertificateMediaId"] = this.certificateMediaId;
        data["CertificateMediaName"] = this.certificateMediaName;
        data["CertificatePassword"] = this.certificatePassword;
        data["CertificateMediaType"] = this.certificateMediaType;
        data["CertificateContentBase64"] = this.certificateContentBase64;
        return data;
    }
}

export interface IImportConfigurationFTPClientDTO {
    url: string;
    port?: number | undefined;
    fTPClientType: FTPClientType;
    userName: string;
    password: string;
    relativePath?: string | undefined;
    deleteFilesAfterTransmission?: boolean;
    useCertificate?: boolean;
    certificateMediaId?: string | undefined;
    certificateMediaName?: string | undefined;
    certificatePassword?: string | undefined;
    certificateMediaType?: MediaStorageType | undefined;
    certificateContentBase64?: string | undefined;
}

export enum FTPClientType {
    Ftp = 1,
    FtpSslImplicit = 2,
    FtpSslExplicit = 3,
    Sftp = 4,
}

export enum MediaStorageType {
    Undefined = 0,
    Jpg = 1,
    Png = 2,
    Bmp = 3,
    Pdf = 4,
    Cer = 5,
    Pfx = 6,
    Ppk = 7,
    P7b = 8,
    P7c = 9,
    Pem = 10,
    Pub = 11,
    Xlsx = 12,
    Csv = 13,
    Xml = 14,
    AnyTextBased = 15,
    AnyBinaryBased = 16,
    Edi = 17,
    Json = 18,
    Xls = 19,
}

export class ImportConfigurationRESTDTO implements IImportConfigurationRESTDTO {
    accessType?: ExportInterfaceConfigurationRESTAuthType;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    aPIFixKey?: string | undefined;
    aPIFixValue?: string | undefined;
    refreshTokenLifetimeInHours?: number | undefined;

    constructor(data?: IImportConfigurationRESTDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessType = _data["AccessType"];
            this.clientId = _data["ClientId"];
            this.clientSecret = _data["ClientSecret"];
            this.aPIFixKey = _data["APIFixKey"];
            this.aPIFixValue = _data["APIFixValue"];
            this.refreshTokenLifetimeInHours = _data["RefreshTokenLifetimeInHours"];
        }
    }

    static fromJS(data: any): ImportConfigurationRESTDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationRESTDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccessType"] = this.accessType;
        data["ClientId"] = this.clientId;
        data["ClientSecret"] = this.clientSecret;
        data["APIFixKey"] = this.aPIFixKey;
        data["APIFixValue"] = this.aPIFixValue;
        data["RefreshTokenLifetimeInHours"] = this.refreshTokenLifetimeInHours;
        return data;
    }
}

export interface IImportConfigurationRESTDTO {
    accessType?: ExportInterfaceConfigurationRESTAuthType;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    aPIFixKey?: string | undefined;
    aPIFixValue?: string | undefined;
    refreshTokenLifetimeInHours?: number | undefined;
}

export enum ExportInterfaceConfigurationRESTAuthType {
    BearerToken = 0,
    APIKey = 1,
}

export class ImportConfigurationAS2DTO implements IImportConfigurationAS2DTO {
    aS2From?: string | undefined;
    aS2To?: string | undefined;
    useCompression?: boolean;
    doSignMessages?: boolean;
    certificateMediaId?: string | undefined;
    certificateMediaName?: string | undefined;
    certificatePassword?: string | undefined;
    certificateMediaType?: MediaStorageType | undefined;
    certificateContentBase64?: string | undefined;

    constructor(data?: IImportConfigurationAS2DTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aS2From = _data["AS2From"];
            this.aS2To = _data["AS2To"];
            this.useCompression = _data["UseCompression"];
            this.doSignMessages = _data["DoSignMessages"];
            this.certificateMediaId = _data["CertificateMediaId"];
            this.certificateMediaName = _data["CertificateMediaName"];
            this.certificatePassword = _data["CertificatePassword"];
            this.certificateMediaType = _data["CertificateMediaType"];
            this.certificateContentBase64 = _data["CertificateContentBase64"];
        }
    }

    static fromJS(data: any): ImportConfigurationAS2DTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationAS2DTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AS2From"] = this.aS2From;
        data["AS2To"] = this.aS2To;
        data["UseCompression"] = this.useCompression;
        data["DoSignMessages"] = this.doSignMessages;
        data["CertificateMediaId"] = this.certificateMediaId;
        data["CertificateMediaName"] = this.certificateMediaName;
        data["CertificatePassword"] = this.certificatePassword;
        data["CertificateMediaType"] = this.certificateMediaType;
        data["CertificateContentBase64"] = this.certificateContentBase64;
        return data;
    }
}

export interface IImportConfigurationAS2DTO {
    aS2From?: string | undefined;
    aS2To?: string | undefined;
    useCompression?: boolean;
    doSignMessages?: boolean;
    certificateMediaId?: string | undefined;
    certificateMediaName?: string | undefined;
    certificatePassword?: string | undefined;
    certificateMediaType?: MediaStorageType | undefined;
    certificateContentBase64?: string | undefined;
}

export class ImportConfigurationFileDTO implements IImportConfigurationFileDTO {
    fileFormat?: ImportFileFormat;
    isTitleContainedInFile?: boolean;
    decimalSeparator?: ExportInterfaceConfigurationDecimalSeparator | undefined;
    separatorCharacter?: string | undefined;
    textFormat?: ExportInterfaceConfigurationTextFormat | undefined;
    fileNameSearchPattern?: string | undefined;
    fieldAssignments?: ImportConfigurationFieldAssignmentDTO[];
    possibleSources?: ImportSourceFieldDefinitionDTO[];
    filter?: FilterDTO | undefined;
    sendResponse?: boolean;
    navisionImportTemplate?: NavisionImportTemplate;
    convertEmailContentToPdf?: boolean;
    eDISchema?: EDISchema | undefined;

    constructor(data?: IImportConfigurationFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileFormat = _data["FileFormat"];
            this.isTitleContainedInFile = _data["IsTitleContainedInFile"];
            this.decimalSeparator = _data["DecimalSeparator"];
            this.separatorCharacter = _data["SeparatorCharacter"];
            this.textFormat = _data["TextFormat"];
            this.fileNameSearchPattern = _data["FileNameSearchPattern"];
            if (Array.isArray(_data["FieldAssignments"])) {
                this.fieldAssignments = [] as any;
                for (let item of _data["FieldAssignments"])
                    this.fieldAssignments!.push(ImportConfigurationFieldAssignmentDTO.fromJS(item));
            }
            if (Array.isArray(_data["PossibleSources"])) {
                this.possibleSources = [] as any;
                for (let item of _data["PossibleSources"])
                    this.possibleSources!.push(ImportSourceFieldDefinitionDTO.fromJS(item));
            }
            this.filter = _data["Filter"] ? FilterDTO.fromJS(_data["Filter"]) : undefined as any;
            this.sendResponse = _data["SendResponse"];
            this.navisionImportTemplate = _data["NavisionImportTemplate"];
            this.convertEmailContentToPdf = _data["ConvertEmailContentToPdf"];
            this.eDISchema = _data["EDISchema"];
        }
    }

    static fromJS(data: any): ImportConfigurationFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileFormat"] = this.fileFormat;
        data["IsTitleContainedInFile"] = this.isTitleContainedInFile;
        data["DecimalSeparator"] = this.decimalSeparator;
        data["SeparatorCharacter"] = this.separatorCharacter;
        data["TextFormat"] = this.textFormat;
        data["FileNameSearchPattern"] = this.fileNameSearchPattern;
        if (Array.isArray(this.fieldAssignments)) {
            data["FieldAssignments"] = [];
            for (let item of this.fieldAssignments)
                data["FieldAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.possibleSources)) {
            data["PossibleSources"] = [];
            for (let item of this.possibleSources)
                data["PossibleSources"].push(item ? item.toJSON() : undefined as any);
        }
        data["Filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        data["SendResponse"] = this.sendResponse;
        data["NavisionImportTemplate"] = this.navisionImportTemplate;
        data["ConvertEmailContentToPdf"] = this.convertEmailContentToPdf;
        data["EDISchema"] = this.eDISchema;
        return data;
    }
}

export interface IImportConfigurationFileDTO {
    fileFormat?: ImportFileFormat;
    isTitleContainedInFile?: boolean;
    decimalSeparator?: ExportInterfaceConfigurationDecimalSeparator | undefined;
    separatorCharacter?: string | undefined;
    textFormat?: ExportInterfaceConfigurationTextFormat | undefined;
    fileNameSearchPattern?: string | undefined;
    fieldAssignments?: ImportConfigurationFieldAssignmentDTO[];
    possibleSources?: ImportSourceFieldDefinitionDTO[];
    filter?: FilterDTO | undefined;
    sendResponse?: boolean;
    navisionImportTemplate?: NavisionImportTemplate;
    convertEmailContentToPdf?: boolean;
    eDISchema?: EDISchema | undefined;
}

export enum ImportFileFormat {
    XML = 0,
    XLS = 1,
    XLSX = 2,
    CSV = 3,
    JSON = 4,
    EDIFACT = 5,
    PDF = 6,
    Acodis = 7,
}

export enum ExportInterfaceConfigurationDecimalSeparator {
    Comma = 0,
    Point = 1,
}

export enum ExportInterfaceConfigurationTextFormat {
    UTF8 = 0,
    ASCII = 1,
    UTF8NoBOM = 2,
}

export class ImportConfigurationFieldAssignmentDTO implements IImportConfigurationFieldAssignmentDTO {
    targetName!: string;
    isGroupingElement?: boolean;
    importFunction?: ImportFunction | undefined;
    fixValue?: string | undefined;
    cap?: number | undefined;
    sourceElementName?: string | undefined;
    sourceElementSelectionPath?: string | undefined;
    position?: number | undefined;
    functionParameter1Value?: string | undefined;
    functionParameter2Value?: string | undefined;
    functionParameter3Value?: string | undefined;
    functionParameter4Value?: string | undefined;
    functionParameter5Value?: string | undefined;

    constructor(data?: IImportConfigurationFieldAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetName = _data["TargetName"];
            this.isGroupingElement = _data["IsGroupingElement"];
            this.importFunction = _data["ImportFunction"];
            this.fixValue = _data["FixValue"];
            this.cap = _data["Cap"];
            this.sourceElementName = _data["SourceElementName"];
            this.sourceElementSelectionPath = _data["SourceElementSelectionPath"];
            this.position = _data["Position"];
            this.functionParameter1Value = _data["FunctionParameter1Value"];
            this.functionParameter2Value = _data["FunctionParameter2Value"];
            this.functionParameter3Value = _data["FunctionParameter3Value"];
            this.functionParameter4Value = _data["FunctionParameter4Value"];
            this.functionParameter5Value = _data["FunctionParameter5Value"];
        }
    }

    static fromJS(data: any): ImportConfigurationFieldAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationFieldAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TargetName"] = this.targetName;
        data["IsGroupingElement"] = this.isGroupingElement;
        data["ImportFunction"] = this.importFunction;
        data["FixValue"] = this.fixValue;
        data["Cap"] = this.cap;
        data["SourceElementName"] = this.sourceElementName;
        data["SourceElementSelectionPath"] = this.sourceElementSelectionPath;
        data["Position"] = this.position;
        data["FunctionParameter1Value"] = this.functionParameter1Value;
        data["FunctionParameter2Value"] = this.functionParameter2Value;
        data["FunctionParameter3Value"] = this.functionParameter3Value;
        data["FunctionParameter4Value"] = this.functionParameter4Value;
        data["FunctionParameter5Value"] = this.functionParameter5Value;
        return data;
    }
}

export interface IImportConfigurationFieldAssignmentDTO {
    targetName: string;
    isGroupingElement?: boolean;
    importFunction?: ImportFunction | undefined;
    fixValue?: string | undefined;
    cap?: number | undefined;
    sourceElementName?: string | undefined;
    sourceElementSelectionPath?: string | undefined;
    position?: number | undefined;
    functionParameter1Value?: string | undefined;
    functionParameter2Value?: string | undefined;
    functionParameter3Value?: string | undefined;
    functionParameter4Value?: string | undefined;
    functionParameter5Value?: string | undefined;
}

export enum ImportFunction {
    NoConversion = 0,
    ToOrderNo = 1,
    MatchOrderItem = 2,
    ToDate = 3,
    ToCurrency = 4,
    ToPrice = 5,
    ToNumberInRange = 6,
    ToQuantity = 7,
    ToToday = 8,
    ToDateOrToToday = 9,
    FromAbbreviatedNumber = 10,
    FixDate = 11,
    ToLanguageCode = 12,
    ToCountryCode = 13,
    ToLineType = 14,
    NoData = 15,
    ValidateCustomerNumber = 16,
    VendorNoLookup = 17,
    ToDateOrNull = 18,
}

export class ImportSourceFieldDefinitionDTO implements IImportSourceFieldDefinitionDTO {
    sourceElementName?: string;
    sourceElementSelectionPath?: string | undefined;
    position?: number | undefined;
    sampleValue?: string | undefined;

    constructor(data?: IImportSourceFieldDefinitionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceElementName = _data["SourceElementName"];
            this.sourceElementSelectionPath = _data["SourceElementSelectionPath"];
            this.position = _data["Position"];
            this.sampleValue = _data["SampleValue"];
        }
    }

    static fromJS(data: any): ImportSourceFieldDefinitionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportSourceFieldDefinitionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SourceElementName"] = this.sourceElementName;
        data["SourceElementSelectionPath"] = this.sourceElementSelectionPath;
        data["Position"] = this.position;
        data["SampleValue"] = this.sampleValue;
        return data;
    }
}

export interface IImportSourceFieldDefinitionDTO {
    sourceElementName?: string;
    sourceElementSelectionPath?: string | undefined;
    position?: number | undefined;
    sampleValue?: string | undefined;
}

export enum NavisionImportTemplate {
    None = 0,
    Excel = 1,
    Xml = 2,
    Web = 3,
    Pdf = 4,
}

export enum EDISchema {
    DELFOR = 0,
    ORDERS = 1,
    ORDRSP = 2,
    DESADV = 3,
    ORDCHG = 4,
    INVOIC = 5,
    SLSRPT = 6,
    INVRPT = 7,
    UpdatePO = 8,
    UpdateSO = 9,
}

export class ImportConfigurationAcodisDTO implements IImportConfigurationAcodisDTO {
    id?: number;
    acodisWorkflowId?: number | undefined;
    category?: string | undefined;

    constructor(data?: IImportConfigurationAcodisDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.acodisWorkflowId = _data["AcodisWorkflowId"];
            this.category = _data["Category"];
        }
    }

    static fromJS(data: any): ImportConfigurationAcodisDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationAcodisDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AcodisWorkflowId"] = this.acodisWorkflowId;
        data["Category"] = this.category;
        return data;
    }
}

export interface IImportConfigurationAcodisDTO {
    id?: number;
    acodisWorkflowId?: number | undefined;
    category?: string | undefined;
}

export class ImportConfigurationManualImportDTO implements IImportConfigurationManualImportDTO {
    id?: number;
    templateVersion?: string | undefined;

    constructor(data?: IImportConfigurationManualImportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.templateVersion = _data["TemplateVersion"];
        }
    }

    static fromJS(data: any): ImportConfigurationManualImportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationManualImportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TemplateVersion"] = this.templateVersion;
        return data;
    }
}

export interface IImportConfigurationManualImportDTO {
    id?: number;
    templateVersion?: string | undefined;
}

export class ImportConfigurationParashiftDTO implements IImportConfigurationParashiftDTO {

    constructor(data?: IImportConfigurationParashiftDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ImportConfigurationParashiftDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigurationParashiftDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IImportConfigurationParashiftDTO {
}

export class PagedResultDTOOfImportConfigurationDTO implements IPagedResultDTOOfImportConfigurationDTO {
    items?: ImportConfigurationDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfImportConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ImportConfigurationDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfImportConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfImportConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfImportConfigurationDTO {
    items?: ImportConfigurationDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class ImportFieldAssignmentDefinitionsDTO implements IImportFieldAssignmentDefinitionsDTO {
    importFunctionDefinitions?: ImportFunctionDefinitionDTO[];
    targetDefinitions?: ImportFieldAssignmentTargetDefinitionDTO[];

    constructor(data?: IImportFieldAssignmentDefinitionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ImportFunctionDefinitions"])) {
                this.importFunctionDefinitions = [] as any;
                for (let item of _data["ImportFunctionDefinitions"])
                    this.importFunctionDefinitions!.push(ImportFunctionDefinitionDTO.fromJS(item));
            }
            if (Array.isArray(_data["TargetDefinitions"])) {
                this.targetDefinitions = [] as any;
                for (let item of _data["TargetDefinitions"])
                    this.targetDefinitions!.push(ImportFieldAssignmentTargetDefinitionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportFieldAssignmentDefinitionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFieldAssignmentDefinitionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.importFunctionDefinitions)) {
            data["ImportFunctionDefinitions"] = [];
            for (let item of this.importFunctionDefinitions)
                data["ImportFunctionDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.targetDefinitions)) {
            data["TargetDefinitions"] = [];
            for (let item of this.targetDefinitions)
                data["TargetDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportFieldAssignmentDefinitionsDTO {
    importFunctionDefinitions?: ImportFunctionDefinitionDTO[];
    targetDefinitions?: ImportFieldAssignmentTargetDefinitionDTO[];
}

export class ImportFunctionDefinitionDTO implements IImportFunctionDefinitionDTO {
    importFunction?: ImportFunction;
    parameter1?: ImportFunctionParameterDefinitionDTO | undefined;
    parameter2?: ImportFunctionParameterDefinitionDTO | undefined;
    parameter3?: ImportFunctionParameterDefinitionDTO | undefined;
    parameter4?: ImportFunctionParameterDefinitionDTO | undefined;
    parameter5?: ImportFunctionParameterDefinitionDTO | undefined;

    constructor(data?: IImportFunctionDefinitionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importFunction = _data["ImportFunction"];
            this.parameter1 = _data["Parameter1"] ? ImportFunctionParameterDefinitionDTO.fromJS(_data["Parameter1"]) : undefined as any;
            this.parameter2 = _data["Parameter2"] ? ImportFunctionParameterDefinitionDTO.fromJS(_data["Parameter2"]) : undefined as any;
            this.parameter3 = _data["Parameter3"] ? ImportFunctionParameterDefinitionDTO.fromJS(_data["Parameter3"]) : undefined as any;
            this.parameter4 = _data["Parameter4"] ? ImportFunctionParameterDefinitionDTO.fromJS(_data["Parameter4"]) : undefined as any;
            this.parameter5 = _data["Parameter5"] ? ImportFunctionParameterDefinitionDTO.fromJS(_data["Parameter5"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImportFunctionDefinitionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFunctionDefinitionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ImportFunction"] = this.importFunction;
        data["Parameter1"] = this.parameter1 ? this.parameter1.toJSON() : undefined as any;
        data["Parameter2"] = this.parameter2 ? this.parameter2.toJSON() : undefined as any;
        data["Parameter3"] = this.parameter3 ? this.parameter3.toJSON() : undefined as any;
        data["Parameter4"] = this.parameter4 ? this.parameter4.toJSON() : undefined as any;
        data["Parameter5"] = this.parameter5 ? this.parameter5.toJSON() : undefined as any;
        return data;
    }
}

export interface IImportFunctionDefinitionDTO {
    importFunction?: ImportFunction;
    parameter1?: ImportFunctionParameterDefinitionDTO | undefined;
    parameter2?: ImportFunctionParameterDefinitionDTO | undefined;
    parameter3?: ImportFunctionParameterDefinitionDTO | undefined;
    parameter4?: ImportFunctionParameterDefinitionDTO | undefined;
    parameter5?: ImportFunctionParameterDefinitionDTO | undefined;
}

export class ImportFunctionParameterDefinitionDTO implements IImportFunctionParameterDefinitionDTO {
    name?: string;
    type?: ImportFunctionParameterType;
    isMandatory?: boolean;
    format?: string | undefined;

    constructor(data?: IImportFunctionParameterDefinitionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.isMandatory = _data["IsMandatory"];
            this.format = _data["Format"];
        }
    }

    static fromJS(data: any): ImportFunctionParameterDefinitionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFunctionParameterDefinitionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["IsMandatory"] = this.isMandatory;
        data["Format"] = this.format;
        return data;
    }
}

export interface IImportFunctionParameterDefinitionDTO {
    name?: string;
    type?: ImportFunctionParameterType;
    isMandatory?: boolean;
    format?: string | undefined;
}

export enum ImportFunctionParameterType {
    String = 0,
    Number = 1,
    Bool = 2,
    Date = 3,
}

export class ImportFieldAssignmentTargetDefinitionDTO implements IImportFieldAssignmentTargetDefinitionDTO {
    supportedFunctions?: ImportFunction[];
    canHaveCap?: boolean;
    canHaveFixValue?: boolean;
    canHaveSetNullValue?: boolean;
    defaultFixValue?: string | undefined;
    fieldType?: string | undefined;
    fieldPath?: string | undefined;
    targetName?: string;
    edifactSourceDefinition?: ImportSourceFieldDefinitionDTO;
    defaultValueDefinition?: ImportFieldAssignmentTargetDefaultValueDefinitionDTO | undefined;

    constructor(data?: IImportFieldAssignmentTargetDefinitionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SupportedFunctions"])) {
                this.supportedFunctions = [] as any;
                for (let item of _data["SupportedFunctions"])
                    this.supportedFunctions!.push(item);
            }
            this.canHaveCap = _data["CanHaveCap"];
            this.canHaveFixValue = _data["CanHaveFixValue"];
            this.canHaveSetNullValue = _data["CanHaveSetNullValue"];
            this.defaultFixValue = _data["DefaultFixValue"];
            this.fieldType = _data["FieldType"];
            this.fieldPath = _data["FieldPath"];
            this.targetName = _data["TargetName"];
            this.edifactSourceDefinition = _data["EdifactSourceDefinition"] ? ImportSourceFieldDefinitionDTO.fromJS(_data["EdifactSourceDefinition"]) : undefined as any;
            this.defaultValueDefinition = _data["DefaultValueDefinition"] ? ImportFieldAssignmentTargetDefaultValueDefinitionDTO.fromJS(_data["DefaultValueDefinition"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImportFieldAssignmentTargetDefinitionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFieldAssignmentTargetDefinitionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.supportedFunctions)) {
            data["SupportedFunctions"] = [];
            for (let item of this.supportedFunctions)
                data["SupportedFunctions"].push(item);
        }
        data["CanHaveCap"] = this.canHaveCap;
        data["CanHaveFixValue"] = this.canHaveFixValue;
        data["CanHaveSetNullValue"] = this.canHaveSetNullValue;
        data["DefaultFixValue"] = this.defaultFixValue;
        data["FieldType"] = this.fieldType;
        data["FieldPath"] = this.fieldPath;
        data["TargetName"] = this.targetName;
        data["EdifactSourceDefinition"] = this.edifactSourceDefinition ? this.edifactSourceDefinition.toJSON() : undefined as any;
        data["DefaultValueDefinition"] = this.defaultValueDefinition ? this.defaultValueDefinition.toJSON() : undefined as any;
        return data;
    }
}

export interface IImportFieldAssignmentTargetDefinitionDTO {
    supportedFunctions?: ImportFunction[];
    canHaveCap?: boolean;
    canHaveFixValue?: boolean;
    canHaveSetNullValue?: boolean;
    defaultFixValue?: string | undefined;
    fieldType?: string | undefined;
    fieldPath?: string | undefined;
    targetName?: string;
    edifactSourceDefinition?: ImportSourceFieldDefinitionDTO;
    defaultValueDefinition?: ImportFieldAssignmentTargetDefaultValueDefinitionDTO | undefined;
}

export class ImportFieldAssignmentTargetDefaultValueDefinitionDTO implements IImportFieldAssignmentTargetDefaultValueDefinitionDTO {
    isGroupingElement?: boolean | undefined;

    constructor(data?: IImportFieldAssignmentTargetDefaultValueDefinitionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isGroupingElement = _data["IsGroupingElement"];
        }
    }

    static fromJS(data: any): ImportFieldAssignmentTargetDefaultValueDefinitionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFieldAssignmentTargetDefaultValueDefinitionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsGroupingElement"] = this.isGroupingElement;
        return data;
    }
}

export interface IImportFieldAssignmentTargetDefaultValueDefinitionDTO {
    isGroupingElement?: boolean | undefined;
}

export class FTPConnectionResponse implements IFTPConnectionResponse {
    succeeded?: boolean;
    connectionLog?: string | undefined;

    constructor(data?: IFTPConnectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["Succeeded"];
            this.connectionLog = _data["ConnectionLog"];
        }
    }

    static fromJS(data: any): FTPConnectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FTPConnectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Succeeded"] = this.succeeded;
        data["ConnectionLog"] = this.connectionLog;
        return data;
    }
}

export interface IFTPConnectionResponse {
    succeeded?: boolean;
    connectionLog?: string | undefined;
}

export class FTPClientConnectionInfoDTO implements IFTPClientConnectionInfoDTO {
    uRL?: string | undefined;
    port?: number;
    fileTransferMode?: FTPClientType;
    userName?: string | undefined;
    password?: string | undefined;
    relativePathOfFiles?: string | undefined;
    useCertificate?: boolean;
    certificateMediaId?: string | undefined;
    certificatePassword?: string | undefined;
    certificateContentBase64?: string | undefined;

    constructor(data?: IFTPClientConnectionInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uRL = _data["URL"];
            this.port = _data["Port"];
            this.fileTransferMode = _data["FileTransferMode"];
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.relativePathOfFiles = _data["RelativePathOfFiles"];
            this.useCertificate = _data["UseCertificate"];
            this.certificateMediaId = _data["CertificateMediaId"];
            this.certificatePassword = _data["CertificatePassword"];
            this.certificateContentBase64 = _data["CertificateContentBase64"];
        }
    }

    static fromJS(data: any): FTPClientConnectionInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FTPClientConnectionInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["URL"] = this.uRL;
        data["Port"] = this.port;
        data["FileTransferMode"] = this.fileTransferMode;
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["RelativePathOfFiles"] = this.relativePathOfFiles;
        data["UseCertificate"] = this.useCertificate;
        data["CertificateMediaId"] = this.certificateMediaId;
        data["CertificatePassword"] = this.certificatePassword;
        data["CertificateContentBase64"] = this.certificateContentBase64;
        return data;
    }
}

export interface IFTPClientConnectionInfoDTO {
    uRL?: string | undefined;
    port?: number;
    fileTransferMode?: FTPClientType;
    userName?: string | undefined;
    password?: string | undefined;
    relativePathOfFiles?: string | undefined;
    useCertificate?: boolean;
    certificateMediaId?: string | undefined;
    certificatePassword?: string | undefined;
    certificateContentBase64?: string | undefined;
}

export class SampleFileDTO implements ISampleFileDTO {
    fileContentBase64?: string;
    fileOptions?: ImportFileOptionsDTO | undefined;

    constructor(data?: ISampleFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileContentBase64 = _data["FileContentBase64"];
            this.fileOptions = _data["FileOptions"] ? ImportFileOptionsDTO.fromJS(_data["FileOptions"]) : undefined as any;
        }
    }

    static fromJS(data: any): SampleFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SampleFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileContentBase64"] = this.fileContentBase64;
        data["FileOptions"] = this.fileOptions ? this.fileOptions.toJSON() : undefined as any;
        return data;
    }
}

export interface ISampleFileDTO {
    fileContentBase64?: string;
    fileOptions?: ImportFileOptionsDTO | undefined;
}

export class ImportFileOptionsDTO implements IImportFileOptionsDTO {
    separatorCharacter?: string | undefined;
    hasTitle?: boolean;
    textFormat?: ExportInterfaceConfigurationTextFormat | undefined;

    constructor(data?: IImportFileOptionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.separatorCharacter = _data["SeparatorCharacter"];
            this.hasTitle = _data["HasTitle"];
            this.textFormat = _data["TextFormat"];
        }
    }

    static fromJS(data: any): ImportFileOptionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFileOptionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SeparatorCharacter"] = this.separatorCharacter;
        data["HasTitle"] = this.hasTitle;
        data["TextFormat"] = this.textFormat;
        return data;
    }
}

export interface IImportFileOptionsDTO {
    separatorCharacter?: string | undefined;
    hasTitle?: boolean;
    textFormat?: ExportInterfaceConfigurationTextFormat | undefined;
}

export class ImportDataSalesOrderDTO implements IImportDataSalesOrderDTO {
    dataIdent?: string;

    constructor(data?: IImportDataSalesOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataIdent = _data["DataIdent"];
        }
    }

    static fromJS(data: any): ImportDataSalesOrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataSalesOrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DataIdent"] = this.dataIdent;
        return data;
    }
}

export interface IImportDataSalesOrderDTO {
    dataIdent?: string;
}

export class ImportProtocolDTO implements IImportProtocolDTO {
    id?: number;
    client?: ClientDTO;
    transferType?: ImportConfigurationTransferType;
    configurationName?: string;
    configurationId?: number | undefined;
    fileFormat?: ImportFileFormat | undefined;
    createdOn?: DateTime;
    modifiedOn?: DateTime;
    modifiedBy?: string;
    sourceInfo?: string | undefined;
    successState?: ImportSuccessState;
    lastErrorMessage?: string | undefined;
    originalFileName?: string | undefined;
    originalFileMediaId?: string | undefined;
    originalArchiveFileUrl?: string | undefined;
    importFileName?: string | undefined;
    importFileMediaId?: string | undefined;
    correctedFileName?: string | undefined;
    correctedFileMediaId?: string | undefined;
    currentIteration?: number | undefined;
    sentToOcrOn?: DateTime | undefined;
    lastState?: ImportConfigurationEntryState;
    navisionImportTemplate?: NavisionImportTemplate;
    logEntries?: ImportProtocolLogEntryDTO[] | undefined;

    constructor(data?: IImportProtocolDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.client = _data["Client"] ? ClientDTO.fromJS(_data["Client"]) : undefined as any;
            this.transferType = _data["TransferType"];
            this.configurationName = _data["ConfigurationName"];
            this.configurationId = _data["ConfigurationId"];
            this.fileFormat = _data["FileFormat"];
            this.createdOn = _data["CreatedOn"] ? DateTime.fromISO(_data["CreatedOn"].toString()) : undefined as any;
            this.modifiedOn = _data["ModifiedOn"] ? DateTime.fromISO(_data["ModifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["ModifiedBy"];
            this.sourceInfo = _data["SourceInfo"];
            this.successState = _data["SuccessState"];
            this.lastErrorMessage = _data["LastErrorMessage"];
            this.originalFileName = _data["OriginalFileName"];
            this.originalFileMediaId = _data["OriginalFileMediaId"];
            this.originalArchiveFileUrl = _data["OriginalArchiveFileUrl"];
            this.importFileName = _data["ImportFileName"];
            this.importFileMediaId = _data["ImportFileMediaId"];
            this.correctedFileName = _data["CorrectedFileName"];
            this.correctedFileMediaId = _data["CorrectedFileMediaId"];
            this.currentIteration = _data["CurrentIteration"];
            this.sentToOcrOn = _data["SentToOcrOn"] ? DateTime.fromISO(_data["SentToOcrOn"].toString()) : undefined as any;
            this.lastState = _data["LastState"];
            this.navisionImportTemplate = _data["NavisionImportTemplate"];
            if (Array.isArray(_data["LogEntries"])) {
                this.logEntries = [] as any;
                for (let item of _data["LogEntries"])
                    this.logEntries!.push(ImportProtocolLogEntryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportProtocolDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProtocolDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Client"] = this.client ? this.client.toJSON() : undefined as any;
        data["TransferType"] = this.transferType;
        data["ConfigurationName"] = this.configurationName;
        data["ConfigurationId"] = this.configurationId;
        data["FileFormat"] = this.fileFormat;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        data["ModifiedBy"] = this.modifiedBy;
        data["SourceInfo"] = this.sourceInfo;
        data["SuccessState"] = this.successState;
        data["LastErrorMessage"] = this.lastErrorMessage;
        data["OriginalFileName"] = this.originalFileName;
        data["OriginalFileMediaId"] = this.originalFileMediaId;
        data["OriginalArchiveFileUrl"] = this.originalArchiveFileUrl;
        data["ImportFileName"] = this.importFileName;
        data["ImportFileMediaId"] = this.importFileMediaId;
        data["CorrectedFileName"] = this.correctedFileName;
        data["CorrectedFileMediaId"] = this.correctedFileMediaId;
        data["CurrentIteration"] = this.currentIteration;
        data["SentToOcrOn"] = this.sentToOcrOn ? this.sentToOcrOn.toString() : undefined as any;
        data["LastState"] = this.lastState;
        data["NavisionImportTemplate"] = this.navisionImportTemplate;
        if (Array.isArray(this.logEntries)) {
            data["LogEntries"] = [];
            for (let item of this.logEntries)
                data["LogEntries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportProtocolDTO {
    id?: number;
    client?: ClientDTO;
    transferType?: ImportConfigurationTransferType;
    configurationName?: string;
    configurationId?: number | undefined;
    fileFormat?: ImportFileFormat | undefined;
    createdOn?: DateTime;
    modifiedOn?: DateTime;
    modifiedBy?: string;
    sourceInfo?: string | undefined;
    successState?: ImportSuccessState;
    lastErrorMessage?: string | undefined;
    originalFileName?: string | undefined;
    originalFileMediaId?: string | undefined;
    originalArchiveFileUrl?: string | undefined;
    importFileName?: string | undefined;
    importFileMediaId?: string | undefined;
    correctedFileName?: string | undefined;
    correctedFileMediaId?: string | undefined;
    currentIteration?: number | undefined;
    sentToOcrOn?: DateTime | undefined;
    lastState?: ImportConfigurationEntryState;
    navisionImportTemplate?: NavisionImportTemplate;
    logEntries?: ImportProtocolLogEntryDTO[] | undefined;
}

export enum ImportSuccessState {
    Pending = 0,
    Error = 1,
    Fixed = 2,
    Success = 3,
    Aborted = 4,
}

export enum ImportConfigurationEntryState {
    Created = 0,
    Receiving = 1,
    ReceivingStoreImmediate = 2,
    ReceivingStoreDSS = 3,
    Received = 4,
    ConvertByOCR = 5,
    ReadyToParse = 6,
    Parsing = 7,
    Parsed = 8,
    DestinationProcessResponsePending = 9,
    DestinationProcessInProgress = 10,
    DestinationProcessError = 11,
    ProcessedAwaitingDestinationData = 12,
    SendResponsesPending = 13,
    Processed = 14,
}

export class ImportProtocolLogEntryDTO implements IImportProtocolLogEntryDTO {
    createdOn?: DateTime;
    statusMessage?: string | undefined;
    iteration?: number | undefined;
    logStatus?: DSSProcessingLogStatus;
    entryIdent?: string | undefined;
    errorLineNumber?: number | undefined;

    constructor(data?: IImportProtocolLogEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["CreatedOn"] ? DateTime.fromISO(_data["CreatedOn"].toString()) : undefined as any;
            this.statusMessage = _data["StatusMessage"];
            this.iteration = _data["Iteration"];
            this.logStatus = _data["LogStatus"];
            this.entryIdent = _data["EntryIdent"];
            this.errorLineNumber = _data["ErrorLineNumber"];
        }
    }

    static fromJS(data: any): ImportProtocolLogEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProtocolLogEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CreatedOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["StatusMessage"] = this.statusMessage;
        data["Iteration"] = this.iteration;
        data["LogStatus"] = this.logStatus;
        data["EntryIdent"] = this.entryIdent;
        data["ErrorLineNumber"] = this.errorLineNumber;
        return data;
    }
}

export interface IImportProtocolLogEntryDTO {
    createdOn?: DateTime;
    statusMessage?: string | undefined;
    iteration?: number | undefined;
    logStatus?: DSSProcessingLogStatus;
    entryIdent?: string | undefined;
    errorLineNumber?: number | undefined;
}

export enum DSSProcessingLogStatus {
    Pending = 0,
    Success = 1,
    Error = 2,
    Warning = 3,
}

export class PagedResultDTOOfImportProtocolDTO implements IPagedResultDTOOfImportProtocolDTO {
    items?: ImportProtocolDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfImportProtocolDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ImportProtocolDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfImportProtocolDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfImportProtocolDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfImportProtocolDTO {
    items?: ImportProtocolDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class ImportFixDTO implements IImportFixDTO {
    importConfigurationEntryId!: number;
    base64ImportData!: string;
    fileName!: string;

    constructor(data?: IImportFixDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importConfigurationEntryId = _data["ImportConfigurationEntryId"];
            this.base64ImportData = _data["Base64ImportData"];
            this.fileName = _data["FileName"];
        }
    }

    static fromJS(data: any): ImportFixDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFixDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ImportConfigurationEntryId"] = this.importConfigurationEntryId;
        data["Base64ImportData"] = this.base64ImportData;
        data["FileName"] = this.fileName;
        return data;
    }
}

export interface IImportFixDTO {
    importConfigurationEntryId: number;
    base64ImportData: string;
    fileName: string;
}

export class ImportFileDTO implements IImportFileDTO {
    name?: string;
    contentBase64?: string;
    mediaType?: MediaStorageType;

    constructor(data?: IImportFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.contentBase64 = _data["ContentBase64"];
            this.mediaType = _data["MediaType"];
        }
    }

    static fromJS(data: any): ImportFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["ContentBase64"] = this.contentBase64;
        data["MediaType"] = this.mediaType;
        return data;
    }
}

export interface IImportFileDTO {
    name?: string;
    contentBase64?: string;
    mediaType?: MediaStorageType;
}

export class ExportInterfaceActivationEmailDTO implements IExportInterfaceActivationEmailDTO {
    configurationId?: number;
    templateId?: number;
    subject?: string | undefined;
    emailContent?: string | undefined;
    emailToUserId?: string | undefined;
    emailTo?: string | undefined;

    constructor(data?: IExportInterfaceActivationEmailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["ConfigurationId"];
            this.templateId = _data["TemplateId"];
            this.subject = _data["Subject"];
            this.emailContent = _data["EmailContent"];
            this.emailToUserId = _data["EmailToUserId"];
            this.emailTo = _data["EmailTo"];
        }
    }

    static fromJS(data: any): ExportInterfaceActivationEmailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceActivationEmailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConfigurationId"] = this.configurationId;
        data["TemplateId"] = this.templateId;
        data["Subject"] = this.subject;
        data["EmailContent"] = this.emailContent;
        data["EmailToUserId"] = this.emailToUserId;
        data["EmailTo"] = this.emailTo;
        return data;
    }
}

export interface IExportInterfaceActivationEmailDTO {
    configurationId?: number;
    templateId?: number;
    subject?: string | undefined;
    emailContent?: string | undefined;
    emailToUserId?: string | undefined;
    emailTo?: string | undefined;
}

export class GenerateActivationEmailsDTO implements IGenerateActivationEmailsDTO {
    configurationId!: number;
    templateId?: number | undefined;

    constructor(data?: IGenerateActivationEmailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["ConfigurationId"];
            this.templateId = _data["TemplateId"];
        }
    }

    static fromJS(data: any): GenerateActivationEmailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateActivationEmailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConfigurationId"] = this.configurationId;
        data["TemplateId"] = this.templateId;
        return data;
    }
}

export interface IGenerateActivationEmailsDTO {
    configurationId: number;
    templateId?: number | undefined;
}

export class ExportInterfaceActivationEmailTemplateDTO implements IExportInterfaceActivationEmailTemplateDTO {
    id?: number;
    templateName?: string | undefined;
    senderName?: string | undefined;
    subject?: string | undefined;
    textHTML?: string | undefined;
    transferType?: ExportInterfaceConfigurationTransferType;
    emailAccountId?: number | undefined;

    constructor(data?: IExportInterfaceActivationEmailTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.templateName = _data["TemplateName"];
            this.senderName = _data["SenderName"];
            this.subject = _data["Subject"];
            this.textHTML = _data["TextHTML"];
            this.transferType = _data["TransferType"];
            this.emailAccountId = _data["EmailAccountId"];
        }
    }

    static fromJS(data: any): ExportInterfaceActivationEmailTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceActivationEmailTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TemplateName"] = this.templateName;
        data["SenderName"] = this.senderName;
        data["Subject"] = this.subject;
        data["TextHTML"] = this.textHTML;
        data["TransferType"] = this.transferType;
        data["EmailAccountId"] = this.emailAccountId;
        return data;
    }
}

export interface IExportInterfaceActivationEmailTemplateDTO {
    id?: number;
    templateName?: string | undefined;
    senderName?: string | undefined;
    subject?: string | undefined;
    textHTML?: string | undefined;
    transferType?: ExportInterfaceConfigurationTransferType;
    emailAccountId?: number | undefined;
}

export enum ExportInterfaceConfigurationTransferType {
    Email = 0,
    SFTPServer = 1,
    FTPClient = 2,
    REST = 3,
    SFTPServerOnly = 4,
    AS2 = 5,
}

export class CreateExportInterfaceActivationEmailTemplateDTO implements ICreateExportInterfaceActivationEmailTemplateDTO {

    constructor(data?: ICreateExportInterfaceActivationEmailTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateExportInterfaceActivationEmailTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExportInterfaceActivationEmailTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreateExportInterfaceActivationEmailTemplateDTO {
}

export class PagedResultDTOOfExportInterfaceActivationEmailTemplateDTO implements IPagedResultDTOOfExportInterfaceActivationEmailTemplateDTO {
    items?: ExportInterfaceActivationEmailTemplateDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfExportInterfaceActivationEmailTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ExportInterfaceActivationEmailTemplateDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfExportInterfaceActivationEmailTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfExportInterfaceActivationEmailTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfExportInterfaceActivationEmailTemplateDTO {
    items?: ExportInterfaceActivationEmailTemplateDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class UpdateExportInterfaceActivationEmailTemplateDTO implements IUpdateExportInterfaceActivationEmailTemplateDTO {
    id?: number;
    templateName?: string | undefined;
    senderName?: string | undefined;
    subject?: string | undefined;
    textHTML?: string | undefined;
    transferType?: ExportInterfaceConfigurationTransferType;
    emailAccountId?: number;

    constructor(data?: IUpdateExportInterfaceActivationEmailTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.templateName = _data["TemplateName"];
            this.senderName = _data["SenderName"];
            this.subject = _data["Subject"];
            this.textHTML = _data["TextHTML"];
            this.transferType = _data["TransferType"];
            this.emailAccountId = _data["EmailAccountId"];
        }
    }

    static fromJS(data: any): UpdateExportInterfaceActivationEmailTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExportInterfaceActivationEmailTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TemplateName"] = this.templateName;
        data["SenderName"] = this.senderName;
        data["Subject"] = this.subject;
        data["TextHTML"] = this.textHTML;
        data["TransferType"] = this.transferType;
        data["EmailAccountId"] = this.emailAccountId;
        return data;
    }
}

export interface IUpdateExportInterfaceActivationEmailTemplateDTO {
    id?: number;
    templateName?: string | undefined;
    senderName?: string | undefined;
    subject?: string | undefined;
    textHTML?: string | undefined;
    transferType?: ExportInterfaceConfigurationTransferType;
    emailAccountId?: number;
}

export class ExportInterfaceConfigTemplateDetailsDTO implements IExportInterfaceConfigTemplateDetailsDTO {
    id!: number;
    configurationName!: string;
    type!: ExportInterfaceConfigurationType;
    transferType!: ExportInterfaceConfigurationTransferType;
    mode!: ExportInterfaceConfigurationMode;
    dataSelectionType?: ExportInterfaceConfigurationDataSelectionType;
    backlogFilterLocations?: string | undefined;
    financeSchedule?: ExportInterfaceConfigurationFinanceSchedule;
    financeSendEmptyData?: boolean;
    financeDataSelectionType?: ExportInterfaceConfigurationFinanceDataSelectionType;
    activationEmailTemplateId?: number | undefined;
    description?: string | undefined;
    active?: boolean;
    scheduleDetails?: ExportInterfaceConfigurationDetailsTimeScheduleDTO | undefined;
    emailDetails?: ExportInterfaceConfigurationDetailsEmailDTO | undefined;
    sFTPDetails?: ExportInterfaceConfigurationDetailsSFTPDTO | undefined;
    fTPClientDetails?: ExportInterfaceConfigurationDetailsFTPClientDTO | undefined;
    rESTDetails?: ExportInterfaceConfigurationDetailsRESTDTO | undefined;
    fileDetails?: ExportInterfaceConfigurationDetailsFileDTO | undefined;

    constructor(data?: IExportInterfaceConfigTemplateDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.configurationName = _data["ConfigurationName"];
            this.type = _data["Type"];
            this.transferType = _data["TransferType"];
            this.mode = _data["Mode"];
            this.dataSelectionType = _data["DataSelectionType"];
            this.backlogFilterLocations = _data["BacklogFilterLocations"];
            this.financeSchedule = _data["FinanceSchedule"];
            this.financeSendEmptyData = _data["FinanceSendEmptyData"];
            this.financeDataSelectionType = _data["FinanceDataSelectionType"];
            this.activationEmailTemplateId = _data["ActivationEmailTemplateId"];
            this.description = _data["Description"];
            this.active = _data["Active"];
            this.scheduleDetails = _data["ScheduleDetails"] ? ExportInterfaceConfigurationDetailsTimeScheduleDTO.fromJS(_data["ScheduleDetails"]) : undefined as any;
            this.emailDetails = _data["EmailDetails"] ? ExportInterfaceConfigurationDetailsEmailDTO.fromJS(_data["EmailDetails"]) : undefined as any;
            this.sFTPDetails = _data["SFTPDetails"] ? ExportInterfaceConfigurationDetailsSFTPDTO.fromJS(_data["SFTPDetails"]) : undefined as any;
            this.fTPClientDetails = _data["FTPClientDetails"] ? ExportInterfaceConfigurationDetailsFTPClientDTO.fromJS(_data["FTPClientDetails"]) : undefined as any;
            this.rESTDetails = _data["RESTDetails"] ? ExportInterfaceConfigurationDetailsRESTDTO.fromJS(_data["RESTDetails"]) : undefined as any;
            this.fileDetails = _data["FileDetails"] ? ExportInterfaceConfigurationDetailsFileDTO.fromJS(_data["FileDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExportInterfaceConfigTemplateDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigTemplateDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ConfigurationName"] = this.configurationName;
        data["Type"] = this.type;
        data["TransferType"] = this.transferType;
        data["Mode"] = this.mode;
        data["DataSelectionType"] = this.dataSelectionType;
        data["BacklogFilterLocations"] = this.backlogFilterLocations;
        data["FinanceSchedule"] = this.financeSchedule;
        data["FinanceSendEmptyData"] = this.financeSendEmptyData;
        data["FinanceDataSelectionType"] = this.financeDataSelectionType;
        data["ActivationEmailTemplateId"] = this.activationEmailTemplateId;
        data["Description"] = this.description;
        data["Active"] = this.active;
        data["ScheduleDetails"] = this.scheduleDetails ? this.scheduleDetails.toJSON() : undefined as any;
        data["EmailDetails"] = this.emailDetails ? this.emailDetails.toJSON() : undefined as any;
        data["SFTPDetails"] = this.sFTPDetails ? this.sFTPDetails.toJSON() : undefined as any;
        data["FTPClientDetails"] = this.fTPClientDetails ? this.fTPClientDetails.toJSON() : undefined as any;
        data["RESTDetails"] = this.rESTDetails ? this.rESTDetails.toJSON() : undefined as any;
        data["FileDetails"] = this.fileDetails ? this.fileDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IExportInterfaceConfigTemplateDetailsDTO {
    id: number;
    configurationName: string;
    type: ExportInterfaceConfigurationType;
    transferType: ExportInterfaceConfigurationTransferType;
    mode: ExportInterfaceConfigurationMode;
    dataSelectionType?: ExportInterfaceConfigurationDataSelectionType;
    backlogFilterLocations?: string | undefined;
    financeSchedule?: ExportInterfaceConfigurationFinanceSchedule;
    financeSendEmptyData?: boolean;
    financeDataSelectionType?: ExportInterfaceConfigurationFinanceDataSelectionType;
    activationEmailTemplateId?: number | undefined;
    description?: string | undefined;
    active?: boolean;
    scheduleDetails?: ExportInterfaceConfigurationDetailsTimeScheduleDTO | undefined;
    emailDetails?: ExportInterfaceConfigurationDetailsEmailDTO | undefined;
    sFTPDetails?: ExportInterfaceConfigurationDetailsSFTPDTO | undefined;
    fTPClientDetails?: ExportInterfaceConfigurationDetailsFTPClientDTO | undefined;
    rESTDetails?: ExportInterfaceConfigurationDetailsRESTDTO | undefined;
    fileDetails?: ExportInterfaceConfigurationDetailsFileDTO | undefined;
}

export enum ExportInterfaceConfigurationType {
    Pricelist = 0,
    CustomerBacklog = 1,
    Finance = 2,
    XMLOrder = 3,
    EDIOrder = 4,
    ProductCatalog = 5,
    CustomerConnection = 6,
    ImportSalesOrderResponse = 101,
}

export enum ExportInterfaceConfigurationMode {
    StandAlone = 0,
    Response = 1,
}

export enum ExportInterfaceConfigurationDataSelectionType {
    CustomerNumber = 1,
    CustomerGroupCode = 2,
    AllCustomers = 3,
}

export enum ExportInterfaceConfigurationFinanceSchedule {
    PreviousDay = 0,
    PreviousWeek = 1,
    PreviousMonth = 2,
}

export enum ExportInterfaceConfigurationFinanceDataSelectionType {
    CustomerNumber = 1,
    CustomerGroupCode = 2,
}

export class ExportInterfaceConfigurationDetailsTimeScheduleDTO implements IExportInterfaceConfigurationDetailsTimeScheduleDTO {
    startDateTime?: DateTime;
    /** null = never ending */
    endDateTime?: DateTime | undefined;
    endTimeSpan?: Duration | undefined;
    repeatEveryNMinutes?: number;
    /** execute on the following days (flags) */
    weekdays?: ExportInterfaceConfigurationDay;

    constructor(data?: IExportInterfaceConfigurationDetailsTimeScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateTime = _data["StartDateTime"] ? DateTime.fromISO(_data["StartDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["EndDateTime"] ? DateTime.fromISO(_data["EndDateTime"].toString()) : undefined as any;
            this.endTimeSpan = _data["EndTimeSpan"] ? Duration.fromISO(_data["EndTimeSpan"].toString()) : undefined as any;
            this.repeatEveryNMinutes = _data["RepeatEveryNMinutes"];
            this.weekdays = _data["Weekdays"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsTimeScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsTimeScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["EndDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["EndTimeSpan"] = this.endTimeSpan ? this.endTimeSpan.toString() : undefined as any;
        data["RepeatEveryNMinutes"] = this.repeatEveryNMinutes;
        data["Weekdays"] = this.weekdays;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsTimeScheduleDTO {
    startDateTime?: DateTime;
    /** null = never ending */
    endDateTime?: DateTime | undefined;
    endTimeSpan?: Duration | undefined;
    repeatEveryNMinutes?: number;
    /** execute on the following days (flags) */
    weekdays?: ExportInterfaceConfigurationDay;
}

export enum ExportInterfaceConfigurationDay {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 4,
    Thursday = 8,
    Friday = 16,
    Saturday = 32,
    Sunday = 64,
}

export class ExportInterfaceConfigurationDetailsEmailDTO implements IExportInterfaceConfigurationDetailsEmailDTO {
    senderName?: string | undefined;
    subject?: string | undefined;
    textHTML?: string | undefined;
    emailAccountId?: number | undefined;

    constructor(data?: IExportInterfaceConfigurationDetailsEmailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderName = _data["SenderName"];
            this.subject = _data["Subject"];
            this.textHTML = _data["TextHTML"];
            this.emailAccountId = _data["EmailAccountId"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsEmailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsEmailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SenderName"] = this.senderName;
        data["Subject"] = this.subject;
        data["TextHTML"] = this.textHTML;
        data["EmailAccountId"] = this.emailAccountId;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsEmailDTO {
    senderName?: string | undefined;
    subject?: string | undefined;
    textHTML?: string | undefined;
    emailAccountId?: number | undefined;
}

export class ExportInterfaceConfigurationDetailsSFTPDTO implements IExportInterfaceConfigurationDetailsSFTPDTO {
    useCustomFolderStructure?: boolean;

    constructor(data?: IExportInterfaceConfigurationDetailsSFTPDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useCustomFolderStructure = _data["UseCustomFolderStructure"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsSFTPDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsSFTPDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UseCustomFolderStructure"] = this.useCustomFolderStructure;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsSFTPDTO {
    useCustomFolderStructure?: boolean;
}

export class ExportInterfaceConfigurationDetailsFTPClientDTO implements IExportInterfaceConfigurationDetailsFTPClientDTO {
    uRL?: string | undefined;
    port?: number;
    clientType?: ExportInterfaceConfigurationFTPClientType;
    userName?: string | undefined;
    password?: string | undefined;
    relativePathOfFiles?: string | undefined;
    useCertificate?: boolean;
    certificateMediaId?: string | undefined;
    certificateMediaName?: string | undefined;
    certificateContentBase64?: string | undefined;
    certificatePassword?: string | undefined;
    certificateMediaType?: MediaStorageType | undefined;

    constructor(data?: IExportInterfaceConfigurationDetailsFTPClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uRL = _data["URL"];
            this.port = _data["Port"];
            this.clientType = _data["ClientType"];
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.relativePathOfFiles = _data["RelativePathOfFiles"];
            this.useCertificate = _data["UseCertificate"];
            this.certificateMediaId = _data["CertificateMediaId"];
            this.certificateMediaName = _data["CertificateMediaName"];
            this.certificateContentBase64 = _data["CertificateContentBase64"];
            this.certificatePassword = _data["CertificatePassword"];
            this.certificateMediaType = _data["CertificateMediaType"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsFTPClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsFTPClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["URL"] = this.uRL;
        data["Port"] = this.port;
        data["ClientType"] = this.clientType;
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["RelativePathOfFiles"] = this.relativePathOfFiles;
        data["UseCertificate"] = this.useCertificate;
        data["CertificateMediaId"] = this.certificateMediaId;
        data["CertificateMediaName"] = this.certificateMediaName;
        data["CertificateContentBase64"] = this.certificateContentBase64;
        data["CertificatePassword"] = this.certificatePassword;
        data["CertificateMediaType"] = this.certificateMediaType;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsFTPClientDTO {
    uRL?: string | undefined;
    port?: number;
    clientType?: ExportInterfaceConfigurationFTPClientType;
    userName?: string | undefined;
    password?: string | undefined;
    relativePathOfFiles?: string | undefined;
    useCertificate?: boolean;
    certificateMediaId?: string | undefined;
    certificateMediaName?: string | undefined;
    certificateContentBase64?: string | undefined;
    certificatePassword?: string | undefined;
    certificateMediaType?: MediaStorageType | undefined;
}

export enum ExportInterfaceConfigurationFTPClientType {
    FTP = 0,
    FTPS = 1,
    SFTPExplicit = 2,
    SFTPImplicit = 3,
}

export class ExportInterfaceConfigurationDetailsRESTDTO implements IExportInterfaceConfigurationDetailsRESTDTO {
    authenticationType?: ExportInterfaceConfigurationRESTAuthType;
    bearerTokenDetails?: ExportInterfaceConfigurationDetailsRESTBTDTO | undefined;
    aPIFixKeyDetails?: ExportInterfaceConfigurationDetailsRESTAPIDTO | undefined;

    constructor(data?: IExportInterfaceConfigurationDetailsRESTDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationType = _data["AuthenticationType"];
            this.bearerTokenDetails = _data["BearerTokenDetails"] ? ExportInterfaceConfigurationDetailsRESTBTDTO.fromJS(_data["BearerTokenDetails"]) : undefined as any;
            this.aPIFixKeyDetails = _data["APIFixKeyDetails"] ? ExportInterfaceConfigurationDetailsRESTAPIDTO.fromJS(_data["APIFixKeyDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsRESTDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsRESTDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AuthenticationType"] = this.authenticationType;
        data["BearerTokenDetails"] = this.bearerTokenDetails ? this.bearerTokenDetails.toJSON() : undefined as any;
        data["APIFixKeyDetails"] = this.aPIFixKeyDetails ? this.aPIFixKeyDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsRESTDTO {
    authenticationType?: ExportInterfaceConfigurationRESTAuthType;
    bearerTokenDetails?: ExportInterfaceConfigurationDetailsRESTBTDTO | undefined;
    aPIFixKeyDetails?: ExportInterfaceConfigurationDetailsRESTAPIDTO | undefined;
}

export class ExportInterfaceConfigurationDetailsRESTBTDTO implements IExportInterfaceConfigurationDetailsRESTBTDTO {
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    refreshTokeLifetimeInH?: number;

    constructor(data?: IExportInterfaceConfigurationDetailsRESTBTDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["ClientId"];
            this.clientSecret = _data["ClientSecret"];
            this.refreshTokeLifetimeInH = _data["RefreshTokeLifetimeInH"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsRESTBTDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsRESTBTDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientId"] = this.clientId;
        data["ClientSecret"] = this.clientSecret;
        data["RefreshTokeLifetimeInH"] = this.refreshTokeLifetimeInH;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsRESTBTDTO {
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    refreshTokeLifetimeInH?: number;
}

export class ExportInterfaceConfigurationDetailsRESTAPIDTO implements IExportInterfaceConfigurationDetailsRESTAPIDTO {
    aPIFixKey?: string | undefined;
    aPIFixKeyValue?: string | undefined;

    constructor(data?: IExportInterfaceConfigurationDetailsRESTAPIDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aPIFixKey = _data["APIFixKey"];
            this.aPIFixKeyValue = _data["APIFixKeyValue"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsRESTAPIDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsRESTAPIDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["APIFixKey"] = this.aPIFixKey;
        data["APIFixKeyValue"] = this.aPIFixKeyValue;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsRESTAPIDTO {
    aPIFixKey?: string | undefined;
    aPIFixKeyValue?: string | undefined;
}

export class ExportInterfaceConfigurationDetailsFileDTO implements IExportInterfaceConfigurationDetailsFileDTO {
    fileFormat?: ExportInterfaceConfigurationFileFormat;
    fileExtension?: string | undefined;
    titleInFile?: string | undefined;
    noOfDecimalPlaces?: number;
    decimalSeparator?: ExportInterfaceConfigurationDecimalSeparator;
    currency?: ExportInterfaceCurrency;
    elementTag?: string | undefined;
    xmlRootTag?: string | undefined;
    includeXmlDeclaration?: boolean;
    separator?: ExportInterfaceConfigurationSeparator;
    csvEnQuoteValues?: boolean;
    suppressHeaderLineInCsv?: boolean;
    generateEndLineInCsv?: boolean;
    textFormat?: ExportInterfaceConfigurationTextFormat;
    processType?: ExportInterfaceConfigurationFileProcessType;
    fileName?: string | undefined;
    additionalStockLocation?: ExportInterfaceConfigurationAdditionalStockLocation;
    fieldAssignments?: ExportInterfaceFieldAssignmentsDTO | undefined;
    lineBasedAllAttributes?: ExportInterfaceConfigurationDetailsFileLineBasedAllAttributesDTO | undefined;
    filter?: ExportInterfaceConfigurationDetailsFileFilterDTO | undefined;

    constructor(data?: IExportInterfaceConfigurationDetailsFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileFormat = _data["FileFormat"];
            this.fileExtension = _data["FileExtension"];
            this.titleInFile = _data["TitleInFile"];
            this.noOfDecimalPlaces = _data["NoOfDecimalPlaces"];
            this.decimalSeparator = _data["DecimalSeparator"];
            this.currency = _data["Currency"];
            this.elementTag = _data["ElementTag"];
            this.xmlRootTag = _data["XmlRootTag"];
            this.includeXmlDeclaration = _data["IncludeXmlDeclaration"];
            this.separator = _data["Separator"];
            this.csvEnQuoteValues = _data["CsvEnQuoteValues"];
            this.suppressHeaderLineInCsv = _data["SuppressHeaderLineInCsv"];
            this.generateEndLineInCsv = _data["GenerateEndLineInCsv"];
            this.textFormat = _data["TextFormat"];
            this.processType = _data["ProcessType"];
            this.fileName = _data["FileName"];
            this.additionalStockLocation = _data["AdditionalStockLocation"];
            this.fieldAssignments = _data["FieldAssignments"] ? ExportInterfaceFieldAssignmentsDTO.fromJS(_data["FieldAssignments"]) : undefined as any;
            this.lineBasedAllAttributes = _data["LineBasedAllAttributes"] ? ExportInterfaceConfigurationDetailsFileLineBasedAllAttributesDTO.fromJS(_data["LineBasedAllAttributes"]) : undefined as any;
            this.filter = _data["Filter"] ? ExportInterfaceConfigurationDetailsFileFilterDTO.fromJS(_data["Filter"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileFormat"] = this.fileFormat;
        data["FileExtension"] = this.fileExtension;
        data["TitleInFile"] = this.titleInFile;
        data["NoOfDecimalPlaces"] = this.noOfDecimalPlaces;
        data["DecimalSeparator"] = this.decimalSeparator;
        data["Currency"] = this.currency;
        data["ElementTag"] = this.elementTag;
        data["XmlRootTag"] = this.xmlRootTag;
        data["IncludeXmlDeclaration"] = this.includeXmlDeclaration;
        data["Separator"] = this.separator;
        data["CsvEnQuoteValues"] = this.csvEnQuoteValues;
        data["SuppressHeaderLineInCsv"] = this.suppressHeaderLineInCsv;
        data["GenerateEndLineInCsv"] = this.generateEndLineInCsv;
        data["TextFormat"] = this.textFormat;
        data["ProcessType"] = this.processType;
        data["FileName"] = this.fileName;
        data["AdditionalStockLocation"] = this.additionalStockLocation;
        data["FieldAssignments"] = this.fieldAssignments ? this.fieldAssignments.toJSON() : undefined as any;
        data["LineBasedAllAttributes"] = this.lineBasedAllAttributes ? this.lineBasedAllAttributes.toJSON() : undefined as any;
        data["Filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsFileDTO {
    fileFormat?: ExportInterfaceConfigurationFileFormat;
    fileExtension?: string | undefined;
    titleInFile?: string | undefined;
    noOfDecimalPlaces?: number;
    decimalSeparator?: ExportInterfaceConfigurationDecimalSeparator;
    currency?: ExportInterfaceCurrency;
    elementTag?: string | undefined;
    xmlRootTag?: string | undefined;
    includeXmlDeclaration?: boolean;
    separator?: ExportInterfaceConfigurationSeparator;
    csvEnQuoteValues?: boolean;
    suppressHeaderLineInCsv?: boolean;
    generateEndLineInCsv?: boolean;
    textFormat?: ExportInterfaceConfigurationTextFormat;
    processType?: ExportInterfaceConfigurationFileProcessType;
    fileName?: string | undefined;
    additionalStockLocation?: ExportInterfaceConfigurationAdditionalStockLocation;
    fieldAssignments?: ExportInterfaceFieldAssignmentsDTO | undefined;
    lineBasedAllAttributes?: ExportInterfaceConfigurationDetailsFileLineBasedAllAttributesDTO | undefined;
    filter?: ExportInterfaceConfigurationDetailsFileFilterDTO | undefined;
}

export enum ExportInterfaceConfigurationFileFormat {
    XML = 0,
    CSV = 1,
}

export enum ExportInterfaceCurrency {
    CHF = 0,
    EUR = 1,
    USD = 2,
}

export enum ExportInterfaceConfigurationSeparator {
    Comma = 0,
    Semicolon = 1,
    Pipe = 2,
    Tab = 3,
}

export enum ExportInterfaceConfigurationFileProcessType {
    ColumnBased = 0,
    LineBased = 1,
}

export enum ExportInterfaceConfigurationAdditionalStockLocation {
    None = 0,
    DE = 1,
    CH = 2,
}

export class ExportInterfaceFieldAssignmentsDTO implements IExportInterfaceFieldAssignmentsDTO {
    assignments?: ExportInterfaceFieldAssignmentDTO[] | undefined;

    constructor(data?: IExportInterfaceFieldAssignmentsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(ExportInterfaceFieldAssignmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportInterfaceFieldAssignmentsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceFieldAssignmentsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExportInterfaceFieldAssignmentsDTO {
    assignments?: ExportInterfaceFieldAssignmentDTO[] | undefined;
}

export class ExportInterfaceFieldAssignmentDTO implements IExportInterfaceFieldAssignmentDTO {
    id?: number;
    sourceName?: string | undefined;
    targetName?: string | undefined;
    overwriteCurrency?: ExportInterfaceCurrency | undefined;
    fixValue?: string | undefined;
    cap?: number | undefined;
    position?: number | undefined;
    exportZeroValueAsEmpty?: boolean;
    customField1Value?: string | undefined;
    customField2Value?: string | undefined;
    customField3Value?: string | undefined;
    customField4Value?: string | undefined;
    customField5Value?: string | undefined;

    constructor(data?: IExportInterfaceFieldAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.sourceName = _data["SourceName"];
            this.targetName = _data["TargetName"];
            this.overwriteCurrency = _data["OverwriteCurrency"];
            this.fixValue = _data["FixValue"];
            this.cap = _data["Cap"];
            this.position = _data["Position"];
            this.exportZeroValueAsEmpty = _data["ExportZeroValueAsEmpty"];
            this.customField1Value = _data["CustomField1Value"];
            this.customField2Value = _data["CustomField2Value"];
            this.customField3Value = _data["CustomField3Value"];
            this.customField4Value = _data["CustomField4Value"];
            this.customField5Value = _data["CustomField5Value"];
        }
    }

    static fromJS(data: any): ExportInterfaceFieldAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceFieldAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SourceName"] = this.sourceName;
        data["TargetName"] = this.targetName;
        data["OverwriteCurrency"] = this.overwriteCurrency;
        data["FixValue"] = this.fixValue;
        data["Cap"] = this.cap;
        data["Position"] = this.position;
        data["ExportZeroValueAsEmpty"] = this.exportZeroValueAsEmpty;
        data["CustomField1Value"] = this.customField1Value;
        data["CustomField2Value"] = this.customField2Value;
        data["CustomField3Value"] = this.customField3Value;
        data["CustomField4Value"] = this.customField4Value;
        data["CustomField5Value"] = this.customField5Value;
        return data;
    }
}

export interface IExportInterfaceFieldAssignmentDTO {
    id?: number;
    sourceName?: string | undefined;
    targetName?: string | undefined;
    overwriteCurrency?: ExportInterfaceCurrency | undefined;
    fixValue?: string | undefined;
    cap?: number | undefined;
    position?: number | undefined;
    exportZeroValueAsEmpty?: boolean;
    customField1Value?: string | undefined;
    customField2Value?: string | undefined;
    customField3Value?: string | undefined;
    customField4Value?: string | undefined;
    customField5Value?: string | undefined;
}

export class ExportInterfaceConfigurationDetailsFileLineBasedAllAttributesDTO implements IExportInterfaceConfigurationDetailsFileLineBasedAllAttributesDTO {
    removeEmptyAttributes?: boolean;
    countryCode?: string | undefined;
    useTitleColumn?: boolean;
    addTitleToAttributeDescription?: boolean;
    titleAttributeSeparator?: string | undefined;
    useUnitColumn?: boolean;
    addUnitToAttributeValue?: boolean;
    unitAttributeSeparator?: string | undefined;
    itemNumberDenominator?: string | undefined;
    titleDenominator?: string | undefined;
    attributeDescriptionDenominator?: string | undefined;
    attributeValueDenominator?: string | undefined;
    unitDenominator?: string | undefined;
    attributeTag?: string | undefined;
    sendLegacyNoAsItemNo?: boolean;
    additionalColumns?: string | undefined;

    constructor(data?: IExportInterfaceConfigurationDetailsFileLineBasedAllAttributesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.removeEmptyAttributes = _data["RemoveEmptyAttributes"];
            this.countryCode = _data["CountryCode"];
            this.useTitleColumn = _data["UseTitleColumn"];
            this.addTitleToAttributeDescription = _data["AddTitleToAttributeDescription"];
            this.titleAttributeSeparator = _data["TitleAttributeSeparator"];
            this.useUnitColumn = _data["UseUnitColumn"];
            this.addUnitToAttributeValue = _data["AddUnitToAttributeValue"];
            this.unitAttributeSeparator = _data["UnitAttributeSeparator"];
            this.itemNumberDenominator = _data["ItemNumberDenominator"];
            this.titleDenominator = _data["TitleDenominator"];
            this.attributeDescriptionDenominator = _data["AttributeDescriptionDenominator"];
            this.attributeValueDenominator = _data["AttributeValueDenominator"];
            this.unitDenominator = _data["UnitDenominator"];
            this.attributeTag = _data["AttributeTag"];
            this.sendLegacyNoAsItemNo = _data["SendLegacyNoAsItemNo"];
            this.additionalColumns = _data["AdditionalColumns"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsFileLineBasedAllAttributesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsFileLineBasedAllAttributesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RemoveEmptyAttributes"] = this.removeEmptyAttributes;
        data["CountryCode"] = this.countryCode;
        data["UseTitleColumn"] = this.useTitleColumn;
        data["AddTitleToAttributeDescription"] = this.addTitleToAttributeDescription;
        data["TitleAttributeSeparator"] = this.titleAttributeSeparator;
        data["UseUnitColumn"] = this.useUnitColumn;
        data["AddUnitToAttributeValue"] = this.addUnitToAttributeValue;
        data["UnitAttributeSeparator"] = this.unitAttributeSeparator;
        data["ItemNumberDenominator"] = this.itemNumberDenominator;
        data["TitleDenominator"] = this.titleDenominator;
        data["AttributeDescriptionDenominator"] = this.attributeDescriptionDenominator;
        data["AttributeValueDenominator"] = this.attributeValueDenominator;
        data["UnitDenominator"] = this.unitDenominator;
        data["AttributeTag"] = this.attributeTag;
        data["SendLegacyNoAsItemNo"] = this.sendLegacyNoAsItemNo;
        data["AdditionalColumns"] = this.additionalColumns;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsFileLineBasedAllAttributesDTO {
    removeEmptyAttributes?: boolean;
    countryCode?: string | undefined;
    useTitleColumn?: boolean;
    addTitleToAttributeDescription?: boolean;
    titleAttributeSeparator?: string | undefined;
    useUnitColumn?: boolean;
    addUnitToAttributeValue?: boolean;
    unitAttributeSeparator?: string | undefined;
    itemNumberDenominator?: string | undefined;
    titleDenominator?: string | undefined;
    attributeDescriptionDenominator?: string | undefined;
    attributeValueDenominator?: string | undefined;
    unitDenominator?: string | undefined;
    attributeTag?: string | undefined;
    sendLegacyNoAsItemNo?: boolean;
    additionalColumns?: string | undefined;
}

export class ExportInterfaceConfigurationDetailsFileFilterDTO implements IExportInterfaceConfigurationDetailsFileFilterDTO {
    lowerPriceLimit?: number | undefined;
    filterCustomerReference?: boolean;
    filterEAN?: boolean;
    filterFixPrice?: boolean;
    brandFilters?: ExportInterfaceConfigurationDetailsFileFilterBrandSubDTO[] | undefined;
    brandSubIncludeFilters?: ExportInterfaceConfigurationDetailsFileFilterBrandSubDTO[] | undefined;
    clearingItemFilter?: ExportInterfaceConfigurationClearingItemFilter;
    additionalStockLocation?: ExportInterfaceConfigurationAdditionalStockLocation;

    constructor(data?: IExportInterfaceConfigurationDetailsFileFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lowerPriceLimit = _data["LowerPriceLimit"];
            this.filterCustomerReference = _data["FilterCustomerReference"];
            this.filterEAN = _data["FilterEAN"];
            this.filterFixPrice = _data["FilterFixPrice"];
            if (Array.isArray(_data["BrandFilters"])) {
                this.brandFilters = [] as any;
                for (let item of _data["BrandFilters"])
                    this.brandFilters!.push(ExportInterfaceConfigurationDetailsFileFilterBrandSubDTO.fromJS(item));
            }
            if (Array.isArray(_data["BrandSubIncludeFilters"])) {
                this.brandSubIncludeFilters = [] as any;
                for (let item of _data["BrandSubIncludeFilters"])
                    this.brandSubIncludeFilters!.push(ExportInterfaceConfigurationDetailsFileFilterBrandSubDTO.fromJS(item));
            }
            this.clearingItemFilter = _data["ClearingItemFilter"];
            this.additionalStockLocation = _data["AdditionalStockLocation"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsFileFilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsFileFilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LowerPriceLimit"] = this.lowerPriceLimit;
        data["FilterCustomerReference"] = this.filterCustomerReference;
        data["FilterEAN"] = this.filterEAN;
        data["FilterFixPrice"] = this.filterFixPrice;
        if (Array.isArray(this.brandFilters)) {
            data["BrandFilters"] = [];
            for (let item of this.brandFilters)
                data["BrandFilters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.brandSubIncludeFilters)) {
            data["BrandSubIncludeFilters"] = [];
            for (let item of this.brandSubIncludeFilters)
                data["BrandSubIncludeFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["ClearingItemFilter"] = this.clearingItemFilter;
        data["AdditionalStockLocation"] = this.additionalStockLocation;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsFileFilterDTO {
    lowerPriceLimit?: number | undefined;
    filterCustomerReference?: boolean;
    filterEAN?: boolean;
    filterFixPrice?: boolean;
    brandFilters?: ExportInterfaceConfigurationDetailsFileFilterBrandSubDTO[] | undefined;
    brandSubIncludeFilters?: ExportInterfaceConfigurationDetailsFileFilterBrandSubDTO[] | undefined;
    clearingItemFilter?: ExportInterfaceConfigurationClearingItemFilter;
    additionalStockLocation?: ExportInterfaceConfigurationAdditionalStockLocation;
}

export class ExportInterfaceConfigurationDetailsFileFilterBrandSubDTO implements IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO {
    filterBrand?: string | undefined;
    filterSubBrand?: string | undefined;

    constructor(data?: IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterBrand = _data["FilterBrand"];
            this.filterSubBrand = _data["FilterSubBrand"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsFileFilterBrandSubDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsFileFilterBrandSubDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilterBrand"] = this.filterBrand;
        data["FilterSubBrand"] = this.filterSubBrand;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO {
    filterBrand?: string | undefined;
    filterSubBrand?: string | undefined;
}

export enum ExportInterfaceConfigurationClearingItemFilter {
    NoClearingItems = 0,
    IncludeClearingItems = 1,
    OnlyClearingItems = 2,
}

export class CreateExportInterfaceConfigTemplateDTO implements ICreateExportInterfaceConfigTemplateDTO {

    constructor(data?: ICreateExportInterfaceConfigTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateExportInterfaceConfigTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExportInterfaceConfigTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreateExportInterfaceConfigTemplateDTO {
}

export class PagedResultDTOOfExportInterfaceConfigTemplateDTO implements IPagedResultDTOOfExportInterfaceConfigTemplateDTO {
    items?: ExportInterfaceConfigTemplateDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfExportInterfaceConfigTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ExportInterfaceConfigTemplateDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfExportInterfaceConfigTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfExportInterfaceConfigTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfExportInterfaceConfigTemplateDTO {
    items?: ExportInterfaceConfigTemplateDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class ExportInterfaceConfigTemplateDTO implements IExportInterfaceConfigTemplateDTO {
    id?: number;
    configurationName?: string | undefined;
    type?: ExportInterfaceConfigurationType;
    transferType?: ExportInterfaceConfigurationTransferType;
    mode?: ExportInterfaceConfigurationMode;
    activationEmailTemplateId?: number | undefined;

    constructor(data?: IExportInterfaceConfigTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.configurationName = _data["ConfigurationName"];
            this.type = _data["Type"];
            this.transferType = _data["TransferType"];
            this.mode = _data["Mode"];
            this.activationEmailTemplateId = _data["ActivationEmailTemplateId"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ConfigurationName"] = this.configurationName;
        data["Type"] = this.type;
        data["TransferType"] = this.transferType;
        data["Mode"] = this.mode;
        data["ActivationEmailTemplateId"] = this.activationEmailTemplateId;
        return data;
    }
}

export interface IExportInterfaceConfigTemplateDTO {
    id?: number;
    configurationName?: string | undefined;
    type?: ExportInterfaceConfigurationType;
    transferType?: ExportInterfaceConfigurationTransferType;
    mode?: ExportInterfaceConfigurationMode;
    activationEmailTemplateId?: number | undefined;
}

export class UpdateExportInterfaceConfigTemplateDTO implements IUpdateExportInterfaceConfigTemplateDTO {
    templateDetails!: ExportInterfaceConfigTemplateDetailsDTO;

    constructor(data?: IUpdateExportInterfaceConfigTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.templateDetails = new ExportInterfaceConfigTemplateDetailsDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateDetails = _data["TemplateDetails"] ? ExportInterfaceConfigTemplateDetailsDTO.fromJS(_data["TemplateDetails"]) : new ExportInterfaceConfigTemplateDetailsDTO();
        }
    }

    static fromJS(data: any): UpdateExportInterfaceConfigTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExportInterfaceConfigTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TemplateDetails"] = this.templateDetails ? this.templateDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateExportInterfaceConfigTemplateDTO {
    templateDetails: ExportInterfaceConfigTemplateDetailsDTO;
}

export class ExportInterfaceConfigurationDetailsDTO implements IExportInterfaceConfigurationDetailsDTO {
    id!: number;
    clientId!: number;
    configurationName!: string;
    type!: ExportInterfaceConfigurationType;
    transferType!: ExportInterfaceConfigurationTransferType;
    mode!: ExportInterfaceConfigurationMode;
    importConfigurationId?: number | undefined;
    activationEmailLastSentOn?: DateTime | undefined;
    activationEmailTemplateId?: number | undefined;
    description?: string | undefined;
    active?: boolean;
    dataSelectionType?: ExportInterfaceConfigurationDataSelectionType;
    backlogFilterLocations?: string | undefined;
    financeSchedule?: ExportInterfaceConfigurationFinanceSchedule;
    financeSendEmptyData?: boolean;
    financeDataSelectionType?: ExportInterfaceConfigurationFinanceDataSelectionType;
    userAccessList?: ExportInterfaceConfigurationUserAccessInfoDTO[] | undefined;
    scheduleDetails?: ExportInterfaceConfigurationDetailsTimeScheduleDTO | undefined;
    emailDetails?: ExportInterfaceConfigurationDetailsEmailDTO | undefined;
    sFTPDetails?: ExportInterfaceConfigurationDetailsSFTPDTO | undefined;
    fTPClientDetails?: ExportInterfaceConfigurationDetailsFTPClientDTO | undefined;
    rESTDetails?: ExportInterfaceConfigurationDetailsRESTDTO | undefined;
    fileDetails?: ExportInterfaceConfigurationDetailsFileDTO | undefined;

    constructor(data?: IExportInterfaceConfigurationDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.clientId = _data["ClientId"];
            this.configurationName = _data["ConfigurationName"];
            this.type = _data["Type"];
            this.transferType = _data["TransferType"];
            this.mode = _data["Mode"];
            this.importConfigurationId = _data["ImportConfigurationId"];
            this.activationEmailLastSentOn = _data["ActivationEmailLastSentOn"] ? DateTime.fromISO(_data["ActivationEmailLastSentOn"].toString()) : undefined as any;
            this.activationEmailTemplateId = _data["ActivationEmailTemplateId"];
            this.description = _data["Description"];
            this.active = _data["Active"];
            this.dataSelectionType = _data["DataSelectionType"];
            this.backlogFilterLocations = _data["BacklogFilterLocations"];
            this.financeSchedule = _data["FinanceSchedule"];
            this.financeSendEmptyData = _data["FinanceSendEmptyData"];
            this.financeDataSelectionType = _data["FinanceDataSelectionType"];
            if (Array.isArray(_data["UserAccessList"])) {
                this.userAccessList = [] as any;
                for (let item of _data["UserAccessList"])
                    this.userAccessList!.push(ExportInterfaceConfigurationUserAccessInfoDTO.fromJS(item));
            }
            this.scheduleDetails = _data["ScheduleDetails"] ? ExportInterfaceConfigurationDetailsTimeScheduleDTO.fromJS(_data["ScheduleDetails"]) : undefined as any;
            this.emailDetails = _data["EmailDetails"] ? ExportInterfaceConfigurationDetailsEmailDTO.fromJS(_data["EmailDetails"]) : undefined as any;
            this.sFTPDetails = _data["SFTPDetails"] ? ExportInterfaceConfigurationDetailsSFTPDTO.fromJS(_data["SFTPDetails"]) : undefined as any;
            this.fTPClientDetails = _data["FTPClientDetails"] ? ExportInterfaceConfigurationDetailsFTPClientDTO.fromJS(_data["FTPClientDetails"]) : undefined as any;
            this.rESTDetails = _data["RESTDetails"] ? ExportInterfaceConfigurationDetailsRESTDTO.fromJS(_data["RESTDetails"]) : undefined as any;
            this.fileDetails = _data["FileDetails"] ? ExportInterfaceConfigurationDetailsFileDTO.fromJS(_data["FileDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ClientId"] = this.clientId;
        data["ConfigurationName"] = this.configurationName;
        data["Type"] = this.type;
        data["TransferType"] = this.transferType;
        data["Mode"] = this.mode;
        data["ImportConfigurationId"] = this.importConfigurationId;
        data["ActivationEmailLastSentOn"] = this.activationEmailLastSentOn ? this.activationEmailLastSentOn.toString() : undefined as any;
        data["ActivationEmailTemplateId"] = this.activationEmailTemplateId;
        data["Description"] = this.description;
        data["Active"] = this.active;
        data["DataSelectionType"] = this.dataSelectionType;
        data["BacklogFilterLocations"] = this.backlogFilterLocations;
        data["FinanceSchedule"] = this.financeSchedule;
        data["FinanceSendEmptyData"] = this.financeSendEmptyData;
        data["FinanceDataSelectionType"] = this.financeDataSelectionType;
        if (Array.isArray(this.userAccessList)) {
            data["UserAccessList"] = [];
            for (let item of this.userAccessList)
                data["UserAccessList"].push(item ? item.toJSON() : undefined as any);
        }
        data["ScheduleDetails"] = this.scheduleDetails ? this.scheduleDetails.toJSON() : undefined as any;
        data["EmailDetails"] = this.emailDetails ? this.emailDetails.toJSON() : undefined as any;
        data["SFTPDetails"] = this.sFTPDetails ? this.sFTPDetails.toJSON() : undefined as any;
        data["FTPClientDetails"] = this.fTPClientDetails ? this.fTPClientDetails.toJSON() : undefined as any;
        data["RESTDetails"] = this.rESTDetails ? this.rESTDetails.toJSON() : undefined as any;
        data["FileDetails"] = this.fileDetails ? this.fileDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsDTO {
    id: number;
    clientId: number;
    configurationName: string;
    type: ExportInterfaceConfigurationType;
    transferType: ExportInterfaceConfigurationTransferType;
    mode: ExportInterfaceConfigurationMode;
    importConfigurationId?: number | undefined;
    activationEmailLastSentOn?: DateTime | undefined;
    activationEmailTemplateId?: number | undefined;
    description?: string | undefined;
    active?: boolean;
    dataSelectionType?: ExportInterfaceConfigurationDataSelectionType;
    backlogFilterLocations?: string | undefined;
    financeSchedule?: ExportInterfaceConfigurationFinanceSchedule;
    financeSendEmptyData?: boolean;
    financeDataSelectionType?: ExportInterfaceConfigurationFinanceDataSelectionType;
    userAccessList?: ExportInterfaceConfigurationUserAccessInfoDTO[] | undefined;
    scheduleDetails?: ExportInterfaceConfigurationDetailsTimeScheduleDTO | undefined;
    emailDetails?: ExportInterfaceConfigurationDetailsEmailDTO | undefined;
    sFTPDetails?: ExportInterfaceConfigurationDetailsSFTPDTO | undefined;
    fTPClientDetails?: ExportInterfaceConfigurationDetailsFTPClientDTO | undefined;
    rESTDetails?: ExportInterfaceConfigurationDetailsRESTDTO | undefined;
    fileDetails?: ExportInterfaceConfigurationDetailsFileDTO | undefined;
}

export class ExportInterfaceConfigurationUserAccessInfoDTO implements IExportInterfaceConfigurationUserAccessInfoDTO {
    userId?: string | undefined;
    userName?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    hasAccess?: boolean;

    constructor(data?: IExportInterfaceConfigurationUserAccessInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.userName = _data["UserName"];
            this.firstname = _data["Firstname"];
            this.lastname = _data["Lastname"];
            this.hasAccess = _data["HasAccess"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationUserAccessInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationUserAccessInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["UserName"] = this.userName;
        data["Firstname"] = this.firstname;
        data["Lastname"] = this.lastname;
        data["HasAccess"] = this.hasAccess;
        return data;
    }
}

export interface IExportInterfaceConfigurationUserAccessInfoDTO {
    userId?: string | undefined;
    userName?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    hasAccess?: boolean;
}

export class CreateExportInterfaceConfigurationDTO implements ICreateExportInterfaceConfigurationDTO {
    clientId?: number;
    mode?: ExportInterfaceConfigurationMode;
    importConfigurationId?: number | undefined;

    constructor(data?: ICreateExportInterfaceConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["ClientId"];
            this.mode = _data["Mode"];
            this.importConfigurationId = _data["ImportConfigurationId"];
        }
    }

    static fromJS(data: any): CreateExportInterfaceConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExportInterfaceConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientId"] = this.clientId;
        data["Mode"] = this.mode;
        data["ImportConfigurationId"] = this.importConfigurationId;
        return data;
    }
}

export interface ICreateExportInterfaceConfigurationDTO {
    clientId?: number;
    mode?: ExportInterfaceConfigurationMode;
    importConfigurationId?: number | undefined;
}

export class UpdateConfigurationFromTemplateDTO implements IUpdateConfigurationFromTemplateDTO {
    configurationId?: number;
    templateId?: number;
    clientId?: number;
    importConfigurationId?: number | undefined;

    constructor(data?: IUpdateConfigurationFromTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["ConfigurationId"];
            this.templateId = _data["TemplateId"];
            this.clientId = _data["ClientId"];
            this.importConfigurationId = _data["ImportConfigurationId"];
        }
    }

    static fromJS(data: any): UpdateConfigurationFromTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigurationFromTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConfigurationId"] = this.configurationId;
        data["TemplateId"] = this.templateId;
        data["ClientId"] = this.clientId;
        data["ImportConfigurationId"] = this.importConfigurationId;
        return data;
    }
}

export interface IUpdateConfigurationFromTemplateDTO {
    configurationId?: number;
    templateId?: number;
    clientId?: number;
    importConfigurationId?: number | undefined;
}

export class PagedResultDTOOfExportInterfaceConfigurationDTO implements IPagedResultDTOOfExportInterfaceConfigurationDTO {
    items?: ExportInterfaceConfigurationDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfExportInterfaceConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ExportInterfaceConfigurationDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfExportInterfaceConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfExportInterfaceConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfExportInterfaceConfigurationDTO {
    items?: ExportInterfaceConfigurationDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class ExportInterfaceConfigurationDTO implements IExportInterfaceConfigurationDTO {
    id?: number;
    clientId?: number;
    clientName?: string | undefined;
    clientNumber?: string | undefined;
    configurationName?: string | undefined;
    type?: ExportInterfaceConfigurationType;
    transferType?: ExportInterfaceConfigurationTransferType;
    mode?: ExportInterfaceConfigurationMode;
    importConfigurationId?: number | undefined;
    dataSelectionType?: ExportInterfaceConfigurationDataSelectionType;
    backlogFilterLocations?: string | undefined;
    financeSchedule?: ExportInterfaceConfigurationFinanceSchedule;
    financeSendEmptyData?: boolean;
    financeDataSelectionType?: ExportInterfaceConfigurationFinanceDataSelectionType;
    activationEmailLastSentOn?: DateTime | undefined;
    activationEmailTemplateId?: number | undefined;
    active?: boolean;

    constructor(data?: IExportInterfaceConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.clientId = _data["ClientId"];
            this.clientName = _data["ClientName"];
            this.clientNumber = _data["ClientNumber"];
            this.configurationName = _data["ConfigurationName"];
            this.type = _data["Type"];
            this.transferType = _data["TransferType"];
            this.mode = _data["Mode"];
            this.importConfigurationId = _data["ImportConfigurationId"];
            this.dataSelectionType = _data["DataSelectionType"];
            this.backlogFilterLocations = _data["BacklogFilterLocations"];
            this.financeSchedule = _data["FinanceSchedule"];
            this.financeSendEmptyData = _data["FinanceSendEmptyData"];
            this.financeDataSelectionType = _data["FinanceDataSelectionType"];
            this.activationEmailLastSentOn = _data["ActivationEmailLastSentOn"] ? DateTime.fromISO(_data["ActivationEmailLastSentOn"].toString()) : undefined as any;
            this.activationEmailTemplateId = _data["ActivationEmailTemplateId"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ClientId"] = this.clientId;
        data["ClientName"] = this.clientName;
        data["ClientNumber"] = this.clientNumber;
        data["ConfigurationName"] = this.configurationName;
        data["Type"] = this.type;
        data["TransferType"] = this.transferType;
        data["Mode"] = this.mode;
        data["ImportConfigurationId"] = this.importConfigurationId;
        data["DataSelectionType"] = this.dataSelectionType;
        data["BacklogFilterLocations"] = this.backlogFilterLocations;
        data["FinanceSchedule"] = this.financeSchedule;
        data["FinanceSendEmptyData"] = this.financeSendEmptyData;
        data["FinanceDataSelectionType"] = this.financeDataSelectionType;
        data["ActivationEmailLastSentOn"] = this.activationEmailLastSentOn ? this.activationEmailLastSentOn.toString() : undefined as any;
        data["ActivationEmailTemplateId"] = this.activationEmailTemplateId;
        data["Active"] = this.active;
        return data;
    }
}

export interface IExportInterfaceConfigurationDTO {
    id?: number;
    clientId?: number;
    clientName?: string | undefined;
    clientNumber?: string | undefined;
    configurationName?: string | undefined;
    type?: ExportInterfaceConfigurationType;
    transferType?: ExportInterfaceConfigurationTransferType;
    mode?: ExportInterfaceConfigurationMode;
    importConfigurationId?: number | undefined;
    dataSelectionType?: ExportInterfaceConfigurationDataSelectionType;
    backlogFilterLocations?: string | undefined;
    financeSchedule?: ExportInterfaceConfigurationFinanceSchedule;
    financeSendEmptyData?: boolean;
    financeDataSelectionType?: ExportInterfaceConfigurationFinanceDataSelectionType;
    activationEmailLastSentOn?: DateTime | undefined;
    activationEmailTemplateId?: number | undefined;
    active?: boolean;
}

export class UpdateExportInterfaceConfigurationDTO implements IUpdateExportInterfaceConfigurationDTO {
    configurationDetails!: ExportInterfaceConfigurationDetailsDTO;

    constructor(data?: IUpdateExportInterfaceConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.configurationDetails = new ExportInterfaceConfigurationDetailsDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationDetails = _data["ConfigurationDetails"] ? ExportInterfaceConfigurationDetailsDTO.fromJS(_data["ConfigurationDetails"]) : new ExportInterfaceConfigurationDetailsDTO();
        }
    }

    static fromJS(data: any): UpdateExportInterfaceConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExportInterfaceConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConfigurationDetails"] = this.configurationDetails ? this.configurationDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateExportInterfaceConfigurationDTO {
    configurationDetails: ExportInterfaceConfigurationDetailsDTO;
}

export class ExportInterfaceConfigurationFTPTestResultDTO implements IExportInterfaceConfigurationFTPTestResultDTO {
    succeeded?: boolean;
    logEntries?: string[] | undefined;

    constructor(data?: IExportInterfaceConfigurationFTPTestResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["Succeeded"];
            if (Array.isArray(_data["LogEntries"])) {
                this.logEntries = [] as any;
                for (let item of _data["LogEntries"])
                    this.logEntries!.push(item);
            }
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationFTPTestResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationFTPTestResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Succeeded"] = this.succeeded;
        if (Array.isArray(this.logEntries)) {
            data["LogEntries"] = [];
            for (let item of this.logEntries)
                data["LogEntries"].push(item);
        }
        return data;
    }
}

export interface IExportInterfaceConfigurationFTPTestResultDTO {
    succeeded?: boolean;
    logEntries?: string[] | undefined;
}

export class ExportInterfaceMasterDataDTO implements IExportInterfaceMasterDataDTO {
    possibleFileNamePlaceholders?: ExportInterfaceConfigurationDetailsFilePlaceholderDTO[] | undefined;
    possibleEmailPlaceholders?: ExportInterfaceConfigurationDetailsFilePlaceholderDTO[] | undefined;
    brandSubBrands?: BrandSubBrandDTO[] | undefined;

    constructor(data?: IExportInterfaceMasterDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["PossibleFileNamePlaceholders"])) {
                this.possibleFileNamePlaceholders = [] as any;
                for (let item of _data["PossibleFileNamePlaceholders"])
                    this.possibleFileNamePlaceholders!.push(ExportInterfaceConfigurationDetailsFilePlaceholderDTO.fromJS(item));
            }
            if (Array.isArray(_data["PossibleEmailPlaceholders"])) {
                this.possibleEmailPlaceholders = [] as any;
                for (let item of _data["PossibleEmailPlaceholders"])
                    this.possibleEmailPlaceholders!.push(ExportInterfaceConfigurationDetailsFilePlaceholderDTO.fromJS(item));
            }
            if (Array.isArray(_data["BrandSubBrands"])) {
                this.brandSubBrands = [] as any;
                for (let item of _data["BrandSubBrands"])
                    this.brandSubBrands!.push(BrandSubBrandDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportInterfaceMasterDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceMasterDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.possibleFileNamePlaceholders)) {
            data["PossibleFileNamePlaceholders"] = [];
            for (let item of this.possibleFileNamePlaceholders)
                data["PossibleFileNamePlaceholders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.possibleEmailPlaceholders)) {
            data["PossibleEmailPlaceholders"] = [];
            for (let item of this.possibleEmailPlaceholders)
                data["PossibleEmailPlaceholders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.brandSubBrands)) {
            data["BrandSubBrands"] = [];
            for (let item of this.brandSubBrands)
                data["BrandSubBrands"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExportInterfaceMasterDataDTO {
    possibleFileNamePlaceholders?: ExportInterfaceConfigurationDetailsFilePlaceholderDTO[] | undefined;
    possibleEmailPlaceholders?: ExportInterfaceConfigurationDetailsFilePlaceholderDTO[] | undefined;
    brandSubBrands?: BrandSubBrandDTO[] | undefined;
}

export class ExportInterfaceConfigurationDetailsFilePlaceholderDTO implements IExportInterfaceConfigurationDetailsFilePlaceholderDTO {
    placeholder?: string | undefined;
    description?: string | undefined;
    descriptionResourceId?: string | undefined;

    constructor(data?: IExportInterfaceConfigurationDetailsFilePlaceholderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeholder = _data["Placeholder"];
            this.description = _data["Description"];
            this.descriptionResourceId = _data["DescriptionResourceId"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationDetailsFilePlaceholderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationDetailsFilePlaceholderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Placeholder"] = this.placeholder;
        data["Description"] = this.description;
        data["DescriptionResourceId"] = this.descriptionResourceId;
        return data;
    }
}

export interface IExportInterfaceConfigurationDetailsFilePlaceholderDTO {
    placeholder?: string | undefined;
    description?: string | undefined;
    descriptionResourceId?: string | undefined;
}

export class BrandSubBrandDTO implements IBrandSubBrandDTO {
    id?: number;
    brandCode?: string | undefined;
    brandName?: string | undefined;
    brandSubCode?: string | undefined;
    brandSubName?: string | undefined;

    constructor(data?: IBrandSubBrandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.brandCode = _data["BrandCode"];
            this.brandName = _data["BrandName"];
            this.brandSubCode = _data["BrandSubCode"];
            this.brandSubName = _data["BrandSubName"];
        }
    }

    static fromJS(data: any): BrandSubBrandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BrandSubBrandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["BrandCode"] = this.brandCode;
        data["BrandName"] = this.brandName;
        data["BrandSubCode"] = this.brandSubCode;
        data["BrandSubName"] = this.brandSubName;
        return data;
    }
}

export interface IBrandSubBrandDTO {
    id?: number;
    brandCode?: string | undefined;
    brandName?: string | undefined;
    brandSubCode?: string | undefined;
    brandSubName?: string | undefined;
}

export class ExportInterfaceAllSourceFieldsDTO implements IExportInterfaceAllSourceFieldsDTO {
    allSourceFields?: { [key in keyof typeof ExportInterfaceConfigurationType]?: ExportInterfaceFieldAssignmentSourceInfoDTO[]; };

    constructor(data?: IExportInterfaceAllSourceFieldsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["AllSourceFields"]) {
                this.allSourceFields = {} as any;
                for (let key in _data["AllSourceFields"]) {
                    if (_data["AllSourceFields"].hasOwnProperty(key))
                        (this.allSourceFields as any)![key] = _data["AllSourceFields"][key] ? _data["AllSourceFields"][key].map((i: any) => ExportInterfaceFieldAssignmentSourceInfoDTO.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): ExportInterfaceAllSourceFieldsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceAllSourceFieldsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allSourceFields) {
            data["AllSourceFields"] = {};
            for (let key in this.allSourceFields) {
                if (this.allSourceFields.hasOwnProperty(key))
                    (data["AllSourceFields"] as any)[key] = (this.allSourceFields as any)[key];
            }
        }
        return data;
    }
}

export interface IExportInterfaceAllSourceFieldsDTO {
    allSourceFields?: { [key in keyof typeof ExportInterfaceConfigurationType]?: ExportInterfaceFieldAssignmentSourceInfoDTO[]; };
}

export class ExportInterfaceFieldAssignmentSourceInfoDTO implements IExportInterfaceFieldAssignmentSourceInfoDTO {
    sourceName?: string | undefined;
    sourceDisplayNameResourceId?: string | undefined;
    canBeEdited?: boolean;
    canHaveCurrency?: boolean;
    canHaveFixValue?: boolean;
    canHaveCap?: boolean;
    canHaveExportZeroValueAsEmpty?: boolean;
    customField1Label?: string | undefined;
    customField2Label?: string | undefined;
    customField3Label?: string | undefined;
    customField4Label?: string | undefined;
    customField5Label?: string | undefined;
    customField1Optional?: boolean;
    customField2Optional?: boolean;
    customField3Optional?: boolean;
    customField4Optional?: boolean;
    customField5Optional?: boolean;
    isValueReplaceable?: boolean;

    constructor(data?: IExportInterfaceFieldAssignmentSourceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["SourceName"];
            this.sourceDisplayNameResourceId = _data["SourceDisplayNameResourceId"];
            this.canBeEdited = _data["CanBeEdited"];
            this.canHaveCurrency = _data["CanHaveCurrency"];
            this.canHaveFixValue = _data["CanHaveFixValue"];
            this.canHaveCap = _data["CanHaveCap"];
            this.canHaveExportZeroValueAsEmpty = _data["CanHaveExportZeroValueAsEmpty"];
            this.customField1Label = _data["CustomField1Label"];
            this.customField2Label = _data["CustomField2Label"];
            this.customField3Label = _data["CustomField3Label"];
            this.customField4Label = _data["CustomField4Label"];
            this.customField5Label = _data["CustomField5Label"];
            this.customField1Optional = _data["CustomField1Optional"];
            this.customField2Optional = _data["CustomField2Optional"];
            this.customField3Optional = _data["CustomField3Optional"];
            this.customField4Optional = _data["CustomField4Optional"];
            this.customField5Optional = _data["CustomField5Optional"];
            this.isValueReplaceable = _data["IsValueReplaceable"];
        }
    }

    static fromJS(data: any): ExportInterfaceFieldAssignmentSourceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceFieldAssignmentSourceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SourceName"] = this.sourceName;
        data["SourceDisplayNameResourceId"] = this.sourceDisplayNameResourceId;
        data["CanBeEdited"] = this.canBeEdited;
        data["CanHaveCurrency"] = this.canHaveCurrency;
        data["CanHaveFixValue"] = this.canHaveFixValue;
        data["CanHaveCap"] = this.canHaveCap;
        data["CanHaveExportZeroValueAsEmpty"] = this.canHaveExportZeroValueAsEmpty;
        data["CustomField1Label"] = this.customField1Label;
        data["CustomField2Label"] = this.customField2Label;
        data["CustomField3Label"] = this.customField3Label;
        data["CustomField4Label"] = this.customField4Label;
        data["CustomField5Label"] = this.customField5Label;
        data["CustomField1Optional"] = this.customField1Optional;
        data["CustomField2Optional"] = this.customField2Optional;
        data["CustomField3Optional"] = this.customField3Optional;
        data["CustomField4Optional"] = this.customField4Optional;
        data["CustomField5Optional"] = this.customField5Optional;
        data["IsValueReplaceable"] = this.isValueReplaceable;
        return data;
    }
}

export interface IExportInterfaceFieldAssignmentSourceInfoDTO {
    sourceName?: string | undefined;
    sourceDisplayNameResourceId?: string | undefined;
    canBeEdited?: boolean;
    canHaveCurrency?: boolean;
    canHaveFixValue?: boolean;
    canHaveCap?: boolean;
    canHaveExportZeroValueAsEmpty?: boolean;
    customField1Label?: string | undefined;
    customField2Label?: string | undefined;
    customField3Label?: string | undefined;
    customField4Label?: string | undefined;
    customField5Label?: string | undefined;
    customField1Optional?: boolean;
    customField2Optional?: boolean;
    customField3Optional?: boolean;
    customField4Optional?: boolean;
    customField5Optional?: boolean;
    isValueReplaceable?: boolean;
}

export class ExportInterfaceConfigurationFilterDTO implements IExportInterfaceConfigurationFilterDTO {
    clientId?: number | undefined;
    searchText?: string | undefined;
    salesPersonCodes?: string[] | undefined;
    countryCodes?: string[] | undefined;
    transferType?: ExportInterfaceConfigurationTransferType | undefined;

    constructor(data?: IExportInterfaceConfigurationFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["ClientId"];
            this.searchText = _data["SearchText"];
            if (Array.isArray(_data["SalesPersonCodes"])) {
                this.salesPersonCodes = [] as any;
                for (let item of _data["SalesPersonCodes"])
                    this.salesPersonCodes!.push(item);
            }
            if (Array.isArray(_data["CountryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["CountryCodes"])
                    this.countryCodes!.push(item);
            }
            this.transferType = _data["TransferType"];
        }
    }

    static fromJS(data: any): ExportInterfaceConfigurationFilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceConfigurationFilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientId"] = this.clientId;
        data["SearchText"] = this.searchText;
        if (Array.isArray(this.salesPersonCodes)) {
            data["SalesPersonCodes"] = [];
            for (let item of this.salesPersonCodes)
                data["SalesPersonCodes"].push(item);
        }
        if (Array.isArray(this.countryCodes)) {
            data["CountryCodes"] = [];
            for (let item of this.countryCodes)
                data["CountryCodes"].push(item);
        }
        data["TransferType"] = this.transferType;
        return data;
    }
}

export interface IExportInterfaceConfigurationFilterDTO {
    clientId?: number | undefined;
    searchText?: string | undefined;
    salesPersonCodes?: string[] | undefined;
    countryCodes?: string[] | undefined;
    transferType?: ExportInterfaceConfigurationTransferType | undefined;
}

export class ExportInterfaceEmailTemplateDTO implements IExportInterfaceEmailTemplateDTO {
    id?: number;
    templateName?: string | undefined;
    senderName?: string | undefined;
    subject?: string | undefined;
    textHTML?: string | undefined;
    emailAccountId?: number | undefined;

    constructor(data?: IExportInterfaceEmailTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.templateName = _data["TemplateName"];
            this.senderName = _data["SenderName"];
            this.subject = _data["Subject"];
            this.textHTML = _data["TextHTML"];
            this.emailAccountId = _data["EmailAccountId"];
        }
    }

    static fromJS(data: any): ExportInterfaceEmailTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceEmailTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TemplateName"] = this.templateName;
        data["SenderName"] = this.senderName;
        data["Subject"] = this.subject;
        data["TextHTML"] = this.textHTML;
        data["EmailAccountId"] = this.emailAccountId;
        return data;
    }
}

export interface IExportInterfaceEmailTemplateDTO {
    id?: number;
    templateName?: string | undefined;
    senderName?: string | undefined;
    subject?: string | undefined;
    textHTML?: string | undefined;
    emailAccountId?: number | undefined;
}

export class CreateExportInterfaceEmailTemplateDTO implements ICreateExportInterfaceEmailTemplateDTO {

    constructor(data?: ICreateExportInterfaceEmailTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateExportInterfaceEmailTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExportInterfaceEmailTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreateExportInterfaceEmailTemplateDTO {
}

export class PagedResultDTOOfExportInterfaceEmailTemplateDTO implements IPagedResultDTOOfExportInterfaceEmailTemplateDTO {
    items?: ExportInterfaceEmailTemplateDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfExportInterfaceEmailTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ExportInterfaceEmailTemplateDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfExportInterfaceEmailTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfExportInterfaceEmailTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfExportInterfaceEmailTemplateDTO {
    items?: ExportInterfaceEmailTemplateDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class UpdateExportInterfaceEmailTemplateDTO implements IUpdateExportInterfaceEmailTemplateDTO {
    id?: number;
    templateName?: string | undefined;
    senderName?: string | undefined;
    subject?: string | undefined;
    textHTML?: string | undefined;
    emailAccountId?: number;

    constructor(data?: IUpdateExportInterfaceEmailTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.templateName = _data["TemplateName"];
            this.senderName = _data["SenderName"];
            this.subject = _data["Subject"];
            this.textHTML = _data["TextHTML"];
            this.emailAccountId = _data["EmailAccountId"];
        }
    }

    static fromJS(data: any): UpdateExportInterfaceEmailTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExportInterfaceEmailTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TemplateName"] = this.templateName;
        data["SenderName"] = this.senderName;
        data["Subject"] = this.subject;
        data["TextHTML"] = this.textHTML;
        data["EmailAccountId"] = this.emailAccountId;
        return data;
    }
}

export interface IUpdateExportInterfaceEmailTemplateDTO {
    id?: number;
    templateName?: string | undefined;
    senderName?: string | undefined;
    subject?: string | undefined;
    textHTML?: string | undefined;
    emailAccountId?: number;
}

export class PagedResultDTOOfExportInterfaceExecutionLogDTO implements IPagedResultDTOOfExportInterfaceExecutionLogDTO {
    items?: ExportInterfaceExecutionLogDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfExportInterfaceExecutionLogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ExportInterfaceExecutionLogDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfExportInterfaceExecutionLogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfExportInterfaceExecutionLogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfExportInterfaceExecutionLogDTO {
    items?: ExportInterfaceExecutionLogDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class ExportInterfaceExecutionLogDTO implements IExportInterfaceExecutionLogDTO {
    id?: number;
    timestamp?: DateTime;
    clientName?: string | undefined;
    clientNumber?: string | undefined;
    configurationName?: string | undefined;
    configurationId?: number;
    success?: boolean;
    errorMessage?: string | undefined;
    configurationType?: ExportInterfaceConfigurationType;

    constructor(data?: IExportInterfaceExecutionLogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.timestamp = _data["Timestamp"] ? DateTime.fromISO(_data["Timestamp"].toString()) : undefined as any;
            this.clientName = _data["ClientName"];
            this.clientNumber = _data["ClientNumber"];
            this.configurationName = _data["ConfigurationName"];
            this.configurationId = _data["ConfigurationId"];
            this.success = _data["Success"];
            this.errorMessage = _data["ErrorMessage"];
            this.configurationType = _data["ConfigurationType"];
        }
    }

    static fromJS(data: any): ExportInterfaceExecutionLogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceExecutionLogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Timestamp"] = this.timestamp ? this.timestamp.toString() : undefined as any;
        data["ClientName"] = this.clientName;
        data["ClientNumber"] = this.clientNumber;
        data["ConfigurationName"] = this.configurationName;
        data["ConfigurationId"] = this.configurationId;
        data["Success"] = this.success;
        data["ErrorMessage"] = this.errorMessage;
        data["ConfigurationType"] = this.configurationType;
        return data;
    }
}

export interface IExportInterfaceExecutionLogDTO {
    id?: number;
    timestamp?: DateTime;
    clientName?: string | undefined;
    clientNumber?: string | undefined;
    configurationName?: string | undefined;
    configurationId?: number;
    success?: boolean;
    errorMessage?: string | undefined;
    configurationType?: ExportInterfaceConfigurationType;
}

export class ExportInterfaceFieldAssignmentTemplateDTO implements IExportInterfaceFieldAssignmentTemplateDTO {
    id?: number;
    templateName?: string | undefined;
    configurationType?: ExportInterfaceConfigurationType;
    assignments?: ExportInterfaceFieldAssignmentDTO[] | undefined;

    constructor(data?: IExportInterfaceFieldAssignmentTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.templateName = _data["TemplateName"];
            this.configurationType = _data["ConfigurationType"];
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(ExportInterfaceFieldAssignmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportInterfaceFieldAssignmentTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceFieldAssignmentTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TemplateName"] = this.templateName;
        data["ConfigurationType"] = this.configurationType;
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExportInterfaceFieldAssignmentTemplateDTO {
    id?: number;
    templateName?: string | undefined;
    configurationType?: ExportInterfaceConfigurationType;
    assignments?: ExportInterfaceFieldAssignmentDTO[] | undefined;
}

export class CreateExportInterfaceFieldAssignmentTemplateDTO implements ICreateExportInterfaceFieldAssignmentTemplateDTO {
    templateName?: string | undefined;
    configurationType?: ExportInterfaceConfigurationType;
    assignments?: ExportInterfaceFieldAssignmentDTO[] | undefined;

    constructor(data?: ICreateExportInterfaceFieldAssignmentTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateName = _data["TemplateName"];
            this.configurationType = _data["ConfigurationType"];
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(ExportInterfaceFieldAssignmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateExportInterfaceFieldAssignmentTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExportInterfaceFieldAssignmentTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TemplateName"] = this.templateName;
        data["ConfigurationType"] = this.configurationType;
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateExportInterfaceFieldAssignmentTemplateDTO {
    templateName?: string | undefined;
    configurationType?: ExportInterfaceConfigurationType;
    assignments?: ExportInterfaceFieldAssignmentDTO[] | undefined;
}

export class PagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO implements IPagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO {
    items?: ExportInterfaceFieldAssignmentTemplateDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ExportInterfaceFieldAssignmentTemplateDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfExportInterfaceFieldAssignmentTemplateDTO {
    items?: ExportInterfaceFieldAssignmentTemplateDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class UpdateExportInterfaceFieldAssignmentTemplateDTO implements IUpdateExportInterfaceFieldAssignmentTemplateDTO {
    id!: number;
    templateName?: string | undefined;
    configurationType?: ExportInterfaceConfigurationType;
    assignments?: ExportInterfaceFieldAssignmentDTO[] | undefined;

    constructor(data?: IUpdateExportInterfaceFieldAssignmentTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.templateName = _data["TemplateName"];
            this.configurationType = _data["ConfigurationType"];
            if (Array.isArray(_data["Assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["Assignments"])
                    this.assignments!.push(ExportInterfaceFieldAssignmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateExportInterfaceFieldAssignmentTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExportInterfaceFieldAssignmentTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TemplateName"] = this.templateName;
        data["ConfigurationType"] = this.configurationType;
        if (Array.isArray(this.assignments)) {
            data["Assignments"] = [];
            for (let item of this.assignments)
                data["Assignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateExportInterfaceFieldAssignmentTemplateDTO {
    id: number;
    templateName?: string | undefined;
    configurationType?: ExportInterfaceConfigurationType;
    assignments?: ExportInterfaceFieldAssignmentDTO[] | undefined;
}

export class ExportInterfaceFieldValueReplacementEntryDTO implements IExportInterfaceFieldValueReplacementEntryDTO {
    id?: number;
    sourceField?: string | undefined;
    sourceValue?: string | undefined;
    replacementValue?: string | undefined;

    constructor(data?: IExportInterfaceFieldValueReplacementEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.sourceField = _data["SourceField"];
            this.sourceValue = _data["SourceValue"];
            this.replacementValue = _data["ReplacementValue"];
        }
    }

    static fromJS(data: any): ExportInterfaceFieldValueReplacementEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceFieldValueReplacementEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SourceField"] = this.sourceField;
        data["SourceValue"] = this.sourceValue;
        data["ReplacementValue"] = this.replacementValue;
        return data;
    }
}

export interface IExportInterfaceFieldValueReplacementEntryDTO {
    id?: number;
    sourceField?: string | undefined;
    sourceValue?: string | undefined;
    replacementValue?: string | undefined;
}

export class ExportInterfaceSaveFieldValueReplacementsDTO implements IExportInterfaceSaveFieldValueReplacementsDTO {
    clientId?: number;
    deletedSourceFields?: string[] | undefined;
    deletedReplacementEntries?: number[] | undefined;
    newOrUpdatedEntries?: ExportInterfaceFieldValueReplacementEntryDTO[] | undefined;

    constructor(data?: IExportInterfaceSaveFieldValueReplacementsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["ClientId"];
            if (Array.isArray(_data["DeletedSourceFields"])) {
                this.deletedSourceFields = [] as any;
                for (let item of _data["DeletedSourceFields"])
                    this.deletedSourceFields!.push(item);
            }
            if (Array.isArray(_data["DeletedReplacementEntries"])) {
                this.deletedReplacementEntries = [] as any;
                for (let item of _data["DeletedReplacementEntries"])
                    this.deletedReplacementEntries!.push(item);
            }
            if (Array.isArray(_data["NewOrUpdatedEntries"])) {
                this.newOrUpdatedEntries = [] as any;
                for (let item of _data["NewOrUpdatedEntries"])
                    this.newOrUpdatedEntries!.push(ExportInterfaceFieldValueReplacementEntryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportInterfaceSaveFieldValueReplacementsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceSaveFieldValueReplacementsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientId"] = this.clientId;
        if (Array.isArray(this.deletedSourceFields)) {
            data["DeletedSourceFields"] = [];
            for (let item of this.deletedSourceFields)
                data["DeletedSourceFields"].push(item);
        }
        if (Array.isArray(this.deletedReplacementEntries)) {
            data["DeletedReplacementEntries"] = [];
            for (let item of this.deletedReplacementEntries)
                data["DeletedReplacementEntries"].push(item);
        }
        if (Array.isArray(this.newOrUpdatedEntries)) {
            data["NewOrUpdatedEntries"] = [];
            for (let item of this.newOrUpdatedEntries)
                data["NewOrUpdatedEntries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExportInterfaceSaveFieldValueReplacementsDTO {
    clientId?: number;
    deletedSourceFields?: string[] | undefined;
    deletedReplacementEntries?: number[] | undefined;
    newOrUpdatedEntries?: ExportInterfaceFieldValueReplacementEntryDTO[] | undefined;
}

export class ExportInterfaceRESTItemPriceDTO implements IExportInterfaceRESTItemPriceDTO {
    itemNo?: string | undefined;
    price?: number;
    currency?: string | undefined;
    stock?: number | undefined;
    nextDelivery?: DateTime | undefined;
    nextConfirmedQuantity?: number | undefined;
    itemNoLegacy?: string | undefined;

    constructor(data?: IExportInterfaceRESTItemPriceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemNo = _data["ItemNo"];
            this.price = _data["Price"];
            this.currency = _data["Currency"];
            this.stock = _data["Stock"];
            this.nextDelivery = _data["NextDelivery"] ? DateTime.fromISO(_data["NextDelivery"].toString()) : undefined as any;
            this.nextConfirmedQuantity = _data["NextConfirmedQuantity"];
            this.itemNoLegacy = _data["ItemNoLegacy"];
        }
    }

    static fromJS(data: any): ExportInterfaceRESTItemPriceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInterfaceRESTItemPriceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemNo"] = this.itemNo;
        data["Price"] = this.price;
        data["Currency"] = this.currency;
        data["Stock"] = this.stock;
        data["NextDelivery"] = this.nextDelivery ? this.nextDelivery.toString() : undefined as any;
        data["NextConfirmedQuantity"] = this.nextConfirmedQuantity;
        data["ItemNoLegacy"] = this.itemNoLegacy;
        return data;
    }
}

export interface IExportInterfaceRESTItemPriceDTO {
    itemNo?: string | undefined;
    price?: number;
    currency?: string | undefined;
    stock?: number | undefined;
    nextDelivery?: DateTime | undefined;
    nextConfirmedQuantity?: number | undefined;
    itemNoLegacy?: string | undefined;
}

export class BitrixItemDTO implements IBitrixItemDTO {
    itemNo?: string | undefined;
    itemNo2?: string | undefined;
    itemDescription?: string | undefined;
    itemDescription2?: string | undefined;
    brandCode?: string | undefined;
    brandSubCode?: string | undefined;
    profileCode?: string | undefined;
    profileDescription?: string | undefined;
    itemDiscountGroup?: string | undefined;
    weightGross?: number;
    weightNet?: number;
    blocked?: boolean;
    nonStockItem?: boolean;
    saleBlocked?: boolean;
    backlogClass?: string | undefined;
    backlogClassCw?: string | undefined;
    packageId?: number;
    packageName?: string | undefined;
    statusId?: number;
    status?: string | undefined;
    eanNo?: string | undefined;
    productGroupCode?: string | undefined;
    productGroupCodeSub?: string | undefined;
    productionReserveQuantity?: number;
    productionReserveValidDate?: DateTime | undefined;
    productManager?: string | undefined;
    centralWarehouse?: boolean;
    vendorItemNo?: string | undefined;
    minimumOrderQuantity?: number;
    priceProtectionPeriod?: number | undefined;
    leadTimeCalculation?: number | undefined;
    stockTime?: number | undefined;
    stockTimeCalculation?: number;
    stockTimeCw?: number | undefined;
    stockTimeCalculationCw?: number;
    purchaseStatusId?: number;
    baseUnitOfMeasure?: string | undefined;
    locationCode?: string | undefined;
    salesMarginCategoryCode?: string | undefined;
    salesMarginCategoryDescription?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IBitrixItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemNo = _data["ItemNo"];
            this.itemNo2 = _data["ItemNo2"];
            this.itemDescription = _data["ItemDescription"];
            this.itemDescription2 = _data["ItemDescription2"];
            this.brandCode = _data["BrandCode"];
            this.brandSubCode = _data["BrandSubCode"];
            this.profileCode = _data["ProfileCode"];
            this.profileDescription = _data["ProfileDescription"];
            this.itemDiscountGroup = _data["ItemDiscountGroup"];
            this.weightGross = _data["WeightGross"];
            this.weightNet = _data["WeightNet"];
            this.blocked = _data["Blocked"];
            this.nonStockItem = _data["NonStockItem"];
            this.saleBlocked = _data["SaleBlocked"];
            this.backlogClass = _data["BacklogClass"];
            this.backlogClassCw = _data["BacklogClassCw"];
            this.packageId = _data["PackageId"];
            this.packageName = _data["PackageName"];
            this.statusId = _data["StatusId"];
            this.status = _data["Status"];
            this.eanNo = _data["EanNo"];
            this.productGroupCode = _data["ProductGroupCode"];
            this.productGroupCodeSub = _data["ProductGroupCodeSub"];
            this.productionReserveQuantity = _data["ProductionReserveQuantity"];
            this.productionReserveValidDate = _data["ProductionReserveValidDate"] ? DateTime.fromISO(_data["ProductionReserveValidDate"].toString()) : undefined as any;
            this.productManager = _data["ProductManager"];
            this.centralWarehouse = _data["CentralWarehouse"];
            this.vendorItemNo = _data["VendorItemNo"];
            this.minimumOrderQuantity = _data["MinimumOrderQuantity"];
            this.priceProtectionPeriod = _data["PriceProtectionPeriod"];
            this.leadTimeCalculation = _data["LeadTimeCalculation"];
            this.stockTime = _data["StockTime"];
            this.stockTimeCalculation = _data["StockTimeCalculation"];
            this.stockTimeCw = _data["StockTimeCw"];
            this.stockTimeCalculationCw = _data["StockTimeCalculationCw"];
            this.purchaseStatusId = _data["PurchaseStatusId"];
            this.baseUnitOfMeasure = _data["BaseUnitOfMeasure"];
            this.locationCode = _data["LocationCode"];
            this.salesMarginCategoryCode = _data["SalesMarginCategoryCode"];
            this.salesMarginCategoryDescription = _data["SalesMarginCategoryDescription"];
            this.rowVersion = _data["RowVersion"];
        }
    }

    static fromJS(data: any): BitrixItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BitrixItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemNo"] = this.itemNo;
        data["ItemNo2"] = this.itemNo2;
        data["ItemDescription"] = this.itemDescription;
        data["ItemDescription2"] = this.itemDescription2;
        data["BrandCode"] = this.brandCode;
        data["BrandSubCode"] = this.brandSubCode;
        data["ProfileCode"] = this.profileCode;
        data["ProfileDescription"] = this.profileDescription;
        data["ItemDiscountGroup"] = this.itemDiscountGroup;
        data["WeightGross"] = this.weightGross;
        data["WeightNet"] = this.weightNet;
        data["Blocked"] = this.blocked;
        data["NonStockItem"] = this.nonStockItem;
        data["SaleBlocked"] = this.saleBlocked;
        data["BacklogClass"] = this.backlogClass;
        data["BacklogClassCw"] = this.backlogClassCw;
        data["PackageId"] = this.packageId;
        data["PackageName"] = this.packageName;
        data["StatusId"] = this.statusId;
        data["Status"] = this.status;
        data["EanNo"] = this.eanNo;
        data["ProductGroupCode"] = this.productGroupCode;
        data["ProductGroupCodeSub"] = this.productGroupCodeSub;
        data["ProductionReserveQuantity"] = this.productionReserveQuantity;
        data["ProductionReserveValidDate"] = this.productionReserveValidDate ? this.productionReserveValidDate.toString() : undefined as any;
        data["ProductManager"] = this.productManager;
        data["CentralWarehouse"] = this.centralWarehouse;
        data["VendorItemNo"] = this.vendorItemNo;
        data["MinimumOrderQuantity"] = this.minimumOrderQuantity;
        data["PriceProtectionPeriod"] = this.priceProtectionPeriod;
        data["LeadTimeCalculation"] = this.leadTimeCalculation;
        data["StockTime"] = this.stockTime;
        data["StockTimeCalculation"] = this.stockTimeCalculation;
        data["StockTimeCw"] = this.stockTimeCw;
        data["StockTimeCalculationCw"] = this.stockTimeCalculationCw;
        data["PurchaseStatusId"] = this.purchaseStatusId;
        data["BaseUnitOfMeasure"] = this.baseUnitOfMeasure;
        data["LocationCode"] = this.locationCode;
        data["SalesMarginCategoryCode"] = this.salesMarginCategoryCode;
        data["SalesMarginCategoryDescription"] = this.salesMarginCategoryDescription;
        data["RowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IBitrixItemDTO {
    itemNo?: string | undefined;
    itemNo2?: string | undefined;
    itemDescription?: string | undefined;
    itemDescription2?: string | undefined;
    brandCode?: string | undefined;
    brandSubCode?: string | undefined;
    profileCode?: string | undefined;
    profileDescription?: string | undefined;
    itemDiscountGroup?: string | undefined;
    weightGross?: number;
    weightNet?: number;
    blocked?: boolean;
    nonStockItem?: boolean;
    saleBlocked?: boolean;
    backlogClass?: string | undefined;
    backlogClassCw?: string | undefined;
    packageId?: number;
    packageName?: string | undefined;
    statusId?: number;
    status?: string | undefined;
    eanNo?: string | undefined;
    productGroupCode?: string | undefined;
    productGroupCodeSub?: string | undefined;
    productionReserveQuantity?: number;
    productionReserveValidDate?: DateTime | undefined;
    productManager?: string | undefined;
    centralWarehouse?: boolean;
    vendorItemNo?: string | undefined;
    minimumOrderQuantity?: number;
    priceProtectionPeriod?: number | undefined;
    leadTimeCalculation?: number | undefined;
    stockTime?: number | undefined;
    stockTimeCalculation?: number;
    stockTimeCw?: number | undefined;
    stockTimeCalculationCw?: number;
    purchaseStatusId?: number;
    baseUnitOfMeasure?: string | undefined;
    locationCode?: string | undefined;
    salesMarginCategoryCode?: string | undefined;
    salesMarginCategoryDescription?: string | undefined;
    rowVersion?: string | undefined;
}

export class BitrixCustomerPriceGroupDTO implements IBitrixCustomerPriceGroupDTO {
    id?: number | undefined;
    customerPriceGroup?: string | undefined;
    paymentTermsCodeDefault?: string | undefined;
    priceLevelCode?: string | undefined;
    disablePricing?: boolean | undefined;
    baseCustomerNo?: string | undefined;
    companyGroupCode?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IBitrixCustomerPriceGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customerPriceGroup = _data["CustomerPriceGroup"];
            this.paymentTermsCodeDefault = _data["PaymentTermsCodeDefault"];
            this.priceLevelCode = _data["PriceLevelCode"];
            this.disablePricing = _data["DisablePricing"];
            this.baseCustomerNo = _data["BaseCustomerNo"];
            this.companyGroupCode = _data["CompanyGroupCode"];
            this.rowVersion = _data["RowVersion"];
        }
    }

    static fromJS(data: any): BitrixCustomerPriceGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BitrixCustomerPriceGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomerPriceGroup"] = this.customerPriceGroup;
        data["PaymentTermsCodeDefault"] = this.paymentTermsCodeDefault;
        data["PriceLevelCode"] = this.priceLevelCode;
        data["DisablePricing"] = this.disablePricing;
        data["BaseCustomerNo"] = this.baseCustomerNo;
        data["CompanyGroupCode"] = this.companyGroupCode;
        data["RowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IBitrixCustomerPriceGroupDTO {
    id?: number | undefined;
    customerPriceGroup?: string | undefined;
    paymentTermsCodeDefault?: string | undefined;
    priceLevelCode?: string | undefined;
    disablePricing?: boolean | undefined;
    baseCustomerNo?: string | undefined;
    companyGroupCode?: string | undefined;
    rowVersion?: string | undefined;
}

export class BitrixCustomerDTO implements IBitrixCustomerDTO {
    customerNo?: string | undefined;
    companyGroupCode?: string | undefined;
    name?: string | undefined;
    name2?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    postCode?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    countryCode?: string | undefined;
    contact?: string | undefined;
    email?: string | undefined;
    phoneNo?: string | undefined;
    faxNo?: string | undefined;
    languageCode?: string | undefined;
    currencyCode?: string | undefined;
    paymentTermsCode?: string | undefined;
    blocked?: boolean;
    salespersonCode?: string | undefined;
    territoryCode?: string | undefined;
    customerGroup?: string | undefined;
    customerPriceGroup?: string | undefined;
    customerDiscountGroup?: string | undefined;
    accountStatus?: number;
    transportChargeId?: number;
    transportChargeName?: string | undefined;
    hidden?: boolean;
    noWebCsv?: boolean;
    systemsPriceGroupCode?: string | undefined;
    priceLevelCode?: string | undefined;
    locationCode?: string | undefined;
    billtoCustomerNo?: string | undefined;
    maxAllowedPriceType?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IBitrixCustomerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerNo = _data["CustomerNo"];
            this.companyGroupCode = _data["CompanyGroupCode"];
            this.name = _data["Name"];
            this.name2 = _data["Name2"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.postCode = _data["PostCode"];
            this.city = _data["City"];
            this.county = _data["County"];
            this.countryCode = _data["CountryCode"];
            this.contact = _data["Contact"];
            this.email = _data["Email"];
            this.phoneNo = _data["PhoneNo"];
            this.faxNo = _data["FaxNo"];
            this.languageCode = _data["LanguageCode"];
            this.currencyCode = _data["CurrencyCode"];
            this.paymentTermsCode = _data["PaymentTermsCode"];
            this.blocked = _data["Blocked"];
            this.salespersonCode = _data["SalespersonCode"];
            this.territoryCode = _data["TerritoryCode"];
            this.customerGroup = _data["CustomerGroup"];
            this.customerPriceGroup = _data["CustomerPriceGroup"];
            this.customerDiscountGroup = _data["CustomerDiscountGroup"];
            this.accountStatus = _data["AccountStatus"];
            this.transportChargeId = _data["TransportChargeId"];
            this.transportChargeName = _data["TransportChargeName"];
            this.hidden = _data["Hidden"];
            this.noWebCsv = _data["NoWebCsv"];
            this.systemsPriceGroupCode = _data["SystemsPriceGroupCode"];
            this.priceLevelCode = _data["PriceLevelCode"];
            this.locationCode = _data["LocationCode"];
            this.billtoCustomerNo = _data["BilltoCustomerNo"];
            this.maxAllowedPriceType = _data["MaxAllowedPriceType"];
            this.rowVersion = _data["RowVersion"];
        }
    }

    static fromJS(data: any): BitrixCustomerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BitrixCustomerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerNo"] = this.customerNo;
        data["CompanyGroupCode"] = this.companyGroupCode;
        data["Name"] = this.name;
        data["Name2"] = this.name2;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["PostCode"] = this.postCode;
        data["City"] = this.city;
        data["County"] = this.county;
        data["CountryCode"] = this.countryCode;
        data["Contact"] = this.contact;
        data["Email"] = this.email;
        data["PhoneNo"] = this.phoneNo;
        data["FaxNo"] = this.faxNo;
        data["LanguageCode"] = this.languageCode;
        data["CurrencyCode"] = this.currencyCode;
        data["PaymentTermsCode"] = this.paymentTermsCode;
        data["Blocked"] = this.blocked;
        data["SalespersonCode"] = this.salespersonCode;
        data["TerritoryCode"] = this.territoryCode;
        data["CustomerGroup"] = this.customerGroup;
        data["CustomerPriceGroup"] = this.customerPriceGroup;
        data["CustomerDiscountGroup"] = this.customerDiscountGroup;
        data["AccountStatus"] = this.accountStatus;
        data["TransportChargeId"] = this.transportChargeId;
        data["TransportChargeName"] = this.transportChargeName;
        data["Hidden"] = this.hidden;
        data["NoWebCsv"] = this.noWebCsv;
        data["SystemsPriceGroupCode"] = this.systemsPriceGroupCode;
        data["PriceLevelCode"] = this.priceLevelCode;
        data["LocationCode"] = this.locationCode;
        data["BilltoCustomerNo"] = this.billtoCustomerNo;
        data["MaxAllowedPriceType"] = this.maxAllowedPriceType;
        data["RowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IBitrixCustomerDTO {
    customerNo?: string | undefined;
    companyGroupCode?: string | undefined;
    name?: string | undefined;
    name2?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    postCode?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    countryCode?: string | undefined;
    contact?: string | undefined;
    email?: string | undefined;
    phoneNo?: string | undefined;
    faxNo?: string | undefined;
    languageCode?: string | undefined;
    currencyCode?: string | undefined;
    paymentTermsCode?: string | undefined;
    blocked?: boolean;
    salespersonCode?: string | undefined;
    territoryCode?: string | undefined;
    customerGroup?: string | undefined;
    customerPriceGroup?: string | undefined;
    customerDiscountGroup?: string | undefined;
    accountStatus?: number;
    transportChargeId?: number;
    transportChargeName?: string | undefined;
    hidden?: boolean;
    noWebCsv?: boolean;
    systemsPriceGroupCode?: string | undefined;
    priceLevelCode?: string | undefined;
    locationCode?: string | undefined;
    billtoCustomerNo?: string | undefined;
    maxAllowedPriceType?: string | undefined;
    rowVersion?: string | undefined;
}

export class MarginCorrectionDTO implements IMarginCorrectionDTO {
    entryNo?: number;
    itemNo?: string | undefined;
    description?: string | undefined;
    currency?: string | undefined;
    currentUnitCost?: number;
    cogsAvg?: number;
    salesQty?: number;
    sales?: number;
    salesPriceAvg?: number;
    profit?: number;
    profitPercent?: number;
    vpUsd?: number;
    vpEur?: number;
    mr?: number;
    comments?: string | undefined;
    nmPercent?: number;
    pm?: string | undefined;
    brand?: string | undefined;
    postingDate?: DateTime;
    week?: string | undefined;
    month?: string | undefined;
    salesperson?: string | undefined;
    customerNo?: string | undefined;
    customerName?: string | undefined;
    customerTier?: string | undefined;
    customerNamedAccount?: string | undefined;
    salesType?: string | undefined;
    vendorNo?: string | undefined;
    vendorName?: string | undefined;
    priceGroup?: string | undefined;
    correctedMargin?: number;
    fileName?: string | undefined;
    fileRowNo?: number;
    dateUploaded?: DateTime;
    userUploaded?: string | undefined;
    brandCode?: string | undefined;
    brandSubCode?: string | undefined;
    budgetRuleCode?: string | undefined;
    lineCheck?: boolean;
    budgetGroup?: number;
    excludeDailyStat?: boolean;
    documentType?: number;
    documentNo?: string | undefined;
    vpChf?: number;
    documentLineNo?: number;
    downChargePercent?: number;
    orderNo?: string | undefined;
    vpComments?: string | undefined;
    lastDateModified?: DateTime;
    lastPmModified?: string | undefined;
    valueEntryNo?: number;
    mrInitial?: number;
    commentsInitial?: string | undefined;
    usdRate?: number;
    eurRate?: number;
    entryType?: number;
    siChf?: number;
    skipProjection?: boolean;
    mrDirect?: number;
    currencyCorrection?: number;
    currencyCorrectionPercent?: number;
    currencyCorrectionRate?: number;
    ruleError?: boolean;
    ruleErrorText?: string | undefined;
    corrValueEntryNo?: number;
    eurUsdRate?: number;
    fixCurrency?: boolean;
    documentCurrency?: string | undefined;
    documentSalesPrice?: number;
    documentSalesAmount?: number;
    ruleErrorStatus?: number;
    feeAmount?: number;
    pp?: number;
    ppCurrency?: string | undefined;
    ppUsd?: number;
    ppEur?: number;
    ppChf?: number;
    dealId?: number;
    lineDiscountAmount?: number;
    serviceCost?: number;
    locationCode?: string | undefined;
    costAmountActual?: number;
    nmOld?: number;
    nmPercentOld?: number;
    exRateId?: number;
    pipsType?: number;
    ppUsdTotal?: number;
    ppEurTotal?: number;
    ppChfTotal?: number;
    lbtUnitCost?: number;
    lbtProfitPercent?: number;
    customerConditionBoni?: number;
    customerConditionCond3P?: number;
    customerConditionKulanz?: number;
    customerConditionPayment?: number;
    customerConditionWkz?: number;
    customerConditionFreeShipment?: number;
    customerConditionInterest?: number;
    customerConditionNewCusBoni?: number;
    customerConditionPot?: number;
    autoPostCode?: string | undefined;
    dpo?: number;
    dso?: number;
    dio?: number;
    icFeeSales?: number;
    pricePush?: number;
    ppUsdUnApplied?: number;
    ppEurUnApplied?: number;
    ppChfUnApplied?: number;
    ppUnAppliedTotalLcy?: number;
    billToCustomerNo?: string | undefined;
    icMarginSales?: number;
    billToCountryCode?: string | undefined;
    sellToCountryCode?: string | undefined;
    shipToCountryCode?: string | undefined;
    aoI?: number;
    rowVersion?: string | undefined;

    constructor(data?: IMarginCorrectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryNo = _data["EntryNo"];
            this.itemNo = _data["ItemNo"];
            this.description = _data["Description"];
            this.currency = _data["Currency"];
            this.currentUnitCost = _data["CurrentUnitCost"];
            this.cogsAvg = _data["CogsAvg"];
            this.salesQty = _data["SalesQty"];
            this.sales = _data["Sales"];
            this.salesPriceAvg = _data["SalesPriceAvg"];
            this.profit = _data["Profit"];
            this.profitPercent = _data["ProfitPercent"];
            this.vpUsd = _data["VpUsd"];
            this.vpEur = _data["VpEur"];
            this.mr = _data["Mr"];
            this.comments = _data["Comments"];
            this.nmPercent = _data["NmPercent"];
            this.pm = _data["Pm"];
            this.brand = _data["Brand"];
            this.postingDate = _data["PostingDate"] ? DateTime.fromISO(_data["PostingDate"].toString()) : undefined as any;
            this.week = _data["Week"];
            this.month = _data["Month"];
            this.salesperson = _data["Salesperson"];
            this.customerNo = _data["CustomerNo"];
            this.customerName = _data["CustomerName"];
            this.customerTier = _data["CustomerTier"];
            this.customerNamedAccount = _data["CustomerNamedAccount"];
            this.salesType = _data["SalesType"];
            this.vendorNo = _data["VendorNo"];
            this.vendorName = _data["VendorName"];
            this.priceGroup = _data["PriceGroup"];
            this.correctedMargin = _data["CorrectedMargin"];
            this.fileName = _data["FileName"];
            this.fileRowNo = _data["FileRowNo"];
            this.dateUploaded = _data["DateUploaded"] ? DateTime.fromISO(_data["DateUploaded"].toString()) : undefined as any;
            this.userUploaded = _data["UserUploaded"];
            this.brandCode = _data["BrandCode"];
            this.brandSubCode = _data["BrandSubCode"];
            this.budgetRuleCode = _data["BudgetRuleCode"];
            this.lineCheck = _data["LineCheck"];
            this.budgetGroup = _data["BudgetGroup"];
            this.excludeDailyStat = _data["ExcludeDailyStat"];
            this.documentType = _data["DocumentType"];
            this.documentNo = _data["DocumentNo"];
            this.vpChf = _data["VpChf"];
            this.documentLineNo = _data["DocumentLineNo"];
            this.downChargePercent = _data["DownChargePercent"];
            this.orderNo = _data["OrderNo"];
            this.vpComments = _data["VpComments"];
            this.lastDateModified = _data["LastDateModified"] ? DateTime.fromISO(_data["LastDateModified"].toString()) : undefined as any;
            this.lastPmModified = _data["LastPmModified"];
            this.valueEntryNo = _data["ValueEntryNo"];
            this.mrInitial = _data["MrInitial"];
            this.commentsInitial = _data["CommentsInitial"];
            this.usdRate = _data["UsdRate"];
            this.eurRate = _data["EurRate"];
            this.entryType = _data["EntryType"];
            this.siChf = _data["SiChf"];
            this.skipProjection = _data["SkipProjection"];
            this.mrDirect = _data["MrDirect"];
            this.currencyCorrection = _data["CurrencyCorrection"];
            this.currencyCorrectionPercent = _data["CurrencyCorrectionPercent"];
            this.currencyCorrectionRate = _data["CurrencyCorrectionRate"];
            this.ruleError = _data["RuleError"];
            this.ruleErrorText = _data["RuleErrorText"];
            this.corrValueEntryNo = _data["CorrValueEntryNo"];
            this.eurUsdRate = _data["EurUsdRate"];
            this.fixCurrency = _data["FixCurrency"];
            this.documentCurrency = _data["DocumentCurrency"];
            this.documentSalesPrice = _data["DocumentSalesPrice"];
            this.documentSalesAmount = _data["DocumentSalesAmount"];
            this.ruleErrorStatus = _data["RuleErrorStatus"];
            this.feeAmount = _data["FeeAmount"];
            this.pp = _data["Pp"];
            this.ppCurrency = _data["PpCurrency"];
            this.ppUsd = _data["PpUsd"];
            this.ppEur = _data["PpEur"];
            this.ppChf = _data["PpChf"];
            this.dealId = _data["DealId"];
            this.lineDiscountAmount = _data["LineDiscountAmount"];
            this.serviceCost = _data["ServiceCost"];
            this.locationCode = _data["LocationCode"];
            this.costAmountActual = _data["CostAmountActual"];
            this.nmOld = _data["NmOld"];
            this.nmPercentOld = _data["NmPercentOld"];
            this.exRateId = _data["ExRateId"];
            this.pipsType = _data["PipsType"];
            this.ppUsdTotal = _data["PpUsdTotal"];
            this.ppEurTotal = _data["PpEurTotal"];
            this.ppChfTotal = _data["PpChfTotal"];
            this.lbtUnitCost = _data["LbtUnitCost"];
            this.lbtProfitPercent = _data["LbtProfitPercent"];
            this.customerConditionBoni = _data["CustomerConditionBoni"];
            this.customerConditionCond3P = _data["CustomerConditionCond3P"];
            this.customerConditionKulanz = _data["CustomerConditionKulanz"];
            this.customerConditionPayment = _data["CustomerConditionPayment"];
            this.customerConditionWkz = _data["CustomerConditionWkz"];
            this.customerConditionFreeShipment = _data["CustomerConditionFreeShipment"];
            this.customerConditionInterest = _data["CustomerConditionInterest"];
            this.customerConditionNewCusBoni = _data["CustomerConditionNewCusBoni"];
            this.customerConditionPot = _data["CustomerConditionPot"];
            this.autoPostCode = _data["AutoPostCode"];
            this.dpo = _data["Dpo"];
            this.dso = _data["Dso"];
            this.dio = _data["Dio"];
            this.icFeeSales = _data["IcFeeSales"];
            this.pricePush = _data["PricePush"];
            this.ppUsdUnApplied = _data["PpUsdUnApplied"];
            this.ppEurUnApplied = _data["PpEurUnApplied"];
            this.ppChfUnApplied = _data["PpChfUnApplied"];
            this.ppUnAppliedTotalLcy = _data["PpUnAppliedTotalLcy"];
            this.billToCustomerNo = _data["BillToCustomerNo"];
            this.icMarginSales = _data["IcMarginSales"];
            this.billToCountryCode = _data["BillToCountryCode"];
            this.sellToCountryCode = _data["SellToCountryCode"];
            this.shipToCountryCode = _data["ShipToCountryCode"];
            this.aoI = _data["AoI"];
            this.rowVersion = _data["RowVersion"];
        }
    }

    static fromJS(data: any): MarginCorrectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MarginCorrectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EntryNo"] = this.entryNo;
        data["ItemNo"] = this.itemNo;
        data["Description"] = this.description;
        data["Currency"] = this.currency;
        data["CurrentUnitCost"] = this.currentUnitCost;
        data["CogsAvg"] = this.cogsAvg;
        data["SalesQty"] = this.salesQty;
        data["Sales"] = this.sales;
        data["SalesPriceAvg"] = this.salesPriceAvg;
        data["Profit"] = this.profit;
        data["ProfitPercent"] = this.profitPercent;
        data["VpUsd"] = this.vpUsd;
        data["VpEur"] = this.vpEur;
        data["Mr"] = this.mr;
        data["Comments"] = this.comments;
        data["NmPercent"] = this.nmPercent;
        data["Pm"] = this.pm;
        data["Brand"] = this.brand;
        data["PostingDate"] = this.postingDate ? this.postingDate.toString() : undefined as any;
        data["Week"] = this.week;
        data["Month"] = this.month;
        data["Salesperson"] = this.salesperson;
        data["CustomerNo"] = this.customerNo;
        data["CustomerName"] = this.customerName;
        data["CustomerTier"] = this.customerTier;
        data["CustomerNamedAccount"] = this.customerNamedAccount;
        data["SalesType"] = this.salesType;
        data["VendorNo"] = this.vendorNo;
        data["VendorName"] = this.vendorName;
        data["PriceGroup"] = this.priceGroup;
        data["CorrectedMargin"] = this.correctedMargin;
        data["FileName"] = this.fileName;
        data["FileRowNo"] = this.fileRowNo;
        data["DateUploaded"] = this.dateUploaded ? this.dateUploaded.toString() : undefined as any;
        data["UserUploaded"] = this.userUploaded;
        data["BrandCode"] = this.brandCode;
        data["BrandSubCode"] = this.brandSubCode;
        data["BudgetRuleCode"] = this.budgetRuleCode;
        data["LineCheck"] = this.lineCheck;
        data["BudgetGroup"] = this.budgetGroup;
        data["ExcludeDailyStat"] = this.excludeDailyStat;
        data["DocumentType"] = this.documentType;
        data["DocumentNo"] = this.documentNo;
        data["VpChf"] = this.vpChf;
        data["DocumentLineNo"] = this.documentLineNo;
        data["DownChargePercent"] = this.downChargePercent;
        data["OrderNo"] = this.orderNo;
        data["VpComments"] = this.vpComments;
        data["LastDateModified"] = this.lastDateModified ? this.lastDateModified.toString() : undefined as any;
        data["LastPmModified"] = this.lastPmModified;
        data["ValueEntryNo"] = this.valueEntryNo;
        data["MrInitial"] = this.mrInitial;
        data["CommentsInitial"] = this.commentsInitial;
        data["UsdRate"] = this.usdRate;
        data["EurRate"] = this.eurRate;
        data["EntryType"] = this.entryType;
        data["SiChf"] = this.siChf;
        data["SkipProjection"] = this.skipProjection;
        data["MrDirect"] = this.mrDirect;
        data["CurrencyCorrection"] = this.currencyCorrection;
        data["CurrencyCorrectionPercent"] = this.currencyCorrectionPercent;
        data["CurrencyCorrectionRate"] = this.currencyCorrectionRate;
        data["RuleError"] = this.ruleError;
        data["RuleErrorText"] = this.ruleErrorText;
        data["CorrValueEntryNo"] = this.corrValueEntryNo;
        data["EurUsdRate"] = this.eurUsdRate;
        data["FixCurrency"] = this.fixCurrency;
        data["DocumentCurrency"] = this.documentCurrency;
        data["DocumentSalesPrice"] = this.documentSalesPrice;
        data["DocumentSalesAmount"] = this.documentSalesAmount;
        data["RuleErrorStatus"] = this.ruleErrorStatus;
        data["FeeAmount"] = this.feeAmount;
        data["Pp"] = this.pp;
        data["PpCurrency"] = this.ppCurrency;
        data["PpUsd"] = this.ppUsd;
        data["PpEur"] = this.ppEur;
        data["PpChf"] = this.ppChf;
        data["DealId"] = this.dealId;
        data["LineDiscountAmount"] = this.lineDiscountAmount;
        data["ServiceCost"] = this.serviceCost;
        data["LocationCode"] = this.locationCode;
        data["CostAmountActual"] = this.costAmountActual;
        data["NmOld"] = this.nmOld;
        data["NmPercentOld"] = this.nmPercentOld;
        data["ExRateId"] = this.exRateId;
        data["PipsType"] = this.pipsType;
        data["PpUsdTotal"] = this.ppUsdTotal;
        data["PpEurTotal"] = this.ppEurTotal;
        data["PpChfTotal"] = this.ppChfTotal;
        data["LbtUnitCost"] = this.lbtUnitCost;
        data["LbtProfitPercent"] = this.lbtProfitPercent;
        data["CustomerConditionBoni"] = this.customerConditionBoni;
        data["CustomerConditionCond3P"] = this.customerConditionCond3P;
        data["CustomerConditionKulanz"] = this.customerConditionKulanz;
        data["CustomerConditionPayment"] = this.customerConditionPayment;
        data["CustomerConditionWkz"] = this.customerConditionWkz;
        data["CustomerConditionFreeShipment"] = this.customerConditionFreeShipment;
        data["CustomerConditionInterest"] = this.customerConditionInterest;
        data["CustomerConditionNewCusBoni"] = this.customerConditionNewCusBoni;
        data["CustomerConditionPot"] = this.customerConditionPot;
        data["AutoPostCode"] = this.autoPostCode;
        data["Dpo"] = this.dpo;
        data["Dso"] = this.dso;
        data["Dio"] = this.dio;
        data["IcFeeSales"] = this.icFeeSales;
        data["PricePush"] = this.pricePush;
        data["PpUsdUnApplied"] = this.ppUsdUnApplied;
        data["PpEurUnApplied"] = this.ppEurUnApplied;
        data["PpChfUnApplied"] = this.ppChfUnApplied;
        data["PpUnAppliedTotalLcy"] = this.ppUnAppliedTotalLcy;
        data["BillToCustomerNo"] = this.billToCustomerNo;
        data["IcMarginSales"] = this.icMarginSales;
        data["BillToCountryCode"] = this.billToCountryCode;
        data["SellToCountryCode"] = this.sellToCountryCode;
        data["ShipToCountryCode"] = this.shipToCountryCode;
        data["AoI"] = this.aoI;
        data["RowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IMarginCorrectionDTO {
    entryNo?: number;
    itemNo?: string | undefined;
    description?: string | undefined;
    currency?: string | undefined;
    currentUnitCost?: number;
    cogsAvg?: number;
    salesQty?: number;
    sales?: number;
    salesPriceAvg?: number;
    profit?: number;
    profitPercent?: number;
    vpUsd?: number;
    vpEur?: number;
    mr?: number;
    comments?: string | undefined;
    nmPercent?: number;
    pm?: string | undefined;
    brand?: string | undefined;
    postingDate?: DateTime;
    week?: string | undefined;
    month?: string | undefined;
    salesperson?: string | undefined;
    customerNo?: string | undefined;
    customerName?: string | undefined;
    customerTier?: string | undefined;
    customerNamedAccount?: string | undefined;
    salesType?: string | undefined;
    vendorNo?: string | undefined;
    vendorName?: string | undefined;
    priceGroup?: string | undefined;
    correctedMargin?: number;
    fileName?: string | undefined;
    fileRowNo?: number;
    dateUploaded?: DateTime;
    userUploaded?: string | undefined;
    brandCode?: string | undefined;
    brandSubCode?: string | undefined;
    budgetRuleCode?: string | undefined;
    lineCheck?: boolean;
    budgetGroup?: number;
    excludeDailyStat?: boolean;
    documentType?: number;
    documentNo?: string | undefined;
    vpChf?: number;
    documentLineNo?: number;
    downChargePercent?: number;
    orderNo?: string | undefined;
    vpComments?: string | undefined;
    lastDateModified?: DateTime;
    lastPmModified?: string | undefined;
    valueEntryNo?: number;
    mrInitial?: number;
    commentsInitial?: string | undefined;
    usdRate?: number;
    eurRate?: number;
    entryType?: number;
    siChf?: number;
    skipProjection?: boolean;
    mrDirect?: number;
    currencyCorrection?: number;
    currencyCorrectionPercent?: number;
    currencyCorrectionRate?: number;
    ruleError?: boolean;
    ruleErrorText?: string | undefined;
    corrValueEntryNo?: number;
    eurUsdRate?: number;
    fixCurrency?: boolean;
    documentCurrency?: string | undefined;
    documentSalesPrice?: number;
    documentSalesAmount?: number;
    ruleErrorStatus?: number;
    feeAmount?: number;
    pp?: number;
    ppCurrency?: string | undefined;
    ppUsd?: number;
    ppEur?: number;
    ppChf?: number;
    dealId?: number;
    lineDiscountAmount?: number;
    serviceCost?: number;
    locationCode?: string | undefined;
    costAmountActual?: number;
    nmOld?: number;
    nmPercentOld?: number;
    exRateId?: number;
    pipsType?: number;
    ppUsdTotal?: number;
    ppEurTotal?: number;
    ppChfTotal?: number;
    lbtUnitCost?: number;
    lbtProfitPercent?: number;
    customerConditionBoni?: number;
    customerConditionCond3P?: number;
    customerConditionKulanz?: number;
    customerConditionPayment?: number;
    customerConditionWkz?: number;
    customerConditionFreeShipment?: number;
    customerConditionInterest?: number;
    customerConditionNewCusBoni?: number;
    customerConditionPot?: number;
    autoPostCode?: string | undefined;
    dpo?: number;
    dso?: number;
    dio?: number;
    icFeeSales?: number;
    pricePush?: number;
    ppUsdUnApplied?: number;
    ppEurUnApplied?: number;
    ppChfUnApplied?: number;
    ppUnAppliedTotalLcy?: number;
    billToCustomerNo?: string | undefined;
    icMarginSales?: number;
    billToCountryCode?: string | undefined;
    sellToCountryCode?: string | undefined;
    shipToCountryCode?: string | undefined;
    aoI?: number;
    rowVersion?: string | undefined;
}

export class PriceListSalesHistoryDTO implements IPriceListSalesHistoryDTO {
    id?: number;
    itemNo?: string | undefined;
    locationCode?: string | undefined;
    companyGroupCode?: string | undefined;
    customerPriceGroup?: string | undefined;
    customerNo?: string | undefined;
    customerName?: string | undefined;
    stockAll?: number | undefined;
    stockZl?: number | undefined;
    stockMain?: number | undefined;
    stockAt?: number | undefined;
    stockBe?: number | undefined;
    stockTransit?: number | undefined;
    agingStateColor?: string | undefined;
    agingStateColorMain?: string | undefined;
    agingStateColorZl?: string | undefined;
    agingQuantityAverage?: number | undefined;
    icPrice?: number | undefined;
    icCurrency?: string | undefined;
    icMarginPercent?: number | undefined;
    icShortageMarginPercent?: number | undefined;
    costPriceIcNet?: number | undefined;
    currencySales?: string | undefined;
    costPriceN1?: number | undefined;
    salesMarginItemShortagePercent?: number | undefined;
    salesMarginItemCustomerPercent?: number | undefined;
    salesMarginItemCustomerFixPercent?: number | undefined;
    salesMarginTotalPercent?: number | undefined;
    fixedPrice?: boolean | undefined;
    fixedPriceDateStart?: DateTime | undefined;
    fixedPriceDateEnd?: DateTime | undefined;
    fixedCustomerPriceInvoice?: number | undefined;
    fixedGrossMarginPercent?: number | undefined;
    fixedGrossMarginAmount?: number | undefined;
    fixedCustomerPriceInvoiceMin?: number | undefined;
    fixedCustomerPriceInvoiceMinBeforeConditions?: number | undefined;
    netSalesBeforeLetter?: number | undefined;
    letterAmount?: number | undefined;
    netSalesExclFee?: number | undefined;
    feeAmount?: number | undefined;
    netSalesInclFee?: number | undefined;
    customerPriceInvoice?: number | undefined;
    approvalState?: string | undefined;
    updatedAt?: DateTime | undefined;
    updatedBy?: string | undefined;
    shortageCode?: string | undefined;
    grossMarginSalesPercent?: number | undefined;
    indicativeSalesPrice?: number | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IPriceListSalesHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.itemNo = _data["ItemNo"];
            this.locationCode = _data["LocationCode"];
            this.companyGroupCode = _data["CompanyGroupCode"];
            this.customerPriceGroup = _data["CustomerPriceGroup"];
            this.customerNo = _data["CustomerNo"];
            this.customerName = _data["CustomerName"];
            this.stockAll = _data["StockAll"];
            this.stockZl = _data["StockZl"];
            this.stockMain = _data["StockMain"];
            this.stockAt = _data["StockAt"];
            this.stockBe = _data["StockBe"];
            this.stockTransit = _data["StockTransit"];
            this.agingStateColor = _data["AgingStateColor"];
            this.agingStateColorMain = _data["AgingStateColorMain"];
            this.agingStateColorZl = _data["AgingStateColorZl"];
            this.agingQuantityAverage = _data["AgingQuantityAverage"];
            this.icPrice = _data["IcPrice"];
            this.icCurrency = _data["IcCurrency"];
            this.icMarginPercent = _data["IcMarginPercent"];
            this.icShortageMarginPercent = _data["IcShortageMarginPercent"];
            this.costPriceIcNet = _data["CostPriceIcNet"];
            this.currencySales = _data["CurrencySales"];
            this.costPriceN1 = _data["CostPriceN1"];
            this.salesMarginItemShortagePercent = _data["SalesMarginItemShortagePercent"];
            this.salesMarginItemCustomerPercent = _data["SalesMarginItemCustomerPercent"];
            this.salesMarginItemCustomerFixPercent = _data["SalesMarginItemCustomerFixPercent"];
            this.salesMarginTotalPercent = _data["SalesMarginTotalPercent"];
            this.fixedPrice = _data["FixedPrice"];
            this.fixedPriceDateStart = _data["FixedPriceDateStart"] ? DateTime.fromISO(_data["FixedPriceDateStart"].toString()) : undefined as any;
            this.fixedPriceDateEnd = _data["FixedPriceDateEnd"] ? DateTime.fromISO(_data["FixedPriceDateEnd"].toString()) : undefined as any;
            this.fixedCustomerPriceInvoice = _data["FixedCustomerPriceInvoice"];
            this.fixedGrossMarginPercent = _data["FixedGrossMarginPercent"];
            this.fixedGrossMarginAmount = _data["FixedGrossMarginAmount"];
            this.fixedCustomerPriceInvoiceMin = _data["FixedCustomerPriceInvoiceMin"];
            this.fixedCustomerPriceInvoiceMinBeforeConditions = _data["FixedCustomerPriceInvoiceMinBeforeConditions"];
            this.netSalesBeforeLetter = _data["NetSalesBeforeLetter"];
            this.letterAmount = _data["LetterAmount"];
            this.netSalesExclFee = _data["NetSalesExclFee"];
            this.feeAmount = _data["FeeAmount"];
            this.netSalesInclFee = _data["NetSalesInclFee"];
            this.customerPriceInvoice = _data["CustomerPriceInvoice"];
            this.approvalState = _data["ApprovalState"];
            this.updatedAt = _data["UpdatedAt"] ? DateTime.fromISO(_data["UpdatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["UpdatedBy"];
            this.shortageCode = _data["ShortageCode"];
            this.grossMarginSalesPercent = _data["GrossMarginSalesPercent"];
            this.indicativeSalesPrice = _data["IndicativeSalesPrice"];
            this.rowVersion = _data["RowVersion"];
        }
    }

    static fromJS(data: any): PriceListSalesHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListSalesHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ItemNo"] = this.itemNo;
        data["LocationCode"] = this.locationCode;
        data["CompanyGroupCode"] = this.companyGroupCode;
        data["CustomerPriceGroup"] = this.customerPriceGroup;
        data["CustomerNo"] = this.customerNo;
        data["CustomerName"] = this.customerName;
        data["StockAll"] = this.stockAll;
        data["StockZl"] = this.stockZl;
        data["StockMain"] = this.stockMain;
        data["StockAt"] = this.stockAt;
        data["StockBe"] = this.stockBe;
        data["StockTransit"] = this.stockTransit;
        data["AgingStateColor"] = this.agingStateColor;
        data["AgingStateColorMain"] = this.agingStateColorMain;
        data["AgingStateColorZl"] = this.agingStateColorZl;
        data["AgingQuantityAverage"] = this.agingQuantityAverage;
        data["IcPrice"] = this.icPrice;
        data["IcCurrency"] = this.icCurrency;
        data["IcMarginPercent"] = this.icMarginPercent;
        data["IcShortageMarginPercent"] = this.icShortageMarginPercent;
        data["CostPriceIcNet"] = this.costPriceIcNet;
        data["CurrencySales"] = this.currencySales;
        data["CostPriceN1"] = this.costPriceN1;
        data["SalesMarginItemShortagePercent"] = this.salesMarginItemShortagePercent;
        data["SalesMarginItemCustomerPercent"] = this.salesMarginItemCustomerPercent;
        data["SalesMarginItemCustomerFixPercent"] = this.salesMarginItemCustomerFixPercent;
        data["SalesMarginTotalPercent"] = this.salesMarginTotalPercent;
        data["FixedPrice"] = this.fixedPrice;
        data["FixedPriceDateStart"] = this.fixedPriceDateStart ? this.fixedPriceDateStart.toString() : undefined as any;
        data["FixedPriceDateEnd"] = this.fixedPriceDateEnd ? this.fixedPriceDateEnd.toString() : undefined as any;
        data["FixedCustomerPriceInvoice"] = this.fixedCustomerPriceInvoice;
        data["FixedGrossMarginPercent"] = this.fixedGrossMarginPercent;
        data["FixedGrossMarginAmount"] = this.fixedGrossMarginAmount;
        data["FixedCustomerPriceInvoiceMin"] = this.fixedCustomerPriceInvoiceMin;
        data["FixedCustomerPriceInvoiceMinBeforeConditions"] = this.fixedCustomerPriceInvoiceMinBeforeConditions;
        data["NetSalesBeforeLetter"] = this.netSalesBeforeLetter;
        data["LetterAmount"] = this.letterAmount;
        data["NetSalesExclFee"] = this.netSalesExclFee;
        data["FeeAmount"] = this.feeAmount;
        data["NetSalesInclFee"] = this.netSalesInclFee;
        data["CustomerPriceInvoice"] = this.customerPriceInvoice;
        data["ApprovalState"] = this.approvalState;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toString() : undefined as any;
        data["UpdatedBy"] = this.updatedBy;
        data["ShortageCode"] = this.shortageCode;
        data["GrossMarginSalesPercent"] = this.grossMarginSalesPercent;
        data["IndicativeSalesPrice"] = this.indicativeSalesPrice;
        data["RowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IPriceListSalesHistoryDTO {
    id?: number;
    itemNo?: string | undefined;
    locationCode?: string | undefined;
    companyGroupCode?: string | undefined;
    customerPriceGroup?: string | undefined;
    customerNo?: string | undefined;
    customerName?: string | undefined;
    stockAll?: number | undefined;
    stockZl?: number | undefined;
    stockMain?: number | undefined;
    stockAt?: number | undefined;
    stockBe?: number | undefined;
    stockTransit?: number | undefined;
    agingStateColor?: string | undefined;
    agingStateColorMain?: string | undefined;
    agingStateColorZl?: string | undefined;
    agingQuantityAverage?: number | undefined;
    icPrice?: number | undefined;
    icCurrency?: string | undefined;
    icMarginPercent?: number | undefined;
    icShortageMarginPercent?: number | undefined;
    costPriceIcNet?: number | undefined;
    currencySales?: string | undefined;
    costPriceN1?: number | undefined;
    salesMarginItemShortagePercent?: number | undefined;
    salesMarginItemCustomerPercent?: number | undefined;
    salesMarginItemCustomerFixPercent?: number | undefined;
    salesMarginTotalPercent?: number | undefined;
    fixedPrice?: boolean | undefined;
    fixedPriceDateStart?: DateTime | undefined;
    fixedPriceDateEnd?: DateTime | undefined;
    fixedCustomerPriceInvoice?: number | undefined;
    fixedGrossMarginPercent?: number | undefined;
    fixedGrossMarginAmount?: number | undefined;
    fixedCustomerPriceInvoiceMin?: number | undefined;
    fixedCustomerPriceInvoiceMinBeforeConditions?: number | undefined;
    netSalesBeforeLetter?: number | undefined;
    letterAmount?: number | undefined;
    netSalesExclFee?: number | undefined;
    feeAmount?: number | undefined;
    netSalesInclFee?: number | undefined;
    customerPriceInvoice?: number | undefined;
    approvalState?: string | undefined;
    updatedAt?: DateTime | undefined;
    updatedBy?: string | undefined;
    shortageCode?: string | undefined;
    grossMarginSalesPercent?: number | undefined;
    indicativeSalesPrice?: number | undefined;
    rowVersion?: string | undefined;
}

export class SendPriceAutomationProposalsResponseDTO implements ISendPriceAutomationProposalsResponseDTO {
    responses?: SendPriceAutomationProposalResponseDTO[] | undefined;

    constructor(data?: ISendPriceAutomationProposalsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Responses"])) {
                this.responses = [] as any;
                for (let item of _data["Responses"])
                    this.responses!.push(SendPriceAutomationProposalResponseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendPriceAutomationProposalsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendPriceAutomationProposalsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responses)) {
            data["Responses"] = [];
            for (let item of this.responses)
                data["Responses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISendPriceAutomationProposalsResponseDTO {
    responses?: SendPriceAutomationProposalResponseDTO[] | undefined;
}

export class SendPriceAutomationProposalResponseDTO implements ISendPriceAutomationProposalResponseDTO {
    pAId?: string | undefined;
    success?: boolean;
    message?: string | undefined;

    constructor(data?: ISendPriceAutomationProposalResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pAId = _data["PAId"];
            this.success = _data["Success"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): SendPriceAutomationProposalResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendPriceAutomationProposalResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PAId"] = this.pAId;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface ISendPriceAutomationProposalResponseDTO {
    pAId?: string | undefined;
    success?: boolean;
    message?: string | undefined;
}

export class SendPriceAutomationProposalsDTO implements ISendPriceAutomationProposalsDTO {
    proposals?: EconworkPAProposalDTO[] | undefined;

    constructor(data?: ISendPriceAutomationProposalsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Proposals"])) {
                this.proposals = [] as any;
                for (let item of _data["Proposals"])
                    this.proposals!.push(EconworkPAProposalDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendPriceAutomationProposalsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendPriceAutomationProposalsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.proposals)) {
            data["Proposals"] = [];
            for (let item of this.proposals)
                data["Proposals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISendPriceAutomationProposalsDTO {
    proposals?: EconworkPAProposalDTO[] | undefined;
}

export class EconworkPAProposalDTO implements IEconworkPAProposalDTO {
    pAId?: string | undefined;
    itemNo?: string | undefined;
    companyGroupCode?: string | undefined;
    customerPriceGroup?: string | undefined;
    customerNo?: string | undefined;
    itemCustomerPercentProposal?: number;
    dataOperation?: PriceAutomationProposalDataOperation;

    constructor(data?: IEconworkPAProposalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pAId = _data["PAId"];
            this.itemNo = _data["ItemNo"];
            this.companyGroupCode = _data["CompanyGroupCode"];
            this.customerPriceGroup = _data["CustomerPriceGroup"];
            this.customerNo = _data["CustomerNo"];
            this.itemCustomerPercentProposal = _data["ItemCustomerPercentProposal"];
            this.dataOperation = _data["DataOperation"];
        }
    }

    static fromJS(data: any): EconworkPAProposalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EconworkPAProposalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PAId"] = this.pAId;
        data["ItemNo"] = this.itemNo;
        data["CompanyGroupCode"] = this.companyGroupCode;
        data["CustomerPriceGroup"] = this.customerPriceGroup;
        data["CustomerNo"] = this.customerNo;
        data["ItemCustomerPercentProposal"] = this.itemCustomerPercentProposal;
        data["DataOperation"] = this.dataOperation;
        return data;
    }
}

export interface IEconworkPAProposalDTO {
    pAId?: string | undefined;
    itemNo?: string | undefined;
    companyGroupCode?: string | undefined;
    customerPriceGroup?: string | undefined;
    customerNo?: string | undefined;
    itemCustomerPercentProposal?: number;
    dataOperation?: PriceAutomationProposalDataOperation;
}

export enum PriceAutomationProposalDataOperation {
    New = 0,
    Update = 1,
    Delete = 2,
}

export class GetEncowayCountryProductPriceResponseDTO implements IGetEncowayCountryProductPriceResponseDTO {
    products?: EncowayCountryProductPriceDTO[] | undefined;
    totalProducts?: number;

    constructor(data?: IGetEncowayCountryProductPriceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(EncowayCountryProductPriceDTO.fromJS(item));
            }
            this.totalProducts = _data["TotalProducts"];
        }
    }

    static fromJS(data: any): GetEncowayCountryProductPriceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetEncowayCountryProductPriceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalProducts"] = this.totalProducts;
        return data;
    }
}

export interface IGetEncowayCountryProductPriceResponseDTO {
    products?: EncowayCountryProductPriceDTO[] | undefined;
    totalProducts?: number;
}

export class EncowayCountryProductPriceDTO implements IEncowayCountryProductPriceDTO {
    sKU?: string | undefined;
    backlogClass?: string | undefined;
    b2BPricewithVAT?: number;
    b2BPricewithoutVAT?: number;
    b2BPromowithVAT?: number;
    b2BPromowithoutVAT?: number;
    b2BCurrencyCode?: string | undefined;
    b2CPricewithVAT?: number;
    b2CPricewithoutVAT?: number;
    b2CPromowithVAT?: number;
    b2CPromowithoutVAT?: number;
    b2CCurrencyCode?: string | undefined;

    constructor(data?: IEncowayCountryProductPriceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.backlogClass = _data["BacklogClass"];
            this.b2BPricewithVAT = _data["B2BPricewithVAT"];
            this.b2BPricewithoutVAT = _data["B2BPricewithoutVAT"];
            this.b2BPromowithVAT = _data["B2BPromowithVAT"];
            this.b2BPromowithoutVAT = _data["B2BPromowithoutVAT"];
            this.b2BCurrencyCode = _data["B2BCurrencyCode"];
            this.b2CPricewithVAT = _data["B2CPricewithVAT"];
            this.b2CPricewithoutVAT = _data["B2CPricewithoutVAT"];
            this.b2CPromowithVAT = _data["B2CPromowithVAT"];
            this.b2CPromowithoutVAT = _data["B2CPromowithoutVAT"];
            this.b2CCurrencyCode = _data["B2CCurrencyCode"];
        }
    }

    static fromJS(data: any): EncowayCountryProductPriceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EncowayCountryProductPriceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["BacklogClass"] = this.backlogClass;
        data["B2BPricewithVAT"] = this.b2BPricewithVAT;
        data["B2BPricewithoutVAT"] = this.b2BPricewithoutVAT;
        data["B2BPromowithVAT"] = this.b2BPromowithVAT;
        data["B2BPromowithoutVAT"] = this.b2BPromowithoutVAT;
        data["B2BCurrencyCode"] = this.b2BCurrencyCode;
        data["B2CPricewithVAT"] = this.b2CPricewithVAT;
        data["B2CPricewithoutVAT"] = this.b2CPricewithoutVAT;
        data["B2CPromowithVAT"] = this.b2CPromowithVAT;
        data["B2CPromowithoutVAT"] = this.b2CPromowithoutVAT;
        data["B2CCurrencyCode"] = this.b2CCurrencyCode;
        return data;
    }
}

export interface IEncowayCountryProductPriceDTO {
    sKU?: string | undefined;
    backlogClass?: string | undefined;
    b2BPricewithVAT?: number;
    b2BPricewithoutVAT?: number;
    b2BPromowithVAT?: number;
    b2BPromowithoutVAT?: number;
    b2BCurrencyCode?: string | undefined;
    b2CPricewithVAT?: number;
    b2CPricewithoutVAT?: number;
    b2CPromowithVAT?: number;
    b2CPromowithoutVAT?: number;
    b2CCurrencyCode?: string | undefined;
}

export class EncowayGetCountryStockResponseDTO implements IEncowayGetCountryStockResponseDTO {
    products?: EncowayCountryStockDTO[] | undefined;
    totalProducts?: number;

    constructor(data?: IEncowayGetCountryStockResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(EncowayCountryStockDTO.fromJS(item));
            }
            this.totalProducts = _data["TotalProducts"];
        }
    }

    static fromJS(data: any): EncowayGetCountryStockResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EncowayGetCountryStockResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalProducts"] = this.totalProducts;
        return data;
    }
}

export interface IEncowayGetCountryStockResponseDTO {
    products?: EncowayCountryStockDTO[] | undefined;
    totalProducts?: number;
}

export class EncowayCountryStockDTO implements IEncowayCountryStockDTO {
    sKU?: string | undefined;
    ruleCode?: string | undefined;
    stockText?: string | undefined;

    constructor(data?: IEncowayCountryStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.ruleCode = _data["RuleCode"];
            this.stockText = _data["StockText"];
        }
    }

    static fromJS(data: any): EncowayCountryStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EncowayCountryStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["RuleCode"] = this.ruleCode;
        data["StockText"] = this.stockText;
        return data;
    }
}

export interface IEncowayCountryStockDTO {
    sKU?: string | undefined;
    ruleCode?: string | undefined;
    stockText?: string | undefined;
}

export class EncowayRegisterBtoConfigurationResponseDTO implements IEncowayRegisterBtoConfigurationResponseDTO {
    btoIdentificationNumber?: string | undefined;
    success?: boolean;

    constructor(data?: IEncowayRegisterBtoConfigurationResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.btoIdentificationNumber = _data["BtoIdentificationNumber"];
            this.success = _data["Success"];
        }
    }

    static fromJS(data: any): EncowayRegisterBtoConfigurationResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EncowayRegisterBtoConfigurationResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BtoIdentificationNumber"] = this.btoIdentificationNumber;
        data["Success"] = this.success;
        return data;
    }
}

export interface IEncowayRegisterBtoConfigurationResponseDTO {
    btoIdentificationNumber?: string | undefined;
    success?: boolean;
}

export class EncowayRegisterBtoConfigurationDTO implements IEncowayRegisterBtoConfigurationDTO {
    header?: EncowayBtoConfigurationHeaderDTO | undefined;
    lineItems?: EncowayBtoConfigurationLineItemDTO[] | undefined;

    constructor(data?: IEncowayRegisterBtoConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["Header"] ? EncowayBtoConfigurationHeaderDTO.fromJS(_data["Header"]) : undefined as any;
            if (Array.isArray(_data["LineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["LineItems"])
                    this.lineItems!.push(EncowayBtoConfigurationLineItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EncowayRegisterBtoConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EncowayRegisterBtoConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Header"] = this.header ? this.header.toJSON() : undefined as any;
        if (Array.isArray(this.lineItems)) {
            data["LineItems"] = [];
            for (let item of this.lineItems)
                data["LineItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEncowayRegisterBtoConfigurationDTO {
    header?: EncowayBtoConfigurationHeaderDTO | undefined;
    lineItems?: EncowayBtoConfigurationLineItemDTO[] | undefined;
}

export class EncowayBtoConfigurationHeaderDTO implements IEncowayBtoConfigurationHeaderDTO {
    cpqReference?: string | undefined;
    bareNumber?: string | undefined;
    description?: string | undefined;
    description2?: string | undefined;
    currencyCodeIso?: string | undefined;
    unitPrice?: number;
    weight?: number;

    constructor(data?: IEncowayBtoConfigurationHeaderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cpqReference = _data["CpqReference"];
            this.bareNumber = _data["BareNumber"];
            this.description = _data["Description"];
            this.description2 = _data["Description2"];
            this.currencyCodeIso = _data["CurrencyCodeIso"];
            this.unitPrice = _data["UnitPrice"];
            this.weight = _data["Weight"];
        }
    }

    static fromJS(data: any): EncowayBtoConfigurationHeaderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EncowayBtoConfigurationHeaderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CpqReference"] = this.cpqReference;
        data["BareNumber"] = this.bareNumber;
        data["Description"] = this.description;
        data["Description2"] = this.description2;
        data["CurrencyCodeIso"] = this.currencyCodeIso;
        data["UnitPrice"] = this.unitPrice;
        data["Weight"] = this.weight;
        return data;
    }
}

export interface IEncowayBtoConfigurationHeaderDTO {
    cpqReference?: string | undefined;
    bareNumber?: string | undefined;
    description?: string | undefined;
    description2?: string | undefined;
    currencyCodeIso?: string | undefined;
    unitPrice?: number;
    weight?: number;
}

export class EncowayBtoConfigurationLineItemDTO implements IEncowayBtoConfigurationLineItemDTO {
    componentLineNumber?: number;
    componentNumberSKU?: string | undefined;
    quantity?: number;
    unitPrice?: number;

    constructor(data?: IEncowayBtoConfigurationLineItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentLineNumber = _data["ComponentLineNumber"];
            this.componentNumberSKU = _data["ComponentNumberSKU"];
            this.quantity = _data["Quantity"];
            this.unitPrice = _data["UnitPrice"];
        }
    }

    static fromJS(data: any): EncowayBtoConfigurationLineItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EncowayBtoConfigurationLineItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ComponentLineNumber"] = this.componentLineNumber;
        data["ComponentNumberSKU"] = this.componentNumberSKU;
        data["Quantity"] = this.quantity;
        data["UnitPrice"] = this.unitPrice;
        return data;
    }
}

export interface IEncowayBtoConfigurationLineItemDTO {
    componentLineNumber?: number;
    componentNumberSKU?: string | undefined;
    quantity?: number;
    unitPrice?: number;
}

export class PriceAutomationProposalDTO implements IPriceAutomationProposalDTO {
    id?: number;
    pAId?: string | undefined;
    itemNo?: string | undefined;
    companyGroupCode?: string | undefined;
    customerPriceGroup?: string | undefined;
    customerNo?: string | undefined;
    itemCustomerPercent?: number;
    dataOperation?: PriceAutomationProposalDataOperation;
    syncStatus?: PriceAutomationBitrixSyncStatus;
    rowVersion?: string | undefined;
    createdOn?: DateTime;
    modifiedOn?: DateTime;
    createdBy?: string;
    modifiedBy?: string;

    constructor(data?: IPriceAutomationProposalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.pAId = _data["PAId"];
            this.itemNo = _data["ItemNo"];
            this.companyGroupCode = _data["CompanyGroupCode"];
            this.customerPriceGroup = _data["CustomerPriceGroup"];
            this.customerNo = _data["CustomerNo"];
            this.itemCustomerPercent = _data["ItemCustomerPercent"];
            this.dataOperation = _data["DataOperation"];
            this.syncStatus = _data["SyncStatus"];
            this.rowVersion = _data["RowVersion"];
            this.createdOn = _data["CreatedOn"] ? DateTime.fromISO(_data["CreatedOn"].toString()) : undefined as any;
            this.modifiedOn = _data["ModifiedOn"] ? DateTime.fromISO(_data["ModifiedOn"].toString()) : undefined as any;
            this.createdBy = _data["CreatedBy"];
            this.modifiedBy = _data["ModifiedBy"];
        }
    }

    static fromJS(data: any): PriceAutomationProposalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PriceAutomationProposalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["PAId"] = this.pAId;
        data["ItemNo"] = this.itemNo;
        data["CompanyGroupCode"] = this.companyGroupCode;
        data["CustomerPriceGroup"] = this.customerPriceGroup;
        data["CustomerNo"] = this.customerNo;
        data["ItemCustomerPercent"] = this.itemCustomerPercent;
        data["DataOperation"] = this.dataOperation;
        data["SyncStatus"] = this.syncStatus;
        data["RowVersion"] = this.rowVersion;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IPriceAutomationProposalDTO {
    id?: number;
    pAId?: string | undefined;
    itemNo?: string | undefined;
    companyGroupCode?: string | undefined;
    customerPriceGroup?: string | undefined;
    customerNo?: string | undefined;
    itemCustomerPercent?: number;
    dataOperation?: PriceAutomationProposalDataOperation;
    syncStatus?: PriceAutomationBitrixSyncStatus;
    rowVersion?: string | undefined;
    createdOn?: DateTime;
    modifiedOn?: DateTime;
    createdBy?: string;
    modifiedBy?: string;
}

export enum PriceAutomationBitrixSyncStatus {
    New = 0,
    Transferred = 1,
}

export class SetPriceAutomationProposalsSyncStatusDTO implements ISetPriceAutomationProposalsSyncStatusDTO {
    proposals?: PriceAutomationProposalSyncStatusDTO[] | undefined;

    constructor(data?: ISetPriceAutomationProposalsSyncStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Proposals"])) {
                this.proposals = [] as any;
                for (let item of _data["Proposals"])
                    this.proposals!.push(PriceAutomationProposalSyncStatusDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetPriceAutomationProposalsSyncStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetPriceAutomationProposalsSyncStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.proposals)) {
            data["Proposals"] = [];
            for (let item of this.proposals)
                data["Proposals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetPriceAutomationProposalsSyncStatusDTO {
    proposals?: PriceAutomationProposalSyncStatusDTO[] | undefined;
}

export class PriceAutomationProposalSyncStatusDTO implements IPriceAutomationProposalSyncStatusDTO {
    id?: number;
    rowVersion?: string | undefined;

    constructor(data?: IPriceAutomationProposalSyncStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.rowVersion = _data["RowVersion"];
        }
    }

    static fromJS(data: any): PriceAutomationProposalSyncStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PriceAutomationProposalSyncStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IPriceAutomationProposalSyncStatusDTO {
    id?: number;
    rowVersion?: string | undefined;
}

export abstract class UpdateItemsResultBaseDTO implements IUpdateItemsResultBaseDTO {
    success?: boolean;
    errorText?: string | undefined;

    constructor(data?: IUpdateItemsResultBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.errorText = _data["ErrorText"];
        }
    }

    static fromJS(data: any): UpdateItemsResultBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UpdateItemsResultBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        data["ErrorText"] = this.errorText;
        return data;
    }
}

export interface IUpdateItemsResultBaseDTO {
    success?: boolean;
    errorText?: string | undefined;
}

export class ItemCockpitUpdateItemsResultDTO extends UpdateItemsResultBaseDTO implements IItemCockpitUpdateItemsResultDTO {
    results?: ItemCockpitUpdateItemResultDTO[];

    constructor(data?: IItemCockpitUpdateItemsResultDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(ItemCockpitUpdateItemResultDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ItemCockpitUpdateItemsResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemCockpitUpdateItemsResultDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IItemCockpitUpdateItemsResultDTO extends IUpdateItemsResultBaseDTO {
    results?: ItemCockpitUpdateItemResultDTO[];
}

export abstract class UpdateItemResultDTO implements IUpdateItemResultDTO {
    itemId?: string | undefined;
    success?: boolean;
    errorText?: string | undefined;
    actionType!: UpdateItemActionType;
    results?: UpdateItemDetailResultDTO[];

    constructor(data?: IUpdateItemResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["ItemId"];
            this.success = _data["Success"];
            this.errorText = _data["ErrorText"];
            this.actionType = _data["ActionType"];
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(UpdateItemDetailResultDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateItemResultDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UpdateItemResultDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemId"] = this.itemId;
        data["Success"] = this.success;
        data["ErrorText"] = this.errorText;
        data["ActionType"] = this.actionType;
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateItemResultDTO {
    itemId?: string | undefined;
    success?: boolean;
    errorText?: string | undefined;
    actionType: UpdateItemActionType;
    results?: UpdateItemDetailResultDTO[];
}

export class ItemCockpitUpdateItemResultDTO extends UpdateItemResultDTO implements IItemCockpitUpdateItemResultDTO {

    constructor(data?: IItemCockpitUpdateItemResultDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ItemCockpitUpdateItemResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemCockpitUpdateItemResultDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IItemCockpitUpdateItemResultDTO extends IUpdateItemResultDTO {
}

export enum UpdateItemActionType {
    Modify = 0,
    Insert = 1,
    Delete = 2,
}

export class UpdateItemDetailResultDTO implements IUpdateItemDetailResultDTO {
    fieldName?: string | undefined;
    success?: boolean;
    errorText?: string | undefined;

    constructor(data?: IUpdateItemDetailResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["FieldName"];
            this.success = _data["Success"];
            this.errorText = _data["ErrorText"];
        }
    }

    static fromJS(data: any): UpdateItemDetailResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateItemDetailResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FieldName"] = this.fieldName;
        data["Success"] = this.success;
        data["ErrorText"] = this.errorText;
        return data;
    }
}

export interface IUpdateItemDetailResultDTO {
    fieldName?: string | undefined;
    success?: boolean;
    errorText?: string | undefined;
}

export abstract class UpdateItemsBaseDTO implements IUpdateItemsBaseDTO {

    constructor(data?: IUpdateItemsBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateItemsBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UpdateItemsBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateItemsBaseDTO {
}

export class ItemCockpitUpdateItemsDTO extends UpdateItemsBaseDTO implements IItemCockpitUpdateItemsDTO {
    items?: ItemCockpitUpdateItemDTO[];

    constructor(data?: IItemCockpitUpdateItemsDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ItemCockpitUpdateItemDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ItemCockpitUpdateItemsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemCockpitUpdateItemsDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IItemCockpitUpdateItemsDTO extends IUpdateItemsBaseDTO {
    items?: ItemCockpitUpdateItemDTO[];
}

export abstract class UpdateItemDTO implements IUpdateItemDTO {
    itemId!: string;
    actionType!: UpdateItemActionType;
    updates?: UpdateItemDetailDTO[];

    constructor(data?: IUpdateItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["ItemId"];
            this.actionType = _data["ActionType"];
            if (Array.isArray(_data["Updates"])) {
                this.updates = [] as any;
                for (let item of _data["Updates"])
                    this.updates!.push(UpdateItemDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateItemDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UpdateItemDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemId"] = this.itemId;
        data["ActionType"] = this.actionType;
        if (Array.isArray(this.updates)) {
            data["Updates"] = [];
            for (let item of this.updates)
                data["Updates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateItemDTO {
    itemId: string;
    actionType: UpdateItemActionType;
    updates?: UpdateItemDetailDTO[];
}

export class ItemCockpitUpdateItemDTO extends UpdateItemDTO implements IItemCockpitUpdateItemDTO {

    constructor(data?: IItemCockpitUpdateItemDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ItemCockpitUpdateItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemCockpitUpdateItemDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IItemCockpitUpdateItemDTO extends IUpdateItemDTO {
}

export class UpdateItemDetailDTO implements IUpdateItemDetailDTO {
    fieldName!: string;
    fieldValue?: string | undefined;

    constructor(data?: IUpdateItemDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["FieldName"];
            this.fieldValue = _data["FieldValue"];
        }
    }

    static fromJS(data: any): UpdateItemDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateItemDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FieldName"] = this.fieldName;
        data["FieldValue"] = this.fieldValue;
        return data;
    }
}

export interface IUpdateItemDetailDTO {
    fieldName: string;
    fieldValue?: string | undefined;
}

export class ItemUomUpdateItemsResultDTO extends UpdateItemsResultBaseDTO implements IItemUomUpdateItemsResultDTO {
    results?: ItemUomUpdateItemResultDTO[];

    constructor(data?: IItemUomUpdateItemsResultDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(ItemUomUpdateItemResultDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ItemUomUpdateItemsResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemUomUpdateItemsResultDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IItemUomUpdateItemsResultDTO extends IUpdateItemsResultBaseDTO {
    results?: ItemUomUpdateItemResultDTO[];
}

export class ItemUomUpdateItemResultDTO extends UpdateItemResultDTO implements IItemUomUpdateItemResultDTO {
    code?: string | undefined;

    constructor(data?: IItemUomUpdateItemResultDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["Code"];
        }
    }

    static override fromJS(data: any): ItemUomUpdateItemResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemUomUpdateItemResultDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        super.toJSON(data);
        return data;
    }
}

export interface IItemUomUpdateItemResultDTO extends IUpdateItemResultDTO {
    code?: string | undefined;
}

export class ItemUomUpdateItemsDTO extends UpdateItemsBaseDTO implements IItemUomUpdateItemsDTO {
    items?: ItemUomUpdateItemDTO[];

    constructor(data?: IItemUomUpdateItemsDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ItemUomUpdateItemDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ItemUomUpdateItemsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemUomUpdateItemsDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IItemUomUpdateItemsDTO extends IUpdateItemsBaseDTO {
    items?: ItemUomUpdateItemDTO[];
}

export class ItemUomUpdateItemDTO extends UpdateItemDTO implements IItemUomUpdateItemDTO {
    code!: string;

    constructor(data?: IItemUomUpdateItemDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["Code"];
        }
    }

    static override fromJS(data: any): ItemUomUpdateItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemUomUpdateItemDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        super.toJSON(data);
        return data;
    }
}

export interface IItemUomUpdateItemDTO extends IUpdateItemDTO {
    code: string;
}

export class ItemWarrantyUpdateItemsResultDTO extends UpdateItemsResultBaseDTO implements IItemWarrantyUpdateItemsResultDTO {
    results?: ItemWarrantyUpdateItemResultDTO[];

    constructor(data?: IItemWarrantyUpdateItemsResultDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(ItemWarrantyUpdateItemResultDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ItemWarrantyUpdateItemsResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemWarrantyUpdateItemsResultDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IItemWarrantyUpdateItemsResultDTO extends IUpdateItemsResultBaseDTO {
    results?: ItemWarrantyUpdateItemResultDTO[];
}

export class ItemWarrantyUpdateItemResultDTO extends UpdateItemResultDTO implements IItemWarrantyUpdateItemResultDTO {
    warrantyTermsCode?: string | undefined;

    constructor(data?: IItemWarrantyUpdateItemResultDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.warrantyTermsCode = _data["WarrantyTermsCode"];
        }
    }

    static override fromJS(data: any): ItemWarrantyUpdateItemResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemWarrantyUpdateItemResultDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WarrantyTermsCode"] = this.warrantyTermsCode;
        super.toJSON(data);
        return data;
    }
}

export interface IItemWarrantyUpdateItemResultDTO extends IUpdateItemResultDTO {
    warrantyTermsCode?: string | undefined;
}

export class ItemWarrantyUpdateItemsDTO extends UpdateItemsBaseDTO implements IItemWarrantyUpdateItemsDTO {
    items?: ItemWarrantyUpdateItemDTO[];

    constructor(data?: IItemWarrantyUpdateItemsDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ItemWarrantyUpdateItemDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ItemWarrantyUpdateItemsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemWarrantyUpdateItemsDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IItemWarrantyUpdateItemsDTO extends IUpdateItemsBaseDTO {
    items?: ItemWarrantyUpdateItemDTO[];
}

export class ItemWarrantyUpdateItemDTO extends UpdateItemDTO implements IItemWarrantyUpdateItemDTO {
    warrantyTermsCode!: string;

    constructor(data?: IItemWarrantyUpdateItemDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.warrantyTermsCode = _data["WarrantyTermsCode"];
        }
    }

    static override fromJS(data: any): ItemWarrantyUpdateItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemWarrantyUpdateItemDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WarrantyTermsCode"] = this.warrantyTermsCode;
        super.toJSON(data);
        return data;
    }
}

export interface IItemWarrantyUpdateItemDTO extends IUpdateItemDTO {
    warrantyTermsCode: string;
}

export class PagedResultDTOOfAssetCollectionDTO implements IPagedResultDTOOfAssetCollectionDTO {
    items?: AssetCollectionDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfAssetCollectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(AssetCollectionDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfAssetCollectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfAssetCollectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfAssetCollectionDTO {
    items?: AssetCollectionDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class AssetCollectionDTO implements IAssetCollectionDTO {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    token?: string | undefined;
    isShared?: boolean;
    sharedUntilDate?: DateTime | undefined;
    createdBy?: string | undefined;
    assets?: AssetCollectionAssetDTO[] | undefined;

    constructor(data?: IAssetCollectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.token = _data["Token"];
            this.isShared = _data["IsShared"];
            this.sharedUntilDate = _data["SharedUntilDate"] ? DateTime.fromISO(_data["SharedUntilDate"].toString()) : undefined as any;
            this.createdBy = _data["CreatedBy"];
            if (Array.isArray(_data["Assets"])) {
                this.assets = [] as any;
                for (let item of _data["Assets"])
                    this.assets!.push(AssetCollectionAssetDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetCollectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetCollectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Token"] = this.token;
        data["IsShared"] = this.isShared;
        data["SharedUntilDate"] = this.sharedUntilDate ? this.sharedUntilDate.toString() : undefined as any;
        data["CreatedBy"] = this.createdBy;
        if (Array.isArray(this.assets)) {
            data["Assets"] = [];
            for (let item of this.assets)
                data["Assets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetCollectionDTO {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    token?: string | undefined;
    isShared?: boolean;
    sharedUntilDate?: DateTime | undefined;
    createdBy?: string | undefined;
    assets?: AssetCollectionAssetDTO[] | undefined;
}

export class AssetCollectionAssetDTO implements IAssetCollectionAssetDTO {
    id?: number;
    relativePathAndName?: string | undefined;
    fileLink?: string | undefined;
    publicName?: string | undefined;
    extension?: string | undefined;
    isFile?: boolean;

    constructor(data?: IAssetCollectionAssetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.relativePathAndName = _data["RelativePathAndName"];
            this.fileLink = _data["FileLink"];
            this.publicName = _data["PublicName"];
            this.extension = _data["Extension"];
            this.isFile = _data["IsFile"];
        }
    }

    static fromJS(data: any): AssetCollectionAssetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetCollectionAssetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RelativePathAndName"] = this.relativePathAndName;
        data["FileLink"] = this.fileLink;
        data["PublicName"] = this.publicName;
        data["Extension"] = this.extension;
        data["IsFile"] = this.isFile;
        return data;
    }
}

export interface IAssetCollectionAssetDTO {
    id?: number;
    relativePathAndName?: string | undefined;
    fileLink?: string | undefined;
    publicName?: string | undefined;
    extension?: string | undefined;
    isFile?: boolean;
}

export class PagedResultDTOOfAssetStorageEntryLimitedDTO implements IPagedResultDTOOfAssetStorageEntryLimitedDTO {
    items?: AssetStorageEntryLimitedDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfAssetStorageEntryLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(AssetStorageEntryLimitedDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfAssetStorageEntryLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfAssetStorageEntryLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfAssetStorageEntryLimitedDTO {
    items?: AssetStorageEntryLimitedDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class AssetStorageEntryLimitedDTO implements IAssetStorageEntryLimitedDTO {
    id?: number;
    relativePathAndName?: string | undefined;
    publicName?: string | undefined;
    fileLink?: string | undefined;

    constructor(data?: IAssetStorageEntryLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.relativePathAndName = _data["RelativePathAndName"];
            this.publicName = _data["PublicName"];
            this.fileLink = _data["FileLink"];
        }
    }

    static fromJS(data: any): AssetStorageEntryLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetStorageEntryLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RelativePathAndName"] = this.relativePathAndName;
        data["PublicName"] = this.publicName;
        data["FileLink"] = this.fileLink;
        return data;
    }
}

export interface IAssetStorageEntryLimitedDTO {
    id?: number;
    relativePathAndName?: string | undefined;
    publicName?: string | undefined;
    fileLink?: string | undefined;
}

export class AssetCollectionPublicViewDTO implements IAssetCollectionPublicViewDTO {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    sharedUntilDate?: DateTime | undefined;
    fileData?: FileManagerResponseDTO | undefined;

    constructor(data?: IAssetCollectionPublicViewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.sharedUntilDate = _data["SharedUntilDate"] ? DateTime.fromISO(_data["SharedUntilDate"].toString()) : undefined as any;
            this.fileData = _data["FileData"] ? FileManagerResponseDTO.fromJS(_data["FileData"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetCollectionPublicViewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetCollectionPublicViewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["SharedUntilDate"] = this.sharedUntilDate ? this.sharedUntilDate.toString() : undefined as any;
        data["FileData"] = this.fileData ? this.fileData.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetCollectionPublicViewDTO {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    sharedUntilDate?: DateTime | undefined;
    fileData?: FileManagerResponseDTO | undefined;
}

export class FileManagerResponseDTO implements IFileManagerResponseDTO {
    cWD?: FileManagerDirectoryContentDTO | undefined;
    files?: FileManagerDirectoryContentDTO[] | undefined;
    error?: ErrorDetailsDTO | undefined;
    details?: FileDetailsDTO | undefined;

    constructor(data?: IFileManagerResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cWD = _data["CWD"] ? FileManagerDirectoryContentDTO.fromJS(_data["CWD"]) : undefined as any;
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileManagerDirectoryContentDTO.fromJS(item));
            }
            this.error = _data["Error"] ? ErrorDetailsDTO.fromJS(_data["Error"]) : undefined as any;
            this.details = _data["Details"] ? FileDetailsDTO.fromJS(_data["Details"]) : undefined as any;
        }
    }

    static fromJS(data: any): FileManagerResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileManagerResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CWD"] = this.cWD ? this.cWD.toJSON() : undefined as any;
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item ? item.toJSON() : undefined as any);
        }
        data["Error"] = this.error ? this.error.toJSON() : undefined as any;
        data["Details"] = this.details ? this.details.toJSON() : undefined as any;
        return data;
    }
}

export interface IFileManagerResponseDTO {
    cWD?: FileManagerDirectoryContentDTO | undefined;
    files?: FileManagerDirectoryContentDTO[] | undefined;
    error?: ErrorDetailsDTO | undefined;
    details?: FileDetailsDTO | undefined;
}

export class FileManagerDirectoryContentDTO implements IFileManagerDirectoryContentDTO {
    path?: string | undefined;
    action?: string | undefined;
    newName?: string | undefined;
    names?: string[] | undefined;
    name?: string | undefined;
    size?: number | undefined;
    previousName?: string | undefined;
    dateModified?: DateTime;
    dateCreated?: DateTime;
    type?: string | undefined;
    id?: string | undefined;
    filterPath?: string | undefined;
    filterId?: string | undefined;
    parentId?: string | undefined;
    targetPath?: string | undefined;
    renameFiles?: string[] | undefined;
    uploadFiles?: string[] | undefined;
    caseSensitive?: boolean;
    searchString?: string | undefined;
    showHiddenItems?: boolean;
    showFileExtension?: boolean;
    data?: FileManagerDirectoryContentDTO[] | undefined;
    targetData?: FileManagerDirectoryContentDTO | undefined;
    permission?: AccessPermission | undefined;
    assignedKeyWords?: AssetStorageKeyWordDTO[] | undefined;
    entryId?: number;
    hasChild?: boolean;
    isFile?: boolean;
    fileLink?: string | undefined;
    source?: string | undefined;
    languageCodeIso3?: string | undefined;
    license?: AssetStorageEntryLicense;
    imageQuality?: ImageQuality | undefined;
    isStaticFileName?: boolean;
    directoryPermissions?: AssetStorageDirectoryPermissionDTO[] | undefined;
    filter?: FilterDTO | undefined;
    linkedAssetCollections?: AssetCollectionDTO[] | undefined;

    constructor(data?: IFileManagerDirectoryContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["Path"];
            this.action = _data["Action"];
            this.newName = _data["NewName"];
            if (Array.isArray(_data["Names"])) {
                this.names = [] as any;
                for (let item of _data["Names"])
                    this.names!.push(item);
            }
            this.name = _data["Name"];
            this.size = _data["Size"];
            this.previousName = _data["PreviousName"];
            this.dateModified = _data["DateModified"] ? DateTime.fromISO(_data["DateModified"].toString()) : undefined as any;
            this.dateCreated = _data["DateCreated"] ? DateTime.fromISO(_data["DateCreated"].toString()) : undefined as any;
            this.type = _data["Type"];
            this.id = _data["Id"];
            this.filterPath = _data["FilterPath"];
            this.filterId = _data["FilterId"];
            this.parentId = _data["ParentId"];
            this.targetPath = _data["TargetPath"];
            if (Array.isArray(_data["RenameFiles"])) {
                this.renameFiles = [] as any;
                for (let item of _data["RenameFiles"])
                    this.renameFiles!.push(item);
            }
            if (Array.isArray(_data["UploadFiles"])) {
                this.uploadFiles = [] as any;
                for (let item of _data["UploadFiles"])
                    this.uploadFiles!.push(item);
            }
            this.caseSensitive = _data["CaseSensitive"];
            this.searchString = _data["SearchString"];
            this.showHiddenItems = _data["ShowHiddenItems"];
            this.showFileExtension = _data["ShowFileExtension"];
            if (Array.isArray(_data["Data"])) {
                this.data = [] as any;
                for (let item of _data["Data"])
                    this.data!.push(FileManagerDirectoryContentDTO.fromJS(item));
            }
            this.targetData = _data["TargetData"] ? FileManagerDirectoryContentDTO.fromJS(_data["TargetData"]) : undefined as any;
            this.permission = _data["Permission"] ? AccessPermission.fromJS(_data["Permission"]) : undefined as any;
            if (Array.isArray(_data["AssignedKeyWords"])) {
                this.assignedKeyWords = [] as any;
                for (let item of _data["AssignedKeyWords"])
                    this.assignedKeyWords!.push(AssetStorageKeyWordDTO.fromJS(item));
            }
            this.entryId = _data["EntryId"];
            this.hasChild = _data["HasChild"];
            this.isFile = _data["IsFile"];
            this.fileLink = _data["FileLink"];
            this.source = _data["Source"];
            this.languageCodeIso3 = _data["LanguageCodeIso3"];
            this.license = _data["License"];
            this.imageQuality = _data["ImageQuality"];
            this.isStaticFileName = _data["IsStaticFileName"];
            if (Array.isArray(_data["DirectoryPermissions"])) {
                this.directoryPermissions = [] as any;
                for (let item of _data["DirectoryPermissions"])
                    this.directoryPermissions!.push(AssetStorageDirectoryPermissionDTO.fromJS(item));
            }
            this.filter = _data["Filter"] ? FilterDTO.fromJS(_data["Filter"]) : undefined as any;
            if (Array.isArray(_data["LinkedAssetCollections"])) {
                this.linkedAssetCollections = [] as any;
                for (let item of _data["LinkedAssetCollections"])
                    this.linkedAssetCollections!.push(AssetCollectionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileManagerDirectoryContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileManagerDirectoryContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Path"] = this.path;
        data["Action"] = this.action;
        data["NewName"] = this.newName;
        if (Array.isArray(this.names)) {
            data["Names"] = [];
            for (let item of this.names)
                data["Names"].push(item);
        }
        data["Name"] = this.name;
        data["Size"] = this.size;
        data["PreviousName"] = this.previousName;
        data["DateModified"] = this.dateModified ? this.dateModified.toString() : undefined as any;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toString() : undefined as any;
        data["Type"] = this.type;
        data["Id"] = this.id;
        data["FilterPath"] = this.filterPath;
        data["FilterId"] = this.filterId;
        data["ParentId"] = this.parentId;
        data["TargetPath"] = this.targetPath;
        if (Array.isArray(this.renameFiles)) {
            data["RenameFiles"] = [];
            for (let item of this.renameFiles)
                data["RenameFiles"].push(item);
        }
        if (Array.isArray(this.uploadFiles)) {
            data["UploadFiles"] = [];
            for (let item of this.uploadFiles)
                data["UploadFiles"].push(item);
        }
        data["CaseSensitive"] = this.caseSensitive;
        data["SearchString"] = this.searchString;
        data["ShowHiddenItems"] = this.showHiddenItems;
        data["ShowFileExtension"] = this.showFileExtension;
        if (Array.isArray(this.data)) {
            data["Data"] = [];
            for (let item of this.data)
                data["Data"].push(item ? item.toJSON() : undefined as any);
        }
        data["TargetData"] = this.targetData ? this.targetData.toJSON() : undefined as any;
        data["Permission"] = this.permission ? this.permission.toJSON() : undefined as any;
        if (Array.isArray(this.assignedKeyWords)) {
            data["AssignedKeyWords"] = [];
            for (let item of this.assignedKeyWords)
                data["AssignedKeyWords"].push(item ? item.toJSON() : undefined as any);
        }
        data["EntryId"] = this.entryId;
        data["HasChild"] = this.hasChild;
        data["IsFile"] = this.isFile;
        data["FileLink"] = this.fileLink;
        data["Source"] = this.source;
        data["LanguageCodeIso3"] = this.languageCodeIso3;
        data["License"] = this.license;
        data["ImageQuality"] = this.imageQuality;
        data["IsStaticFileName"] = this.isStaticFileName;
        if (Array.isArray(this.directoryPermissions)) {
            data["DirectoryPermissions"] = [];
            for (let item of this.directoryPermissions)
                data["DirectoryPermissions"].push(item ? item.toJSON() : undefined as any);
        }
        data["Filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        if (Array.isArray(this.linkedAssetCollections)) {
            data["LinkedAssetCollections"] = [];
            for (let item of this.linkedAssetCollections)
                data["LinkedAssetCollections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFileManagerDirectoryContentDTO {
    path?: string | undefined;
    action?: string | undefined;
    newName?: string | undefined;
    names?: string[] | undefined;
    name?: string | undefined;
    size?: number | undefined;
    previousName?: string | undefined;
    dateModified?: DateTime;
    dateCreated?: DateTime;
    type?: string | undefined;
    id?: string | undefined;
    filterPath?: string | undefined;
    filterId?: string | undefined;
    parentId?: string | undefined;
    targetPath?: string | undefined;
    renameFiles?: string[] | undefined;
    uploadFiles?: string[] | undefined;
    caseSensitive?: boolean;
    searchString?: string | undefined;
    showHiddenItems?: boolean;
    showFileExtension?: boolean;
    data?: FileManagerDirectoryContentDTO[] | undefined;
    targetData?: FileManagerDirectoryContentDTO | undefined;
    permission?: AccessPermission | undefined;
    assignedKeyWords?: AssetStorageKeyWordDTO[] | undefined;
    entryId?: number;
    hasChild?: boolean;
    isFile?: boolean;
    fileLink?: string | undefined;
    source?: string | undefined;
    languageCodeIso3?: string | undefined;
    license?: AssetStorageEntryLicense;
    imageQuality?: ImageQuality | undefined;
    isStaticFileName?: boolean;
    directoryPermissions?: AssetStorageDirectoryPermissionDTO[] | undefined;
    filter?: FilterDTO | undefined;
    linkedAssetCollections?: AssetCollectionDTO[] | undefined;
}

export class AccessPermission implements IAccessPermission {
    copy?: boolean;
    download?: boolean;
    write?: boolean;
    writeContents?: boolean;
    read?: boolean;
    upload?: boolean;
    message?: string;

    constructor(data?: IAccessPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.copy = _data["Copy"];
            this.download = _data["Download"];
            this.write = _data["Write"];
            this.writeContents = _data["WriteContents"];
            this.read = _data["Read"];
            this.upload = _data["Upload"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): AccessPermission {
        data = typeof data === 'object' ? data : {};
        let result = new AccessPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Copy"] = this.copy;
        data["Download"] = this.download;
        data["Write"] = this.write;
        data["WriteContents"] = this.writeContents;
        data["Read"] = this.read;
        data["Upload"] = this.upload;
        data["Message"] = this.message;
        return data;
    }
}

export interface IAccessPermission {
    copy?: boolean;
    download?: boolean;
    write?: boolean;
    writeContents?: boolean;
    read?: boolean;
    upload?: boolean;
    message?: string;
}

export class AssetStorageKeyWordDTO implements IAssetStorageKeyWordDTO {
    id?: number;
    name!: string;

    constructor(data?: IAssetStorageKeyWordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): AssetStorageKeyWordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetStorageKeyWordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IAssetStorageKeyWordDTO {
    id?: number;
    name: string;
}

export enum AssetStorageEntryLicense {
    Ours = 0,
    Purchased = 1,
    AuthorizedByManufacturer = 2,
    Unknown = 3,
}

export enum ImageQuality {
    HighQuality = 0,
    LowQuality = 1,
}

export class AssetStorageDirectoryPermissionDTO implements IAssetStorageDirectoryPermissionDTO {
    id?: number;
    directoryId?: number;
    groupId?: number;
    read?: boolean;
    write?: boolean;

    constructor(data?: IAssetStorageDirectoryPermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.directoryId = _data["DirectoryId"];
            this.groupId = _data["GroupId"];
            this.read = _data["Read"];
            this.write = _data["Write"];
        }
    }

    static fromJS(data: any): AssetStorageDirectoryPermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetStorageDirectoryPermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DirectoryId"] = this.directoryId;
        data["GroupId"] = this.groupId;
        data["Read"] = this.read;
        data["Write"] = this.write;
        return data;
    }
}

export interface IAssetStorageDirectoryPermissionDTO {
    id?: number;
    directoryId?: number;
    groupId?: number;
    read?: boolean;
    write?: boolean;
}

export class ErrorDetailsDTO implements IErrorDetailsDTO {
    code?: string | undefined;
    message?: string | undefined;
    fileExists?: string[] | undefined;

    constructor(data?: IErrorDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.message = _data["Message"];
            if (Array.isArray(_data["FileExists"])) {
                this.fileExists = [] as any;
                for (let item of _data["FileExists"])
                    this.fileExists!.push(item);
            }
        }
    }

    static fromJS(data: any): ErrorDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Message"] = this.message;
        if (Array.isArray(this.fileExists)) {
            data["FileExists"] = [];
            for (let item of this.fileExists)
                data["FileExists"].push(item);
        }
        return data;
    }
}

export interface IErrorDetailsDTO {
    code?: string | undefined;
    message?: string | undefined;
    fileExists?: string[] | undefined;
}

export class FileDetailsDTO implements IFileDetailsDTO {
    name?: string | undefined;
    location?: string | undefined;
    isFile?: boolean;
    size?: string | undefined;
    created?: DateTime;
    modified?: DateTime;
    multipleFiles?: boolean;
    permission?: AccessPermission | undefined;

    constructor(data?: IFileDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.location = _data["Location"];
            this.isFile = _data["IsFile"];
            this.size = _data["Size"];
            this.created = _data["Created"] ? DateTime.fromISO(_data["Created"].toString()) : undefined as any;
            this.modified = _data["Modified"] ? DateTime.fromISO(_data["Modified"].toString()) : undefined as any;
            this.multipleFiles = _data["MultipleFiles"];
            this.permission = _data["Permission"] ? AccessPermission.fromJS(_data["Permission"]) : undefined as any;
        }
    }

    static fromJS(data: any): FileDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Location"] = this.location;
        data["IsFile"] = this.isFile;
        data["Size"] = this.size;
        data["Created"] = this.created ? this.created.toString() : undefined as any;
        data["Modified"] = this.modified ? this.modified.toString() : undefined as any;
        data["MultipleFiles"] = this.multipleFiles;
        data["Permission"] = this.permission ? this.permission.toJSON() : undefined as any;
        return data;
    }
}

export interface IFileDetailsDTO {
    name?: string | undefined;
    location?: string | undefined;
    isFile?: boolean;
    size?: string | undefined;
    created?: DateTime;
    modified?: DateTime;
    multipleFiles?: boolean;
    permission?: AccessPermission | undefined;
}

export class AssetStorageUploadResultDTO implements IAssetStorageUploadResultDTO {
    assetStorageEntryId?: number;

    constructor(data?: IAssetStorageUploadResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetStorageEntryId = _data["AssetStorageEntryId"];
        }
    }

    static fromJS(data: any): AssetStorageUploadResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetStorageUploadResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssetStorageEntryId"] = this.assetStorageEntryId;
        return data;
    }
}

export interface IAssetStorageUploadResultDTO {
    assetStorageEntryId?: number;
}

export class UpdateAssetStorageEntryDTO implements IUpdateAssetStorageEntryDTO {
    id!: number;
    source?: string | undefined;
    languageCodeIso3?: string | undefined;
    license?: AssetStorageEntryLicense | undefined;
    base64FileData?: string | undefined;
    imageQuality?: ImageQuality | undefined;
    assignedAssetKeyWords?: number[] | undefined;

    constructor(data?: IUpdateAssetStorageEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.source = _data["Source"];
            this.languageCodeIso3 = _data["LanguageCodeIso3"];
            this.license = _data["License"];
            this.base64FileData = _data["Base64FileData"];
            this.imageQuality = _data["ImageQuality"];
            if (Array.isArray(_data["AssignedAssetKeyWords"])) {
                this.assignedAssetKeyWords = [] as any;
                for (let item of _data["AssignedAssetKeyWords"])
                    this.assignedAssetKeyWords!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateAssetStorageEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetStorageEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Source"] = this.source;
        data["LanguageCodeIso3"] = this.languageCodeIso3;
        data["License"] = this.license;
        data["Base64FileData"] = this.base64FileData;
        data["ImageQuality"] = this.imageQuality;
        if (Array.isArray(this.assignedAssetKeyWords)) {
            data["AssignedAssetKeyWords"] = [];
            for (let item of this.assignedAssetKeyWords)
                data["AssignedAssetKeyWords"].push(item);
        }
        return data;
    }
}

export interface IUpdateAssetStorageEntryDTO {
    id: number;
    source?: string | undefined;
    languageCodeIso3?: string | undefined;
    license?: AssetStorageEntryLicense | undefined;
    base64FileData?: string | undefined;
    imageQuality?: ImageQuality | undefined;
    assignedAssetKeyWords?: number[] | undefined;
}

export class UpdateAssetStorageDirectoryPermissionsDTO implements IUpdateAssetStorageDirectoryPermissionsDTO {
    directoryId?: number;
    directoryPermissions?: AssetStorageDirectoryPermissionDTO[];

    constructor(data?: IUpdateAssetStorageDirectoryPermissionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.directoryId = _data["DirectoryId"];
            if (Array.isArray(_data["DirectoryPermissions"])) {
                this.directoryPermissions = [] as any;
                for (let item of _data["DirectoryPermissions"])
                    this.directoryPermissions!.push(AssetStorageDirectoryPermissionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAssetStorageDirectoryPermissionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetStorageDirectoryPermissionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DirectoryId"] = this.directoryId;
        if (Array.isArray(this.directoryPermissions)) {
            data["DirectoryPermissions"] = [];
            for (let item of this.directoryPermissions)
                data["DirectoryPermissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateAssetStorageDirectoryPermissionsDTO {
    directoryId?: number;
    directoryPermissions?: AssetStorageDirectoryPermissionDTO[];
}

export class PagedResultDTOOfAssetStorageKeyWordDTO implements IPagedResultDTOOfAssetStorageKeyWordDTO {
    items?: AssetStorageKeyWordDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfAssetStorageKeyWordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(AssetStorageKeyWordDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfAssetStorageKeyWordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfAssetStorageKeyWordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfAssetStorageKeyWordDTO {
    items?: AssetStorageKeyWordDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class PagedResultDTOOfAssetStoragePermissionGroupDTO implements IPagedResultDTOOfAssetStoragePermissionGroupDTO {
    items?: AssetStoragePermissionGroupDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfAssetStoragePermissionGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(AssetStoragePermissionGroupDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfAssetStoragePermissionGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfAssetStoragePermissionGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfAssetStoragePermissionGroupDTO {
    items?: AssetStoragePermissionGroupDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class AssetStoragePermissionGroupDTO implements IAssetStoragePermissionGroupDTO {
    id?: number;
    name?: string | undefined;
    users?: AssetStoragePermissionGroupUserDTO[] | undefined;

    constructor(data?: IAssetStoragePermissionGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(AssetStoragePermissionGroupUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetStoragePermissionGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetStoragePermissionGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetStoragePermissionGroupDTO {
    id?: number;
    name?: string | undefined;
    users?: AssetStoragePermissionGroupUserDTO[] | undefined;
}

export class AssetStoragePermissionGroupUserDTO implements IAssetStoragePermissionGroupUserDTO {
    userId!: string;
    user?: UserInfoDTO | undefined;

    constructor(data?: IAssetStoragePermissionGroupUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.user = _data["User"] ? UserInfoDTO.fromJS(_data["User"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetStoragePermissionGroupUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetStoragePermissionGroupUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["User"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetStoragePermissionGroupUserDTO {
    userId: string;
    user?: UserInfoDTO | undefined;
}

export class CreateAssetStoragePermissionGroupDTO implements ICreateAssetStoragePermissionGroupDTO {
    name!: string;
    users?: AssetStoragePermissionGroupUserDTO[] | undefined;

    constructor(data?: ICreateAssetStoragePermissionGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(AssetStoragePermissionGroupUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAssetStoragePermissionGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetStoragePermissionGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateAssetStoragePermissionGroupDTO {
    name: string;
    users?: AssetStoragePermissionGroupUserDTO[] | undefined;
}

export class UpdateAssetStoragePermissionGroupDTO implements IUpdateAssetStoragePermissionGroupDTO {
    id!: number;
    name?: string | undefined;
    users?: UpdateAssetStoragePermissionGroupUserDTO[] | undefined;

    constructor(data?: IUpdateAssetStoragePermissionGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(UpdateAssetStoragePermissionGroupUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAssetStoragePermissionGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetStoragePermissionGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateAssetStoragePermissionGroupDTO {
    id: number;
    name?: string | undefined;
    users?: UpdateAssetStoragePermissionGroupUserDTO[] | undefined;
}

export class UpdateAssetStoragePermissionGroupUserDTO implements IUpdateAssetStoragePermissionGroupUserDTO {
    userId!: string;

    constructor(data?: IUpdateAssetStoragePermissionGroupUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): UpdateAssetStoragePermissionGroupUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetStoragePermissionGroupUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        return data;
    }
}

export interface IUpdateAssetStoragePermissionGroupUserDTO {
    userId: string;
}

export class PagedResultDTOOfBrandLogoDTO implements IPagedResultDTOOfBrandLogoDTO {
    items?: BrandLogoDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfBrandLogoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(BrandLogoDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfBrandLogoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfBrandLogoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfBrandLogoDTO {
    items?: BrandLogoDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class BrandLogoDTO implements IBrandLogoDTO {
    id?: number;
    brand?: string | undefined;
    brandSub?: string | undefined;
    fileLink?: string | undefined;
    fileSize?: number;
    isKey?: boolean;
    publicName?: string | undefined;
    originalFileName?: string | undefined;
    fileExtension?: string | undefined;
    altText?: string | undefined;
    shops?: BrandLogoShopDTO[] | undefined;

    constructor(data?: IBrandLogoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.brand = _data["Brand"];
            this.brandSub = _data["BrandSub"];
            this.fileLink = _data["FileLink"];
            this.fileSize = _data["FileSize"];
            this.isKey = _data["IsKey"];
            this.publicName = _data["PublicName"];
            this.originalFileName = _data["OriginalFileName"];
            this.fileExtension = _data["FileExtension"];
            this.altText = _data["AltText"];
            if (Array.isArray(_data["Shops"])) {
                this.shops = [] as any;
                for (let item of _data["Shops"])
                    this.shops!.push(BrandLogoShopDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BrandLogoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BrandLogoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Brand"] = this.brand;
        data["BrandSub"] = this.brandSub;
        data["FileLink"] = this.fileLink;
        data["FileSize"] = this.fileSize;
        data["IsKey"] = this.isKey;
        data["PublicName"] = this.publicName;
        data["OriginalFileName"] = this.originalFileName;
        data["FileExtension"] = this.fileExtension;
        data["AltText"] = this.altText;
        if (Array.isArray(this.shops)) {
            data["Shops"] = [];
            for (let item of this.shops)
                data["Shops"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBrandLogoDTO {
    id?: number;
    brand?: string | undefined;
    brandSub?: string | undefined;
    fileLink?: string | undefined;
    fileSize?: number;
    isKey?: boolean;
    publicName?: string | undefined;
    originalFileName?: string | undefined;
    fileExtension?: string | undefined;
    altText?: string | undefined;
    shops?: BrandLogoShopDTO[] | undefined;
}

export class BrandLogoShopDTO implements IBrandLogoShopDTO {
    id?: number;
    brandLogoId?: number;
    shopId?: string | undefined;
    isKey?: boolean;

    constructor(data?: IBrandLogoShopDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.brandLogoId = _data["BrandLogoId"];
            this.shopId = _data["ShopId"];
            this.isKey = _data["IsKey"];
        }
    }

    static fromJS(data: any): BrandLogoShopDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BrandLogoShopDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["BrandLogoId"] = this.brandLogoId;
        data["ShopId"] = this.shopId;
        data["IsKey"] = this.isKey;
        return data;
    }
}

export interface IBrandLogoShopDTO {
    id?: number;
    brandLogoId?: number;
    shopId?: string | undefined;
    isKey?: boolean;
}

export class CreateBrandLogoDTO implements ICreateBrandLogoDTO {
    brands!: AssetBrandDTO[];
    publicName!: string;
    originalFileName!: string;
    fileExtension!: string;
    shops?: string[] | undefined;
    base64FileData!: string;
    isKey?: boolean;
    replaceAllProductLogos?: boolean;
    replaceCustomLogos?: boolean;
    altText?: string | undefined;

    constructor(data?: ICreateBrandLogoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.brands = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Brands"])) {
                this.brands = [] as any;
                for (let item of _data["Brands"])
                    this.brands!.push(AssetBrandDTO.fromJS(item));
            }
            this.publicName = _data["PublicName"];
            this.originalFileName = _data["OriginalFileName"];
            this.fileExtension = _data["FileExtension"];
            if (Array.isArray(_data["Shops"])) {
                this.shops = [] as any;
                for (let item of _data["Shops"])
                    this.shops!.push(item);
            }
            this.base64FileData = _data["Base64FileData"];
            this.isKey = _data["IsKey"];
            this.replaceAllProductLogos = _data["ReplaceAllProductLogos"];
            this.replaceCustomLogos = _data["ReplaceCustomLogos"];
            this.altText = _data["AltText"];
        }
    }

    static fromJS(data: any): CreateBrandLogoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBrandLogoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.brands)) {
            data["Brands"] = [];
            for (let item of this.brands)
                data["Brands"].push(item ? item.toJSON() : undefined as any);
        }
        data["PublicName"] = this.publicName;
        data["OriginalFileName"] = this.originalFileName;
        data["FileExtension"] = this.fileExtension;
        if (Array.isArray(this.shops)) {
            data["Shops"] = [];
            for (let item of this.shops)
                data["Shops"].push(item);
        }
        data["Base64FileData"] = this.base64FileData;
        data["IsKey"] = this.isKey;
        data["ReplaceAllProductLogos"] = this.replaceAllProductLogos;
        data["ReplaceCustomLogos"] = this.replaceCustomLogos;
        data["AltText"] = this.altText;
        return data;
    }
}

export interface ICreateBrandLogoDTO {
    brands: AssetBrandDTO[];
    publicName: string;
    originalFileName: string;
    fileExtension: string;
    shops?: string[] | undefined;
    base64FileData: string;
    isKey?: boolean;
    replaceAllProductLogos?: boolean;
    replaceCustomLogos?: boolean;
    altText?: string | undefined;
}

export class AssetBrandDTO implements IAssetBrandDTO {
    brand!: string;
    brandSub?: string | undefined;

    constructor(data?: IAssetBrandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brand = _data["Brand"];
            this.brandSub = _data["BrandSub"];
        }
    }

    static fromJS(data: any): AssetBrandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetBrandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Brand"] = this.brand;
        data["BrandSub"] = this.brandSub;
        return data;
    }
}

export interface IAssetBrandDTO {
    brand: string;
    brandSub?: string | undefined;
}

export class DeleteBrandLogoDTO implements IDeleteBrandLogoDTO {
    id!: number;
    deleteAllProductLogos?: boolean;
    reapplyProductLogos?: boolean;

    constructor(data?: IDeleteBrandLogoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.deleteAllProductLogos = _data["DeleteAllProductLogos"];
            this.reapplyProductLogos = _data["ReapplyProductLogos"];
        }
    }

    static fromJS(data: any): DeleteBrandLogoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBrandLogoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DeleteAllProductLogos"] = this.deleteAllProductLogos;
        data["ReapplyProductLogos"] = this.reapplyProductLogos;
        return data;
    }
}

export interface IDeleteBrandLogoDTO {
    id: number;
    deleteAllProductLogos?: boolean;
    reapplyProductLogos?: boolean;
}

export class PagedResultDTOOfProductAssetDTOStargate implements IPagedResultDTOOfProductAssetDTOStargate {
    items?: ProductAssetDTOStargate[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfProductAssetDTOStargate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ProductAssetDTOStargate.fromJS(item));
            }
            this.totalNumberOfItems = _data["TotalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfProductAssetDTOStargate {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfProductAssetDTOStargate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfProductAssetDTOStargate {
    items?: ProductAssetDTOStargate[] | undefined;
    totalNumberOfItems?: number;
}

export class ProductAssetDTOStargate implements IProductAssetDTOStargate {
    sKU?: string | undefined;
    manItemInfo?: string | undefined;
    description?: string | undefined;
    description2?: string | undefined;
    brandId?: string | undefined;
    brandSubId?: string | undefined;
    isPublishedToWeb?: boolean;
    shopIds?: string[] | undefined;
    assets?: AssetDTOStargate[] | undefined;

    constructor(data?: IProductAssetDTOStargate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKU = _data["SKU"];
            this.manItemInfo = _data["ManItemInfo"];
            this.description = _data["Description"];
            this.description2 = _data["Description2"];
            this.brandId = _data["BrandId"];
            this.brandSubId = _data["BrandSubId"];
            this.isPublishedToWeb = _data["IsPublishedToWeb"];
            if (Array.isArray(_data["ShopIds"])) {
                this.shopIds = [] as any;
                for (let item of _data["ShopIds"])
                    this.shopIds!.push(item);
            }
            if (Array.isArray(_data["Assets"])) {
                this.assets = [] as any;
                for (let item of _data["Assets"])
                    this.assets!.push(AssetDTOStargate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductAssetDTOStargate {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAssetDTOStargate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SKU"] = this.sKU;
        data["ManItemInfo"] = this.manItemInfo;
        data["Description"] = this.description;
        data["Description2"] = this.description2;
        data["BrandId"] = this.brandId;
        data["BrandSubId"] = this.brandSubId;
        data["IsPublishedToWeb"] = this.isPublishedToWeb;
        if (Array.isArray(this.shopIds)) {
            data["ShopIds"] = [];
            for (let item of this.shopIds)
                data["ShopIds"].push(item);
        }
        if (Array.isArray(this.assets)) {
            data["Assets"] = [];
            for (let item of this.assets)
                data["Assets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductAssetDTOStargate {
    sKU?: string | undefined;
    manItemInfo?: string | undefined;
    description?: string | undefined;
    description2?: string | undefined;
    brandId?: string | undefined;
    brandSubId?: string | undefined;
    isPublishedToWeb?: boolean;
    shopIds?: string[] | undefined;
    assets?: AssetDTOStargate[] | undefined;
}

export class AssetDTOStargate implements IAssetDTOStargate {
    id?: number;
    publicName?: string | undefined;
    altText?: string | undefined;
    originalFileName?: string | undefined;
    fileExtension?: string | undefined;
    fileSize?: number;
    fileLink?: string | undefined;
    languageCodeIso3?: string | undefined;
    type?: AssetType;
    syncStatus?: AssetSyncStatus;
    syncMessage?: string | undefined;
    orderIndex?: number;
    shops?: AssetShopDTO[] | undefined;
    isUploading?: boolean;

    constructor(data?: IAssetDTOStargate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.publicName = _data["PublicName"];
            this.altText = _data["AltText"];
            this.originalFileName = _data["OriginalFileName"];
            this.fileExtension = _data["FileExtension"];
            this.fileSize = _data["FileSize"];
            this.fileLink = _data["FileLink"];
            this.languageCodeIso3 = _data["LanguageCodeIso3"];
            this.type = _data["Type"];
            this.syncStatus = _data["SyncStatus"];
            this.syncMessage = _data["SyncMessage"];
            this.orderIndex = _data["OrderIndex"];
            if (Array.isArray(_data["Shops"])) {
                this.shops = [] as any;
                for (let item of _data["Shops"])
                    this.shops!.push(AssetShopDTO.fromJS(item));
            }
            this.isUploading = _data["IsUploading"];
        }
    }

    static fromJS(data: any): AssetDTOStargate {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDTOStargate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["PublicName"] = this.publicName;
        data["AltText"] = this.altText;
        data["OriginalFileName"] = this.originalFileName;
        data["FileExtension"] = this.fileExtension;
        data["FileSize"] = this.fileSize;
        data["FileLink"] = this.fileLink;
        data["LanguageCodeIso3"] = this.languageCodeIso3;
        data["Type"] = this.type;
        data["SyncStatus"] = this.syncStatus;
        data["SyncMessage"] = this.syncMessage;
        data["OrderIndex"] = this.orderIndex;
        if (Array.isArray(this.shops)) {
            data["Shops"] = [];
            for (let item of this.shops)
                data["Shops"].push(item ? item.toJSON() : undefined as any);
        }
        data["IsUploading"] = this.isUploading;
        return data;
    }
}

export interface IAssetDTOStargate {
    id?: number;
    publicName?: string | undefined;
    altText?: string | undefined;
    originalFileName?: string | undefined;
    fileExtension?: string | undefined;
    fileSize?: number;
    fileLink?: string | undefined;
    languageCodeIso3?: string | undefined;
    type?: AssetType;
    syncStatus?: AssetSyncStatus;
    syncMessage?: string | undefined;
    orderIndex?: number;
    shops?: AssetShopDTO[] | undefined;
    isUploading?: boolean;
}

export class AssetShopDTO implements IAssetShopDTO {
    id?: number;
    assetId?: number;
    shopId?: string | undefined;
    isKey?: boolean;

    constructor(data?: IAssetShopDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.assetId = _data["AssetId"];
            this.shopId = _data["ShopId"];
            this.isKey = _data["IsKey"];
        }
    }

    static fromJS(data: any): AssetShopDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetShopDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AssetId"] = this.assetId;
        data["ShopId"] = this.shopId;
        data["IsKey"] = this.isKey;
        return data;
    }
}

export interface IAssetShopDTO {
    id?: number;
    assetId?: number;
    shopId?: string | undefined;
    isKey?: boolean;
}

export class UpdateAssetDTO implements IUpdateAssetDTO {
    id?: number;
    publicName?: string | undefined;
    language?: string | undefined;
    type?: AssetType | undefined;
    shopIds?: string[] | undefined;
    base64FileData?: string | undefined;
    originalFileName?: string | undefined;
    altText?: string | undefined;

    constructor(data?: IUpdateAssetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.publicName = _data["PublicName"];
            this.language = _data["Language"];
            this.type = _data["Type"];
            if (Array.isArray(_data["ShopIds"])) {
                this.shopIds = [] as any;
                for (let item of _data["ShopIds"])
                    this.shopIds!.push(item);
            }
            this.base64FileData = _data["Base64FileData"];
            this.originalFileName = _data["OriginalFileName"];
            this.altText = _data["AltText"];
        }
    }

    static fromJS(data: any): UpdateAssetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["PublicName"] = this.publicName;
        data["Language"] = this.language;
        data["Type"] = this.type;
        if (Array.isArray(this.shopIds)) {
            data["ShopIds"] = [];
            for (let item of this.shopIds)
                data["ShopIds"].push(item);
        }
        data["Base64FileData"] = this.base64FileData;
        data["OriginalFileName"] = this.originalFileName;
        data["AltText"] = this.altText;
        return data;
    }
}

export interface IUpdateAssetDTO {
    id?: number;
    publicName?: string | undefined;
    language?: string | undefined;
    type?: AssetType | undefined;
    shopIds?: string[] | undefined;
    base64FileData?: string | undefined;
    originalFileName?: string | undefined;
    altText?: string | undefined;
}

export class AssetConfigurationsDTO implements IAssetConfigurationsDTO {
    supportedAssetLanguages?: string[] | undefined;
    supportedAssetDocumentFileExtensions?: string[] | undefined;
    supportedAssetImageFileExtensions?: string[] | undefined;
    supportedAssetLogoFileExtensions?: string[] | undefined;
    supportedLandingPageFileExtensions?: string[] | undefined;
    forbiddenAssetFileExtensions?: string[] | undefined;
    supportedShopIds?: string[] | undefined;
    supportedResolutionsInDpi?: number[] | undefined;

    constructor(data?: IAssetConfigurationsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SupportedAssetLanguages"])) {
                this.supportedAssetLanguages = [] as any;
                for (let item of _data["SupportedAssetLanguages"])
                    this.supportedAssetLanguages!.push(item);
            }
            if (Array.isArray(_data["SupportedAssetDocumentFileExtensions"])) {
                this.supportedAssetDocumentFileExtensions = [] as any;
                for (let item of _data["SupportedAssetDocumentFileExtensions"])
                    this.supportedAssetDocumentFileExtensions!.push(item);
            }
            if (Array.isArray(_data["SupportedAssetImageFileExtensions"])) {
                this.supportedAssetImageFileExtensions = [] as any;
                for (let item of _data["SupportedAssetImageFileExtensions"])
                    this.supportedAssetImageFileExtensions!.push(item);
            }
            if (Array.isArray(_data["SupportedAssetLogoFileExtensions"])) {
                this.supportedAssetLogoFileExtensions = [] as any;
                for (let item of _data["SupportedAssetLogoFileExtensions"])
                    this.supportedAssetLogoFileExtensions!.push(item);
            }
            if (Array.isArray(_data["SupportedLandingPageFileExtensions"])) {
                this.supportedLandingPageFileExtensions = [] as any;
                for (let item of _data["SupportedLandingPageFileExtensions"])
                    this.supportedLandingPageFileExtensions!.push(item);
            }
            if (Array.isArray(_data["ForbiddenAssetFileExtensions"])) {
                this.forbiddenAssetFileExtensions = [] as any;
                for (let item of _data["ForbiddenAssetFileExtensions"])
                    this.forbiddenAssetFileExtensions!.push(item);
            }
            if (Array.isArray(_data["SupportedShopIds"])) {
                this.supportedShopIds = [] as any;
                for (let item of _data["SupportedShopIds"])
                    this.supportedShopIds!.push(item);
            }
            if (Array.isArray(_data["SupportedResolutionsInDpi"])) {
                this.supportedResolutionsInDpi = [] as any;
                for (let item of _data["SupportedResolutionsInDpi"])
                    this.supportedResolutionsInDpi!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetConfigurationsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetConfigurationsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.supportedAssetLanguages)) {
            data["SupportedAssetLanguages"] = [];
            for (let item of this.supportedAssetLanguages)
                data["SupportedAssetLanguages"].push(item);
        }
        if (Array.isArray(this.supportedAssetDocumentFileExtensions)) {
            data["SupportedAssetDocumentFileExtensions"] = [];
            for (let item of this.supportedAssetDocumentFileExtensions)
                data["SupportedAssetDocumentFileExtensions"].push(item);
        }
        if (Array.isArray(this.supportedAssetImageFileExtensions)) {
            data["SupportedAssetImageFileExtensions"] = [];
            for (let item of this.supportedAssetImageFileExtensions)
                data["SupportedAssetImageFileExtensions"].push(item);
        }
        if (Array.isArray(this.supportedAssetLogoFileExtensions)) {
            data["SupportedAssetLogoFileExtensions"] = [];
            for (let item of this.supportedAssetLogoFileExtensions)
                data["SupportedAssetLogoFileExtensions"].push(item);
        }
        if (Array.isArray(this.supportedLandingPageFileExtensions)) {
            data["SupportedLandingPageFileExtensions"] = [];
            for (let item of this.supportedLandingPageFileExtensions)
                data["SupportedLandingPageFileExtensions"].push(item);
        }
        if (Array.isArray(this.forbiddenAssetFileExtensions)) {
            data["ForbiddenAssetFileExtensions"] = [];
            for (let item of this.forbiddenAssetFileExtensions)
                data["ForbiddenAssetFileExtensions"].push(item);
        }
        if (Array.isArray(this.supportedShopIds)) {
            data["SupportedShopIds"] = [];
            for (let item of this.supportedShopIds)
                data["SupportedShopIds"].push(item);
        }
        if (Array.isArray(this.supportedResolutionsInDpi)) {
            data["SupportedResolutionsInDpi"] = [];
            for (let item of this.supportedResolutionsInDpi)
                data["SupportedResolutionsInDpi"].push(item);
        }
        return data;
    }
}

export interface IAssetConfigurationsDTO {
    supportedAssetLanguages?: string[] | undefined;
    supportedAssetDocumentFileExtensions?: string[] | undefined;
    supportedAssetImageFileExtensions?: string[] | undefined;
    supportedAssetLogoFileExtensions?: string[] | undefined;
    supportedLandingPageFileExtensions?: string[] | undefined;
    forbiddenAssetFileExtensions?: string[] | undefined;
    supportedShopIds?: string[] | undefined;
    supportedResolutionsInDpi?: number[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}